
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("g7CEg", function(module, exports) {
$parcel$export(module.exports, "UniformWrapper", function () { return $85ecc4bac898c23a$export$227673ab846fab74; });

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $01zo5 = parcelRequire("01zo5");

var $5HK05 = parcelRequire("5HK05");

var $3d4V3 = parcelRequire("3d4V3");

var $hu7gH = parcelRequire("hu7gH");

var $eNxv9 = parcelRequire("eNxv9");

var $g70ym = parcelRequire("g70ym");
const $85ecc4bac898c23a$var$resolveRenderer = ({ type: type })=>{
    const MissingComponent = ()=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $g70ym.UniformMissingComponent), {
            componentName: type
        });
    var _UNIFORM_DEFINITIONS_type;
    return (_UNIFORM_DEFINITIONS_type = (0, $eNxv9.default)[type]) !== null && _UNIFORM_DEFINITIONS_type !== void 0 ? _UNIFORM_DEFINITIONS_type : MissingComponent;
};
const $85ecc4bac898c23a$export$227673ab846fab74 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const preloadedComposition = typeof window !== "undefined" ? window._uniformPreloadedComposition : null;
    const initialData = preloadedComposition || composition;
    const [data, setData] = (0, $gljCV.useState)(initialData);
    const [isFetched, setIsFetched] = (0, $gljCV.useState)(!!initialData);
    // Listen for postMessage events to update composition dynamically
    // Only enabled if allowPostMessage flag is set and in non-production environments
    (0, $gljCV.useEffect)(()=>{
        if (typeof window === "undefined") return;
        // Only enable if allowPostMessage flag is set
        if (!isAllowPostMessage) return;
        const handleMessage = async (event)=>{
            var _event_data, _event_data1;
            // Check if message is for updating Uniform composition
            if (((_event_data = event.data) === null || _event_data === void 0 ? void 0 : _event_data.type) === "UNIFORM_COMPOSITION_UPDATE" && ((_event_data1 = event.data) === null || _event_data1 === void 0 ? void 0 : _event_data1.composition)) try {
                var _compositionData_compositionApiResponse;
                const compositionData = event.data.composition;
                // If composition is wrapped in compositionApiResponse, extract it
                const rawComposition = ((_compositionData_compositionApiResponse = compositionData.compositionApiResponse) === null || _compositionData_compositionApiResponse === void 0 ? void 0 : _compositionData_compositionApiResponse.composition) || compositionData;
                // Enhance the composition
                const enhancedComp = await (0, $3d4V3.enhanceComposition)(rawComposition);
                // Update state to trigger re-render
                setData(enhancedComp);
                setIsFetched(true);
                console.log("Uniform composition updated via postMessage");
            } catch (error) {
                console.error("Error processing composition from postMessage:", error);
            }
        };
        window.addEventListener("message", handleMessage);
        return ()=>{
            window.removeEventListener("message", handleMessage);
        };
    }, [
        isAllowPostMessage
    ]);
    (0, $gljCV.useEffect)(()=>{
        if (initialData) return;
        const fetchComposition = async ()=>{
            if (typeof window === "undefined") return;
            const { path: path, locale: locale } = (0, $hu7gH.parseRoute)(window.location);
            if (path === "uniform-preview" && isAllowPostMessage === true) {
                console.log("uniform-preview with allowPostMessage - waiting for postMessage");
                return;
            }
            const slug = path.startsWith("/") ? path.substring(1) : path;
            const cdn = "https://wac-uniform-promotion--production.us-east-1.prod.public.atl-paas.net/";
            const cdn_path = `${cdn}release/${locale}/${slug}/composition.json`;
            try {
                const req = await fetch(cdn_path);
                const file = await req.json();
                const enhancedComp = await (0, $3d4V3.enhanceComposition)(file.compositionApiResponse.composition);
                setData(enhancedComp);
            } catch (error) {
                console.error("Error fetching composition from CDN:", error);
                if (composition) setData(composition);
            }
            setIsFetched(true);
        };
        fetchComposition();
    }, [
        initialData,
        composition
    ]);
    if (isUniformPlayground) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformPlayground), {
        resolveRenderer: $85ecc4bac898c23a$var$resolveRenderer,
        contextualEditingEnhancer: ({ composition: composition })=>(0, $3d4V3.enhanceComposition)(composition)
    });
    return isFetched && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformComposition), {
            data: (0, $5HK05.expectContent)(data),
            behaviorTracking: "onLoad",
            resolveRenderer: $85ecc4bac898c23a$var$resolveRenderer,
            contextualEditingEnhancer: ({ composition: composition })=>(0, $3d4V3.enhanceComposition)(composition)
        })
    });
};

});
parcelRegister("eNxv9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ccc1f30aa8c203e0$export$2e2bcd8739ae039; });
parcelRequire("dGB94");
var $4JOZV = parcelRequire("4JOZV");

var $gqoQW = parcelRequire("gqoQW");
parcelRequire("8LAtF");
var $4TmNR = parcelRequire("4TmNR");

var $c9Fb2 = parcelRequire("c9Fb2");

var $18J8o = parcelRequire("18J8o");
parcelRequire("d81Rk");
var $1d9MG = parcelRequire("1d9MG");
parcelRequire("48CBm");
var $jgyhc = parcelRequire("jgyhc");
parcelRequire("g76er");
var $8hbU0 = parcelRequire("8hbU0");
parcelRequire("eWth0");
var $aghrj = parcelRequire("aghrj");
parcelRequire("9RECE");
var $6SooZ = parcelRequire("6SooZ");
parcelRequire("l1OVK");
var $4h1q1 = parcelRequire("4h1q1");
parcelRequire("jrpGZ");
var $k1kqo = parcelRequire("k1kqo");
parcelRequire("l95R2");
var $jswU3 = parcelRequire("jswU3");
parcelRequire("iBGmF");
var $82Z9J = parcelRequire("82Z9J");
parcelRequire("fB1rt");
var $9eDC1 = parcelRequire("9eDC1");
parcelRequire("c3MyV");
var $hStuA = parcelRequire("hStuA");
parcelRequire("kXH46");
var $8MWwK = parcelRequire("8MWwK");
parcelRequire("8NuGV");
var $5nbaa = parcelRequire("5nbaa");
parcelRequire("jdYL5");
var $cDjwJ = parcelRequire("cDjwJ");
parcelRequire("mh7Fj");
var $gl1tq = parcelRequire("gl1tq");
parcelRequire("kueIh");
var $hvVOW = parcelRequire("hvVOW");
parcelRequire("2Uect");
var $2540f = parcelRequire("2540f");
parcelRequire("gkej5");
var $j6nXt = parcelRequire("j6nXt");
parcelRequire("9Ldi7");
var $jK7xK = parcelRequire("jK7xK");

var $856b3 = parcelRequire("856b3");
parcelRequire("48xZO");
var $2bofd = parcelRequire("2bofd");
parcelRequire("kGRnr");
var $3VYCw = parcelRequire("3VYCw");
parcelRequire("7uMUN");
var $g0xMT = parcelRequire("g0xMT");
parcelRequire("kENrP");
var $3E3Vm = parcelRequire("3E3Vm");
parcelRequire("lwwc5");
var $7d42O = parcelRequire("7d42O");
parcelRequire("6Xg4D");
var $f7IMH = parcelRequire("f7IMH");
parcelRequire("86Uds");
var $jGtmE = parcelRequire("jGtmE");
parcelRequire("ewf1g");
var $2XwEb = parcelRequire("2XwEb");
parcelRequire("Q6uLA");
var $2oS3p = parcelRequire("2oS3p");
parcelRequire("bQ2Tp");
var $6JkkA = parcelRequire("6JkkA");
parcelRequire("ctoCY");
var $1ij5s = parcelRequire("1ij5s");
parcelRequire("4aqCo");
var $3jkl6 = parcelRequire("3jkl6");
parcelRequire("40haA");
var $bkhKq = parcelRequire("bkhKq");
parcelRequire("7LEgv");
var $6jbRM = parcelRequire("6jbRM");
parcelRequire("k2y5m");
var $ks0ka = parcelRequire("ks0ka");
parcelRequire("fChjk");
var $71BPb = parcelRequire("71BPb");
parcelRequire("zIzFT");
var $bmNwd = parcelRequire("bmNwd");
parcelRequire("eZkeB");
var $5c1uT = parcelRequire("5c1uT");
parcelRequire("8sJj3");
var $f8O2Y = parcelRequire("f8O2Y");
parcelRequire("6840w");
var $iSxa6 = parcelRequire("iSxa6");
parcelRequire("9YhLi");
var $lATol = parcelRequire("lATol");
parcelRequire("7s9SJ");
var $3E1lH = parcelRequire("3E1lH");
parcelRequire("QTohK");
var $7xYdG = parcelRequire("7xYdG");
parcelRequire("4YNFt");
var $gebIf = parcelRequire("gebIf");
parcelRequire("3Fbib");
var $9tius = parcelRequire("9tius");
parcelRequire("gC9ew");
var $aT8t4 = parcelRequire("aT8t4");
parcelRequire("2cLcb");
var $eNJPT = parcelRequire("eNJPT");

var $6OBcA = parcelRequire("6OBcA");
parcelRequire("emoLr");
var $4oasi = parcelRequire("4oasi");

var $5h2w8 = parcelRequire("5h2w8");
parcelRequire("8Ocd4");
var $exkom = parcelRequire("exkom");
parcelRequire("esueT");
var $6smfw = parcelRequire("6smfw");
parcelRequire("kiHKn");
var $2Oxuw = parcelRequire("2Oxuw");
parcelRequire("eCz5y");
var $4Aw5W = parcelRequire("4Aw5W");
parcelRequire("6xyfr");
var $4LrCk = parcelRequire("4LrCk");
parcelRequire("g7Irr");
var $v15B3 = parcelRequire("v15B3");

var $71GXn = parcelRequire("71GXn");
parcelRequire("iSYyH");
var $3DCiB = parcelRequire("3DCiB");
parcelRequire("gdpMV");
var $acEyk = parcelRequire("acEyk");
parcelRequire("6Oj1c");
var $ies6q = parcelRequire("ies6q");
parcelRequire("f4xf5");
var $dXwUh = parcelRequire("dXwUh");
parcelRequire("5sAm0");
var $kfc2o = parcelRequire("kfc2o");

var $JXKd7 = parcelRequire("JXKd7");
parcelRequire("akfBj");
var $j4sH0 = parcelRequire("j4sH0");
parcelRequire("ej1nL");
var $evFps = parcelRequire("evFps");
parcelRequire("loBJh");
var $eWY7v = parcelRequire("eWY7v");
parcelRequire("dj2gn");
var $kb0v3 = parcelRequire("kb0v3");
parcelRequire("dC1vp");
var $gP8Hr = parcelRequire("gP8Hr");
parcelRequire("1il1O");
var $cwpkM = parcelRequire("cwpkM");
parcelRequire("gh93G");
var $11uBo = parcelRequire("11uBo");
parcelRequire("84zj4");
var $hnLdc = parcelRequire("hnLdc");

var $4iHqa = parcelRequire("4iHqa");

var $74AbP = parcelRequire("74AbP");
parcelRequire("3NZjV");
var $3QKwy = parcelRequire("3QKwy");
parcelRequire("aRY8n");
var $lEcJc = parcelRequire("lEcJc");
parcelRequire("jghFx");
var $1GX5U = parcelRequire("1GX5U");
parcelRequire("eHC4Z");
var $fzMpf = parcelRequire("fzMpf");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ccc1f30aa8c203e0$var$UNIFORM_DEFINITIONS = {
    accordion: (0, $4JOZV.default),
    agileArticleBodyContent: (0, $gqoQW.default),
    agileHubSidebarNav: (0, $4TmNR.default),
    agileTutorialBodyContent: (0, $c9Fb2.default),
    articleIntroductionContent: (0, $18J8o.default),
    backgroundVideoContainer: (0, $1d9MG.default),
    bannerAlert: (0, $jgyhc.default),
    blockContainer: (0, $8MWwK.default),
    bodyContent: (0, $8hbU0.default),
    button: (0, $6SooZ.default),
    card: (0, $k1kqo.default),
    collectionPricingHero: (0, $jswU3.default),
    columnLayout: (0, $82Z9J.UniformColumnLayout),
    confluenceAnimatedHero: (0, $9eDC1.default),
    connector: (0, $hStuA.default),
    contentBlock: (0, $5nbaa.default),
    ctaWithPolygonBackground: (0, $4h1q1.default),
    customerBodyContent: (0, $aghrj.default),
    customerStat: (0, $cDjwJ.default),
    customerStoriesDetailsHero: (0, $gl1tq.default),
    customerTestimonials: (0, $hvVOW.default),
    enhancedBanner: (0, $jK7xK.default),
    downloadRow: (0, $2540f.default),
    downloadTable: (0, $j6nXt.default),
    expand: (0, $856b3.default),
    featuresHighlight: (0, $g0xMT.default),
    globalFooter: (0, $3E3Vm.default),
    globalNav: (0, $7d42O.default),
    heading: (0, $f7IMH.default),
    heroCarouselSection: (0, $jGtmE.default),
    heroSection: (0, $2XwEb.default),
    horizontalDivider: (0, $2oS3p.default),
    image: (0, $6JkkA.default),
    imageV2: (0, $1ij5s.default),
    integration: (0, $3jkl6.default),
    invisibleContent: (0, $bkhKq.default),
    productCardBlock: (0, $4oasi.default),
    roadmapFeatures: (0, $exkom.default),
    rovoChatContainer: (0, $2Oxuw.default),
    rovoChatBox: (0, $6smfw.default),
    rovoChatHeader: (0, $4Aw5W.default),
    scrollableHeroCards: (0, $v15B3.default),
    jiraTemplatesTabContentSubgridLayout: (0, $6jbRM.default),
    link: (0, $ks0ka.default),
    list: (0, $71BPb.default),
    listv2: (0, $bmNwd.default),
    logos: (0, $5c1uT.default),
    lozenge: (0, $f8O2Y.default),
    mobileApp: (0, $iSxa6.default),
    modal: (0, $lATol.default),
    page: (0, $3E1lH.default),
    pagination: (0, $7xYdG.default),
    panel: (0, $gebIf.default),
    personalizationContainer: (0, $9tius.default),
    pricingCalculator: (0, $aT8t4.default),
    pricingTable: (0, $eNJPT.default),
    productCard: (0, $6OBcA.default),
    rovoHero: (0, $4LrCk.default),
    sideNav: (0, $71GXn.default),
    sideNavCollection: (0, $3DCiB.default),
    sideNavLink: (0, $acEyk.default),
    signUpForm: (0, $ies6q.default),
    subProduct: (0, $j4sH0.default),
    templateCta: (0, $kb0v3.default),
    pullQuote: (0, $5h2w8.default),
    singleTab: (0, $dXwUh.default),
    splitBackgroundContainer: (0, $kfc2o.default),
    statsSection: (0, $JXKd7.default),
    statsigExperimentContainer: (0, $2bofd.default),
    statsigFeatureGateContainer: (0, $3VYCw.default),
    subColumnLayout: (0, $82Z9J.UniformSubColumnLayout),
    tabs12Col: (0, $evFps.default),
    tabs8Col: (0, $eWY7v.default),
    templateModalButton: (0, $gP8Hr.default),
    templatePreview: (0, $cwpkM.default),
    text: (0, $11uBo.default),
    textWithIcon: (0, $hnLdc.default),
    topicIntroductionContent: (0, $4iHqa.default),
    tutorialIntroductionContent: (0, $74AbP.default),
    variant: (0, $3QKwy.default),
    variantContainer: (0, $lEcJc.default),
    video: (0, $1GX5U.default),
    videoCarousel: (0, $fzMpf.default)
};
var $ccc1f30aa8c203e0$export$2e2bcd8739ae039 = $ccc1f30aa8c203e0$var$UNIFORM_DEFINITIONS;

});
parcelRegister("dGB94", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("4JOZV")).default; });

var $4JOZV = parcelRequire("4JOZV");

});
parcelRegister("4JOZV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a332e2a761197bf6$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $dZNgt = parcelRequire("dZNgt");

var $6cu9L = parcelRequire("6cu9L");

var $lTkkF = parcelRequire("lTkkF");
const $a332e2a761197bf6$var$UniformAccordion = (props)=>{
    const { id: id, header: header, textBody: textBody, richText: richText } = props;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $6cu9L.Accordion), {
        id: id,
        header: header,
        content: richText ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            text: richText
        }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : textBody
    });
};
var $a332e2a761197bf6$export$2e2bcd8739ae039 = $a332e2a761197bf6$var$UniformAccordion;

});
parcelRegister("dZNgt", function(module, exports) {
$parcel$export(module.exports, "isRichTextValueConsideredEmpty", function () { return $a3072fd4d6f8ea7f$export$3113f85f4f2c043b; });
$parcel$export(module.exports, "getRichTextTagsFromTextFormat", function () { return $a3072fd4d6f8ea7f$export$5a89a4161bd9ebd2; });
$parcel$export(module.exports, "walkRichTextTree", function () { return $a3072fd4d6f8ea7f$export$5a4dbd7b3859d56e; });
// src/elements.ts

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");
var $a3072fd4d6f8ea7f$var$rendererTypeTagMap = /* @__PURE__ */ new Map([
    [
        "linebreak",
        [
            "br"
        ]
    ],
    [
        "quote",
        [
            "blockquote"
        ]
    ],
    [
        "code",
        [
            "pre",
            "code"
        ]
    ]
]);
function $a3072fd4d6f8ea7f$export$a4ec677d66b3eef3(text) {
    return text.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $a3072fd4d6f8ea7f$export$8553002765ef8155(format) {
    return Boolean(format && [
        "center",
        "end",
        "justify",
        "left",
        "right",
        "start"
    ].includes(format));
}
function $a3072fd4d6f8ea7f$export$2d8458e4858dd6bc(direction) {
    return Boolean(direction && [
        "ltr",
        "rtl"
    ].includes(direction));
}
var $a3072fd4d6f8ea7f$var$voidElements = /* @__PURE__ */ new Set([
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "link",
    "meta",
    "source",
    "track",
    "wbr"
]);
function $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, attributes, children) {
    const attributesString = attributes && attributes.size > 0 ? " " + Array.from(attributes).reduce((result, [key, value])=>[
            ...result,
            `${key}="${value}"`
        ], []).join(" ") : "";
    return $a3072fd4d6f8ea7f$var$voidElements.has(tag) ? `<${tag}${attributesString}>` : `<${tag}${attributesString}>${children != null ? children : ""}</${tag}>`;
}
// src/guards.ts
function $a3072fd4d6f8ea7f$export$70f15e3e004ad6dd(arr) {
    return Array.isArray(arr) && arr.length > 0;
}
function $a3072fd4d6f8ea7f$export$5397ae48e85521ee(node) {
    return !!node && typeof node === "object" && "type" in node;
}
function $a3072fd4d6f8ea7f$export$bce37bf8275274bb(value) {
    return typeof value === "object" && value !== null && "root" in value && $a3072fd4d6f8ea7f$export$5397ae48e85521ee(value.root);
}
function $a3072fd4d6f8ea7f$export$76356ac770fe566f(node, type) {
    return $a3072fd4d6f8ea7f$export$5397ae48e85521ee(node) && node.type === type;
}
function $a3072fd4d6f8ea7f$export$3113f85f4f2c043b(value) {
    if (!value) return true;
    if (value.root.children.length === 0) return true;
    if (value.root.children.length > 1) return false;
    const child = value.root.children[0];
    if (!$a3072fd4d6f8ea7f$export$76356ac770fe566f(child, "paragraph")) return false;
    return child.children === void 0 || child.children.length === 0;
}
function $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(node) {
    return "children" in node && $a3072fd4d6f8ea7f$export$70f15e3e004ad6dd(node.children);
}
// src/nodes/asset.ts
var $a3072fd4d6f8ea7f$export$7b8470edeb266d2d = ({ context: context })=>{
    var _a, _b;
    const node = context.currentNode;
    if (node.__asset === void 0) return "";
    if (node.__asset.type !== "image") return "";
    const imgAttributes = /* @__PURE__ */ new Map();
    imgAttributes.set("src", node.__asset.fields.url.value);
    if ((_a = node.__asset.fields.title) == null ? void 0 : _a.value) imgAttributes.set("alt", node.__asset.fields.title.value);
    const img = $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("img", imgAttributes);
    const figcaption = ((_b = node.__asset.fields.description) == null ? void 0 : _b.value) ? $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("figcaption", null, node.__asset.fields.description.value) : "";
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("figure", null, `${img}${figcaption}`);
};
// src/nodes/heading.ts
var $a3072fd4d6f8ea7f$export$bf6388ba992fa09c = ({ context: context, renderChildren: renderChildren })=>{
    var _a;
    const node = context.currentNode;
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb((_a = node.tag) != null ? _a : "h1", null, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$headingTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/link.ts
var $a3072fd4d6f8ea7f$export$936fe693edb52ead = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    const href = $a3072fd4d6f8ea7f$export$14401f8b485975ea(node.link);
    if (href) attributes.set("href", href);
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("a", attributes, renderChildren(context.currentNode.children));
};
function $a3072fd4d6f8ea7f$export$14401f8b485975ea(link) {
    switch(link == null ? void 0 : link.type){
        case "email":
            return `mailto:${link.path}`;
        case "tel":
            return `tel:${link.path}`;
        case "url":
            return link.path;
        case "projectMapNode":
            return link.path;
    }
}
// src/nodes/list.ts
var $a3072fd4d6f8ea7f$export$7d9d55832c255604 = ({ context: context, renderChildren: renderChildren })=>{
    var _a;
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if (node.start > 1) attributes.set("start", node.start.toString());
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb((_a = node.tag) != null ? _a : "ul", attributes, renderChildren(context.currentNode.children));
};
// src/nodes/listitem.ts
var $a3072fd4d6f8ea7f$export$7db814f6895f686a = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if (Number.isFinite(node.value) && node.value > 0) attributes.set("value", node.value.toString());
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("li", attributes, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$listitemTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    if (!$a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode)) return "";
    const childrenRendered = renderChildren(context.currentNode.children);
    if (childrenRendered.endsWith(" ")) return childrenRendered;
    return `${childrenRendered} `;
};
// src/nodes/paragraph.ts
var $a3072fd4d6f8ea7f$export$8bcf4977d6029c8 = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if ($a3072fd4d6f8ea7f$export$8553002765ef8155(node.format)) attributes.set("style", `text-align: ${node.format};`);
    if ($a3072fd4d6f8ea7f$export$2d8458e4858dd6bc(node.direction)) attributes.set("dir", node.direction);
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("p", attributes, $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : "<br>");
};
var $a3072fd4d6f8ea7f$var$paragraphTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/root.ts
var $a3072fd4d6f8ea7f$export$1a6e4df79d5098f8 = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : "";
};
// src/nodes/table.ts
var $a3072fd4d6f8ea7f$export$29b37b9cb24833f8 = ({ context: context, renderChildren: renderChildren })=>{
    return [
        "table",
        "tbody"
    ].reduceRight((children, tag)=>{
        return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, null, children);
    }, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$tableTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/tablecell.ts
var $a3072fd4d6f8ea7f$export$5bdbd5436df1f109 = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const tag = $a3072fd4d6f8ea7f$export$37fd5c6d3c00d303(node.headerState);
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, null, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$tablecellTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
function $a3072fd4d6f8ea7f$export$37fd5c6d3c00d303(headerState) {
    if (headerState === 0) return "td";
    return "th";
}
// src/nodes/tablerow.ts
var $a3072fd4d6f8ea7f$export$28c41253e2c9901a = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb("tr", null, renderChildren(context.currentNode.children));
};
var $a3072fd4d6f8ea7f$var$tablerowTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/text.ts
var $a3072fd4d6f8ea7f$export$56ed6376d093860 = ({ context: context })=>{
    const node = context.currentNode;
    const tags = $a3072fd4d6f8ea7f$export$5a89a4161bd9ebd2(node.format);
    const pureText = $a3072fd4d6f8ea7f$export$a4ec677d66b3eef3(node.text);
    return tags.length === 0 ? pureText : tags.reduceRight((children, tag)=>{
        return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, null, children);
    }, pureText);
};
var $a3072fd4d6f8ea7f$var$textTextRenderer = ({ context: context })=>{
    const node = context.currentNode;
    return node.text;
};
function $a3072fd4d6f8ea7f$export$5a89a4161bd9ebd2(format) {
    const tags = [];
    if (format & 1) tags.push("strong");
    if (format & 2) tags.push("em");
    if (format & 4) tags.push("s");
    if (format & 8) tags.push("u");
    if (format & 16) tags.push("code");
    if (format & 32) tags.push("sub");
    if (format & 64) tags.push("sup");
    return tags;
}
// src/nodes/tab.ts
var $a3072fd4d6f8ea7f$var$tabHtmlRenderer = ()=>{
    return "	";
};
var $a3072fd4d6f8ea7f$var$tabTextRenderer = ()=>{
    return "	";
};
// src/renderToHtml.ts
var $a3072fd4d6f8ea7f$var$rendererTypeMap = /* @__PURE__ */ new Map([
    [
        "heading",
        $a3072fd4d6f8ea7f$export$bf6388ba992fa09c
    ],
    [
        "link",
        $a3072fd4d6f8ea7f$export$936fe693edb52ead
    ],
    [
        "list",
        $a3072fd4d6f8ea7f$export$7d9d55832c255604
    ],
    [
        "listitem",
        $a3072fd4d6f8ea7f$export$7db814f6895f686a
    ],
    [
        "paragraph",
        $a3072fd4d6f8ea7f$export$8bcf4977d6029c8
    ],
    [
        "root",
        $a3072fd4d6f8ea7f$export$1a6e4df79d5098f8
    ],
    [
        "text",
        $a3072fd4d6f8ea7f$export$56ed6376d093860
    ],
    [
        "tab",
        $a3072fd4d6f8ea7f$var$tabHtmlRenderer
    ],
    [
        "table",
        $a3072fd4d6f8ea7f$export$29b37b9cb24833f8
    ],
    [
        "tablecell",
        $a3072fd4d6f8ea7f$export$5bdbd5436df1f109
    ],
    [
        "tablerow",
        $a3072fd4d6f8ea7f$export$28c41253e2c9901a
    ],
    [
        "asset",
        $a3072fd4d6f8ea7f$export$7b8470edeb266d2d
    ]
]);
var $a3072fd4d6f8ea7f$export$28174e313edd87cd = (context)=>{
    const renderer = $a3072fd4d6f8ea7f$var$rendererTypeMap.get(context.currentNode.type);
    if (renderer) return renderer;
    const tags = $a3072fd4d6f8ea7f$var$rendererTypeTagMap.get(context.currentNode.type);
    if (tags) return ({ renderChildren: renderChildren })=>{
        var _a;
        return (_a = tags.reduceRight((children, tag)=>{
            return $a3072fd4d6f8ea7f$export$1b1ba35a6df515eb(tag, null, children);
        }, $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : void 0)) != null ? _a : "";
    };
    return ()=>`<!-- WARNING: No renderer for type ${context.currentNode.type} -->`;
};
function $a3072fd4d6f8ea7f$var$initializeRenderContext(node, parentContext) {
    let ancestorNodes = [];
    if (parentContext == null ? void 0 : parentContext.ancestorNodes) ancestorNodes = ancestorNodes.concat(parentContext.ancestorNodes);
    if (parentContext == null ? void 0 : parentContext.currentNode) ancestorNodes.unshift(parentContext.currentNode);
    return (0, $dPABA._)((0, $6ogO3._)({}, parentContext != null ? parentContext : {}), {
        currentNode: node,
        ancestorNodes: ancestorNodes
    });
}
function $a3072fd4d6f8ea7f$export$32f1246b4326e182(node, parentContext) {
    var _a;
    if (!$a3072fd4d6f8ea7f$export$5397ae48e85521ee(node)) return "";
    const context = $a3072fd4d6f8ea7f$var$initializeRenderContext(node, parentContext);
    let renderer = (_a = context.resolveRenderer) == null ? void 0 : _a.call(context, context);
    if (typeof renderer === "undefined") renderer = $a3072fd4d6f8ea7f$export$28174e313edd87cd(context);
    else if (renderer === null) return "";
    const renderChildren = (children)=>$a3072fd4d6f8ea7f$export$e4421ac256b62cb6(children, context);
    if (renderer) return renderer({
        context: context,
        renderChildren: renderChildren
    });
    else throw new Error(`There is no renderer for node type: ${context.currentNode.type}`);
}
function $a3072fd4d6f8ea7f$export$e4421ac256b62cb6(children, context) {
    return Array.isArray(children) ? children.map((node)=>$a3072fd4d6f8ea7f$export$32f1246b4326e182(node, context)).join("") : "";
}
// src/nodes/linebreak.ts
var $a3072fd4d6f8ea7f$var$linebreakTextRenderer = ()=>{
    return " ";
};
// src/renderToText.ts
var $a3072fd4d6f8ea7f$var$rendererTypeMap2 = /* @__PURE__ */ new Map([
    [
        "text",
        $a3072fd4d6f8ea7f$var$textTextRenderer
    ],
    [
        "tab",
        $a3072fd4d6f8ea7f$var$tabTextRenderer
    ],
    [
        "linebreak",
        $a3072fd4d6f8ea7f$var$linebreakTextRenderer
    ],
    [
        "paragraph",
        $a3072fd4d6f8ea7f$var$paragraphTextRenderer
    ],
    [
        "listitem",
        $a3072fd4d6f8ea7f$var$listitemTextRenderer
    ],
    [
        "heading",
        $a3072fd4d6f8ea7f$var$headingTextRenderer
    ],
    [
        "table",
        $a3072fd4d6f8ea7f$var$tableTextRenderer
    ],
    [
        "tablecell",
        $a3072fd4d6f8ea7f$var$tablecellTextRenderer
    ],
    [
        "tablerow",
        $a3072fd4d6f8ea7f$var$tablerowTextRenderer
    ]
]);
var $a3072fd4d6f8ea7f$export$dd531e7b53a0cbec = (context)=>{
    const renderer = $a3072fd4d6f8ea7f$var$rendererTypeMap2.get(context.currentNode.type);
    if (renderer) return renderer;
    return ({ context: context2, renderChildren: renderChildren })=>{
        return $a3072fd4d6f8ea7f$export$bd5ff50f0e53d41c(context2.currentNode) ? renderChildren(context2.currentNode.children) : "";
    };
};
function $a3072fd4d6f8ea7f$var$initializeRenderContext2(node, parentContext) {
    let ancestorNodes = [];
    if (parentContext == null ? void 0 : parentContext.ancestorNodes) ancestorNodes = ancestorNodes.concat(parentContext.ancestorNodes);
    if (parentContext == null ? void 0 : parentContext.currentNode) ancestorNodes.unshift(parentContext.currentNode);
    return (0, $dPABA._)((0, $6ogO3._)({}, parentContext != null ? parentContext : {}), {
        currentNode: node,
        ancestorNodes: ancestorNodes
    });
}
function $a3072fd4d6f8ea7f$export$f21c5276b1e9847a(node, parentContext) {
    var _a;
    if (!$a3072fd4d6f8ea7f$export$5397ae48e85521ee(node)) return "";
    const context = $a3072fd4d6f8ea7f$var$initializeRenderContext2(node, parentContext);
    let renderer = (_a = context.resolveRenderer) == null ? void 0 : _a.call(context, context);
    if (typeof renderer === "undefined") renderer = $a3072fd4d6f8ea7f$export$dd531e7b53a0cbec(context);
    else if (renderer === null) return "";
    const renderChildren = (children)=>$a3072fd4d6f8ea7f$export$6ba9468a0a4c5ffc(children, context);
    if (renderer) {
        const rendered = renderer({
            context: context,
            renderChildren: renderChildren
        });
        return context.ancestorNodes.length > 0 ? rendered : rendered.trim();
    } else throw new Error(`There is no renderer for node type: ${context.currentNode.type}`);
}
function $a3072fd4d6f8ea7f$export$6ba9468a0a4c5ffc(children, context) {
    return Array.isArray(children) ? children.map((node)=>$a3072fd4d6f8ea7f$export$f21c5276b1e9847a(node, context)).join("") : "";
}
// src/utils.ts
var $a3072fd4d6f8ea7f$export$5a4dbd7b3859d56e = (node, callback, parent)=>{
    if (!$a3072fd4d6f8ea7f$export$5397ae48e85521ee(node)) return;
    callback(node, parent);
    if (Array.isArray(node.children)) {
        let i = 0;
        while(node.children.length > i){
            $a3072fd4d6f8ea7f$export$5a4dbd7b3859d56e(node.children[i], callback, node);
            i += 1;
        }
    }
};
var $a3072fd4d6f8ea7f$export$4593e5e0513f0a70 = [
    {
        label: "Heading 1",
        type: "h1"
    },
    {
        label: "Heading 2",
        type: "h2"
    },
    {
        label: "Heading 3",
        type: "h3"
    },
    {
        label: "Heading 4",
        type: "h4"
    },
    {
        label: "Heading 5",
        type: "h5"
    },
    {
        label: "Heading 6",
        type: "h6"
    },
    {
        label: "Bullet List",
        type: "unorderedList"
    },
    {
        label: "Ordered List",
        type: "orderedList"
    },
    {
        label: "Link",
        type: "link"
    },
    {
        label: "Blockquote",
        type: "quote"
    },
    {
        label: "Code Block",
        type: "code"
    },
    {
        label: "Table",
        type: "table"
    },
    {
        label: "Asset",
        type: "asset"
    },
    {
        label: "Dynamic Token",
        type: "variable"
    }
];
var $a3072fd4d6f8ea7f$export$1c57de179d11d54c = [
    {
        label: "Bold",
        type: "bold"
    },
    {
        label: "Italic",
        type: "italic"
    },
    {
        label: "Underline",
        type: "underline"
    },
    {
        label: "Strikethrough",
        type: "strikethrough"
    },
    {
        label: "Code",
        type: "code"
    },
    {
        label: "Superscript",
        type: "superscript"
    },
    {
        label: "Subscript",
        type: "subscript"
    }
];
var $a3072fd4d6f8ea7f$export$401e495ff5af005a = (type)=>{
    var _a;
    if (type === "paragraph") return "Normal";
    const element = $a3072fd4d6f8ea7f$export$4593e5e0513f0a70.find((element2)=>element2.type === type);
    return (_a = element == null ? void 0 : element.label) != null ? _a : type;
};
var $a3072fd4d6f8ea7f$export$419f7a872c5c801f = (type)=>{
    var _a;
    const format = $a3072fd4d6f8ea7f$export$1c57de179d11d54c.find((element)=>element.type === type);
    return (_a = format == null ? void 0 : format.label) != null ? _a : type;
};
var $a3072fd4d6f8ea7f$export$ea67c934009c1e06 = {
    root: {
        type: "root",
        version: 1,
        direction: null,
        format: "",
        indent: 0,
        children: [
            {
                type: "paragraph",
                version: 1,
                format: "start",
                indent: 0,
                direction: null,
                children: [],
                textFormat: 0,
                textStyle: ""
            }
        ]
    }
};

});



parcelRegister("gqoQW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $68351194849b003b$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $lc29s = parcelRequire("lc29s");
const $68351194849b003b$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        name: "",
        contentComponents: []
    };
    const { bodyTextContainer: bodyTextContainer } = body;
    var _bodyTextContainer_supportingConceptNameExternal, _bodyTextContainer_contentComponents;
    const formattedBody = {
        name: (_bodyTextContainer_supportingConceptNameExternal = bodyTextContainer === null || bodyTextContainer === void 0 ? void 0 : bodyTextContainer.supportingConceptNameExternal) !== null && _bodyTextContainer_supportingConceptNameExternal !== void 0 ? _bodyTextContainer_supportingConceptNameExternal : "",
        contentComponents: $68351194849b003b$var$formatContentComponent((_bodyTextContainer_contentComponents = bodyTextContainer === null || bodyTextContainer === void 0 ? void 0 : bodyTextContainer.contentComponents) !== null && _bodyTextContainer_contentComponents !== void 0 ? _bodyTextContainer_contentComponents : [])
    };
    return formattedBody;
};
const $68351194849b003b$var$formatContentComponent = (contentComponents)=>{
    if (!contentComponents) return [];
    const formattedContentComponents = contentComponents.map(// eslint-disable-next-line complexity
    (contentComponent)=>{
        var _contentComponent_fields, _contentComponent_fields1, _contentComponent_fields2, _contentComponent_fields3, _contentComponent_fields4, _contentComponent_fields5, _contentComponent_fields6, _contentComponent_fields7, _contentComponent_fields8, _contentComponent_fields9, _contentComponent_fields10, _contentComponent_fields11, _contentComponent_fields12, _contentComponent_fields13, _contentComponent_fields14, _contentComponent_fields15, _contentComponent_fields16, _contentComponent_fields17, _contentComponent_fields18, _contentComponent_fields19, _contentComponent_fields20, _contentComponent_fields21, _contentComponent_fields22, _contentComponent_fields23;
        if (contentComponent.sys.contentType.sys.id === "textComponent") return {
            __typename: "TextComponent",
            name: (_contentComponent_fields = contentComponent.fields) === null || _contentComponent_fields === void 0 ? void 0 : _contentComponent_fields.textComponentNameExternal,
            text: (_contentComponent_fields1 = contentComponent.fields) === null || _contentComponent_fields1 === void 0 ? void 0 : _contentComponent_fields1.text
        };
        else if (contentComponent.sys.contentType.sys.id === "assetComponent") return {
            __typename: "AssetComponent",
            asset: $68351194849b003b$var$formatAsset((_contentComponent_fields2 = contentComponent.fields) === null || _contentComponent_fields2 === void 0 ? void 0 : _contentComponent_fields2.asset),
            caption: (_contentComponent_fields3 = contentComponent.fields) === null || _contentComponent_fields3 === void 0 ? void 0 : _contentComponent_fields3.assetCaption,
            assetRelatedText: (_contentComponent_fields4 = contentComponent.fields) === null || _contentComponent_fields4 === void 0 ? void 0 : _contentComponent_fields4.assetRelatedText
        };
        else if (contentComponent.sys.contentType.sys.id === "proTipComponent") {
            var _contentComponent_fields24, _contentComponent_fields25, _contentComponent_fields26, _contentComponent_fields27, _contentComponent_fields28, _contentComponent_fields29, _contentComponent_fields30;
            let proTipText = "";
            if ((_contentComponent_fields24 = contentComponent.fields) === null || _contentComponent_fields24 === void 0 ? void 0 : _contentComponent_fields24.proTipRichText) proTipText = (_contentComponent_fields25 = contentComponent.fields) === null || _contentComponent_fields25 === void 0 ? void 0 : _contentComponent_fields25.proTipRichText;
            else if ((_contentComponent_fields26 = contentComponent.fields) === null || _contentComponent_fields26 === void 0 ? void 0 : _contentComponent_fields26.proTipText) proTipText = (_contentComponent_fields27 = contentComponent.fields) === null || _contentComponent_fields27 === void 0 ? void 0 : _contentComponent_fields27.proTipText;
            else if ((_contentComponent_fields28 = contentComponent.fields) === null || _contentComponent_fields28 === void 0 ? void 0 : _contentComponent_fields28.proTipTextShort) proTipText = (_contentComponent_fields29 = contentComponent.fields) === null || _contentComponent_fields29 === void 0 ? void 0 : _contentComponent_fields29.proTipTextShort;
            return {
                __typename: "ProTipComponent",
                name: (_contentComponent_fields30 = contentComponent.fields) === null || _contentComponent_fields30 === void 0 ? void 0 : _contentComponent_fields30.proTipNameExternal,
                proTipText: proTipText
            };
        } else if (contentComponent.sys.contentType.sys.id === "embeddedVideoAsset") return {
            __typename: "EmbeddedVideoAsset",
            embeddedVideoAssetName: (_contentComponent_fields5 = contentComponent.fields) === null || _contentComponent_fields5 === void 0 ? void 0 : _contentComponent_fields5.embeddedVideoAssetNameExternal,
            embedded: (_contentComponent_fields6 = contentComponent.fields) === null || _contentComponent_fields6 === void 0 ? void 0 : _contentComponent_fields6.embedded,
            embedAssetOverlay: $68351194849b003b$var$formatAsset((_contentComponent_fields7 = contentComponent.fields) === null || _contentComponent_fields7 === void 0 ? void 0 : _contentComponent_fields7.embedAssetOverlay)
        };
        else if (contentComponent.sys.contentType.sys.id === "twitterComponent") return {
            __typename: "TwitterComponent",
            twitterComponentName: (_contentComponent_fields8 = contentComponent.fields) === null || _contentComponent_fields8 === void 0 ? void 0 : _contentComponent_fields8.twitterComponentExternalName,
            tweetText: (_contentComponent_fields9 = contentComponent.fields) === null || _contentComponent_fields9 === void 0 ? void 0 : _contentComponent_fields9.tweetText,
            twitterUrl: (_contentComponent_fields10 = contentComponent.fields) === null || _contentComponent_fields10 === void 0 ? void 0 : _contentComponent_fields10.twitterUrl
        };
        else if (contentComponent.sys.contentType.sys.id === "callToAction") return {
            __typename: "CallToAction",
            title: (_contentComponent_fields11 = contentComponent.fields) === null || _contentComponent_fields11 === void 0 ? void 0 : _contentComponent_fields11.ctaTitleExternal,
            valueProposition: (_contentComponent_fields12 = contentComponent.fields) === null || _contentComponent_fields12 === void 0 ? void 0 : _contentComponent_fields12.valueProposition,
            ctaText: (_contentComponent_fields13 = contentComponent.fields) === null || _contentComponent_fields13 === void 0 ? void 0 : _contentComponent_fields13.ctaText,
            url: (_contentComponent_fields14 = contentComponent.fields) === null || _contentComponent_fields14 === void 0 ? void 0 : _contentComponent_fields14.ctaUrl,
            asset: $68351194849b003b$var$formatAsset((_contentComponent_fields15 = contentComponent.fields) === null || _contentComponent_fields15 === void 0 ? void 0 : _contentComponent_fields15.ctaAsset),
            product: (_contentComponent_fields16 = contentComponent.fields) === null || _contentComponent_fields16 === void 0 ? void 0 : _contentComponent_fields16.product,
            dataBlueprintModule: (_contentComponent_fields17 = contentComponent.fields) === null || _contentComponent_fields17 === void 0 ? void 0 : _contentComponent_fields17.dataBlueprintModule
        };
        else if (contentComponent.sys.contentType.sys.id === "questionComponent") return {
            __typename: "QuestionComponent",
            questionTitle: (_contentComponent_fields18 = contentComponent.fields) === null || _contentComponent_fields18 === void 0 ? void 0 : _contentComponent_fields18.questionTitleExternal,
            answer: (_contentComponent_fields19 = contentComponent.fields) === null || _contentComponent_fields19 === void 0 ? void 0 : _contentComponent_fields19.answer,
            answerAsset: $68351194849b003b$var$formatAsset((_contentComponent_fields20 = contentComponent.fields) === null || _contentComponent_fields20 === void 0 ? void 0 : _contentComponent_fields20.answerAsset)
        };
        else if (contentComponent.sys.contentType.sys.id === "callOutComponent") return {
            __typename: "CallOutComponent",
            title: (_contentComponent_fields21 = contentComponent.fields) === null || _contentComponent_fields21 === void 0 ? void 0 : _contentComponent_fields21.callOutComponentTitleExternal,
            callOutText: (_contentComponent_fields22 = contentComponent.fields) === null || _contentComponent_fields22 === void 0 ? void 0 : _contentComponent_fields22.callOutText,
            icon: $68351194849b003b$var$formatAsset((_contentComponent_fields23 = contentComponent.fields) === null || _contentComponent_fields23 === void 0 ? void 0 : _contentComponent_fields23.callOutComponentIcon)
        };
        else // Default case for unknown component types
        return (0, $6ogO3._)({
            __typename: "UnknownComponent"
        }, contentComponent);
    });
    // Filter out unknown component types
    return formattedContentComponents.filter((component)=>component.__typename !== "UnknownComponent");
};
// eslint-disable-next-line complexity
const $68351194849b003b$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $68351194849b003b$var$UniformAgileArticleBodyContent = (props)=>{
    const bodyComponent = (0, $gljCV.useMemo)(()=>$68351194849b003b$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $lc29s.AgileArticleBodyContent), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        bodyTextContainer: bodyComponent
    }));
};
var $68351194849b003b$export$2e2bcd8739ae039 = $68351194849b003b$var$UniformAgileArticleBodyContent;

});
parcelRegister("lc29s", function(module, exports) {
$parcel$export(module.exports, "AgileArticleBodyContent", function () { return $84279984a160b445$export$5ccbc19baa270323; });
/* agile-article-body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable react/jsx-key */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $gA8LO = parcelRequire("gA8LO");

var $gtz2R = parcelRequire("gtz2R");

var $2fk4i = parcelRequire("2fk4i");

var $2smMv = parcelRequire("2smMv");

var $B5GRx = parcelRequire("B5GRx");

var $dWJQD = parcelRequire("dWJQD");
function $84279984a160b445$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $gA8LO.documentToHtmlString)(richText);
}
const $84279984a160b445$export$5ccbc19baa270323 = ({ bodyTextContainer: bodyTextContainer })=>{
    var _bodyTextContainer_contentComponents;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        "data-testid": "agile-hub-article-content",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_6rthze3t"
                ]),
                children: bodyTextContainer === null || bodyTextContainer === void 0 ? void 0 : bodyTextContainer.name
            }),
            bodyTextContainer === null || bodyTextContainer === void 0 ? void 0 : (_bodyTextContainer_contentComponents = bodyTextContainer.contentComponents) === null || _bodyTextContainer_contentComponents === void 0 ? void 0 : _bodyTextContainer_contentComponents.map((component)=>{
                var _component_asset, _component_asset1, _component_asset2;
                var _component_name, _component_text, _component_asset_url, _component_asset_description, _component_asset_contentType, _component_embeddedVideoAssetName, _component_name1, _component_name2, _component_proTipText, _component_title, _component_title1, _component_callOutText, _component_questionTitle, _component_questionTitle1, _component_answer;
                if ((0, $dWJQD.isTextComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_rrz6idpf _1cobidpf _7exwv47k _1o6vv47k"
                    ]),
                    children: [
                        (component === null || component === void 0 ? void 0 : component.name) && /*#__PURE__*/ (0, $dypTs.jsx)("h3", {
                            children: component === null || component === void 0 ? void 0 : component.name
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                            name: (_component_name = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name !== void 0 ? _component_name : "",
                            text: $84279984a160b445$var$getRichText((_component_text = component === null || component === void 0 ? void 0 : component.text) !== null && _component_text !== void 0 ? _component_text : "")
                        })
                    ]
                });
                else if ((0, $dWJQD.isAssetComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                            src: (_component_asset_url = component === null || component === void 0 ? void 0 : (_component_asset = component.asset) === null || _component_asset === void 0 ? void 0 : _component_asset.url) !== null && _component_asset_url !== void 0 ? _component_asset_url : "",
                            alt: (_component_asset_description = component === null || component === void 0 ? void 0 : (_component_asset1 = component.asset) === null || _component_asset1 === void 0 ? void 0 : _component_asset1.description) !== null && _component_asset_description !== void 0 ? _component_asset_description : "",
                            contentType: (_component_asset_contentType = component === null || component === void 0 ? void 0 : (_component_asset2 = component.asset) === null || _component_asset2 === void 0 ? void 0 : _component_asset2.contentType) !== null && _component_asset_contentType !== void 0 ? _component_asset_contentType : "",
                            className: (0, $2jatx.default)([
                                "_p12f1osq"
                            ])
                        }),
                        (component === null || component === void 0 ? void 0 : component.caption) && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                "fine-print"
                            ]),
                            children: component === null || component === void 0 ? void 0 : component.caption
                        })
                    ]
                });
                else if ((0, $dWJQD.isEmbedComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $gtz2R.AgileVideo), {
                    embedLink: (component === null || component === void 0 ? void 0 : component.embedded) || "",
                    thumbnail: component === null || component === void 0 ? void 0 : component.embedAssetOverlay,
                    title: (_component_embeddedVideoAssetName = component === null || component === void 0 ? void 0 : component.embeddedVideoAssetName) !== null && _component_embeddedVideoAssetName !== void 0 ? _component_embeddedVideoAssetName : ""
                });
                else if ((0, $dWJQD.isProTipText)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2smMv.Panel), {
                    panelType: "pro-tip",
                    label: (_component_name1 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name1 !== void 0 ? _component_name1 : "",
                    description: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                        name: (_component_name2 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name2 !== void 0 ? _component_name2 : "",
                        text: $84279984a160b445$var$getRichText((_component_proTipText = component === null || component === void 0 ? void 0 : component.proTipText) !== null && _component_proTipText !== void 0 ? _component_proTipText : "")
                    })
                });
                else if ((0, $dWJQD.isCallOutComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2smMv.Panel), {
                    panelType: "highlight",
                    label: (_component_title = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title !== void 0 ? _component_title : "",
                    description: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                        name: (_component_title1 = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title1 !== void 0 ? _component_title1 : "",
                        text: $84279984a160b445$var$getRichText((_component_callOutText = component === null || component === void 0 ? void 0 : component.callOutText) !== null && _component_callOutText !== void 0 ? _component_callOutText : "")
                    })
                });
                else if ((0, $dWJQD.isQuestionComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2smMv.Panel), {
                    panelType: "highlight",
                    label: (_component_questionTitle = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle !== void 0 ? _component_questionTitle : "",
                    description: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                        name: (_component_questionTitle1 = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle1 !== void 0 ? _component_questionTitle1 : "",
                        text: $84279984a160b445$var$getRichText((_component_answer = component === null || component === void 0 ? void 0 : component.answer) !== null && _component_answer !== void 0 ? _component_answer : "")
                    })
                });
                return null;
            })
        ]
    });
};

});


parcelRegister("8LAtF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("4TmNR")).default; });

var $4TmNR = parcelRequire("4TmNR");

});
parcelRegister("4TmNR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $87b6eb0e6c9f57b6$export$2e2bcd8739ae039; });
/* agile-hub-sidebar-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $gljCV = parcelRequire("gljCV");

var $8e22h = parcelRequire("8e22h");

var $46Ma8 = parcelRequire("46Ma8");

var $bxChG = parcelRequire("bxChG");

var $kKKSr = parcelRequire("kKKSr");

var $g3AHF = parcelRequire("g3AHF");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $h5IJb = parcelRequire("h5IJb");
const $87b6eb0e6c9f57b6$var$desktopCss = null;
const $87b6eb0e6c9f57b6$var$tabletMobileCss = null;
const $87b6eb0e6c9f57b6$var$navContainerCss = null;
const $87b6eb0e6c9f57b6$var$listCss = null;
const $87b6eb0e6c9f57b6$var$navHeaderCss = null;
const $87b6eb0e6c9f57b6$var$mobileExpandableButtonCss = null;
const $87b6eb0e6c9f57b6$var$mobileNavContentCss = null;
const $87b6eb0e6c9f57b6$var$mobileNavContentCollapsedCss = null;
const $87b6eb0e6c9f57b6$var$firstLevelNavItemCss = null;
const $87b6eb0e6c9f57b6$var$dividerCss = null;
const $87b6eb0e6c9f57b6$var$topicNameCss = null;
const $87b6eb0e6c9f57b6$var$topicLinkCss = null;
const $87b6eb0e6c9f57b6$var$topicNoNestedCss = null;
const $87b6eb0e6c9f57b6$var$secondLevelLinkCss = null;
const $87b6eb0e6c9f57b6$var$dotContainerCss = null;
const $87b6eb0e6c9f57b6$var$getCurrRoute = ()=>{
    let currRoute = window.location.pathname;
    if (currRoute === "/uniform-preview") {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        var _urlParams_get;
        currRoute = (_urlParams_get = urlParams.get("path")) !== null && _urlParams_get !== void 0 ? _urlParams_get : "";
    }
    return currRoute;
};
const $87b6eb0e6c9f57b6$var$NavList = ()=>{
    const navData = (0, $h5IJb.getAgileHubSidebarNavData)();
    const localizedHref = (0, $kooLp.useLocalizedHref);
    const getExpandedTopic = (route)=>{
        return navData.findIndex((topic)=>"nestedLinks" in topic && topic.nestedLinks.some((link)=>link.url === route));
    };
    const route = $87b6eb0e6c9f57b6$var$getCurrRoute();
    const expandedTopicIndex = getExpandedTopic(route);
    const lastIndex = navData.length - 1;
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_qtt8glyw _1yt4ze3t _18s8ze3t"
        ]),
        children: navData.map((topic, index)=>/*#__PURE__*/ (0, $dypTs.jsx)("li", {
                className: (0, $2jatx.default)([
                    "_1rjcpxbi",
                    index !== lastIndex && "_179ryzqy"
                ]),
                style: {
                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                },
                children: "url" in topic ? /*#__PURE__*/ (0, $dypTs.jsx)("a", {
                    href: localizedHref(topic.url),
                    "aria-current": route === topic.url ? "page" : undefined,
                    className: (0, $2jatx.default)([
                        "_v564h5h4 _30l317la"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                    },
                    children: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _y3gn1e5h",
                            "_bozg1f4h",
                            "h6"
                        ]),
                        children: intl.formatMessage(topic.name)
                    })
                }) : /*#__PURE__*/ (0, $dypTs.jsx)((0, $g3AHF.Expand), {
                    label: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: "h6",
                        children: intl.formatMessage(topic.name)
                    }),
                    isExpanded: index === expandedTopicIndex,
                    children: /*#__PURE__*/ (0, $dypTs.jsx)("ul", {
                        id: `section-${index}`,
                        className: (0, $2jatx.default)([
                            "_qtt8glyw _1yt4ze3t _18s8ze3t"
                        ]),
                        children: topic.nestedLinks.map((link)=>/*#__PURE__*/ (0, $dypTs.jsx)("li", {
                                children: /*#__PURE__*/ (0, $dypTs.jsxs)("a", {
                                    href: localizedHref(link.url),
                                    "aria-current": route === link.url ? "page" : undefined,
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _zulpu2gc _1rjcu2gc _v564h5h4 _30l317la"
                                    ]),
                                    style: {
                                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o"
                                            ]),
                                            children: route === link.url && /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kKKSr))), {
                                                label: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                                            className: (0, $2jatx.default)([
                                                route === link.url && "_k48p1fw0",
                                                "p"
                                            ]),
                                            children: intl.formatMessage(link.name)
                                        })
                                    ]
                                })
                            }, intl.formatMessage(link.name)))
                    })
                })
            }, intl.formatMessage(topic.name)))
    });
};
const $87b6eb0e6c9f57b6$var$MobileExpandableNav = ({ children: children })=>{
    const intl = (0, $8e22h.default)();
    const [isExpanded, setIsExpanded] = (0, $gljCV.useState)(false);
    const [buttonBottom, setButtonBottom] = (0, $gljCV.useState)(0);
    const navRef = (0, $gljCV.useRef)(null);
    const buttonRef = (0, $gljCV.useRef)(null);
    const contentRef = (0, $gljCV.useRef)(null);
    const handleToggle = ()=>{
        setIsExpanded(!isExpanded);
    };
    // Calculate button position for nav positioning
    (0, $gljCV.useEffect)(()=>{
        const updateButtonPosition = ()=>{
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                setButtonBottom(rect.bottom);
            }
        };
        updateButtonPosition();
        window.addEventListener("resize", updateButtonPosition);
        window.addEventListener("scroll", updateButtonPosition);
        return ()=>{
            window.removeEventListener("resize", updateButtonPosition);
            window.removeEventListener("scroll", updateButtonPosition);
        };
    }, []);
    // Prevent body scroll when nav is open
    (0, $gljCV.useEffect)(()=>{
        if (isExpanded) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
        // Cleanup on unmount
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        isExpanded
    ]);
    // Scroll to top when nav expands
    (0, $gljCV.useEffect)(()=>{
        if (isExpanded && contentRef.current) contentRef.current.scrollTop = 0;
    }, [
        isExpanded
    ]);
    // Handle click outside to close nav
    (0, $gljCV.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (isExpanded && navRef.current && !navRef.current.contains(event.target)) setIsExpanded(false);
        };
        if (isExpanded) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        ref: navRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)("button", {
                ref: buttonRef,
                onClick: handleToggle,
                "aria-expanded": isExpanded,
                "aria-controls": "mobile-nav-content",
                className: (0, $2jatx.default)([
                    "_1bsb1osq _bfhk150w _19itglyw _1yt41hnt _1e0c1txw _4cvr1h6o _zulpu2gc _80omtlke _v564mfn2 _irr3u4vp _v736zwfg _chtuzwfg"
                ]),
                style: {
                    "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                    "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                },
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_4t3i1ejb _1bsb1ejb _1e0c1txw _4cvr1h6o _1bah1h6o _1wybf6fq _k48p8n31 _syaz17la"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                        },
                        children: isExpanded ? /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxChG))), {
                            label: ""
                        }) : /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($46Ma8))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: "eyebrow-md",
                        children: intl.formatMessage({
                            id: "agile-hub.sidenav.agile-hub-topics",
                            defaultMessage: "Agile hub topics"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                ref: contentRef,
                id: "mobile-nav-content",
                className: (0, $2jatx.default)([
                    "_bfhkcd5j _1bsb1osq _bozg1wqb _y4ti1wqb _v5641pfq _1reo1wug _18m91wug _v736zwfg _chtuzwfg",
                    isExpanded ? "_kqsw1n9t _152t1um1 _1e02idpf _rjxpidpf _u7coidpf _1bsbauwl _4t3iqi8f _c71lqi8f _tzy4kb7n _1pbyzo7u _1reo15vq _18m915vq _bfhkcd5j _1q51v47k _85i51ejb _bozg1wqb _y4ti1wqb _v736xy5q _chtuxy5q" : "_c71lidpf _tzy4idpf"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_ab93rs": (0, $6ZVlx.default)(buttonBottom, "px")
                },
                children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1reo1wug _18m91wug _85i51ejb"
                    ]),
                    children: children
                })
            })
        ]
    });
};
const $87b6eb0e6c9f57b6$var$UniformAgileHubSidebarNav = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        "aria-label": "Sidebar Navigation",
        className: (0, $2jatx.default)([
            "_19ityzqy _2rkovwyg _1yt4v47k _tnv2150w _tl28idpf _axwiidpf _1hwcidpf _sp8tidpf _13jeglyw _1l9uidpf"
        ]),
        style: {
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "tablet-desktop-nav"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _1yt41dg4",
                            "eyebrow-md"
                        ]),
                        children: intl.formatMessage({
                            id: "agile-hub.sidenav.browse-topics",
                            defaultMessage: "Browse topics"
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_c71l1pse _1reo1wug _18m91wug"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)($87b6eb0e6c9f57b6$var$NavList, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_dm25glyw _kqsw1n9t _1pbykb7n _1bsb1osq",
                    "mobile-nav"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)($87b6eb0e6c9f57b6$var$MobileExpandableNav, {
                    children: /*#__PURE__*/ (0, $dypTs.jsx)($87b6eb0e6c9f57b6$var$NavList, {})
                })
            })
        ]
    });
};
var $87b6eb0e6c9f57b6$export$2e2bcd8739ae039 = $87b6eb0e6c9f57b6$var$UniformAgileHubSidebarNav;

});
parcelRegister("bxChG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e2df2c0b677df1945f42cd8e58b7f64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8670793cd6a627cd$var$_react = $8670793cd6a627cd$var$_interopRequireDefault((parcelRequire("gljCV")));

var $8670793cd6a627cd$var$_baseNew = $8670793cd6a627cd$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $8670793cd6a627cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8670793cd6a627cd$var$MinusIcon = (props)=>/*#__PURE__*/ $8670793cd6a627cd$var$_react.default.createElement($8670793cd6a627cd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$8670793cd6a627cd$var$MinusIcon.displayName = 'MinusIcon';
var $8670793cd6a627cd$var$_default = module.exports.default = $8670793cd6a627cd$var$MinusIcon;

});

parcelRegister("h5IJb", function(module, exports) {
$parcel$export(module.exports, "getAgileHubSidebarNavData", function () { return $5fca14148c4f5cbd$export$8fb0a717eaa8070d; });

var $fnHPc = parcelRequire("fnHPc");
const $5fca14148c4f5cbd$export$8fb0a717eaa8070d = ()=>{
    return [
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.agile-coach",
                defaultMessage: "What is Agile?"
            }),
            url: "/agile"
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.agile-manifesto",
                defaultMessage: "Agile Manifesto"
            }),
            url: "/agile/manifesto"
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.scrum",
                defaultMessage: "Scrum"
            }),
            nestedLinks: [
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/scrum"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.sprints",
                        defaultMessage: "Sprints"
                    }),
                    url: "/agile/scrum/sprints"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.sprint-planning",
                        defaultMessage: "Sprint planning"
                    }),
                    url: "/agile/scrum/sprint-planning"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.ceremonies",
                        defaultMessage: "Ceremonies"
                    }),
                    url: "/agile/scrum/ceremonies"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.backlogs",
                        defaultMessage: "Backlogs"
                    }),
                    url: "/agile/scrum/backlogs"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.sprint-reviews",
                        defaultMessage: "Sprint reviews"
                    }),
                    url: "/agile/scrum/sprint-reviews"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.standups",
                        defaultMessage: "Standups"
                    }),
                    url: "/agile/scrum/standups"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.scrum-master",
                        defaultMessage: "Scrum master"
                    }),
                    url: "/agile/scrum/scrum-master"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.retrospectives",
                        defaultMessage: "Retrospectives"
                    }),
                    url: "/agile/scrum/retrospectives"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.distributed-scrum",
                        defaultMessage: "Distributed scrum"
                    }),
                    url: "/agile/scrum/distributed-scrum"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.roles",
                        defaultMessage: "Roles"
                    }),
                    url: "/agile/scrum/roles"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.scrum-of-scrums",
                        defaultMessage: "Scrum of scrums"
                    }),
                    url: "/agile/scrum/scrum-of-scrums"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.artifacts",
                        defaultMessage: "Agile scrum artifacts"
                    }),
                    url: "/agile/scrum/artifacts"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.scrum-metrics",
                        defaultMessage: "Scrum metrics"
                    }),
                    url: "/agile/scrum/scrum-metrics"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.jira-confluence-scrum",
                        defaultMessage: "Jira Confluence scrum"
                    }),
                    url: "/agile/scrum/jira-confluence-scrum"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.agile-vs-scrum",
                        defaultMessage: "Agile vs Scrum"
                    }),
                    url: "/agile/scrum/agile-vs-scrum"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.backlog-refinement",
                        defaultMessage: "Backlog Refinement Guide"
                    }),
                    url: "/agile/scrum/backlog-refinement"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.scrum.scrum-master-project-manager",
                        defaultMessage: "Scrum master vs. project manager"
                    }),
                    url: "/agile/scrum/scrum-master-project-manager"
                }
            ]
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.kanban",
                defaultMessage: "Kanban"
            }),
            nestedLinks: [
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.kanban-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/kanban"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.kanban.boards",
                        defaultMessage: "Boards"
                    }),
                    url: "/agile/kanban/boards"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.kanban.wip-limits",
                        defaultMessage: "WIP limits"
                    }),
                    url: "/agile/kanban/wip-limits"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.kanban.kanban-vs-scrum",
                        defaultMessage: "Kanban vs Scrum"
                    }),
                    url: "/agile/kanban/kanban-vs-scrum"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.kanban.kanplan",
                        defaultMessage: "Kanplan"
                    }),
                    url: "/agile/kanban/kanplan"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.kanban.cards",
                        defaultMessage: "Kanban cards"
                    }),
                    url: "/agile/kanban/cards"
                }
            ]
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.project-management",
                defaultMessage: "Agile project management"
            }),
            nestedLinks: [
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/project-management"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-management-intro",
                        defaultMessage: "Project management intro"
                    }),
                    url: "/agile/project-management/project-management-intro"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow",
                        defaultMessage: "Workflow"
                    }),
                    url: "/agile/project-management/workflow"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.ai-workflow-automation",
                        defaultMessage: "AI workflow automation"
                    }),
                    url: "/agile/project-management/ai-workflow-automation"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.epics-stories-themes",
                        defaultMessage: "Epics, stories, themes"
                    }),
                    url: "/agile/project-management/epics-stories-themes"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.epics",
                        defaultMessage: "Epics"
                    }),
                    url: "/agile/project-management/epics"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.user-stories",
                        defaultMessage: "User Stories"
                    }),
                    url: "/agile/project-management/user-stories"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.estimation",
                        defaultMessage: "Estimation"
                    }),
                    url: "/agile/project-management/estimation"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.task-management-tools",
                        defaultMessage: "Task management tools"
                    }),
                    url: "/agile/project-management/task-management-tools"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.metrics",
                        defaultMessage: "Metrics"
                    }),
                    url: "/agile/project-management/metrics"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.gantt-chart",
                        defaultMessage: "Gantt chart"
                    }),
                    url: "/agile/project-management/gantt-chart"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.best-free-project-management-software",
                        defaultMessage: "Best free project management software"
                    }),
                    url: "/agile/project-management/free-project-management-software"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.program-management",
                        defaultMessage: "Program management vs. project management"
                    }),
                    url: "/agile/project-management/program-management"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-baseline",
                        defaultMessage: "Project baseline"
                    }),
                    url: "/agile/project-management/project-baseline"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.continuous-improvement",
                        defaultMessage: "Continuous improvement"
                    }),
                    url: "/agile/project-management/continuous-improvement"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.lean-principles",
                        defaultMessage: "Lean principles"
                    }),
                    url: "/agile/project-management/lean-principles"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.3-pillars-scrum",
                        defaultMessage: "3 pillars of Scrum"
                    }),
                    url: "/agile/project-management/3-pillars-scrum"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scrum-board",
                        defaultMessage: "Scrum Board"
                    }),
                    url: "/agile/project-management/scrum-board"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.waterfall-methodology",
                        defaultMessage: "Waterfall Methodology"
                    }),
                    url: "/agile/project-management/waterfall-methodology"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.velocity-scrum",
                        defaultMessage: "Velocity in Scrum"
                    }),
                    url: "/agile/project-management/velocity-scrum"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.definition-of-ready",
                        defaultMessage: "What is Definition of Ready"
                    }),
                    url: "/agile/project-management/definition-of-ready"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.lean-vs-agile",
                        defaultMessage: "Lean vs. agile"
                    }),
                    url: "/agile/project-management/lean-vs-agile"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scrumban",
                        defaultMessage: "Scrumban"
                    }),
                    url: "/agile/project-management/scrumban"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.lean-methodology",
                        defaultMessage: "Lean Methodology"
                    }),
                    url: "/agile/project-management/lean-methodology"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-backlog",
                        defaultMessage: "Sprint backlog"
                    }),
                    url: "/agile/project-management/sprint-backlog"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.burn-up-chart",
                        defaultMessage: "Burn up chart"
                    }),
                    url: "/agile/project-management/burn-up-chart"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.kanban-principles",
                        defaultMessage: "4 kanban principles"
                    }),
                    url: "/agile/project-management/kanban-principles"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.kanban-metrics",
                        defaultMessage: "4 kanban metrics"
                    }),
                    url: "/agile/project-management/kanban-metrics"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.program-vs-project-manager",
                        defaultMessage: "Program vs. Project Manager"
                    }),
                    url: "/agile/project-management/program-vs-project-manager"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.gantt-chart-examples",
                        defaultMessage: "Gantt chart examples"
                    }),
                    url: "/agile/project-management/gantt-chart-examples"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.definition-of-done",
                        defaultMessage: "Definition of done"
                    }),
                    url: "/agile/project-management/definition-of-done"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.backlog-grooming",
                        defaultMessage: "Backlog grooming"
                    }),
                    url: "/agile/project-management/backlog-grooming"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.lean-process-improvement",
                        defaultMessage: "Lean process improvement"
                    }),
                    url: "/agile/project-management/lean-process-improvement"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.backlog-refinement-meeting",
                        defaultMessage: "Backlog refinement meetings"
                    }),
                    url: "/agile/project-management/backlog-refinement-meeting"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scrum-values",
                        defaultMessage: "Scrum values"
                    }),
                    url: "/agile/project-management/scrum-values"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scope-of-work",
                        defaultMessage: "Scope of work"
                    }),
                    url: "/agile/project-management/scope-of-work"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scrum-tools",
                        defaultMessage: "Scrum tools"
                    }),
                    url: "/agile/project-management/scrum-tools"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.tools",
                        defaultMessage: "Tools"
                    }),
                    url: "/agile/project-management/tools"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-automation-software",
                        defaultMessage: "Workflow automation software"
                    }),
                    url: "/agile/project-management/workflow-automation-software"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.templates",
                        defaultMessage: "Templates"
                    }),
                    url: "/agile/project-management/templates"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.task-tracker",
                        defaultMessage: "Task tracker"
                    }),
                    url: "/agile/project-management/task-tracker"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-automation",
                        defaultMessage: "Workflow automation"
                    }),
                    url: "/agile/project-management/workflow-automation"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.status-report",
                        defaultMessage: "Status report"
                    }),
                    url: "/agile/project-management/status-report"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-chart",
                        defaultMessage: "Workflow chart"
                    }),
                    url: "/agile/project-management/workflow-chart"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-roadmap",
                        defaultMessage: "Project roadmap"
                    }),
                    url: "/agile/project-management/project-roadmap"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-schedule",
                        defaultMessage: "Project schedule"
                    }),
                    url: "/agile/project-management/project-schedule"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.issue-tracking-software",
                        defaultMessage: "Tracking software"
                    }),
                    url: "/agile/project-management/issue-tracking-software"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.roadmap-tools",
                        defaultMessage: "Roadmap tools"
                    }),
                    url: "/agile/project-management/roadmap-tools"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.technology-roadmap",
                        defaultMessage: "Technology roadmap"
                    }),
                    url: "/agile/project-management/technology-roadmap"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-scheduling-software",
                        defaultMessage: "Project scheduling software"
                    }),
                    url: "/agile/project-management/project-scheduling-software"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.backlog-management-tools",
                        defaultMessage: "Backlog management tools"
                    }),
                    url: "/agile/project-management/backlog-management-tools"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-management",
                        defaultMessage: "Understanding workflow management strategies"
                    }),
                    url: "/agile/project-management/workflow-management"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-examples",
                        defaultMessage: "Workflow examples"
                    }),
                    url: "/agile/project-management/workflow-examples"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.create-project-roadmap",
                        defaultMessage: "Create project roadmap"
                    }),
                    url: "/agile/project-management/create-project-roadmap"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-planning-tools",
                        defaultMessage: "Sprint planning tools"
                    }),
                    url: "/agile/project-management/sprint-planning-tools"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-demo",
                        defaultMessage: "Sprint demo"
                    }),
                    url: "/agile/project-management/sprint-demo"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-timeline-software",
                        defaultMessage: "Project Timeline Software"
                    }),
                    url: "/agile/project-management/project-timeline-software"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.task-management-tools",
                        defaultMessage: "Top task management tools"
                    }),
                    url: "/agile/project-management/task-management-tools"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-backlog-product-backlog",
                        defaultMessage: "Product backlog vs. sprint backlog"
                    }),
                    url: "/agile/project-management/sprint-backlog-product-backlog"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-management-tools",
                        defaultMessage: "Top workflow management tools"
                    }),
                    url: "/agile/project-management/workflow-management-tools"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-management-dependencies",
                        defaultMessage: "Project dependencies"
                    }),
                    url: "/agile/project-management/project-management-dependencies"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.task-management-dashboard",
                        defaultMessage: "Task dashboard guide"
                    }),
                    url: "/agile/project-management/task-management-dashboard"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-cadence",
                        defaultMessage: "Sprint cadence"
                    }),
                    url: "/agile/project-management/sprint-cadence"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.fast-tracking",
                        defaultMessage: "Fast tracking"
                    }),
                    url: "/agile/project-management/fast-tracking"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.fibonacci-story-points",
                        defaultMessage: "Fibonacci story points"
                    }),
                    url: "/agile/project-management/fibonacci-story-points"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.product-vs-project-management",
                        defaultMessage: "Product vs. Project Management"
                    }),
                    url: "/agile/project-management/product-vs-project-management"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.deadline-management",
                        defaultMessage: "Deadline management"
                    }),
                    url: "/agile/project-management/deadline-management"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.skills",
                        defaultMessage: "10 must-have skills"
                    }),
                    url: "/agile/project-management/skills"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workload-management",
                        defaultMessage: "Workload management"
                    }),
                    url: "/agile/project-management/workload-management"
                }
            ]
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.product-management",
                defaultMessage: "Product Management"
            }),
            nestedLinks: [
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/product-management"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-roadmaps",
                        defaultMessage: "Product Roadmaps"
                    }),
                    url: "/agile/product-management/product-roadmaps"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-manager",
                        defaultMessage: "Product Manager"
                    }),
                    url: "/agile/product-management/product-manager"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.tips-for-new-product-manager",
                        defaultMessage: "Tips for new product managers"
                    }),
                    url: "/agile/product-management/tips-for-new-product-manager"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.roadmaps",
                        defaultMessage: "Roadmaps"
                    }),
                    url: "/agile/product-management/roadmaps"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.tips-for-presenting-product-roadmaps",
                        defaultMessage: "Tips for presenting product roadmaps"
                    }),
                    url: "/agile/product-management/tips-for-presenting-product-roadmaps"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.requirements",
                        defaultMessage: "Requirements"
                    }),
                    url: "/agile/product-management/requirements"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-analytics",
                        defaultMessage: "Product analytics"
                    }),
                    url: "/agile/product-management/product-analytics"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-development",
                        defaultMessage: "Product development"
                    }),
                    url: "/agile/product-management/product-development"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.remote-product-management",
                        defaultMessage: "Remote product management"
                    }),
                    url: "/agile/product-management/remote-product-management"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.minimum-viable-product",
                        defaultMessage: "Minimal viable product"
                    }),
                    url: "/agile/product-management/minimum-viable-product"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.discovery",
                        defaultMessage: "Product discovery"
                    }),
                    url: "/agile/product-management/discovery"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-specification",
                        defaultMessage: "Product specification"
                    }),
                    url: "/agile/product-management/product-specification"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-development-strategy",
                        defaultMessage: "Product development strategy"
                    }),
                    url: "/agile/product-management/product-development-strategy"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-development-software",
                        defaultMessage: "Product development software"
                    }),
                    url: "/agile/product-management/product-development-software"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.new-product-development-process",
                        defaultMessage: "New product development process"
                    }),
                    url: "/agile/product-management/new-product-development-process"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-management-kpis",
                        defaultMessage: "Product management KPIs"
                    }),
                    url: "/agile/product-management/product-management-kpis"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.nps-score",
                        defaultMessage: "Net Promoter Score (NPS)"
                    }),
                    url: "/agile/product-management/nps-score"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-critique",
                        defaultMessage: "Product critique"
                    }),
                    url: "/agile/product-management/product-critique"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.prioritization-framework",
                        defaultMessage: "Prioritization frameworks"
                    }),
                    url: "/agile/product-management/prioritization-framework"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-features",
                        defaultMessage: "Product features"
                    }),
                    url: "/agile/product-management/product-features"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-management-tools",
                        defaultMessage: "Product management tools"
                    }),
                    url: "/agile/product-management/product-management-tools"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.plm",
                        defaultMessage: "Product Lifecycle Management"
                    }),
                    url: "/agile/product-management/plm"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.roadmap-software",
                        defaultMessage: "9 best roadmap software for teams"
                    }),
                    url: "/agile/product-management/roadmap-software"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-launch-checklist",
                        defaultMessage: "Product launch checklist"
                    }),
                    url: "/agile/product-management/product-launch-checklist"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-strategy",
                        defaultMessage: "Product strategy"
                    }),
                    url: "/agile/product-management/product-strategy"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-engineering",
                        defaultMessage: "Product engineering"
                    }),
                    url: "/agile/product-management/product-engineering"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-operations",
                        defaultMessage: "Product operations"
                    }),
                    url: "/agile/product-management/product-operations"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.portfolio-management",
                        defaultMessage: "Portfolio management"
                    }),
                    url: "/agile/product-management/portfolio-management"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.pm-and-ai",
                        defaultMessage: "AI and product management"
                    }),
                    url: "/agile/product-management/pm-and-ai"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.growth-product-management",
                        defaultMessage: "Growth product management"
                    }),
                    url: "/agile/product-management/growth-product-management"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-metrics",
                        defaultMessage: "Product metrics"
                    }),
                    url: "/agile/product-management/product-metrics"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-release",
                        defaultMessage: "Product release"
                    }),
                    url: "/agile/product-management/product-release"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.feature-request",
                        defaultMessage: "Feature request"
                    }),
                    url: "/agile/product-management/feature-request"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-launch",
                        defaultMessage: "Product launch"
                    }),
                    url: "/agile/product-management/product-launch"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-planning",
                        defaultMessage: "Product planning"
                    }),
                    url: "/agile/product-management/product-planning"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-launch-event",
                        defaultMessage: "Product launch event"
                    }),
                    url: "/agile/product-management/product-launch-event"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-operating-model",
                        defaultMessage: "Product operating model"
                    }),
                    url: "/agile/product-management/product-operating-model"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-design",
                        defaultMessage: "Product design"
                    }),
                    url: "/agile/product-management/product-design"
                }
            ]
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.value-stream-management",
                defaultMessage: "Value Stream Management"
            }),
            url: "/agile/value-stream-management"
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.advantage",
                defaultMessage: "The agile advantage"
            }),
            nestedLinks: [
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.advantage-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/advantage"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.advantage.connect-business-strategy-to-development-reality",
                        defaultMessage: "Connecting business strategy to development reality"
                    }),
                    url: "/agile/advantage/connect-business-strategy-to-development-reality"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.advantage.agile-is-a-competitive-advantage",
                        defaultMessage: "Agile is a competitive advantage"
                    }),
                    url: "/agile/advantage/agile-is-a-competitive-advantage"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.advantage.agile-mindset",
                        defaultMessage: "Cultivating an agile mindset"
                    }),
                    url: "/agile/advantage/agile-mindset"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.advantage.going-agile",
                        defaultMessage: "Going agile"
                    }),
                    url: "/agile/advantage/going-agile"
                }
            ]
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.agile-at-scale",
                defaultMessage: "Agile at scale"
            }),
            nestedLinks: [
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/agile-at-scale"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.managing-an-agile-portfolio",
                        defaultMessage: "Managing an agile portfolio"
                    }),
                    url: "/agile/agile-at-scale/managing-an-agile-portfolio"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.lean-portfolio-management",
                        defaultMessage: "Lean portfolio management"
                    }),
                    url: "/agile/agile-at-scale/lean-portfolio-management"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.okr",
                        defaultMessage: "Okrs"
                    }),
                    url: "/agile/agile-at-scale/okr"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.long-term-agile-planning",
                        defaultMessage: "Long-term agile planning"
                    }),
                    url: "/agile/agile-at-scale/long-term-agile-planning"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.what-is-safe",
                        defaultMessage: "What is SAFe?"
                    }),
                    url: "/agile/agile-at-scale/what-is-safe"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.spotify",
                        defaultMessage: "Spotify model"
                    }),
                    url: "/agile/agile-at-scale/spotify"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.scrum-at-scale",
                        defaultMessage: "Organizational agility with Scrum@Scale"
                    }),
                    url: "/agile/agile-at-scale/scrum-at-scale"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.agile-iron-triangle",
                        defaultMessage: "Agile iron triangle"
                    }),
                    url: "/agile/agile-at-scale/agile-iron-triangle"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.less",
                        defaultMessage: "The Large-Scale Scrum (LeSS) framework"
                    }),
                    url: "/agile/agile-at-scale/less"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.using-improvement-kata-to-support-lean",
                        defaultMessage: "Using Improvement Kata to support lean"
                    }),
                    url: "/agile/agile-at-scale/using-improvement-kata-to-support-lean"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.beyond-the-basics-whitepaper",
                        defaultMessage: "Beyond the basics whitepaper"
                    }),
                    url: "/agile/agile-at-scale/beyond-the-basics-whitepaper"
                }
            ]
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.software-development",
                defaultMessage: "Software development"
            }),
            nestedLinks: [
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/software-development"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.developer",
                        defaultMessage: "Developer"
                    }),
                    url: "/agile/software-development/developer"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.dev-managers-vs-scrum-masters",
                        defaultMessage: "Dev managers vs scrum masters"
                    }),
                    url: "/agile/software-development/dev-managers-vs-scrum-masters"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.git",
                        defaultMessage: "Git"
                    }),
                    url: "/agile/software-development/git"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.branching",
                        defaultMessage: "Branching"
                    }),
                    url: "/agile/software-development/branching"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.git-branching-video",
                        defaultMessage: "Git branching video"
                    }),
                    url: "/agile/software-development/git-branching-video"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.code-reviews",
                        defaultMessage: "Code reviews"
                    }),
                    url: "/agile/software-development/code-reviews"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.release",
                        defaultMessage: "Release"
                    }),
                    url: "/agile/software-development/release"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.technical-debt",
                        defaultMessage: "Technical debt"
                    }),
                    url: "/agile/software-development/technical-debt"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.testing",
                        defaultMessage: "Testing"
                    }),
                    url: "/agile/software-development/testing"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.incident-response",
                        defaultMessage: "Incident response"
                    }),
                    url: "/agile/software-development/incident-response"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.continuous-integration",
                        defaultMessage: "Continuous integration"
                    }),
                    url: "/agile/software-development/continuous-integration"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.sdlc",
                        defaultMessage: "Sdlc"
                    }),
                    url: "/agile/software-development/sdlc"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.bug-triage",
                        defaultMessage: "Bug triage: definition, examples, and best practices"
                    }),
                    url: "/agile/software-development/bug-triage"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.software-development.software-deployment",
                        defaultMessage: "Software deployment"
                    }),
                    url: "/agile/software-development/software-deployment"
                }
            ]
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.design",
                defaultMessage: "Design"
            }),
            nestedLinks: [
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.design-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/design"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-design",
                        defaultMessage: "Agile design"
                    }),
                    url: "/agile/design/design-process"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.design.product-design-process-customer-interview",
                        defaultMessage: "Product design process customer interview"
                    }),
                    url: "/agile/design/product-design-process-customer-interview"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.design.collaborative-design-in-agile-teams-video",
                        defaultMessage: "Collaborative design in agile teams video"
                    }),
                    url: "/agile/design/collaborative-design-in-agile-teams-video"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.design.creative-operations",
                        defaultMessage: "Creative operations"
                    }),
                    url: "/agile/design/creative-operations"
                }
            ]
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.agile-marketing",
                defaultMessage: "Agile marketing"
            }),
            nestedLinks: [
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/agile-marketing"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing.what-is-agile-marketing",
                        defaultMessage: "What is Agile Marketing?"
                    }),
                    url: "/agile/agile-marketing/what-is-agile-marketing"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing.what-is-a-marketing-project-manager",
                        defaultMessage: "What is a marketing project manager?"
                    }),
                    url: "/agile/agile-marketing/marketing-project-manager"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing.agile-marketing-team",
                        defaultMessage: "How to create an agile marketing team"
                    }),
                    url: "/agile/agile-marketing/agile-marketing-team"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing.ai-marketing-automation",
                        defaultMessage: "AI marketing automation"
                    }),
                    url: "/agile/agile-marketing/ai-marketing-automation"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing.marketing-operations",
                        defaultMessage: "Marketing operations"
                    }),
                    url: "/agile/agile-marketing/marketing-operations"
                }
            ]
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.devops",
                defaultMessage: "DevOps"
            }),
            url: "/agile/devops"
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.teams",
                defaultMessage: "Agile Teams"
            }),
            nestedLinks: [
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.teams-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/teams"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.teams.remote-teams",
                        defaultMessage: "Remote teams"
                    }),
                    url: "/agile/teams/remote-teams"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.teams.working-with-specialists",
                        defaultMessage: "Working with specialists"
                    }),
                    url: "/agile/teams/working-with-specialists"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.teams.release-ready-teams",
                        defaultMessage: "Release ready teams"
                    }),
                    url: "/agile/teams/release-ready-teams"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.teams.agilents-agile-transformation-journey",
                        defaultMessage: "Agilent's agile transformation journey"
                    }),
                    url: "/agile/teams/agilents-agile-transformation-journey"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.teams.advanced-roadmaps-teams",
                        defaultMessage: "Advanced Roadmaps"
                    }),
                    url: "/agile/teams/advanced-roadmaps-teams"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.teams.jira-twitter-unified-projects-teamwork",
                        defaultMessage: "How Twitter uses Jira"
                    }),
                    url: "/agile/teams/jira-twitter-unified-projects-teamwork"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.teams.scrum-kanban-agile",
                        defaultMessage: "How we chose our agile"
                    }),
                    url: "/agile/teams/scrum-kanban-agile"
                }
            ]
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.tutorials",
                defaultMessage: "Agile tutorials"
            }),
            nestedLinks: [
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/tutorials"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.jira-confluence-sprint-refinement",
                        defaultMessage: "Jira and Confluence sprint refinement"
                    }),
                    url: "/agile/tutorials/jira-confluence-sprint-refinement"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-do-scrum-with-jira-software",
                        defaultMessage: "How to do scrum with Jira"
                    }),
                    url: "/agile/tutorials/how-to-do-scrum-with-jira"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-do-kanban-with-jira-software",
                        defaultMessage: "Learn kanban with Jira"
                    }),
                    url: "/agile/tutorials/how-to-do-kanban-with-jira"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.epics",
                        defaultMessage: "Learn how to use Epics in Jira"
                    }),
                    url: "/agile/tutorials/epics"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.creating-your-agile-board",
                        defaultMessage: "Learn how to create an agile board in Jira"
                    }),
                    url: "/agile/tutorials/creating-your-agile-board"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.sprints",
                        defaultMessage: "Learn how to use sprints in Jira"
                    }),
                    url: "/agile/tutorials/sprints"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.versions",
                        defaultMessage: "Learn Versions with Jira"
                    }),
                    url: "/agile/tutorials/versions"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.issues",
                        defaultMessage: "Learn Issues with Jira"
                    }),
                    url: "/agile/tutorials/issues"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.burndown-charts",
                        defaultMessage: "Learn burndown charts with Jira"
                    }),
                    url: "/agile/tutorials/burndown-charts"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-auto-create-subtasks-with-jira-software-automation",
                        defaultMessage: "Auto-create sub-tasks and update fields in Jira"
                    }),
                    url: "/agile/tutorials/how-to-auto-create-subtasks-with-jira-automation"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-automatically-assign-issues-with-jira-software-automation",
                        defaultMessage: "How to automatically assign issues with Jira Automation"
                    }),
                    url: "/agile/tutorials/how-to-automatically-assign-issues-with-jira-software-automation"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-sync-epics-stories-with-jira-software-automation",
                        defaultMessage: "How to sync epics stories with Jira Automation"
                    }),
                    url: "/agile/tutorials/how-to-sync-epics-stories-with-jira-software-automation"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-escalate-overdue-issues-with-jira-software-automation",
                        defaultMessage: "Automatically escalate overdue issues in Jira"
                    }),
                    url: "/agile/tutorials/how-to-escalate-overdue-issues-with-jira-software-automation"
                }
            ]
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.agile-conversations",
                defaultMessage: "Agile conversations"
            }),
            nestedLinks: [
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-conversations-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/agile-conversations"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-conversations.marketing-agility",
                        defaultMessage: "Unlocking marketing agility"
                    }),
                    url: "/agile/agile-conversations/marketing-agility"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-conversations.customer-research-tips",
                        defaultMessage: "The power of agile and customer insights"
                    }),
                    url: "/agile/agile-conversations/customer-research-tips"
                },
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.agile-conversations.think-big-work-small",
                        defaultMessage: "Think big, work small"
                    }),
                    url: "/agile/agile-conversations/think-big-work-small"
                }
            ]
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.about",
                defaultMessage: "About the Agile Coach"
            }),
            nestedLinks: [
                {
                    name: (0, $fnHPc.defineMessage)({
                        id: "agile-hub.sidenav.about-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/about"
                }
            ]
        },
        {
            name: (0, $fnHPc.defineMessage)({
                id: "agile-hub.sidenav.all-articles",
                defaultMessage: "All articles"
            }),
            url: "/agile/articles"
        }
    ];
};

});



parcelRegister("c9Fb2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ff6af174273a016a$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $isviz = parcelRequire("isviz");
const $ff6af174273a016a$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        tutorialUseStepTitle: null,
        tutorialBodyTextContainer: null
    };
    const { tutorialInstructionSteps: tutorialInstructionSteps } = body;
    var _tutorialInstructionSteps_tutorialUseStepTitleExternal, _formatContentComponent;
    const formattedBody = {
        tutorialUseStepTitle: (_tutorialInstructionSteps_tutorialUseStepTitleExternal = tutorialInstructionSteps === null || tutorialInstructionSteps === void 0 ? void 0 : tutorialInstructionSteps.tutorialUseStepTitleExternal) !== null && _tutorialInstructionSteps_tutorialUseStepTitleExternal !== void 0 ? _tutorialInstructionSteps_tutorialUseStepTitleExternal : null,
        tutorialBodyTextContainer: (_formatContentComponent = $ff6af174273a016a$var$formatContentComponent(tutorialInstructionSteps === null || tutorialInstructionSteps === void 0 ? void 0 : tutorialInstructionSteps.tutorialBodyTextContainer)) !== null && _formatContentComponent !== void 0 ? _formatContentComponent : null
    };
    return formattedBody;
};
const $ff6af174273a016a$var$formatContentComponent = (contentComponents)=>{
    if (!contentComponents) return [];
    const formattedContentComponents = contentComponents.map(// eslint-disable-next-line complexity
    (contentComponent)=>{
        var _contentComponent_fields, _contentComponent_fields1, _contentComponent_fields2, _contentComponent_fields3, _contentComponent_fields4, _contentComponent_fields5, _contentComponent_fields6, _contentComponent_fields7, _contentComponent_fields8, _contentComponent_fields9, _contentComponent_fields10, _contentComponent_fields11, _contentComponent_fields12, _contentComponent_fields13, _contentComponent_fields14, _contentComponent_fields15, _contentComponent_fields16, _contentComponent_fields17, _contentComponent_fields18, _contentComponent_fields19, _contentComponent_fields20, _contentComponent_fields21, _contentComponent_fields22, _contentComponent_fields23;
        if (contentComponent.sys.contentType.sys.id === "textComponent") return {
            __typename: "TextComponent",
            name: (_contentComponent_fields = contentComponent.fields) === null || _contentComponent_fields === void 0 ? void 0 : _contentComponent_fields.textComponentNameExternal,
            text: (_contentComponent_fields1 = contentComponent.fields) === null || _contentComponent_fields1 === void 0 ? void 0 : _contentComponent_fields1.text
        };
        else if (contentComponent.sys.contentType.sys.id === "assetComponent") return {
            __typename: "AssetComponent",
            asset: $ff6af174273a016a$var$formatAsset((_contentComponent_fields2 = contentComponent.fields) === null || _contentComponent_fields2 === void 0 ? void 0 : _contentComponent_fields2.asset),
            caption: (_contentComponent_fields3 = contentComponent.fields) === null || _contentComponent_fields3 === void 0 ? void 0 : _contentComponent_fields3.assetCaption,
            assetRelatedText: (_contentComponent_fields4 = contentComponent.fields) === null || _contentComponent_fields4 === void 0 ? void 0 : _contentComponent_fields4.assetRelatedText
        };
        else if (contentComponent.sys.contentType.sys.id === "proTipComponent") {
            var _contentComponent_fields24, _contentComponent_fields25, _contentComponent_fields26, _contentComponent_fields27, _contentComponent_fields28, _contentComponent_fields29, _contentComponent_fields30;
            let proTipText = "";
            if ((_contentComponent_fields24 = contentComponent.fields) === null || _contentComponent_fields24 === void 0 ? void 0 : _contentComponent_fields24.proTipRichText) proTipText = (_contentComponent_fields25 = contentComponent.fields) === null || _contentComponent_fields25 === void 0 ? void 0 : _contentComponent_fields25.proTipRichText;
            else if ((_contentComponent_fields26 = contentComponent.fields) === null || _contentComponent_fields26 === void 0 ? void 0 : _contentComponent_fields26.proTipText) proTipText = (_contentComponent_fields27 = contentComponent.fields) === null || _contentComponent_fields27 === void 0 ? void 0 : _contentComponent_fields27.proTipText;
            else if ((_contentComponent_fields28 = contentComponent.fields) === null || _contentComponent_fields28 === void 0 ? void 0 : _contentComponent_fields28.proTipTextShort) proTipText = (_contentComponent_fields29 = contentComponent.fields) === null || _contentComponent_fields29 === void 0 ? void 0 : _contentComponent_fields29.proTipTextShort;
            return {
                __typename: "ProTipComponent",
                name: (_contentComponent_fields30 = contentComponent.fields) === null || _contentComponent_fields30 === void 0 ? void 0 : _contentComponent_fields30.proTipNameExternal,
                proTipText: proTipText
            };
        } else if (contentComponent.sys.contentType.sys.id === "embeddedVideoAsset") return {
            __typename: "EmbeddedVideoAsset",
            embeddedVideoAssetName: (_contentComponent_fields5 = contentComponent.fields) === null || _contentComponent_fields5 === void 0 ? void 0 : _contentComponent_fields5.embeddedVideoAssetNameExternal,
            embedded: (_contentComponent_fields6 = contentComponent.fields) === null || _contentComponent_fields6 === void 0 ? void 0 : _contentComponent_fields6.embedded,
            embedAssetOverlay: $ff6af174273a016a$var$formatAsset((_contentComponent_fields7 = contentComponent.fields) === null || _contentComponent_fields7 === void 0 ? void 0 : _contentComponent_fields7.embedAssetOverlay)
        };
        else if (contentComponent.sys.contentType.sys.id === "twitterComponent") return {
            __typename: "TwitterComponent",
            twitterComponentName: (_contentComponent_fields8 = contentComponent.fields) === null || _contentComponent_fields8 === void 0 ? void 0 : _contentComponent_fields8.twitterComponentExternalName,
            tweetText: (_contentComponent_fields9 = contentComponent.fields) === null || _contentComponent_fields9 === void 0 ? void 0 : _contentComponent_fields9.tweetText,
            twitterUrl: (_contentComponent_fields10 = contentComponent.fields) === null || _contentComponent_fields10 === void 0 ? void 0 : _contentComponent_fields10.twitterUrl
        };
        else if (contentComponent.sys.contentType.sys.id === "callToAction") return {
            __typename: "CallToAction",
            title: (_contentComponent_fields11 = contentComponent.fields) === null || _contentComponent_fields11 === void 0 ? void 0 : _contentComponent_fields11.ctaTitleExternal,
            valueProposition: (_contentComponent_fields12 = contentComponent.fields) === null || _contentComponent_fields12 === void 0 ? void 0 : _contentComponent_fields12.valueProposition,
            ctaText: (_contentComponent_fields13 = contentComponent.fields) === null || _contentComponent_fields13 === void 0 ? void 0 : _contentComponent_fields13.ctaText,
            url: (_contentComponent_fields14 = contentComponent.fields) === null || _contentComponent_fields14 === void 0 ? void 0 : _contentComponent_fields14.ctaUrl,
            asset: $ff6af174273a016a$var$formatAsset((_contentComponent_fields15 = contentComponent.fields) === null || _contentComponent_fields15 === void 0 ? void 0 : _contentComponent_fields15.ctaAsset),
            product: (_contentComponent_fields16 = contentComponent.fields) === null || _contentComponent_fields16 === void 0 ? void 0 : _contentComponent_fields16.product,
            dataBlueprintModule: (_contentComponent_fields17 = contentComponent.fields) === null || _contentComponent_fields17 === void 0 ? void 0 : _contentComponent_fields17.dataBlueprintModule
        };
        else if (contentComponent.sys.contentType.sys.id === "questionComponent") return {
            __typename: "QuestionComponent",
            questionTitle: (_contentComponent_fields18 = contentComponent.fields) === null || _contentComponent_fields18 === void 0 ? void 0 : _contentComponent_fields18.questionTitleExternal,
            answer: (_contentComponent_fields19 = contentComponent.fields) === null || _contentComponent_fields19 === void 0 ? void 0 : _contentComponent_fields19.answer,
            answerAsset: $ff6af174273a016a$var$formatAsset((_contentComponent_fields20 = contentComponent.fields) === null || _contentComponent_fields20 === void 0 ? void 0 : _contentComponent_fields20.answerAsset)
        };
        else if (contentComponent.sys.contentType.sys.id === "callOutComponent") return {
            __typename: "CallOutComponent",
            title: (_contentComponent_fields21 = contentComponent.fields) === null || _contentComponent_fields21 === void 0 ? void 0 : _contentComponent_fields21.callOutComponentTitleExternal,
            callOutText: (_contentComponent_fields22 = contentComponent.fields) === null || _contentComponent_fields22 === void 0 ? void 0 : _contentComponent_fields22.callOutText,
            icon: $ff6af174273a016a$var$formatAsset((_contentComponent_fields23 = contentComponent.fields) === null || _contentComponent_fields23 === void 0 ? void 0 : _contentComponent_fields23.callOutComponentIcon)
        };
        else // Default case for unknown component types
        return (0, $6ogO3._)({
            __typename: "UnknownComponent"
        }, contentComponent);
    });
    // Filter out unknown component types
    return formattedContentComponents.filter((component)=>component.__typename !== "UnknownComponent");
};
// eslint-disable-next-line complexity
const $ff6af174273a016a$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $ff6af174273a016a$var$UniformAgileTutorialBodyContent = (props)=>{
    const tutorialInstructionSteps = (0, $gljCV.useMemo)(()=>$ff6af174273a016a$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $isviz.AgileTutorialBodyContent), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tutorialInstructionSteps: tutorialInstructionSteps
    }));
};
var $ff6af174273a016a$export$2e2bcd8739ae039 = $ff6af174273a016a$var$UniformAgileTutorialBodyContent;

});
parcelRegister("isviz", function(module, exports) {
$parcel$export(module.exports, "AgileTutorialBodyContent", function () { return $5431fe47e0026259$export$4b3aacc978c972ad; });
/* agile-tutorial-body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable react/jsx-key */ // @ts-ignore

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
parcelRequire("gljCV");

var $gA8LO = parcelRequire("gA8LO");

var $gtz2R = parcelRequire("gtz2R");

var $2fk4i = parcelRequire("2fk4i");

var $2smMv = parcelRequire("2smMv");

var $B5GRx = parcelRequire("B5GRx");

var $dWJQD = parcelRequire("dWJQD");
function $5431fe47e0026259$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $gA8LO.documentToHtmlString)(richText);
}
const $5431fe47e0026259$export$4b3aacc978c972ad = ({ tutorialInstructionSteps: tutorialInstructionSteps })=>{
    var _tutorialInstructionSteps_tutorialBodyTextContainer;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        "data-testid": "agile-hub-tutorial-content",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_6rthze3t"
                ]),
                children: tutorialInstructionSteps === null || tutorialInstructionSteps === void 0 ? void 0 : tutorialInstructionSteps.tutorialUseStepTitle
            }),
            tutorialInstructionSteps === null || tutorialInstructionSteps === void 0 ? void 0 : (_tutorialInstructionSteps_tutorialBodyTextContainer = tutorialInstructionSteps.tutorialBodyTextContainer) === null || _tutorialInstructionSteps_tutorialBodyTextContainer === void 0 ? void 0 : _tutorialInstructionSteps_tutorialBodyTextContainer.map(// eslint-disable-next-line complexity
            (component)=>{
                var _component_asset, _component_asset1, _component_asset2;
                var _component_name, _component_text, _component_asset_url, _component_asset_description, _component_asset_contentType, _component_embeddedVideoAssetName, _component_name1, _component_name2, _component_proTipText, _component_title, _component_title1, _component_callOutText, _component_questionTitle, _component_questionTitle1, _component_answer;
                if ((0, $dWJQD.isTextComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_rrz6idpf _1cobidpf _7exwv47k _1o6vv47k"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                        name: (_component_name = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name !== void 0 ? _component_name : "",
                        text: $5431fe47e0026259$var$getRichText((_component_text = component === null || component === void 0 ? void 0 : component.text) !== null && _component_text !== void 0 ? _component_text : "")
                    })
                });
                else if ((0, $dWJQD.isAssetComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                            src: (_component_asset_url = component === null || component === void 0 ? void 0 : (_component_asset = component.asset) === null || _component_asset === void 0 ? void 0 : _component_asset.url) !== null && _component_asset_url !== void 0 ? _component_asset_url : "",
                            alt: (_component_asset_description = component === null || component === void 0 ? void 0 : (_component_asset1 = component.asset) === null || _component_asset1 === void 0 ? void 0 : _component_asset1.description) !== null && _component_asset_description !== void 0 ? _component_asset_description : "",
                            contentType: (_component_asset_contentType = component === null || component === void 0 ? void 0 : (_component_asset2 = component.asset) === null || _component_asset2 === void 0 ? void 0 : _component_asset2.contentType) !== null && _component_asset_contentType !== void 0 ? _component_asset_contentType : "",
                            className: (0, $2jatx.default)([
                                "_p12f1osq"
                            ])
                        }),
                        (component === null || component === void 0 ? void 0 : component.caption) && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                "fine-print"
                            ]),
                            children: component === null || component === void 0 ? void 0 : component.caption
                        })
                    ]
                });
                else if ((0, $dWJQD.isEmbedComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $gtz2R.AgileVideo), {
                    embedLink: (component === null || component === void 0 ? void 0 : component.embedded) || "",
                    thumbnail: component === null || component === void 0 ? void 0 : component.embedAssetOverlay,
                    title: (_component_embeddedVideoAssetName = component === null || component === void 0 ? void 0 : component.embeddedVideoAssetName) !== null && _component_embeddedVideoAssetName !== void 0 ? _component_embeddedVideoAssetName : ""
                });
                else if ((0, $dWJQD.isProTipText)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2smMv.Panel), {
                    panelType: "pro-tip",
                    label: (_component_name1 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name1 !== void 0 ? _component_name1 : "",
                    description: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                        name: (_component_name2 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name2 !== void 0 ? _component_name2 : "",
                        text: $5431fe47e0026259$var$getRichText((_component_proTipText = component === null || component === void 0 ? void 0 : component.proTipText) !== null && _component_proTipText !== void 0 ? _component_proTipText : "")
                    })
                });
                else if ((0, $dWJQD.isCallOutComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2smMv.Panel), {
                    panelType: "highlight",
                    label: (_component_title = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title !== void 0 ? _component_title : "",
                    description: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                        name: (_component_title1 = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title1 !== void 0 ? _component_title1 : "",
                        text: $5431fe47e0026259$var$getRichText((_component_callOutText = component === null || component === void 0 ? void 0 : component.callOutText) !== null && _component_callOutText !== void 0 ? _component_callOutText : "")
                    })
                });
                else if ((0, $dWJQD.isQuestionComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2smMv.Panel), {
                    panelType: "highlight",
                    label: (_component_questionTitle = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle !== void 0 ? _component_questionTitle : "",
                    description: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                        name: (_component_questionTitle1 = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle1 !== void 0 ? _component_questionTitle1 : "",
                        text: $5431fe47e0026259$var$getRichText((_component_answer = component === null || component === void 0 ? void 0 : component.answer) !== null && _component_answer !== void 0 ? _component_answer : "")
                    })
                });
                return null;
            })
        ]
    });
};

});


parcelRegister("18J8o", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $60da9e73de0f934a$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $gA8LO = parcelRequire("gA8LO");

var $23WOk = parcelRequire("23WOk");
const $60da9e73de0f934a$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        articleIntroductionName: null,
        articleIntroductionDetails: null,
        articleIntroductionAsset: null,
        embedLink: null,
        componentizedIntroduction: null
    };
    const { articleintroduction: articleintroduction } = body;
    function getRichText(richText) {
        if (typeof richText === "string") return richText;
        return (0, $gA8LO.documentToHtmlString)(richText);
    }
    var _articleintroduction_articleIntroductionTitleExternal, _getRichText, _formatAsset, _articleintroduction_embedLink, _formatContentComponent;
    const formattedBody = {
        articleIntroductionName: (_articleintroduction_articleIntroductionTitleExternal = articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.articleIntroductionTitleExternal) !== null && _articleintroduction_articleIntroductionTitleExternal !== void 0 ? _articleintroduction_articleIntroductionTitleExternal : null,
        articleIntroductionDetails: (_getRichText = getRichText(articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.articleIntroductionDetails)) !== null && _getRichText !== void 0 ? _getRichText : null,
        articleIntroductionAsset: (_formatAsset = $60da9e73de0f934a$var$formatAsset(articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.articleIntroductionAsset)) !== null && _formatAsset !== void 0 ? _formatAsset : null,
        embedLink: (_articleintroduction_embedLink = articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.embedLink) !== null && _articleintroduction_embedLink !== void 0 ? _articleintroduction_embedLink : null,
        componentizedIntroduction: (_formatContentComponent = $60da9e73de0f934a$var$formatContentComponent(articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.componentizedIntroduction)) !== null && _formatContentComponent !== void 0 ? _formatContentComponent : null
    };
    return formattedBody;
};
const $60da9e73de0f934a$var$formatContentComponent = (contentComponents)=>{
    if (!contentComponents) return null;
    const formattedContentComponents = contentComponents.map(// eslint-disable-next-line complexity
    (contentComponent)=>{
        var _contentComponent_fields, _contentComponent_fields1, _contentComponent_fields2, _contentComponent_fields3, _contentComponent_fields4, _contentComponent_fields5, _contentComponent_fields6, _contentComponent_fields7, _contentComponent_fields8, _contentComponent_fields9, _contentComponent_fields10, _contentComponent_fields11, _contentComponent_fields12, _contentComponent_fields13, _contentComponent_fields14, _contentComponent_fields15, _contentComponent_fields16, _contentComponent_fields17, _contentComponent_fields18, _contentComponent_fields19, _contentComponent_fields20, _contentComponent_fields21, _contentComponent_fields22, _contentComponent_fields23;
        if (contentComponent.sys.contentType.sys.id === "textComponent") return {
            __typename: "TextComponent",
            name: (_contentComponent_fields = contentComponent.fields) === null || _contentComponent_fields === void 0 ? void 0 : _contentComponent_fields.textComponentNameExternal,
            text: (_contentComponent_fields1 = contentComponent.fields) === null || _contentComponent_fields1 === void 0 ? void 0 : _contentComponent_fields1.text
        };
        else if (contentComponent.sys.contentType.sys.id === "assetComponent") return {
            __typename: "AssetComponent",
            asset: $60da9e73de0f934a$var$formatAsset((_contentComponent_fields2 = contentComponent.fields) === null || _contentComponent_fields2 === void 0 ? void 0 : _contentComponent_fields2.asset),
            caption: (_contentComponent_fields3 = contentComponent.fields) === null || _contentComponent_fields3 === void 0 ? void 0 : _contentComponent_fields3.assetCaption,
            assetRelatedText: (_contentComponent_fields4 = contentComponent.fields) === null || _contentComponent_fields4 === void 0 ? void 0 : _contentComponent_fields4.assetRelatedText
        };
        else if (contentComponent.sys.contentType.sys.id === "proTipComponent") {
            var _contentComponent_fields24, _contentComponent_fields25, _contentComponent_fields26, _contentComponent_fields27, _contentComponent_fields28, _contentComponent_fields29, _contentComponent_fields30;
            let proTipText = "";
            if ((_contentComponent_fields24 = contentComponent.fields) === null || _contentComponent_fields24 === void 0 ? void 0 : _contentComponent_fields24.proTipRichText) proTipText = (_contentComponent_fields25 = contentComponent.fields) === null || _contentComponent_fields25 === void 0 ? void 0 : _contentComponent_fields25.proTipRichText;
            else if ((_contentComponent_fields26 = contentComponent.fields) === null || _contentComponent_fields26 === void 0 ? void 0 : _contentComponent_fields26.proTipText) proTipText = (_contentComponent_fields27 = contentComponent.fields) === null || _contentComponent_fields27 === void 0 ? void 0 : _contentComponent_fields27.proTipText;
            else if ((_contentComponent_fields28 = contentComponent.fields) === null || _contentComponent_fields28 === void 0 ? void 0 : _contentComponent_fields28.proTipTextShort) proTipText = (_contentComponent_fields29 = contentComponent.fields) === null || _contentComponent_fields29 === void 0 ? void 0 : _contentComponent_fields29.proTipTextShort;
            return {
                __typename: "ProTipComponent",
                name: (_contentComponent_fields30 = contentComponent.fields) === null || _contentComponent_fields30 === void 0 ? void 0 : _contentComponent_fields30.proTipNameExternal,
                proTipText: proTipText
            };
        } else if (contentComponent.sys.contentType.sys.id === "embeddedVideoAsset") return {
            __typename: "EmbeddedVideoAsset",
            embeddedVideoAssetName: (_contentComponent_fields5 = contentComponent.fields) === null || _contentComponent_fields5 === void 0 ? void 0 : _contentComponent_fields5.embeddedVideoAssetNameExternal,
            embedded: (_contentComponent_fields6 = contentComponent.fields) === null || _contentComponent_fields6 === void 0 ? void 0 : _contentComponent_fields6.embedded,
            embedAssetOverlay: $60da9e73de0f934a$var$formatAsset((_contentComponent_fields7 = contentComponent.fields) === null || _contentComponent_fields7 === void 0 ? void 0 : _contentComponent_fields7.embedAssetOverlay)
        };
        else if (contentComponent.sys.contentType.sys.id === "twitterComponent") return {
            __typename: "TwitterComponent",
            twitterComponentName: (_contentComponent_fields8 = contentComponent.fields) === null || _contentComponent_fields8 === void 0 ? void 0 : _contentComponent_fields8.twitterComponentExternalName,
            tweetText: (_contentComponent_fields9 = contentComponent.fields) === null || _contentComponent_fields9 === void 0 ? void 0 : _contentComponent_fields9.tweetText,
            twitterUrl: (_contentComponent_fields10 = contentComponent.fields) === null || _contentComponent_fields10 === void 0 ? void 0 : _contentComponent_fields10.twitterUrl
        };
        else if (contentComponent.sys.contentType.sys.id === "callToAction") return {
            __typename: "CallToAction",
            title: (_contentComponent_fields11 = contentComponent.fields) === null || _contentComponent_fields11 === void 0 ? void 0 : _contentComponent_fields11.ctaTitleExternal,
            valueProposition: (_contentComponent_fields12 = contentComponent.fields) === null || _contentComponent_fields12 === void 0 ? void 0 : _contentComponent_fields12.valueProposition,
            ctaText: (_contentComponent_fields13 = contentComponent.fields) === null || _contentComponent_fields13 === void 0 ? void 0 : _contentComponent_fields13.ctaText,
            url: (_contentComponent_fields14 = contentComponent.fields) === null || _contentComponent_fields14 === void 0 ? void 0 : _contentComponent_fields14.ctaUrl,
            asset: $60da9e73de0f934a$var$formatAsset((_contentComponent_fields15 = contentComponent.fields) === null || _contentComponent_fields15 === void 0 ? void 0 : _contentComponent_fields15.ctaAsset),
            product: (_contentComponent_fields16 = contentComponent.fields) === null || _contentComponent_fields16 === void 0 ? void 0 : _contentComponent_fields16.product,
            dataBlueprintModule: (_contentComponent_fields17 = contentComponent.fields) === null || _contentComponent_fields17 === void 0 ? void 0 : _contentComponent_fields17.dataBlueprintModule
        };
        else if (contentComponent.sys.contentType.sys.id === "questionComponent") return {
            __typename: "QuestionComponent",
            questionTitle: (_contentComponent_fields18 = contentComponent.fields) === null || _contentComponent_fields18 === void 0 ? void 0 : _contentComponent_fields18.questionTitleExternal,
            answer: (_contentComponent_fields19 = contentComponent.fields) === null || _contentComponent_fields19 === void 0 ? void 0 : _contentComponent_fields19.answer,
            answerAsset: $60da9e73de0f934a$var$formatAsset((_contentComponent_fields20 = contentComponent.fields) === null || _contentComponent_fields20 === void 0 ? void 0 : _contentComponent_fields20.answerAsset)
        };
        else if (contentComponent.sys.contentType.sys.id === "callOutComponent") return {
            __typename: "CallOutComponent",
            title: (_contentComponent_fields21 = contentComponent.fields) === null || _contentComponent_fields21 === void 0 ? void 0 : _contentComponent_fields21.callOutComponentTitleExternal,
            callOutText: (_contentComponent_fields22 = contentComponent.fields) === null || _contentComponent_fields22 === void 0 ? void 0 : _contentComponent_fields22.callOutText,
            icon: $60da9e73de0f934a$var$formatAsset((_contentComponent_fields23 = contentComponent.fields) === null || _contentComponent_fields23 === void 0 ? void 0 : _contentComponent_fields23.callOutComponentIcon)
        };
        else // Default case for unknown component types
        return (0, $6ogO3._)({
            __typename: "UnknownComponent"
        }, contentComponent);
    });
    // Filter out unknown component types
    return formattedContentComponents.filter((component)=>component.__typename !== "UnknownComponent");
};
// eslint-disable-next-line complexity
const $60da9e73de0f934a$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $60da9e73de0f934a$var$UniformArticleIntroductionContent = (props)=>{
    const articleIntroduction = (0, $gljCV.useMemo)(()=>$60da9e73de0f934a$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $23WOk.ArticleIntroductionContent), {
        articleIntroduction: articleIntroduction
    });
};
var $60da9e73de0f934a$export$2e2bcd8739ae039 = $60da9e73de0f934a$var$UniformArticleIntroductionContent;

});
parcelRegister("23WOk", function(module, exports) {
$parcel$export(module.exports, "ArticleIntroductionContent", function () { return $9583517d12ffdc14$export$6ccfc3df312e7dbb; });
/* article-introduction-content.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable react/jsx-key */ // @ts-ignore

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
parcelRequire("gljCV");

var $gA8LO = parcelRequire("gA8LO");

var $gtz2R = parcelRequire("gtz2R");

var $2fk4i = parcelRequire("2fk4i");

var $2smMv = parcelRequire("2smMv");

var $B5GRx = parcelRequire("B5GRx");

var $dWJQD = parcelRequire("dWJQD");
function $9583517d12ffdc14$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $gA8LO.documentToHtmlString)(richText);
}
const $9583517d12ffdc14$export$6ccfc3df312e7dbb = ({ articleIntroduction: articleIntroduction })=>{
    var _articleIntroduction_componentizedIntroduction;
    var _articleIntroduction_articleIntroductionName, _articleIntroduction_articleIntroductionDetails, _articleIntroduction_embedLink, _articleIntroduction_articleIntroductionName1;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        "data-testid": "agile-hub-introduction-content",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            (articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionName) && /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_6rthze3t"
                ]),
                children: articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionName
            }),
            (articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionDetails) && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthv47k"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                    name: (_articleIntroduction_articleIntroductionName = articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionName) !== null && _articleIntroduction_articleIntroductionName !== void 0 ? _articleIntroduction_articleIntroductionName : "",
                    text: $9583517d12ffdc14$var$getRichText((_articleIntroduction_articleIntroductionDetails = articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionDetails) !== null && _articleIntroduction_articleIntroductionDetails !== void 0 ? _articleIntroduction_articleIntroductionDetails : "")
                })
            }),
            (articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.embedLink) && /*#__PURE__*/ (0, $dypTs.jsx)((0, $gtz2R.AgileVideo), {
                embedLink: (_articleIntroduction_embedLink = articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.embedLink) !== null && _articleIntroduction_embedLink !== void 0 ? _articleIntroduction_embedLink : "",
                title: (_articleIntroduction_articleIntroductionName1 = articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionName) !== null && _articleIntroduction_articleIntroductionName1 !== void 0 ? _articleIntroduction_articleIntroductionName1 : "",
                thumbnail: articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionAsset
            }),
            articleIntroduction === null || articleIntroduction === void 0 ? void 0 : (_articleIntroduction_componentizedIntroduction = articleIntroduction.componentizedIntroduction) === null || _articleIntroduction_componentizedIntroduction === void 0 ? void 0 : _articleIntroduction_componentizedIntroduction.map(// eslint-disable-next-line complexity
            (component)=>{
                var _component_asset, _component_asset1, _component_asset2;
                var _component_name, _component_text, _component_asset_url, _component_asset_description, _component_asset_contentType, _component_embeddedVideoAssetName, _component_name1, _component_name2, _component_proTipText, _component_title, _component_title1, _component_callOutText, _component_questionTitle, _component_questionTitle1, _component_answer;
                if ((0, $dWJQD.isTextComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_rrz6idpf _1cobidpf _7exwv47k _1o6vv47k"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                        name: (_component_name = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name !== void 0 ? _component_name : "",
                        text: $9583517d12ffdc14$var$getRichText((_component_text = component === null || component === void 0 ? void 0 : component.text) !== null && _component_text !== void 0 ? _component_text : "")
                    })
                });
                else if ((0, $dWJQD.isAssetComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                            src: (_component_asset_url = component === null || component === void 0 ? void 0 : (_component_asset = component.asset) === null || _component_asset === void 0 ? void 0 : _component_asset.url) !== null && _component_asset_url !== void 0 ? _component_asset_url : "",
                            alt: (_component_asset_description = component === null || component === void 0 ? void 0 : (_component_asset1 = component.asset) === null || _component_asset1 === void 0 ? void 0 : _component_asset1.description) !== null && _component_asset_description !== void 0 ? _component_asset_description : "",
                            contentType: (_component_asset_contentType = component === null || component === void 0 ? void 0 : (_component_asset2 = component.asset) === null || _component_asset2 === void 0 ? void 0 : _component_asset2.contentType) !== null && _component_asset_contentType !== void 0 ? _component_asset_contentType : "",
                            className: (0, $2jatx.default)([
                                "_p12f1osq"
                            ])
                        }),
                        (component === null || component === void 0 ? void 0 : component.caption) && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                "fine-print"
                            ]),
                            children: component === null || component === void 0 ? void 0 : component.caption
                        })
                    ]
                });
                else if ((0, $dWJQD.isEmbedComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $gtz2R.AgileVideo), {
                    embedLink: (component === null || component === void 0 ? void 0 : component.embedded) || "",
                    thumbnail: component === null || component === void 0 ? void 0 : component.embedAssetOverlay,
                    title: (_component_embeddedVideoAssetName = component === null || component === void 0 ? void 0 : component.embeddedVideoAssetName) !== null && _component_embeddedVideoAssetName !== void 0 ? _component_embeddedVideoAssetName : ""
                });
                else if ((0, $dWJQD.isProTipText)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2smMv.Panel), {
                    panelType: "pro-tip",
                    label: (_component_name1 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name1 !== void 0 ? _component_name1 : "",
                    description: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                        name: (_component_name2 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name2 !== void 0 ? _component_name2 : "",
                        text: $9583517d12ffdc14$var$getRichText((_component_proTipText = component === null || component === void 0 ? void 0 : component.proTipText) !== null && _component_proTipText !== void 0 ? _component_proTipText : "")
                    })
                });
                else if ((0, $dWJQD.isCallOutComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2smMv.Panel), {
                    panelType: "highlight",
                    label: (_component_title = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title !== void 0 ? _component_title : "",
                    description: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                        name: (_component_title1 = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title1 !== void 0 ? _component_title1 : "",
                        text: $9583517d12ffdc14$var$getRichText((_component_callOutText = component === null || component === void 0 ? void 0 : component.callOutText) !== null && _component_callOutText !== void 0 ? _component_callOutText : "")
                    })
                });
                else if ((0, $dWJQD.isQuestionComponent)(component)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2smMv.Panel), {
                    panelType: "highlight",
                    label: (_component_questionTitle = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle !== void 0 ? _component_questionTitle : "",
                    description: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                        name: (_component_questionTitle1 = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle1 !== void 0 ? _component_questionTitle1 : "",
                        text: $9583517d12ffdc14$var$getRichText((_component_answer = component === null || component === void 0 ? void 0 : component.answer) !== null && _component_answer !== void 0 ? _component_answer : "")
                    })
                });
                return null;
            })
        ]
    });
};

});


parcelRegister("d81Rk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("1d9MG")).default; });

var $1d9MG = parcelRequire("1d9MG");

});
parcelRegister("1d9MG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $44015486d9fa361e$export$2e2bcd8739ae039; });
/* background-video-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $cc8iN = parcelRequire("cc8iN");

var $ahmPu = parcelRequire("ahmPu");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $32ng3 = parcelRequire("32ng3");
const $44015486d9fa361e$var$containerStyles = null;
const $44015486d9fa361e$var$contentStyles = null;
const $44015486d9fa361e$var$svgOverlayStyles = null;
const $44015486d9fa361e$var$backgroundVideoStyles = null;
const $44015486d9fa361e$var$headingStyles = null;
const $44015486d9fa361e$var$descriptionStyles = null;
const $44015486d9fa361e$var$controlButtonStyles = null;
// eslint-disable-next-line complexity
const $44015486d9fa361e$var$UniformBackgroundVideoContainer = (props)=>{
    const containerRef = (0, $gljCV.useRef)(null);
    const [isVisible, setIsVisible] = (0, $gljCV.useState)(false);
    const videoRef = (0, $gljCV.useRef)(null);
    const [isPlaying, setPlaying] = (0, $gljCV.useState)(false);
    const [hasEnded, setHasEnded] = (0, $gljCV.useState)(false);
    const [currentVideoSource, setCurrentVideoSource] = (0, $gljCV.useState)("");
    const [windowWidth, setWindowWidth] = (0, $gljCV.useState)(typeof globalThis.window !== "undefined" ? globalThis.window.innerWidth : 1200);
    const [holeWidth, setHoleWidth] = (0, $gljCV.useState)(1); // Separate width for rectangle
    const [holeHeight, setHoleHeight] = (0, $gljCV.useState)(1); // Separate height for rectangle
    const [holeRadius, setHoleRadius] = (0, $gljCV.useState)(300);
    const [containerDimensions, setContainerDimensions] = (0, $gljCV.useState)({
        width: 0,
        height: 0
    });
    const intl = (0, $8e22h.default)();
    const prefersReducedMotion = typeof globalThis.window !== "undefined" ? globalThis.window.matchMedia("(prefers-reduced-motion: reduce)").matches : false;
    // can turn the feature flag on to disable the overlay if it's glitchy
    const isAnimationOverlayEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7823AnimationOverlayOption);
    const computedWidth = containerDimensions.width || 1200;
    const computedHeight = containerDimensions.height || 700;
    const getVideoSource = (0, $gljCV.useCallback)((width)=>{
        if (width >= 1024) return props.videoSourceDesktop;
        if (width >= 768) return props.videoSourceTablet;
        return props.videoSourceMobile;
    }, [
        props.videoSourceDesktop,
        props.videoSourceTablet,
        props.videoSourceMobile
    ]);
    (0, $gljCV.useEffect)(()=>{
        const handleResize = ()=>{
            if (typeof globalThis.window !== "undefined") setWindowWidth(globalThis.window.innerWidth);
        };
        const updateVideoSource = (newSource)=>{
            if (newSource === currentVideoSource) return;
            setCurrentVideoSource(newSource);
            if (!videoRef.current) return;
            if (isPlaying) {
                const currentTime = videoRef.current.currentTime;
                videoRef.current.src = newSource;
                videoRef.current.load();
                videoRef.current.currentTime = currentTime;
                videoRef.current.play().catch(()=>{
                // Ignore error likely due to autoplay restrictions or browser power saving
                });
            } else {
                videoRef.current.src = newSource;
                videoRef.current.load();
            }
        };
        const initialSource = getVideoSource(windowWidth);
        updateVideoSource(initialSource);
        if (typeof globalThis.window !== "undefined") {
            globalThis.window.addEventListener("resize", handleResize);
            return ()=>globalThis.window.removeEventListener("resize", handleResize);
        }
        return undefined;
    }, [
        windowWidth,
        currentVideoSource,
        isPlaying,
        getVideoSource
    ]);
    const togglePlay = ()=>{
        if (videoRef.current) {
            if (isPlaying) videoRef.current.pause();
            else videoRef.current.play().catch(()=>{
            // Ignore error likely due to autoplay restrictions or browser power saving
            });
        }
    };
    const handleVideoPlay = ()=>{
        setPlaying(true);
        setHasEnded(false);
    };
    const handleVideoPause = ()=>setPlaying(false);
    const handleVideoEnded = ()=>{
        setPlaying(false);
        setHasEnded(true);
    };
    const startHoleAnimation = (0, $gljCV.useCallback)((containerElement)=>{
        const containerWidth = containerElement.offsetWidth;
        const containerHeight = containerElement.offsetHeight;
        setContainerDimensions({
            width: containerWidth,
            height: containerHeight
        });
        setTimeout(()=>{
            const startTime = Date.now();
            const duration = 800;
            const startSize = 1;
            const animationInterval = setInterval(()=>{
                const elapsed = Date.now() - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easedProgress = 1 - Math.pow(1 - progress, 3); // ease-out cubic
                const currentHoleWidth = startSize + (containerWidth - startSize) * easedProgress;
                const currentHoleHeight = startSize + (containerHeight - startSize) * easedProgress;
                const currentRadius = 300 * (1 - Math.min(progress * 1.5, 1));
                setHoleWidth(currentHoleWidth);
                setHoleHeight(currentHoleHeight);
                setHoleRadius(currentRadius);
                if (progress >= 1) clearInterval(animationInterval);
            }, 16);
        }, 800);
    }, []);
    (0, $gljCV.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) {
                setIsVisible(true);
                if (videoRef.current && !prefersReducedMotion) videoRef.current.play().catch(()=>{
                // Ignore error likely due to autoplay restrictions or browser power saving
                });
                if (!prefersReducedMotion && containerRef.current && isAnimationOverlayEnabled) startHoleAnimation(containerRef.current);
                else if (containerRef.current && isAnimationOverlayEnabled) {
                    const containerWidth = containerRef.current.offsetWidth;
                    const containerHeight = containerRef.current.offsetHeight;
                    setContainerDimensions({
                        width: containerWidth,
                        height: containerHeight
                    });
                    setHoleWidth(containerWidth);
                    setHoleHeight(containerHeight);
                    setHoleRadius(0);
                }
            }
        }, {
            threshold: 0.3
        });
        if (containerRef.current) observer.observe(containerRef.current);
        return ()=>observer.disconnect();
    }, [
        prefersReducedMotion,
        startHoleAnimation,
        isAnimationOverlayEnabled
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_bfhkmt5y _kqswh2mm _1reo15vq _18m915vq _4t3i1j7z _1gdlbcwg _1knekdgb"
        ]),
        style: {
            "--video-width-mobile": props.videoWidthMobile ? `${props.videoWidthMobile}px` : "500px",
            "--video-height-mobile": props.videoHeightMobile ? `${props.videoHeightMobile}px` : "700px",
            "--video-width-tablet": props.videoWidthTablet ? `${props.videoWidthTablet}px` : "800px",
            "--video-height-tablet": props.videoHeightTablet ? `${props.videoHeightTablet}px` : "1000px",
            "--video-width-desktop": props.videoWidthDesktop ? `${props.videoWidthDesktop}px` : "1200px",
            "--video-height-desktop": props.videoHeightDesktop ? `${props.videoHeightDesktop}px` : "700px",
            "--_1ex89o1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark0"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("video", {
                ref: videoRef,
                src: currentVideoSource,
                muted: true,
                loop: props.videoLoop || false,
                playsInline: true,
                onPlay: handleVideoPlay,
                onPause: handleVideoPause,
                onEnded: handleVideoEnded,
                className: (0, $2jatx.default)([
                    "_kqswstnw _19pk1wug _2hwx1wug _otyr1wug _18u01wug _152tidpf _u7coidpf _1pbykb7n _1e021l2x _rjxp1l2x _4t3i1j7z _1j7jwqo7 _19tlwqo7 _1gdlbcwg _nqop1vnc _1a5h1vnc _1knekdgb"
                ])
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_tzy4idpf _kqswh2mm _1pbycs5v _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _y3gn1h6o _19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _p12f1osq _4t3i1osq _1bsbbxu3 _w19jrnt7 _v5641v33 _1s4p1erl _14u4kb7n _22qt1amc",
                    isVisible ? "animate-reveal" : ""
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_18s812pl _16cqcd5j",
                            "video-heading"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: props.videoHeading
                    }),
                    props.videoDescription && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_163ycd5j",
                            "video-description"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: props.videoDescription
                    }),
                    props.videoCta && props.videoCtaLink && /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Link), {
                        href: props.videoCtaLink,
                        text: props.videoCta,
                        type: "primary",
                        bgColor: "bgBlackBlue"
                    })
                ]
            }),
            !hasEnded && /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                onClick: togglePlay,
                className: (0, $2jatx.default)([
                    "_80omtlke _tzy41ou4 _bfhk1j28 _syazcd5j _19it1axk _2rko17td _4t3i1ul9 _1bsb1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1pbyegat _rjxppxbi _u7copxbi _16l4kb7n _w8l5dlk8"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_514je1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.pill"))
                },
                children: isPlaying ? /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc8iN))), {
                    label: intl.formatMessage({
                        id: "uniform-video.pause",
                        defaultMessage: "Pause"
                    })
                }) : /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                    label: intl.formatMessage({
                        id: "uniform-video.play",
                        defaultMessage: "Play"
                    })
                })
            }),
            isAnimationOverlayEnabled && /*#__PURE__*/ (0, $dypTs.jsxs)("svg", {
                viewBox: `0 0 ${computedWidth} ${computedHeight}`,
                preserveAspectRatio: "none",
                className: (0, $2jatx.default)([
                    "_kqswstnw _1pby11wp _lcxvglyw _1r04idpf _1bsb1osq _4t3i1osq _1lmqglyw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $dypTs.jsxs)("mask", {
                            id: "hole-mask",
                            children: [
                                /*#__PURE__*/ (0, $dypTs.jsx)("rect", {
                                    width: computedWidth,
                                    height: computedHeight,
                                    fill: "white"
                                }),
                                /*#__PURE__*/ (0, $dypTs.jsx)("rect", {
                                    x: computedWidth / 2 - holeWidth / 2,
                                    y: computedHeight / 2 - holeHeight / 2,
                                    width: holeWidth,
                                    height: holeHeight,
                                    rx: holeRadius,
                                    ry: holeRadius,
                                    fill: "black"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("rect", {
                        width: computedWidth,
                        height: computedHeight,
                        fill: (0, $kbpa7.wacToken)("color.neutral.light0"),
                        mask: "url(#hole-mask)"
                    })
                ]
            })
        ]
    });
};
var $44015486d9fa361e$export$2e2bcd8739ae039 = $44015486d9fa361e$var$UniformBackgroundVideoContainer;

});


parcelRegister("48CBm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("jgyhc")).default; });

var $jgyhc = parcelRequire("jgyhc");

});
parcelRegister("jgyhc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f03812964141fa1$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $2HoYQ = parcelRequire("2HoYQ");
const $4f03812964141fa1$var$UniformBannerAlert = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2HoYQ.BannerAlert), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "bannerAlert",
            "data-event": "clicked"
        }
    }));
};
var $4f03812964141fa1$export$2e2bcd8739ae039 = $4f03812964141fa1$var$UniformBannerAlert;

});


parcelRegister("g76er", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("8hbU0")).default; });

var $8hbU0 = parcelRequire("8hbU0");

});
parcelRegister("8hbU0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b29fa8567cae1d0$export$2e2bcd8739ae039; });
/* body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("gljCV");

var $gA8LO = parcelRequire("gA8LO");

var $64xAu = parcelRequire("64xAu");

var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $lTkkF = parcelRequire("lTkkF");
const $7b29fa8567cae1d0$var$UniformBodyContent = ({ body: body })=>{
    const intl = (0, $8e22h.default)();
    const customComponentRenderer = (node)=>{
        switch(node.data.target.sys.contentType.sys.id){
            case "embeddedVideoAsset":
                {
                    const embeddedVideoAssetData = node.data.target.fields;
                    let embeddedVideoThumbnail = undefined;
                    if (embeddedVideoAssetData.embedAssetOverlayOl) {
                        const orangeLogicThumbnail = embeddedVideoAssetData.embedAssetOverlayOl.fields;
                        var _orangeLogicThumbnail_assetUrl;
                        const imageUrl = orangeLogicThumbnail.assetJson ? orangeLogicThumbnail.assetJson.imageUrl : (_orangeLogicThumbnail_assetUrl = orangeLogicThumbnail.assetUrl) !== null && _orangeLogicThumbnail_assetUrl !== void 0 ? _orangeLogicThumbnail_assetUrl : "";
                        var _orangeLogicThumbnail_alt;
                        embeddedVideoThumbnail = {
                            src: imageUrl,
                            alt: (_orangeLogicThumbnail_alt = orangeLogicThumbnail.alt) !== null && _orangeLogicThumbnail_alt !== void 0 ? _orangeLogicThumbnail_alt : ""
                        };
                    } else if (embeddedVideoAssetData.embedAssetOverlay) embeddedVideoThumbnail = {
                        src: embeddedVideoAssetData.embedAssetOverlay.fields.file.url,
                        alt: embeddedVideoAssetData.embedAssetOverlay.fields.description,
                        contentType: embeddedVideoAssetData.embedAssetOverlay.fields.file.contentType
                    };
                    if (!embeddedVideoAssetData.embedded) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $dypTs.Fragment), {});
                    var _embeddedVideoAssetData_embeddedVideoAssetNameExternal;
                    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.EmbeddedVideo), {
                            embedUrl: embeddedVideoAssetData.embedded,
                            thumbnail: embeddedVideoThumbnail,
                            title: (_embeddedVideoAssetData_embeddedVideoAssetNameExternal = embeddedVideoAssetData.embeddedVideoAssetNameExternal) !== null && _embeddedVideoAssetData_embeddedVideoAssetNameExternal !== void 0 ? _embeddedVideoAssetData_embeddedVideoAssetNameExternal : ""
                        })
                    });
                }
            case "proTipComponent":
                {
                    const proTipComponentData = node.data.target.fields;
                    var _proTipComponentData_proTipText;
                    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Panel), {
                            panelType: "pro-tip",
                            label: proTipComponentData.proTipNameExternal,
                            description: proTipComponentData.proTipRichText ? /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: (0, $gA8LO.documentToHtmlString)(proTipComponentData.proTipRichText)
                                }
                            }) : (_proTipComponentData_proTipText = proTipComponentData.proTipText) !== null && _proTipComponentData_proTipText !== void 0 ? _proTipComponentData_proTipText : ""
                        })
                    });
                }
            case "callOutComponent":
                {
                    const callOutComponentData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Panel), {
                            panelType: "highlight",
                            label: callOutComponentData.callOutComponentTitleExternal,
                            description: callOutComponentData.callOutText ? /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: (0, $gA8LO.documentToHtmlString)(callOutComponentData.callOutText)
                                }
                            }) : ""
                        })
                    });
                }
            case "callOut":
                {
                    var _callOutData_orangeLogicImage, _callOutData_orangeLogicImage1, _callOutData_orangeLogicImage2, _callOutData_orangeLogicImage3, _callOutData_orangeLogicImage4, _callOutData_orangeLogicImage5;
                    const callOutData = node.data.target.fields;
                    var _callOutData_orangeLogicImage_fields_assetUrl;
                    const imageUrl = ((_callOutData_orangeLogicImage = callOutData.orangeLogicImage) === null || _callOutData_orangeLogicImage === void 0 ? void 0 : _callOutData_orangeLogicImage.fields.assetJson) ? (_callOutData_orangeLogicImage1 = callOutData.orangeLogicImage) === null || _callOutData_orangeLogicImage1 === void 0 ? void 0 : _callOutData_orangeLogicImage1.fields.assetJson.imageUrl : (_callOutData_orangeLogicImage_fields_assetUrl = (_callOutData_orangeLogicImage2 = callOutData.orangeLogicImage) === null || _callOutData_orangeLogicImage2 === void 0 ? void 0 : _callOutData_orangeLogicImage2.fields.assetUrl) !== null && _callOutData_orangeLogicImage_fields_assetUrl !== void 0 ? _callOutData_orangeLogicImage_fields_assetUrl : undefined;
                    const sideBySideContentCss = null;
                    var _callOutData_orangeLogicImage_fields_alt;
                    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi",
                            "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulppxbi"
                        ]),
                        children: [
                            imageUrl && /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                                src: imageUrl,
                                alt: (_callOutData_orangeLogicImage_fields_alt = (_callOutData_orangeLogicImage3 = callOutData.orangeLogicImage) === null || _callOutData_orangeLogicImage3 === void 0 ? void 0 : _callOutData_orangeLogicImage3.fields.alt) !== null && _callOutData_orangeLogicImage_fields_alt !== void 0 ? _callOutData_orangeLogicImage_fields_alt : "",
                                style: ((_callOutData_orangeLogicImage4 = callOutData.orangeLogicImage) === null || _callOutData_orangeLogicImage4 === void 0 ? void 0 : _callOutData_orangeLogicImage4.fields.width) ? {
                                    width: (_callOutData_orangeLogicImage5 = callOutData.orangeLogicImage) === null || _callOutData_orangeLogicImage5 === void 0 ? void 0 : _callOutData_orangeLogicImage5.fields.width
                                } : undefined
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.ContentBlock), {
                                title: callOutData.callOutTitleExternal,
                                text: callOutData.callOutShortDescription ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
                                    text: (0, $gA8LO.documentToHtmlString)(callOutData.callOutShortDescription)
                                }) : "",
                                callToActionProps: callOutData.callToActionText && callOutData.urlLink ? {
                                    link: {
                                        text: callOutData.callToActionText,
                                        href: callOutData.urlLink
                                    }
                                } : undefined
                            })
                        ]
                    });
                }
            case "beforeYouBeginComponent":
                {
                    const beforeYouBeginData = node.data.target.fields;
                    const beforeYouBeginContainerCss = null;
                    const individualItemContainerCss = null;
                    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi",
                            "_bfhk150w _1yt4xy5q _zulppxbi _1e0c1txw _2lx21bp4"
                        ]),
                        style: {
                            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                        },
                        children: [
                            beforeYouBeginData.time && /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _19wgu2gc _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $dypTs.jsx)("h3", {
                                        className: "eyebrow-lg",
                                        children: intl.formatMessage({
                                            id: "beforeYouBegin.time",
                                            defaultMessage: "Time"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                                        children: beforeYouBeginData.time
                                    })
                                ]
                            }),
                            beforeYouBeginData.audience && /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _19wgu2gc _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $dypTs.jsx)("h3", {
                                        className: "eyebrow-lg",
                                        children: intl.formatMessage({
                                            id: "beforeYouBegin.audience",
                                            defaultMessage: "Audience"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
                                        text: (0, $gA8LO.documentToHtmlString)(beforeYouBeginData.audience)
                                    })
                                ]
                            }),
                            beforeYouBeginData.prerequisite && /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _19wgu2gc _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $dypTs.jsx)("h3", {
                                        className: "eyebrow-lg",
                                        children: intl.formatMessage({
                                            id: "beforeYouBegin.prerequisite",
                                            defaultMessage: "Prerequisite"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
                                        text: (0, $gA8LO.documentToHtmlString)(beforeYouBeginData.prerequisite)
                                    })
                                ]
                            })
                        ]
                    });
                }
            case "orangeLogicAsset":
                {
                    const orangeLogicAssetData = node.data.target.fields;
                    var _orangeLogicAssetData_assetUrl;
                    const imageUrl = orangeLogicAssetData.assetJson ? orangeLogicAssetData.assetJson.imageUrl : (_orangeLogicAssetData_assetUrl = orangeLogicAssetData.assetUrl) !== null && _orangeLogicAssetData_assetUrl !== void 0 ? _orangeLogicAssetData_assetUrl : undefined;
                    if (imageUrl === undefined) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $dypTs.Fragment), {});
                    var _orangeLogicAssetData_alt;
                    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _1e0c1txw _1bah1h6o",
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                            src: imageUrl,
                            alt: (_orangeLogicAssetData_alt = orangeLogicAssetData.alt) !== null && _orangeLogicAssetData_alt !== void 0 ? _orangeLogicAssetData_alt : "",
                            style: orangeLogicAssetData.width ? {
                                width: orangeLogicAssetData.width
                            } : undefined
                        })
                    });
                }
            case "callToActionMicrocopy":
                {
                    const callToActionMicrocopyData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Button), {
                            href: callToActionMicrocopyData.ctaUrl,
                            dataEventProps: {
                                "data-product-key": "uniform",
                                "data-event-component": "linkButton",
                                "data-event-container": "bodyContentInline",
                                "data-event": "clicked"
                            },
                            children: callToActionMicrocopyData.ctaButtonText
                        })
                    });
                }
            case "codeBlock":
                {
                    const codeBlockData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
                        text: `<pre><code>${codeBlockData.code}</code></pre>`
                    });
                }
            default:
                return /*#__PURE__*/ (0, $dypTs.jsx)((0, $dypTs.Fragment), {});
        }
    };
    const renderContentfulRichTextNodes = (nodes)=>{
        return nodes.map((node)=>{
            switch(node.nodeType){
                case "embedded-entry-block":
                    return customComponentRenderer(node);
                case "embedded-asset-block":
                    {
                        const embeddedAssetBlockData = node.data.target;
                        return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                            src: embeddedAssetBlockData.fields.file.url,
                            alt: embeddedAssetBlockData.fields.description,
                            style: $7b29fa8567cae1d0$var$embeddedItemStyles
                        });
                    }
                case "blockquote":
                    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.PullQuote), {
                        quote: "",
                        quoteRichTextString: $7b29fa8567cae1d0$var$parseRichTextStringForOnlyContentInsideParagraphs((0, $gA8LO.documentToHtmlString)({
                            nodeType: (0, $64xAu.BLOCKS).DOCUMENT,
                            content: node.content,
                            data: {}
                        }))
                    });
                default:
                    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
                        text: (0, $gA8LO.documentToHtmlString)({
                            nodeType: (0, $64xAu.BLOCKS).DOCUMENT,
                            content: [
                                node
                            ],
                            data: {}
                        })
                    });
            }
        });
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        id: "body-content",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1srcpxbi _e3fzidpf _1cmiidpf _ynj4idpf _b289idpf"
        ]),
        children: renderContentfulRichTextNodes(body.content)
    });
};
const $7b29fa8567cae1d0$var$embeddedItemStyles = {
    maxWidth: "100%",
    marginBlock: "var(--ds-space-200, 16px)"
};
const $7b29fa8567cae1d0$var$bodyContainerCss = null;
const $7b29fa8567cae1d0$var$parseRichTextStringForOnlyContentInsideParagraphs = (richTextString)=>{
    const paragraphRegex = /<p\b[^>]*>(.*?)<\/p>/gi;
    const matches = Array.from(richTextString.matchAll(paragraphRegex));
    return matches ? matches.map((m)=>m[1]).join() : richTextString;
};
var $7b29fa8567cae1d0$export$2e2bcd8739ae039 = $7b29fa8567cae1d0$var$UniformBodyContent;

});
parcelRegister("64xAu", function(module, exports) {
"use strict";
var $46bd2b9c21a7b5bb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $46bd2b9c21a7b5bb$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $46bd2b9c21a7b5bb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $46bd2b9c21a7b5bb$var$__createBinding(exports1, m, p);
};
var $46bd2b9c21a7b5bb$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $46bd2b9c21a7b5bb$var$__createBinding(result, mod, k);
    }
    $46bd2b9c21a7b5bb$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaWithNodeType = module.exports.helpers = module.exports.EMPTY_DOCUMENT = module.exports.MARKS = module.exports.INLINES = module.exports.BLOCKS = void 0;

var $gtF1Z = parcelRequire("gtF1Z");
Object.defineProperty(module.exports, "BLOCKS", {
    enumerable: true,
    get: function() {
        return $gtF1Z.BLOCKS;
    }
});

var $joEAx = parcelRequire("joEAx");
Object.defineProperty(module.exports, "INLINES", {
    enumerable: true,
    get: function() {
        return $joEAx.INLINES;
    }
});

var $KxfKT = parcelRequire("KxfKT");
Object.defineProperty(module.exports, "MARKS", {
    enumerable: true,
    get: function() {
        return $KxfKT.MARKS;
    }
});

$46bd2b9c21a7b5bb$var$__exportStar((parcelRequire("d6bJ5")), module.exports);

$46bd2b9c21a7b5bb$var$__exportStar((parcelRequire("i0KlZ")), module.exports);

$46bd2b9c21a7b5bb$var$__exportStar((parcelRequire("lSrCb")), module.exports);

var $jcvXp = parcelRequire("jcvXp");
Object.defineProperty(module.exports, "EMPTY_DOCUMENT", {
    enumerable: true,
    get: function() {
        return $jcvXp.EMPTY_DOCUMENT;
    }
});

var $46bd2b9c21a7b5bb$var$helpers = $46bd2b9c21a7b5bb$var$__importStar((parcelRequire("lHRA2")));
module.exports.helpers = $46bd2b9c21a7b5bb$var$helpers;

var $gNeDz = parcelRequire("gNeDz");
Object.defineProperty(module.exports, "getSchemaWithNodeType", {
    enumerable: true,
    get: function() {
        return $gNeDz.getSchemaWithNodeType;
    }
});

});
parcelRegister("gtF1Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */ var $bfef2ead0526aeb7$var$BLOCKS;
(function(BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})($bfef2ead0526aeb7$var$BLOCKS || (module.exports.BLOCKS = $bfef2ead0526aeb7$var$BLOCKS = {}));

});

parcelRegister("joEAx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 *
 * @note This should be kept in alphabetical order since the
 * [validation package](https://github.com/contentful/content-stack/tree/master/packages/validation)
 *  relies on the values being in a predictable order.
 */ var $e1efbe36794f9c51$var$INLINES;
(function(INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
})($e1efbe36794f9c51$var$INLINES || (module.exports.INLINES = $e1efbe36794f9c51$var$INLINES = {}));

});

parcelRegister("KxfKT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MARKS = void 0;
/**
 * Map of all Contentful marks.
 */ var $08be175e69ccd2d5$var$MARKS;
(function(MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
})($08be175e69ccd2d5$var$MARKS || (module.exports.MARKS = $08be175e69ccd2d5$var$MARKS = {}));

});

parcelRegister("d6bJ5", function(module, exports) {
"use strict";
var $9894ee7e238fa515$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $9894ee7e238fa515$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1_MARKS = module.exports.V1_NODE_TYPES = module.exports.TEXT_CONTAINERS = module.exports.HEADINGS = module.exports.CONTAINERS = module.exports.VOID_BLOCKS = module.exports.TABLE_BLOCKS = module.exports.LIST_ITEM_BLOCKS = module.exports.TOP_LEVEL_BLOCKS = void 0;

var $gtF1Z = parcelRequire("gtF1Z");

var $joEAx = parcelRequire("joEAx");

var $KxfKT = parcelRequire("KxfKT");
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */ module.exports.TOP_LEVEL_BLOCKS = [
    $gtF1Z.BLOCKS.PARAGRAPH,
    $gtF1Z.BLOCKS.HEADING_1,
    $gtF1Z.BLOCKS.HEADING_2,
    $gtF1Z.BLOCKS.HEADING_3,
    $gtF1Z.BLOCKS.HEADING_4,
    $gtF1Z.BLOCKS.HEADING_5,
    $gtF1Z.BLOCKS.HEADING_6,
    $gtF1Z.BLOCKS.OL_LIST,
    $gtF1Z.BLOCKS.UL_LIST,
    $gtF1Z.BLOCKS.HR,
    $gtF1Z.BLOCKS.QUOTE,
    $gtF1Z.BLOCKS.EMBEDDED_ENTRY,
    $gtF1Z.BLOCKS.EMBEDDED_ASSET,
    $gtF1Z.BLOCKS.EMBEDDED_RESOURCE,
    $gtF1Z.BLOCKS.TABLE
];
/**
 * Array of all allowed block types inside list items
 */ module.exports.LIST_ITEM_BLOCKS = [
    $gtF1Z.BLOCKS.PARAGRAPH,
    $gtF1Z.BLOCKS.HEADING_1,
    $gtF1Z.BLOCKS.HEADING_2,
    $gtF1Z.BLOCKS.HEADING_3,
    $gtF1Z.BLOCKS.HEADING_4,
    $gtF1Z.BLOCKS.HEADING_5,
    $gtF1Z.BLOCKS.HEADING_6,
    $gtF1Z.BLOCKS.OL_LIST,
    $gtF1Z.BLOCKS.UL_LIST,
    $gtF1Z.BLOCKS.HR,
    $gtF1Z.BLOCKS.QUOTE,
    $gtF1Z.BLOCKS.EMBEDDED_ENTRY,
    $gtF1Z.BLOCKS.EMBEDDED_ASSET,
    $gtF1Z.BLOCKS.EMBEDDED_RESOURCE
];
module.exports.TABLE_BLOCKS = [
    $gtF1Z.BLOCKS.TABLE,
    $gtF1Z.BLOCKS.TABLE_ROW,
    $gtF1Z.BLOCKS.TABLE_CELL,
    $gtF1Z.BLOCKS.TABLE_HEADER_CELL
];
/**
 * Array of all void block types
 */ module.exports.VOID_BLOCKS = [
    $gtF1Z.BLOCKS.HR,
    $gtF1Z.BLOCKS.EMBEDDED_ENTRY,
    $gtF1Z.BLOCKS.EMBEDDED_ASSET,
    $gtF1Z.BLOCKS.EMBEDDED_RESOURCE
];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */ module.exports.CONTAINERS = ($9894ee7e238fa515$var$_a = {}, $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.OL_LIST] = [
    $gtF1Z.BLOCKS.LIST_ITEM
], $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.UL_LIST] = [
    $gtF1Z.BLOCKS.LIST_ITEM
], $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.LIST_ITEM] = module.exports.LIST_ITEM_BLOCKS, $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.QUOTE] = [
    $gtF1Z.BLOCKS.PARAGRAPH
], $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.TABLE] = [
    $gtF1Z.BLOCKS.TABLE_ROW
], $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.TABLE_ROW] = [
    $gtF1Z.BLOCKS.TABLE_CELL,
    $gtF1Z.BLOCKS.TABLE_HEADER_CELL
], $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.TABLE_CELL] = [
    $gtF1Z.BLOCKS.PARAGRAPH,
    $gtF1Z.BLOCKS.UL_LIST,
    $gtF1Z.BLOCKS.OL_LIST
], $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.TABLE_HEADER_CELL] = [
    $gtF1Z.BLOCKS.PARAGRAPH
], $9894ee7e238fa515$var$_a);
/**
 * Array of all heading levels
 */ module.exports.HEADINGS = [
    $gtF1Z.BLOCKS.HEADING_1,
    $gtF1Z.BLOCKS.HEADING_2,
    $gtF1Z.BLOCKS.HEADING_3,
    $gtF1Z.BLOCKS.HEADING_4,
    $gtF1Z.BLOCKS.HEADING_5,
    $gtF1Z.BLOCKS.HEADING_6
];
/**
 * Array of all block types that may contain text and inline nodes.
 */ module.exports.TEXT_CONTAINERS = $9894ee7e238fa515$var$__spreadArray([
    $gtF1Z.BLOCKS.PARAGRAPH
], module.exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */ module.exports.V1_NODE_TYPES = [
    $gtF1Z.BLOCKS.DOCUMENT,
    $gtF1Z.BLOCKS.PARAGRAPH,
    $gtF1Z.BLOCKS.HEADING_1,
    $gtF1Z.BLOCKS.HEADING_2,
    $gtF1Z.BLOCKS.HEADING_3,
    $gtF1Z.BLOCKS.HEADING_4,
    $gtF1Z.BLOCKS.HEADING_5,
    $gtF1Z.BLOCKS.HEADING_6,
    $gtF1Z.BLOCKS.OL_LIST,
    $gtF1Z.BLOCKS.UL_LIST,
    $gtF1Z.BLOCKS.LIST_ITEM,
    $gtF1Z.BLOCKS.HR,
    $gtF1Z.BLOCKS.QUOTE,
    $gtF1Z.BLOCKS.EMBEDDED_ENTRY,
    $gtF1Z.BLOCKS.EMBEDDED_ASSET,
    $joEAx.INLINES.HYPERLINK,
    $joEAx.INLINES.ENTRY_HYPERLINK,
    $joEAx.INLINES.ASSET_HYPERLINK,
    $joEAx.INLINES.EMBEDDED_ENTRY,
    'text'
];
/**
 * Marks before `superscript` & `subscript` release.
 */ module.exports.V1_MARKS = [
    $KxfKT.MARKS.BOLD,
    $KxfKT.MARKS.CODE,
    $KxfKT.MARKS.ITALIC,
    $KxfKT.MARKS.UNDERLINE
];

});

parcelRegister("i0KlZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lSrCb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jcvXp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DOCUMENT = void 0;

var $gtF1Z = parcelRequire("gtF1Z");
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */ module.exports.EMPTY_DOCUMENT = {
    nodeType: $gtF1Z.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: $gtF1Z.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {}
                }
            ]
        }
    ]
};

});

parcelRegister("lHRA2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isInline = $fcd72d09a811ef65$var$isInline;
module.exports.isBlock = $fcd72d09a811ef65$var$isBlock;
module.exports.isText = $fcd72d09a811ef65$var$isText;

var $gtF1Z = parcelRequire("gtF1Z");

var $joEAx = parcelRequire("joEAx");
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */ function $fcd72d09a811ef65$var$hasValue(obj, value) {
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var key = _a[_i];
        if (value === obj[key]) return true;
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */ function $fcd72d09a811ef65$var$isInline(node) {
    return $fcd72d09a811ef65$var$hasValue($joEAx.INLINES, node.nodeType);
}
/**
 * Checks if the node is an instance of Block.
 */ function $fcd72d09a811ef65$var$isBlock(node) {
    return $fcd72d09a811ef65$var$hasValue($gtF1Z.BLOCKS, node.nodeType);
}
/**
 * Checks if the node is an instance of Text.
 */ function $fcd72d09a811ef65$var$isText(node) {
    return node.nodeType === 'text';
}

});

parcelRegister("gNeDz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaWithNodeType = $c39c9393711ba206$var$getSchemaWithNodeType;
function $c39c9393711ba206$var$getSchemaWithNodeType(nodeType) {
    try {
        return require("./generated/".concat(nodeType, ".json"));
    } catch (error) {
        throw new Error("Schema for nodeType \"".concat(nodeType, "\" was not found."));
    }
}

});




parcelRegister("eWth0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("aghrj")).default; });

var $aghrj = parcelRequire("aghrj");

});
parcelRegister("aghrj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4cbd318bfd44317a$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $9Kroa = parcelRequire("9Kroa");
const $4cbd318bfd44317a$export$d9468344d3651243 = (body)=>{
    if (!body) return {};
    const { story: story, richText: richText, image: image, embeddedVideoLink: embeddedVideoLink, imageCaption: imageCaption } = body;
    var _story_storyText, _ref, _story_bodyAsset, _story_embeddedVideoLink, _ref1, _story_bodyAssetCaption, _ref2;
    const formattedBody = {
        storyText: (_ref = (_story_storyText = story === null || story === void 0 ? void 0 : story.storyText) !== null && _story_storyText !== void 0 ? _story_storyText : richText) !== null && _ref !== void 0 ? _ref : undefined,
        bodyAsset: $4cbd318bfd44317a$var$formatBodyAsset((_story_bodyAsset = story === null || story === void 0 ? void 0 : story.bodyAsset) !== null && _story_bodyAsset !== void 0 ? _story_bodyAsset : image),
        embeddedVideoLink: (_ref1 = (_story_embeddedVideoLink = story === null || story === void 0 ? void 0 : story.embeddedVideoLink) !== null && _story_embeddedVideoLink !== void 0 ? _story_embeddedVideoLink : embeddedVideoLink) !== null && _ref1 !== void 0 ? _ref1 : undefined,
        bodyAssetCaption: (_ref2 = (_story_bodyAssetCaption = story === null || story === void 0 ? void 0 : story.bodyAssetCaption) !== null && _story_bodyAssetCaption !== void 0 ? _story_bodyAssetCaption : imageCaption) !== null && _ref2 !== void 0 ? _ref2 : undefined,
        quote: $4cbd318bfd44317a$var$formatQuote(story === null || story === void 0 ? void 0 : story.quote)
    };
    // Remove undefined properties
    return Object.fromEntries(Object.entries(formattedBody).filter(([_, value])=>value !== undefined));
};
// eslint-disable-next-line complexity
const $4cbd318bfd44317a$var$formatBodyAsset = (bodyAsset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_details_image, _fields_file_details1, _fields_file2, _fields_file_details_image1, _fields_file_details2, _fields_file3, _fields_file4, _fields_file5;
    if (!(bodyAsset === null || bodyAsset === void 0 ? void 0 : bodyAsset.fields)) return undefined;
    const { fields: fields } = bodyAsset;
    var _fields_file_fileName, _fields_file_details_image_height, _fields_file_details_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_details_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_details1 = _fields_file2.details) === null || _fields_file_details1 === void 0 ? void 0 : (_fields_file_details_image = _fields_file_details1.image) === null || _fields_file_details_image === void 0 ? void 0 : _fields_file_details_image.height) !== null && _fields_file_details_image_height !== void 0 ? _fields_file_details_image_height : null,
        width: (_fields_file_details_image_width = (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : (_fields_file_details2 = _fields_file3.details) === null || _fields_file_details2 === void 0 ? void 0 : (_fields_file_details_image1 = _fields_file_details2.image) === null || _fields_file_details_image1 === void 0 ? void 0 : _fields_file_details_image1.width) !== null && _fields_file_details_image_width !== void 0 ? _fields_file_details_image_width : null,
        url: (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file5 = fields.file) === null || _fields_file5 === void 0 ? void 0 : _fields_file5.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $4cbd318bfd44317a$var$formatQuote = (quote)=>{
    if (!(quote === null || quote === void 0 ? void 0 : quote.fields)) return undefined;
    const { fields: fields } = quote;
    return {
        quote: fields.advocateQuote,
        authorName: fields.advocateName,
        authorDetails: fields.advocateJobTitle
    };
};
/**
 * @deprecated - Please use UniformBodyContent at /uniform/components/body-content instead
 */ const $4cbd318bfd44317a$var$UniformBodyContent = (props)=>{
    const bodyComponent = (0, $gljCV.useMemo)(()=>$4cbd318bfd44317a$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $9Kroa.BodyContent), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        story: bodyComponent
    }));
};
var $4cbd318bfd44317a$export$2e2bcd8739ae039 = $4cbd318bfd44317a$var$UniformBodyContent;

});
parcelRegister("9Kroa", function(module, exports) {
$parcel$export(module.exports, "BodyContent", function () { return $484d9f987682576e$export$36cf6d64005c1ddf; });
/* body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $gA8LO = parcelRequire("gA8LO");

var $gtz2R = parcelRequire("gtz2R");

var $HMZ3r = parcelRequire("HMZ3r");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");

var $B5GRx = parcelRequire("B5GRx");
function $484d9f987682576e$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $gA8LO.documentToHtmlString)(richText);
}
const $484d9f987682576e$export$36cf6d64005c1ddf = ({ story: story })=>{
    var _story_bodyAsset_url, _story_bodyAsset_description;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        "data-testid": "customer-story-article-content",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb"
        ]),
        children: [
            (story === null || story === void 0 ? void 0 : story.storyText) && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_rrz6idpf _1cobidpf _7exw1ejb _1o6v1ejb"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                    name: null,
                    text: $484d9f987682576e$var$getRichText(story.storyText)
                })
            }),
            (story === null || story === void 0 ? void 0 : story.quote) && /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
                layout: "10",
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.PullQuote), {
                    quote: story.quote.quote,
                    authorName: story.quote.authorName,
                    authorDetails: story.quote.authorDetails,
                    alignment: "start",
                    variant: story.quote.heroQuote ? "cutout" : "basic"
                })
            }),
            (story === null || story === void 0 ? void 0 : story.bodyAsset) && (story === null || story === void 0 ? void 0 : story.embeddedVideoLink) && /*#__PURE__*/ (0, $dypTs.jsx)((0, $gtz2R.AgileVideo), {
                embedLink: story.embeddedVideoLink,
                thumbnail: story.bodyAsset,
                title: ""
            }),
            (story === null || story === void 0 ? void 0 : story.bodyAsset) && !(story === null || story === void 0 ? void 0 : story.embeddedVideoLink) && /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _zulpu2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $HMZ3r.default), {
                        src: (_story_bodyAsset_url = story.bodyAsset.url) !== null && _story_bodyAsset_url !== void 0 ? _story_bodyAsset_url : "",
                        alt: (_story_bodyAsset_description = story.bodyAsset.description) !== null && _story_bodyAsset_description !== void 0 ? _story_bodyAsset_description : "",
                        contentType: story.bodyAsset.contentType,
                        baseWidth: 856,
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1bsbmebt _195g1wug"
                        ]),
                        style: {
                            "--_1396dc4": (0, $6ZVlx.default)(story.bodyAsset.width ? `${story.bodyAsset.width}px` : "100%")
                        }
                    }),
                    story.bodyAssetCaption && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "fine-print"
                        ]),
                        children: story.bodyAssetCaption
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("9RECE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("6SooZ")).default; });

var $6SooZ = parcelRequire("6SooZ");

});
parcelRegister("6SooZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ab26b742cd3a699c$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $kooLp = parcelRequire("kooLp");

var $lqyi6 = parcelRequire("lqyi6");
const $ab26b742cd3a699c$var$UniformButton = (props)=>{
    const localizedHref = (0, $kooLp.useLocalizedHref)(props.href);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $lqyi6.Button), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        href: localizedHref,
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "button",
            "data-event": "clicked"
        },
        children: props.text
    }));
};
var $ab26b742cd3a699c$export$2e2bcd8739ae039 = $ab26b742cd3a699c$var$UniformButton;

});


parcelRegister("l1OVK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("4h1q1")).default; });

var $4h1q1 = parcelRequire("4h1q1");

});
parcelRegister("4h1q1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f39a289a0539a8be$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $01zo5 = parcelRequire("01zo5");

var $2fk4i = parcelRequire("2fk4i");
parcelRequire("l1i8p");
var $5JoNJ = parcelRequire("5JoNJ");

var $kooLp = parcelRequire("kooLp");
const $f39a289a0539a8be$export$386f3ec84bf404ad = (props)=>{
    var _props_ctaUrl;
    const localizedHref = (0, $kooLp.useLocalizedHref)((_props_ctaUrl = props.ctaUrl) !== null && _props_ctaUrl !== void 0 ? _props_ctaUrl : "");
    const button = ()=>{
        if (props.ctaText && props.ctaText !== "" && props.ctaUrl && props.ctaUrl !== "") return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Button), {
            href: localizedHref,
            dataEventProps: {
                "data-product-key": "uniform",
                "data-event-component": "linkButton",
                "data-event-container": "ctaSection",
                "data-event": "clicked"
            },
            children: props.ctaText
        });
        return;
    };
    var _button;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $5JoNJ.CallToAction), {
        header: props.title,
        paragraph: props.description,
        button: (_button = button()) !== null && _button !== void 0 ? _button : /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
            name: "ctaButton"
        }),
        backgroundColor: props.backgroundColor
    });
};
var $f39a289a0539a8be$export$2e2bcd8739ae039 = $f39a289a0539a8be$export$386f3ec84bf404ad;

});
parcelRegister("l1i8p", function(module, exports) {
$parcel$export(module.exports, "CallToAction", function () { return (parcelRequire("5JoNJ")).CallToAction; });
$parcel$export(module.exports, "HeroCarousel", function () { return (parcelRequire("us1N6")).HeroCarousel; });
$parcel$export(module.exports, "Logos", function () { return (parcelRequire("behZZ")).Logos; });
$parcel$export(module.exports, "FeaturesHighlight", function () { return (parcelRequire("anFhN")).FeaturesHighlight; });
$parcel$export(module.exports, "Integration", function () { return (parcelRequire("ifNiy")).Integration; });
$parcel$export(module.exports, "MobileApp", function () { return (parcelRequire("euqle")).MobileApp; });
$parcel$export(module.exports, "SideNav", function () { return (parcelRequire("5f18E")).SideNav; });

var $5JoNJ = parcelRequire("5JoNJ");

var $i1SI4 = parcelRequire("i1SI4");

var $anFhN = parcelRequire("anFhN");

var $8J2ZV = parcelRequire("8J2ZV");

var $us1N6 = parcelRequire("us1N6");

var $ifNiy = parcelRequire("ifNiy");

var $behZZ = parcelRequire("behZZ");

var $euqle = parcelRequire("euqle");

var $5f18E = parcelRequire("5f18E");

var $4Fnxt = parcelRequire("4Fnxt");
parcelRequire("5uGt2");
var $7kpd6 = parcelRequire("7kpd6");

});
parcelRegister("5JoNJ", function(module, exports) {
$parcel$export(module.exports, "CallToAction", function () { return $fb865668dbde9df8$export$9438b36140854db6; });
/* call-to-action.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $fb865668dbde9df8$var$callToActionStyles = null;
const $fb865668dbde9df8$var$typographyOverrides = null;
const $fb865668dbde9df8$var$polygonStyles = null;
const $fb865668dbde9df8$var$contentStyles = null;
const $fb865668dbde9df8$export$9438b36140854db6 = ({ header: header, paragraph: paragraph, button: button, backgroundColor: backgroundColor = "black" })=>{
    let transformedButton;
    if (backgroundColor === "blue") transformedButton = /*#__PURE__*/ (0, $gljCV.cloneElement)(button, {
        variant: "primary_alt"
    });
    return /*#__PURE__*/ (0, $dypTs.jsx)("section", {
        className: (0, $2jatx.default)([
            "_p12f1git _195g1wug _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
            style: {
                "--background-color": (0, $kbpa7.wacToken)(`color.primary.${backgroundColor}`)
            },
            className: (0, $2jatx.default)([
                "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci"
            ]),
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _zulpu2gc _6rthxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_1mou78py",
                                    "h3"
                                ]),
                                style: {
                                    color: (0, $kbpa7.wacToken)("color.neutral.light0")
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1mou78py",
                                    ".body-md"
                                ]),
                                style: {
                                    color: (0, $kbpa7.wacToken)("color.neutral.light0")
                                },
                                children: paragraph
                            })
                        ]
                    })
                }),
                transformedButton !== null && transformedButton !== void 0 ? transformedButton : button
            ]
        })
    });
};

});

parcelRegister("i1SI4", function(module, exports) {
$parcel$export(module.exports, "CustomerTestimonials", function () { return $82b7f8eaea519598$export$ff99f9acc73d9931; });
/* customer-testimonials.tsx generated by @compiled/babel-plugin v0.28.8 */ // Initial changes from ADG4CustomerTestimonials
// Removed scroll Ref and inview tracker, since there is no longer an automatic transition to new tabs
// Removed className since it was not in use
// Removed testimonialCta since that is a non standard usage in the Confluence Product Tour and clouds the core Design Pattern
// Removed Blue as an option for backgrounds for now since that is not spec
// Removed h2 heading (that should be included as a Content Block separately going forward)
// Removed TypographyStyles wrapper for consistency with other components/patterns
// Cleaned up unused classnames within the component

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $a9lfn = parcelRequire("a9lfn");

var $ftgEA = parcelRequire("ftgEA");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");
// Not able to use wacToken function with cssMap. Need to refactor this in the future to use dynamic functions
const $82b7f8eaea519598$var$backgroundColorStyleMap = {
    black: "_bfhkr3uz",
    white: "_bfhku67f"
};
const $82b7f8eaea519598$var$backgroundShape = null;
const $82b7f8eaea519598$var$fontColorStyleMap = {
    "dark-bg": "_syaz12cp",
    "white-bg": "_syazn7od"
};
const $82b7f8eaea519598$var$topLineStyleMap = {
    black: "_bfhku67f",
    white: "_bfhkr3uz"
};
const $82b7f8eaea519598$var$logoOptionStyleMap = {
    "dark-bg": "_d4ksu67f _i862u67f _1uiy1wzc",
    "white-bg": "_d4ksr3uz _i862r3uz"
};
const $82b7f8eaea519598$var$justifyContentStyleMap = {
    "dark-bg": "_1bahh9n0",
    "white-bg": "_1bah1h6o"
};
const $82b7f8eaea519598$export$ff99f9acc73d9931 = ({ bgColor: bgColor = "black", testimonials: testimonials, productKey: productKey })=>{
    const bgTheme = bgColor === "black" ? "dark-bg" : "white-bg";
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $a9lfn.Adg4Tabs), {
        loop: true,
        children: /*#__PURE__*/ (0, $dypTs.jsx)("section", {
            children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1pbykb7n _6rth1jfw",
                    $82b7f8eaea519598$var$fontColorStyleMap[bgTheme]
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _1r04idpf _1bsb1lk2 _p12fklux _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rfm1osq",
                                    $82b7f8eaea519598$var$backgroundColorStyleMap[bgColor],
                                    bgColor === "black" && "_mkrzq8qa _kxoh75ra"
                                ])
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c11p5 _yv0ehkll _2z05hkll _1ir7idpf _bhknkb7n _1rrs1txw _s9hn1ekt _16l7kb7n _w53ccs5v"
                                ]),
                                children: testimonials.map((testimonial, index)=>{
                                    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $a9lfn.Adg4TabPanel), {
                                        id: `${index}`,
                                        panelIndex: index,
                                        forceRender: true,
                                        hideTabPanelRole: true,
                                        children: /*#__PURE__*/ (0, $dypTs.jsx)($82b7f8eaea519598$var$TopRowContent, {
                                            testimonial: testimonial,
                                            index: index,
                                            bgTheme: bgTheme,
                                            bgColor: bgColor
                                        })
                                    }, index);
                                })
                            }),
                            testimonials.length > 1 && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1reo15vq _18m915vq _1bsb1osq _1bah1yb4 _1v611bp4 _476dgktf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $dypTs.jsxs)((0, $a9lfn.Adg4DraggableTabList), {
                                        rowGap: "32px",
                                        className: (0, $2jatx.default)([
                                            "_6rth1fu0 _1q511aa3 _qtt8agmp"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_kqswstnw _152tt94y _1e02idpf _rjxpidpf _4t3it94y _2rkoyh40 _tzy4105o _xaej183y",
                                                    $82b7f8eaea519598$var$topLineStyleMap[bgColor]
                                                ])
                                            }),
                                            testimonials.map((testimonial, index)=>{
                                                return /*#__PURE__*/ (0, $dypTs.jsx)((0, $a9lfn.Adg4DraggableTab), {
                                                    as: "li",
                                                    tabIndex: index,
                                                    dataEventProps: {
                                                        "data-product-key": productKey,
                                                        "data-event-component": "tab",
                                                        "data-event-container": "testimonialsSection",
                                                        "data-event": "clicked",
                                                        "data-label-english": testimonial.label
                                                    },
                                                    label: testimonial.label,
                                                    className: (0, $2jatx.default)([
                                                        $82b7f8eaea519598$var$logoOptionStyleMap[bgTheme],
                                                        "_1e0c1txw _1bah1fhb _4cvr1fhb _kqswh2mm _1atpidpf"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $dypTs.jsx)($82b7f8eaea519598$var$LogoTabContent, {
                                                        testimonialLogo: testimonial.logo
                                                    })
                                                }, index);
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $82b7f8eaea519598$var$TopRowContent = ({ testimonial: testimonial, index: index, bgTheme: bgTheme, bgColor: bgColor, isPanelActive: isPanelActive })=>{
    var _testimonial_link_type;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
            "_6rth1ylp _1e0c11p5 _yv0ewxkt _gy1pzwfg _tzy4idpf _1pbykb7n _1ph4hkll",
            isPanelActive && "_tzy4kb7n _1pbycs5v"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _i0dlhwvj _1e0c1txw _1bah1h6o _4cvresu3 _16xt1ssb _1rfm1vuk _q5ugidpf _7tld1wug _14adidpf _4uro1wug _7bcc1n8h _18jmidpf _qji61wug _ms0lidpf _v5we1wug"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bna7ng7t _1jtm1c95 _1fhe1c95 _1cwsdlvw _mezj1wug _v4pn1ule",
                        isPanelActive && "_m3691nt4"
                    ]),
                    children: typeof testimonial.image !== "string" && "contentType" in testimonial.image ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $ftgEA.ContentPlatformImage), (0, $6ogO3._)({}, testimonial.image)) : /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), {
                        image: {
                            src: testimonial.image,
                            alt: ""
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_i0dl1nrf _1reo15vq _18m915vq _1a8l1ssb"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4t3i1osq _2rkogktf _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _26vxys9h _12rr1e9y _1rfm1osq",
                        $82b7f8eaea519598$var$justifyContentStyleMap[bgTheme]
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_v5641pn7 _1e0c1txw _2lx21bp4 _zulp1tcg",
                            isPanelActive && "_y44v13sw _11vozap6"
                        ]),
                        children: [
                            testimonial.eyebrow && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "eyebrow-md"
                                ]),
                                children: testimonial.eyebrow
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsxs)("blockquote", {
                                className: (0, $2jatx.default)([
                                    $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "callout"
                                ]),
                                children: [
                                    "\u201C",
                                    testimonial.quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                            "eyebrow-lg"
                                        ]),
                                        children: testimonial.name
                                    }),
                                    /*#__PURE__*/ (0, $dypTs.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                            "body-md title"
                                        ]),
                                        children: testimonial.title
                                    })
                                ]
                            }),
                            testimonial.link ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Link), {
                                anchorProps: {
                                    tabIndex: isPanelActive ? 0 : -1
                                },
                                text: testimonial.link.text,
                                href: testimonial.link.url,
                                type: (_testimonial_link_type = testimonial.link.type) !== null && _testimonial_link_type !== void 0 ? _testimonial_link_type : "primary",
                                bgColor: bgColor === "black" ? "bgBlackBlue" : "bgWhite",
                                dataEventProps: testimonial.link.dataEventProps
                            }) : null
                        ]
                    }, index)
                })
            })
        ]
    });
};
const $82b7f8eaea519598$var$topRowActiveStyle = null;
const $82b7f8eaea519598$var$customerImagesImgActiveStyle = null;
const $82b7f8eaea519598$var$quoteContainerActiveStyle = null;
const $82b7f8eaea519598$var$LogoTabContent = ({ testimonialLogo: testimonialLogo, isSelected: isSelected = false })=>{
    const isContentfulImage = "contentType" in testimonialLogo;
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_tzy4kb7n _kqswstnw _152tj39m _1e02idpf _rjxpidpf _4t3i14y2 _2rkoyh40",
                    "top-marker"
                ])
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_11q7glyw _19itidpf _r06hglyw _1q51gktf _80omtlke _kqswh2mm"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_tzy4105o _v5641bs3 _16l4kb7n",
                        "_4t3i1u1b _1e0c1txw _4cvr1h6o",
                        isSelected && "_tzy4kb7n"
                    ]),
                    children: isContentfulImage ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $ftgEA.ContentPlatformImage), (0, $dPABA._)((0, $6ogO3._)({}, testimonialLogo), {
                        width: "140",
                        height: "34",
                        style: {
                            objectFit: "contain",
                            objectPosition: "center center"
                        },
                        className: "tab-logo"
                    })) : testimonialLogo
                })
            })
        ]
    });
};
// LogoTabContent styles
const $82b7f8eaea519598$var$logoImgStyle = null;
const $82b7f8eaea519598$var$logoImgSelectedStyle = null;
const $82b7f8eaea519598$var$logoButtonStyle = null;
const $82b7f8eaea519598$var$topMarkerStyle = null;
const $82b7f8eaea519598$var$logoImgContainerStyle = null;
// ADG4CustomerTestimonials styles
const $82b7f8eaea519598$var$topLineStyles = null;
const $82b7f8eaea519598$var$testimonialKeyframeStyles = null;
const $82b7f8eaea519598$var$rowWidthStyle = null;
const $82b7f8eaea519598$var$topRowStyle = null;
const $82b7f8eaea519598$var$bgShapeStyle = null;
const $82b7f8eaea519598$var$customerImagesSectionStyles = null;
const $82b7f8eaea519598$var$customerImagesSectionImageStyles = null;
const $82b7f8eaea519598$var$customerQuotesSectionStyle = null;
const $82b7f8eaea519598$var$testimonialQuotesSectionStyle = null;
const $82b7f8eaea519598$var$quoteContainerStyle = null;
const $82b7f8eaea519598$var$quoteContainerPStyle = null;
const $82b7f8eaea519598$var$logosContainerBaseStyle = null;
const $82b7f8eaea519598$var$logosStyle = null;
const $82b7f8eaea519598$var$logoOptionStyle = null;
const $82b7f8eaea519598$var$testimonialStyles = null;
const $82b7f8eaea519598$var$tabPanelWrapperStyles = null;

});

parcelRegister("anFhN", function(module, exports) {
$parcel$export(module.exports, "FeaturesHighlight", function () { return $00c15acb18b151d4$export$bf20c48d528647dd; });
/* features-highlight.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $gljCV = parcelRequire("gljCV");

var $ggSCt = parcelRequire("ggSCt");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $lE15B = parcelRequire("lE15B");

var $kbpa7 = parcelRequire("kbpa7");
const $00c15acb18b151d4$export$bf20c48d528647dd = (props)=>{
    const [activeFeature, setActiveFeature] = (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).useState(0);
    const onFeatureSelect = (featureKey)=>{
        setActiveFeature(featureKey);
    };
    const singleFeature = (content, featureKey)=>/*#__PURE__*/ (0, $dypTs.jsxs)("div", {
            onClick: ()=>onFeatureSelect(featureKey),
            onKeyDown: (e)=>{
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onFeatureSelect(featureKey);
                }
            },
            className: (0, $2jatx.default)([
                "_80omtlke _kqswh2mm _u5ggpxbi _11xx17la _uoz5x71z _suga1ule _1ah31y44",
                `feature ${activeFeature === featureKey ? "selected" : ""}`
            ]),
            role: "tab",
            tabIndex: 0,
            style: {
                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
            },
            children: [
                activeFeature === featureKey && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _1pbykb7n _bfhk17la _2rko1y44 _1bsb1osq _4t3iftgi _165t1osq _glteftgi"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                    }
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_owpupxbi _6ssjpxbi"
                    ]),
                    children: content
                })
            ]
        });
    const feature1Text = /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.ContentBlock), {
        title: props.feature1Title,
        titleAs: "h3",
        text: props.feature1Body,
        eyebrow: props.feature1Eyebrow,
        alignment: "start"
    });
    var _props_feature1ImageAltText;
    const feature1Image = /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), {
        image: {
            src: props.feature1ImageSrc,
            alt: (_props_feature1ImageAltText = props.feature1ImageAltText) !== null && _props_feature1ImageAltText !== void 0 ? _props_feature1ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    var _props_feature1VideoAltText;
    const feature1Video = props.feature1VideoSrc ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lE15B.Video), {
        src: props.feature1VideoSrc,
        poster: props.feature1VideoPoster,
        alt: (_props_feature1VideoAltText = props.feature1VideoAltText) !== null && _props_feature1VideoAltText !== void 0 ? _props_feature1VideoAltText : ""
    }, "feature1-video") : null;
    var _props_feature2VideoAltText;
    const feature2Video = props.feature2VideoSrc ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lE15B.Video), {
        src: props.feature2VideoSrc,
        poster: props.feature2VideoPoster,
        alt: (_props_feature2VideoAltText = props.feature2VideoAltText) !== null && _props_feature2VideoAltText !== void 0 ? _props_feature2VideoAltText : ""
    }, "feature2-video") : null;
    var _props_feature3VideoAltText;
    const feature3Video = props.feature3VideoSrc ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lE15B.Video), {
        src: props.feature3VideoSrc,
        poster: props.feature3VideoPoster,
        alt: (_props_feature3VideoAltText = props.feature3VideoAltText) !== null && _props_feature3VideoAltText !== void 0 ? _props_feature3VideoAltText : ""
    }, "feature3-video") : null;
    const feature2Text = /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.ContentBlock), {
        title: props.feature2Title,
        titleAs: "h3",
        text: props.feature2Body,
        eyebrow: props.feature2Eyebrow,
        alignment: "start"
    });
    var _props_feature2ImageAltText;
    const feature2Image = /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), {
        image: {
            src: props.feature2ImageSrc,
            alt: (_props_feature2ImageAltText = props.feature2ImageAltText) !== null && _props_feature2ImageAltText !== void 0 ? _props_feature2ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const feature3Text = /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.ContentBlock), {
        title: props.feature3Title,
        titleAs: "h3",
        text: props.feature3Body,
        eyebrow: props.feature3Eyebrow,
        alignment: "start"
    });
    var _props_feature3ImageAltText;
    const feature3Image = /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), {
        image: {
            src: props.feature3ImageSrc,
            alt: (_props_feature3ImageAltText = props.feature3ImageAltText) !== null && _props_feature3ImageAltText !== void 0 ? _props_feature3ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const featureTexts = [
        feature1Text,
        feature2Text,
        props.feature3Title && feature3Text
    ];
    const content = [
        props.feature1ImageSrc ? feature1Image : feature1Video,
        props.feature2ImageSrc ? feature2Image : feature2Video,
        props.feature3Title && props.feature3ImageSrc ? feature3Image : feature3Video
    ];
    const sectionContainerStyles = null;
    const topContentContainerStyles = null;
    const featuresContainerStyles = null;
    const imageContainerStyles = null;
    const navDotsContainerStyles = null;
    const navDot = (featureNum)=>{
        return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bsbftgi _4t3iftgi _2rko1y44 _bfhk1cls"
            ]),
            style: {
                "--_1lhuu6n": (0, $6ZVlx.default)(featureNum === activeFeature ? (0, $kbpa7.wacToken)("color.primary.black") : (0, $kbpa7.wacToken)("color.neutral.light500"))
            }
        });
    };
    // @ts-ignore
    const navDotsContainer = (_)=>/*#__PURE__*/ (0, $dypTs.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _zulppxbi _1bah1h6o _1q51pxbi"
            ]),
            children: featureTexts.map((_, index)=>navDot(index))
        });
    const mobileCarouselContainerStyles = null;
    const sliderSettings = {
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        afterChange: (current)=>setActiveFeature(current),
        appendDots: navDotsContainer
    };
    const featureSlideStyles = null;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_15fl1wug _1d2w1wug _1svy1wug _seov1wug _16imoahv _b8yq1osq _14b51osq _su071wqb _1j8bcx6w _181n11p5 _dwk3usvi _19wg14hz _11mz1tcg _owpu1wqb _10jxzqdx _1vsw1vi7 _suga1txw _1gde1bp4 _1rfm1osq _tnru1osq _8164pxbi _133i1jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1rfm1osq _xlt11ejb _s51szwfg _uoz5179g _1e3ceqnf _1e0c1txw _2lx21bp4 _zulpu2gc _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.ContentBlock), {
                        title: props.title,
                        titleAs: "h2",
                        text: props.description,
                        alignment: "center"
                    }),
                    props.linkText && props.linkHref && // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name -- Link component renders accessible text content via the text prop and ariaLabel
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Link), {
                        text: props.linkText,
                        href: props.linkHref,
                        ariaLabel: props.linkText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                role: "tablist",
                className: (0, $2jatx.default)([
                    "_1e3cx71z _dm251txw _1ini1bp4 _kzvi1bgi _1e0cglyw"
                ]),
                children: featureTexts.map((feature, index)=>singleFeature(feature, index))
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                role: "tabpanel",
                className: (0, $2jatx.default)([
                    "_1e3cthi2 _165t1osq _uoz5uufb _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    children: content[activeFeature]
                }, activeFeature)
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule",
                    "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _ll151ule _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _zwvbidpf _19wzidpf _2awfidpf _l1guidpf _3otn1r31 _1d59glyw _r3kx1o36 _1y6utlke _1t6x161g _1u6z161g _1vpa161g _5skb161g _1xca161g _xcl1161g _rzx1161g _1xcr161g _57of161g _b29h161g _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1qa65mfb _r4f35mfb _y1t8b3bt _1v9lb3bt _v42h1hrf _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _gzcot94y _tovh1txw _160x1h6o _1a23usic _k4vw1ule _19i1glyw _1afyglyw _1xnx1ule _qzmo15vq _1xzb1ule _ntpm1wug _4v68okh7 _13h3glyw",
                    "slider-container"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggSCt))), (0, $dPABA._)((0, $6ogO3._)({}, sliderSettings), {
                    children: featureTexts.map((feature, index)=>/*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_18zrzwfg _1e0c1txw _2lx21bp4 _zulppxbi"
                            ]),
                            children: [
                                singleFeature(feature, index),
                                content[index]
                            ]
                        }, index))
                }))
            })
        ]
    });
};
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $00c15acb18b151d4$var$slickStyle = null;

});

parcelRegister("8J2ZV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3798516d873ca4cc$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $3798516d873ca4cc$export$887967f05dc521ae = (_param)=>{
    var { layout: layout = "image-right" } = _param, props = (0, $aPnCa._)(_param, [
        "layout"
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)("section", {
        style: {
            "--background-color": `${props.backgroundColor ? (0, $kbpa7.wacToken)(props.backgroundColor) : "transparent"}`
        },
        className: (0, $2jatx.default)([
            "_11q76ulk"
        ]),
        children: layout === "image-both" ? /*#__PURE__*/ (0, $dypTs.jsx)($3798516d873ca4cc$var$HeroBothImages, (0, $6ogO3._)({
            layout: layout
        }, props)) : /*#__PURE__*/ (0, $dypTs.jsx)($3798516d873ca4cc$var$HeroOneImage, (0, $6ogO3._)({
            layout: layout
        }, props))
    });
};
var $3798516d873ca4cc$export$2e2bcd8739ae039 = $3798516d873ca4cc$export$887967f05dc521ae;
const $3798516d873ca4cc$var$DARK_BKGD_COLORS = [
    "color.primary.black"
];
const $3798516d873ca4cc$var$HeadingContent = ({ heading: heading, subheading: subheading, callToActionProps: callToActionProps, size: size = "regular", backgroundColor: backgroundColor })=>{
    const _ref = callToActionProps !== null && callToActionProps !== void 0 ? callToActionProps : {}, { text: buttonText } = _ref, buttonProps = (0, $aPnCa._)(_ref, [
        "text"
    ]);
    const isLarge = size === "large";
    const useLightText = backgroundColor ? $3798516d873ca4cc$var$DARK_BKGD_COLORS.includes(backgroundColor) : false;
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("h1", {
                style: {
                    color: useLightText ? (0, $kbpa7.wacToken)("color.neutral.light0") : "inherit"
                },
                className: (0, $2jatx.default)([
                    "_18s8ze3t",
                    isLarge ? "superhero" : undefined
                ]),
                children: heading
            }),
            subheading && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_6rthze3t",
                    isLarge ? "body-lg" : "body-md"
                ]),
                style: {
                    color: useLightText ? (0, $kbpa7.wacToken)("color.neutral.light0") : "inherit"
                },
                children: subheading
            }),
            buttonText && buttonProps && /*#__PURE__*/ (0, $dypTs.jsx)((0, $lqyi6.Button), (0, $dPABA._)((0, $6ogO3._)({}, buttonProps), {
                size: "large",
                className: (0, $2jatx.default)([
                    "_1pfhxy5q"
                ]),
                children: buttonText
            }))
        ]
    });
};
const $3798516d873ca4cc$var$HeroOneImage = (_param)=>{
    var { layout: layout = "image-right", imageProps: imageProps } = _param, props = (0, $aPnCa._)(_param, [
        "layout",
        "imageProps"
    ]);
    var _imageProps_alt;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp1ejb _1rjc1jfw _y3gn1h6o _4cvr1h6o _1j8bwxkt _lagd18l3 _19wgxy5q _uj6kv2br _1ooboahv _1s0lxncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        layout === "image-left" && "_1b1qcs5v"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsx)($3798516d873ca4cc$var$HeadingContent, (0, $6ogO3._)({}, props))
                }),
                imageProps && /*#__PURE__*/ (0, $dypTs.jsx)((0, $bSVv5.Image), {
                    maxPossibleWidth: 700,
                    src: imageProps.src,
                    alt: (_imageProps_alt = imageProps.alt) !== null && _imageProps_alt !== void 0 ? _imageProps_alt : "",
                    loading: "eager",
                    width: imageProps.width,
                    height: imageProps.height
                })
            ]
        })
    });
};
const $3798516d873ca4cc$var$gridStyle = null;
const $3798516d873ca4cc$var$headingStyle = null;
const $3798516d873ca4cc$var$imageStartStyle = null;
const $3798516d873ca4cc$var$bodyStyle = null;
const $3798516d873ca4cc$var$buttonStyle = null;
/*
This is an experimental start to support the needs of the Hero variation with images on the sides, primary content centered
Initial support is seens on Product enterprise pages (such as /software/jira/enterprise) as served by WAC Authoring Engine

TODO: We need to understand the levels of configurability desired/needed to support a variety of use cases, collab with design.
  Currently it is very tailored to the aforementioned enterprise experience
*/ const $3798516d873ca4cc$var$HeroBothImages = (_param)=>{
    var { imageProps: imageProps, secondaryImageProps: secondaryImageProps } = _param, props = (0, $aPnCa._)(_param, [
        "imageProps",
        "secondaryImageProps"
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_uaqo1x3a _13j917im",
                    "_kqswh2mm _1e0c11p5 _10fp1h6o _y3gn1h6o _4cvr1h6o _6a6z1h6o _1rjc1jfw _14b51ssb _su07u2gc _1ooboahv _1s0lxncg _bxthb3bt _t4hxstnw _1yp51osq _1bpvsmen _brhgmgnk _5kbx1f51 _1gg8w2la _n4lfidpf _1nls12it _14xsidpf _16bh12it _1z0y9by0 _ixsu1osq _a6uwb3bt _dbttstnw _83tk1wn5 _10wjmgnk _tzs91f51 _wi3i1048 _1x65idpf _oppa12it _1ohy1kly _nd8fidpf _1yam12it _ugza1kly _mlxy9by0 _k4z51osq _xcpbpwvu"
                ]),
                style: {
                    "--_1thiznr": (0, $6ZVlx.default)(imageProps ? `url(${imageProps.src})` : "none"),
                    "--_c31b9r": (0, $6ZVlx.default)(secondaryImageProps ? `url(${secondaryImageProps.src})` : "none")
                },
                children: /*#__PURE__*/ (0, $dypTs.jsx)($3798516d873ca4cc$var$HeadingContent, (0, $dPABA._)((0, $6ogO3._)({}, props), {
                    size: "regular"
                }))
            })
        })
    });
};
const $3798516d873ca4cc$var$gridTwoImagesStyle = null;

});

parcelRegister("us1N6", function(module, exports) {
$parcel$export(module.exports, "HeroCarousel", function () { return $13e2b0d7d2657b7f$export$b92905002f03c113; });
/* hero-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $8EEDU = parcelRequire("8EEDU");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");
const $13e2b0d7d2657b7f$export$b92905002f03c113 = ({ tabsData: tabsData })=>{
    const [selectedTab, setSelectedTab] = (0, $gljCV.useState)(0);
    const listRef = (0, $gljCV.useRef)(null);
    const { ref: lastTabRef, inView: isTabListEndVisible } = (0, $jKShK.useInView)({
        root: listRef === null || listRef === void 0 ? void 0 : listRef.current,
        threshold: 1
    });
    const { ref: firstTabRef, inView: isTabListStartVisible } = (0, $jKShK.useInView)({
        root: listRef === null || listRef === void 0 ? void 0 : listRef.current,
        threshold: 1
    });
    (0, $gljCV.useEffect)(()=>{
        const listElement = listRef === null || listRef === void 0 ? void 0 : listRef.current;
        if (listElement) {
            var _listElement_children;
            const tabElement = (_listElement_children = listElement.children) === null || _listElement_children === void 0 ? void 0 : _listElement_children[selectedTab + 1];
            if (tabElement && typeof tabElement.scrollIntoView === "function") {
                tabElement.scrollIntoView({
                    behavior: "smooth",
                    inline: "center",
                    block: "end"
                });
                tabElement.focus();
            }
        }
    }, [
        selectedTab
    ]);
    const onKeyDown = (e)=>{
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            let newFocusIndex = 0;
            if (e.key === "ArrowRight") {
                newFocusIndex = selectedTab + 1;
                if (newFocusIndex >= tabsData.length) newFocusIndex = 0;
            } else if (e.key === "ArrowLeft") {
                newFocusIndex = selectedTab - 1;
                // If we're at the start, move to the end
                if (newFocusIndex < 0) newFocusIndex = tabsData.length - 1;
            }
            setSelectedTab(newFocusIndex);
        }
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)("section", {
        id: "hero-carousel",
        "data-testid": "hero-carousel",
        className: (0, $2jatx.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21sxn _1bsb1osq _1reo15vq _18m915vq"
            ]),
            children: [
                /*#__PURE__*/ (0, $dypTs.jsxs)($13e2b0d7d2657b7f$var$TabList, {
                    listRef: listRef,
                    isTabListViewable: isTabListStartVisible && isTabListEndVisible,
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                            ref: firstTabRef
                        }),
                        tabsData.map((tab, i)=>/*#__PURE__*/ (0, $dypTs.jsxs)($13e2b0d7d2657b7f$var$Tab, {
                                isSelected: i === selectedTab,
                                id: tab.id,
                                onClick: ()=>{
                                    setSelectedTab(i);
                                },
                                onKeyDown: onKeyDown,
                                children: [
                                    tab.eyebrow && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_syaz121t _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "eyebrow-sm"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.eyebrow
                                    }),
                                    /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_syaz121t _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "_1wyb19as _k48p16tn _vwz41xr0"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.title
                                    })
                                ]
                            }, tab.id)),
                        /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                            ref: lastTabRef
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)($13e2b0d7d2657b7f$var$PanelContainer, {
                    children: tabsData.map((tab, i)=>/*#__PURE__*/ (0, $dypTs.jsx)($13e2b0d7d2657b7f$var$Panel, {
                            isSelected: i === selectedTab,
                            id: tab.id,
                            panel: tab.panel,
                            titleAs: i === 0 ? "h1" : "h2"
                        }, tab.id))
                })
            ]
        })
    });
};
var $13e2b0d7d2657b7f$export$2e2bcd8739ae039 = $13e2b0d7d2657b7f$export$b92905002f03c113;
const $13e2b0d7d2657b7f$var$TabList = ({ children: children, listRef: listRef, isTabListViewable: isTabListViewable })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_11q71hlo _1bsb1osq _syazcd5j _1reo15vq _18m915vq _18zrzwfg _su071wqb"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            // @ts-ignore
            ref: listRef,
            tabIndex: -1,
            role: "tablist",
            className: (0, $2jatx.default)([
                "_1tkegad4 _1e0c1txw _qtt8glyw _1mouidpf _195g1wug _18zridpf _1rjcie5z _1reo15zi _rjfvx6dd _b8yqzqdx _zcekze3t _kpfhglyw",
                isTabListViewable && "_1bah1h6o"
            ]),
            children: children
        })
    });
};
const $13e2b0d7d2657b7f$var$Tab = ({ children: children, isSelected: isSelected, id: id, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("button", {
        type: "button",
        tabIndex: isSelected ? 0 : -1,
        role: "tab",
        "aria-selected": isSelected ? "true" : "false",
        "aria-controls": `hero-panel-${id}`,
        id: `hero-tab-${id}`,
        onClick: onClick,
        onKeyDown: onKeyDown,
        "data-label": `hero-tab-${id}`,
        className: (0, $2jatx.default)([
            "_mqm21kma _v564ucvz _179rglyw _h7alglyw _r06hglyw _bfhk1j28 _ect41kw7 _1wyb1j6v _1bsb1ltq _1ul91ltq _80omtlke _1hu1v2br _1rjcu2gc _18zr1ejb _4cvrv2br _1e0c1txw _2lx21bp4 _zulp12x7 _ihhukb7n _n41hkb7n",
            isSelected && "_mqm21hn9 _1mrhkb7n"
        ]),
        style: {
            "--_1vwzriw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.yellow"))
        },
        children: children
    });
};
const $13e2b0d7d2657b7f$var$PanelContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5"
        ]),
        children: children
    });
};
const $13e2b0d7d2657b7f$var$Panel = (_param)=>{
    var { isSelected: isSelected, id: id, panel: panel } = _param, props = (0, $aPnCa._)(_param, [
        "isSelected",
        "id",
        "panel"
    ]);
    var _panel_secondaryCallToAction, _panel_bgImage, _panel_secondaryCallToAction1;
    const [isModalOpen, setIsModalOpen] = (0, $gljCV.useState)(false);
    const baseStyle = null;
    const isVideoLink = ((_panel_secondaryCallToAction = panel.secondaryCallToAction) === null || _panel_secondaryCallToAction === void 0 ? void 0 : _panel_secondaryCallToAction.type) === "video";
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        role: "tabpanel",
        id: `hero-panel-${id}`,
        "data-testid": `hero-panel-${id}`,
        "aria-hidden": !isSelected,
        "aria-labelledby": `hero-tab-${id}`,
        className: (0, $2jatx.default)([
            "_v564twcc _yyhy183o _1ii7183o _1e0c11p5 _tzy4idpf _1pby1mrw _kqswh2mm",
            isSelected && "_tzy4kb7n _1pbykb7n",
            "_1kt9b3bt _1g0v1mrw _1cs8stnw _1tesidpf _1rusu6yl _aetrb3bt _1bqq1mrw _18postnw _16gxidpf _z0ai1osq _wbcj14i6 _1kje1h6o _1hfku6yl _1a1fdirt _19h91dfr _z0bc12wd"
        ]),
        style: {
            "--bg-color": panel.bgColor === "neutral" ? (0, $kbpa7.wacToken)(`color.neutral.light200`) : (0, $kbpa7.wacToken)(`color.primary.${panel.bgColor}`),
            "--_1gk99st": (0, $6ZVlx.default)(((_panel_bgImage = panel.bgImage) === null || _panel_bgImage === void 0 ? void 0 : _panel_bgImage.lg) ? `url(${panel.bgImage.lg})` : undefined),
            "--_xe4ghn": (0, $6ZVlx.default)(panel.layout === "end" ? "0% 50%" : "center center")
        },
        children: [
            isVideoLink && /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Modal), {
                isOpen: isModalOpen,
                closeModal: ()=>{
                    setIsModalOpen(false);
                },
                closeLabel: "Close video",
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $8EEDU.default), {
                    muted: false,
                    videoType: "mp4",
                    videoLink: (_panel_secondaryCallToAction1 = panel.secondaryCallToAction) === null || _panel_secondaryCallToAction1 === void 0 ? void 0 : _panel_secondaryCallToAction1.href
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_yyhy183o _1ii7183o _18zrzwfg _1rjcxncg _1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp1ejb _1qon1h6o _1lb81h6o _5qqy1h6o _su071wqb _1rqtcx6w _pdlmxy5q _10jxzqdx",
                    panel.layout === "end" ? "_1uyy1d44 _1cxzv2br _10wbv2br _s0n3v2br" : panel.layout === "start" ? "_1uyy1vi5 _1cxzv2br _10wbv2br _s0n3v2br" : "_1uyyeqnf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)($13e2b0d7d2657b7f$var$PanelContent, {
                        panel: panel,
                        titleAs: props.titleAs
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)($13e2b0d7d2657b7f$var$PanelActions, (0, $dPABA._)((0, $6ogO3._)({}, panel), {
                        onVideoClick: isVideoLink ? (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            setIsModalOpen(true);
                        } : undefined
                    }))
                ]
            })
        ]
    });
};
const $13e2b0d7d2657b7f$var$PanelContent = (_param)=>{
    var { panel: panel } = _param, props = (0, $aPnCa._)(_param, [
        "panel"
    ]);
    // We need to think about this more holistically going forward, instead of on a per component level
    const isForegroundLight = [
        "blue",
        "black"
    ].includes(panel.bgColor);
    const { titleAs: Title = "h2" } = props;
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)(Title, {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    isForegroundLight && "_syaz121t",
                    "h1"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: panel.title
            }),
            panel.body && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    isForegroundLight && "_syaz121t",
                    "body-lg"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: panel.body
            })
        ]
    });
};
const $13e2b0d7d2657b7f$var$PanelActions = (panel)=>{
    return panel && /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1n261g80 _zulp1ejb",
            (panel.layout === "start" || panel.layout === "end") && "_msupv2br"
        ]),
        children: [
            panel.primaryCallToAction && /*#__PURE__*/ (0, $dypTs.jsx)($13e2b0d7d2657b7f$var$PrimaryCallToAction, (0, $6ogO3._)({
                bgColor: panel.bgColor
            }, panel.primaryCallToAction)),
            panel.secondaryCallToAction && /*#__PURE__*/ (0, $dypTs.jsx)($13e2b0d7d2657b7f$var$SecondaryCallToAction, (0, $6ogO3._)({}, panel))
        ]
    });
};
const $13e2b0d7d2657b7f$var$PrimaryCallToAction = (props)=>{
    const { bgColor: bgColor } = props, rest = (0, $aPnCa._)(props, [
        "bgColor"
    ]);
    let variant = "primary";
    if (bgColor === "blue") variant = "primary_alt";
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $lqyi6.Button), (0, $dPABA._)((0, $6ogO3._)({}, rest), {
        variant: variant,
        "data-testid": "primary-cta",
        children: props.text
    }));
};
const $13e2b0d7d2657b7f$var$SecondaryCallToAction = (panel)=>{
    const { secondaryCallToAction: secondaryCallToAction } = panel;
    const bgColor = [
        "blue",
        "black"
    ].includes(panel.bgColor) ? "bgBlackBlue" : "bgWhite";
    return(// @ts-ignore
    /*#__PURE__*/ (0, $dypTs.jsx)((0, $iPPTB.Link), (0, $dPABA._)((0, $6ogO3._)({}, secondaryCallToAction), {
        bgColor: bgColor,
        anchorProps: {
            "data-testid": "secondary-cta"
        },
        onClick: panel.onVideoClick
    })));
};
const $13e2b0d7d2657b7f$var$sectionStyles = null;
const $13e2b0d7d2657b7f$var$tabListStyle = null;
const $13e2b0d7d2657b7f$var$scrollableStyle = null;
const $13e2b0d7d2657b7f$var$fittableStyle = null;
const $13e2b0d7d2657b7f$var$tabStyle = null;
const $13e2b0d7d2657b7f$var$tabTextStyle = null;
/* Need to refactor our default typography to reduce need for important on a classless paragraph */ const $13e2b0d7d2657b7f$var$tabTitleStyle = null;
const $13e2b0d7d2657b7f$var$tabSelectedStyle = null;
const $13e2b0d7d2657b7f$var$panelContainerStyle = null;
const $13e2b0d7d2657b7f$var$panelStyle = null;
const $13e2b0d7d2657b7f$var$panelSelectedStyle = null;
const $13e2b0d7d2657b7f$var$panelDetailsStyle = null;
const $13e2b0d7d2657b7f$var$panelEndStyle = null;
const $13e2b0d7d2657b7f$var$panelStartStyle = null;
const $13e2b0d7d2657b7f$var$panelCenteredStyle = null;
const $13e2b0d7d2657b7f$var$detailsTextStyle = null;
const $13e2b0d7d2657b7f$var$panelColorStyle = null;
const $13e2b0d7d2657b7f$var$actionContainerStyle = null;
const $13e2b0d7d2657b7f$var$actionStartStyle = null;

});

parcelRegister("ifNiy", function(module, exports) {
$parcel$export(module.exports, "Integration", function () { return $945afc5e0498e2e0$export$8912007324034abd; });
/* integration.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $945afc5e0498e2e0$var$logoSizes = {
    regular: {
        size: "78px",
        cornerRadius: "18.7px"
    },
    large: {
        size: "100px",
        cornerRadius: "24px"
    }
};
const $945afc5e0498e2e0$var$IntegrationLogo = (props)=>{
    const logoListItemStyles = null;
    const logoLinkStyles = null;
    const logoImageContainerStyles = null;
    if (!props.href) return null;
    return /*#__PURE__*/ (0, $dypTs.jsx)("li", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _1bsbcae7 _4t3icae7 _bfhkcd5j _19it1k0a _2rko13r7 _gltef22m _165tf22m _2oz41w8s _1dbz1cd0"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300")),
            "--_1jpuyj7": (0, $6ZVlx.default)($945afc5e0498e2e0$var$logoSizes[props.logoSize].size),
            "--_1k7rxgg": (0, $6ZVlx.default)($945afc5e0498e2e0$var$logoSizes[props.logoSize].cornerRadius)
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)("a", {
            href: props.href,
            className: (0, $2jatx.default)([
                "_1e0c1txw _4t3i1osq _1bsb1osq _4cvr1h6o _1bah1h6o _1yt4u2gc"
            ]),
            children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbsq37 _4t3isbdl"
                ]),
                style: {
                    "--_1hn5070": (0, $6ZVlx.default)(props.width ? `${props.width}px` : "100%"),
                    "--_1jk4xy3": (0, $6ZVlx.default)(props.width ? "auto" : "100%")
                },
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                    src: props.src,
                    alt: props.alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            })
        })
    });
};
const $945afc5e0498e2e0$export$8912007324034abd = ({ eyebrow: eyebrow, title: title, titleAs: titleAs = "h3", body: body, linkLabel: linkLabel, linkHref: linkHref, logos: logos, background: background = "polygon", backgroundColor: backgroundColor = "neutral.light100", flipLayout: flipLayout = false })=>{
    const numLogos = logos.filter((logo)=>{
        var _logo_href;
        return (_logo_href = logo.href) !== null && _logo_href !== void 0 ? _logo_href : false;
    }).length;
    const logoSize = numLogos <= 6 ? "large" : "regular";
    const responsiveSectionDividerHeightsStyles = null;
    const sectionStyles = null;
    const polygonStyles = null;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _kqswh2mm _1moul8wr _11q7fulm _1rjcq9zu",
            "_9luy1wqb _ce5au29b _wfa7llbu"
        ]),
        style: {
            "--_pxzrua": (0, $6ZVlx.default)(background === "full" ? 0 : "var(--ds-space-800, 64px)"),
            "--_1sgx88i": (0, $6ZVlx.default)(background === "full" ? (0, $kbpa7.wacToken)(`color.${backgroundColor}`) : "transparent")
        },
        children: [
            background === "polygon" && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_11q71xvm _kqswstnw _1bsb1osq _4t3imhst _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s _1kt9b3bt _1cs8stnw _iajm14o7 _kfgtq9zu _1mp41osq _1s6k1xvm _tgsmcdv4 _aetrb3bt _18postnw _1qdgq9zu _19nq1osq _z0ai1osq _16r21xvm _1oj41mhh"
                ]),
                style: {
                    "--_vp2za": (0, $6ZVlx.default)((0, $kbpa7.wacToken)(`color.${backgroundColor}`))
                }
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_195g1wug _p12f1osq _1bsb1osq _kqswh2mm _1pbykb7n _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg _4t3i1osq _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1n261g80 _p12f1to9 _195g1wug _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bah1h6o _4cvr1h6o _1p571ejb _gy1pxy5q _8fz6nklw _688gkb7n",
                            flipLayout && "_1f49kb7n",
                            numLogos === 7 && "_w9am12am _1bhm12am"
                        ]),
                        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $dypTs.jsx)($945afc5e0498e2e0$var$IntegrationLogo, (0, $dPABA._)((0, $6ogO3._)({}, logo), {
                                logoSize: logoSize
                            }), index))
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.ContentBlock), {
                        eyebrow: eyebrow,
                        title: title,
                        titleAs: titleAs,
                        text: body,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref
                            }
                        } : undefined,
                        alignment: {
                            mobile: "center",
                            tablet: "start",
                            desktop: "start"
                        }
                    })
                ]
            })
        ]
    });
};
const $945afc5e0498e2e0$var$contentContainerStyles = null;
const $945afc5e0498e2e0$var$logosContainerStyles = null;
const $945afc5e0498e2e0$var$sevenLogosGridStyles = null;

});

parcelRegister("behZZ", function(module, exports) {
$parcel$export(module.exports, "Logos", function () { return $511c14fce74817fd$export$c847549a613b9060; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $2fk4i = parcelRequire("2fk4i");
const $511c14fce74817fd$export$c847549a613b9060 = ({ logos: logos })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1bah1h6o _1p57oahv _gy1pxy5q _99s6xncg _1plrxncg _4cvr1h6o"
        ]),
        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $dypTs.jsx)("li", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                    src: logo.src,
                    alt: logo.alt,
                    style: (0, $6ogO3._)({}, $511c14fce74817fd$var$logoStyles, logo.width ? {
                        width: `${logo.width}px`,
                        height: "auto"
                    } : {})
                })
            }, index))
    });
};
const $511c14fce74817fd$var$logosContainerStyle = null;
const $511c14fce74817fd$var$logoStyles = {
    height: "32px",
    width: "auto",
    maxWidth: "auto",
    filter: "grayscale(100%) brightness(66%)",
    ["-webkit-filter"]: "grayscale(100%) brightness(66%)"
};

});

parcelRegister("euqle", function(module, exports) {
$parcel$export(module.exports, "MobileApp", function () { return $dec4263d3b3e8269$export$f81bbe9088ca57b0; });
/* mobile-app.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $2fk4i = parcelRequire("2fk4i");
const $dec4263d3b3e8269$export$f81bbe9088ca57b0 = ({ title: title, description: description, linkLabel: linkLabel, linkHref: linkHref, imageSrc: imageSrc, imageAlt: imageAlt = "", appleAppStoreUrl: appleAppStoreUrl, googlePlayStoreUrl: googlePlayStoreUrl })=>{
    return /*#__PURE__*/ (0, $dypTs.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1pfhxncg"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1yd3xy5q _40tuxncg _1mou1wug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.ContentBlock), {
                        title: title,
                        titleAs: "h2",
                        text: description,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref
                            }
                        } : undefined
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _zulppxbi _1pfhxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)("a", {
                                href: appleAppStoreUrl,
                                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3g0xj4162q6vj8iis1nr5pkh2scjm13a.png",
                                    alt: "Download on the Apple App Store"
                                })
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsx)("a", {
                                href: googlePlayStoreUrl,
                                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/md1w60b88865q56fl84744t5u0heh751.png",
                                    alt: "Get it on the Google Play Store"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                    src: imageSrc,
                    alt: imageAlt,
                    className: (0, $2jatx.default)([
                        "_glte1osq _165t1pna _12rrk5xz _1vkhidpf _1x6l1osq _1bsb1osq _4t3ia91z _5ral1dfr _rsufq0ho"
                    ])
                })
            })
        ]
    });
};
const $dec4263d3b3e8269$var$sectionStyles = null;
const $dec4263d3b3e8269$var$leftSideContentStyles = null;
const $dec4263d3b3e8269$var$appStoreLinksContainerStyles = null;
const $dec4263d3b3e8269$var$imageContainerStyles = null;
const $dec4263d3b3e8269$var$imageStyles = null;

});

parcelRegister("5f18E", function(module, exports) {
$parcel$export(module.exports, "SideNav", function () { return $0ecd955324bfea13$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $46Ma8 = parcelRequire("46Ma8");

var $bxChG = parcelRequire("bxChG");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $0ecd955324bfea13$var$MobileExpandableNav = ({ title: title, children: children })=>{
    const [isExpanded, setIsExpanded] = (0, $gljCV.useState)(false);
    const [buttonBottom, setButtonBottom] = (0, $gljCV.useState)(0);
    const navRef = (0, $gljCV.useRef)(null);
    const buttonRef = (0, $gljCV.useRef)(null);
    const contentRef = (0, $gljCV.useRef)(null);
    const handleToggle = ()=>{
        setIsExpanded(!isExpanded);
    };
    // Calculate button position for nav positioning
    (0, $gljCV.useEffect)(()=>{
        const updateButtonPosition = ()=>{
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                setButtonBottom(rect.bottom);
            }
        };
        updateButtonPosition();
        window.addEventListener("resize", updateButtonPosition);
        window.addEventListener("scroll", updateButtonPosition);
        return ()=>{
            window.removeEventListener("resize", updateButtonPosition);
            window.removeEventListener("scroll", updateButtonPosition);
        };
    }, []);
    // Prevent body scroll when nav is open
    (0, $gljCV.useEffect)(()=>{
        if (isExpanded) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        isExpanded
    ]);
    // Handle click outside to close nav
    (0, $gljCV.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (isExpanded && navRef.current && !navRef.current.contains(event.target)) setIsExpanded(false);
        };
        if (isExpanded) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        ref: navRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)("button", {
                ref: buttonRef,
                onClick: handleToggle,
                "aria-expanded": isExpanded,
                "aria-controls": "mobile-side-nav-content",
                className: (0, $2jatx.default)([
                    "_1bsb1osq _4t3i1wqb _bfhk150w _19itglyw _1yt41hnt _1e0c1txw _4cvr1h6o _zulpu2gc _80omtlke _v564mfn2 _kqswh2mm _1pbyibnn _irr3u4vp _s51sxy5q"
                ]),
                style: {
                    "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                    "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                },
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_4t3i1ejb _1bsb1ejb _1e0c1txw _4cvr1h6o _1bah1h6o _syaz17la"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                        },
                        children: isExpanded ? /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxChG))), {
                            label: ""
                        }) : /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($46Ma8))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: "eyebrow-md",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                ref: contentRef,
                id: "mobile-side-nav-content",
                className: (0, $2jatx.default)([
                    "_bfhkcd5j _1bsb1osq _18zr1wqb _v564vpel _1reo1wug _18m91wug _s51sxy5q",
                    isExpanded ? "_kqsw1n9t _152t1um1 _dk5didpf _u7coidpf _1bsbauwl _4t3iqi8f _c71lqi8f _tzy4kb7n _1pbyzo7u _1reo15vq _18m915vq _bfhkcd5j _1q51v47k _85i51wqb _18zr1wqb _s51sxy5q" : "_kqsw1n9t _c71lidpf _tzy4idpf _lcxvglyw _152tidpf _dk5didpf _1bsbauwl"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_ab93rs": (0, $6ZVlx.default)(buttonBottom, "px")
                },
                children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1reo1wug _18m91wug"
                    ]),
                    children: children
                })
            })
        ]
    });
};
const $0ecd955324bfea13$export$6b43f262d1299a2e = ({ sideNavItems: sideNavItems })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_qtt8glyw _18s8ze3t _1yt4ze3t _1reo1wug _18m91wug _1jc21nkh _1xey1k0a",
            "sidenav-menu"
        ]),
        style: {
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
        },
        children: sideNavItems.map((sideNavItem)=>{
            if (sideNavItem.type === "collection") return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.SideNavCollection), {
                type: "collection",
                collectionName: sideNavItem.collectionName,
                sideNavItems: sideNavItem.sideNavItems,
                depth: 0
            }, sideNavItem.collectionName);
            if (sideNavItem.type === "link") return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.SideNavLink), {
                dataEventProps: sideNavItem.dataEventProps,
                type: "link",
                text: sideNavItem.text,
                href: sideNavItem.href,
                anchors: sideNavItem.anchors,
                depth: 0
            }, sideNavItem.text);
            return null;
        })
    });
};
const $0ecd955324bfea13$export$1a35787d6353cf6a = ({ title: title, sideNavItems: sideNavItems })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)("nav", {
                id: "side-nav-desktop",
                "aria-label": intl.formatMessage({
                    id: "hub.sidenav.desktop.label",
                    defaultMessage: `{hub_topics} desktop navigation`
                }, {
                    hub_topics: title
                }),
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_kqsw1if8 _152t1dln",
                    "_19ityzqy _2rkovwyg _1yt4v47k _85i51wqb _4t3i1ns9"
                ]),
                style: {
                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
                },
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1tke1wqb _1yt41dg4",
                            "eyebrow-md"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)($0ecd955324bfea13$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("nav", {
                id: "side-nav-tablet-mobile",
                "aria-label": intl.formatMessage({
                    id: "hub.sidenav.mobile.label",
                    defaultMessage: `{hub_topics} mobile navigation`
                }, {
                    hub_topics: title
                }),
                className: (0, $2jatx.default)([
                    "_dm25glyw",
                    "_kqsw1n9t _1e02idpf _1pbyegat _1bsbauwl"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)($0ecd955324bfea13$var$MobileExpandableNav, {
                    title: title,
                    children: /*#__PURE__*/ (0, $dypTs.jsx)($0ecd955324bfea13$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_dm25glyw",
                    "_4t3i1wqb"
                ])
            })
        ]
    });
};
const $0ecd955324bfea13$var$desktopCss = null;
const $0ecd955324bfea13$var$tabletMobileCss = null;
const $0ecd955324bfea13$var$stickyCss = null;
const $0ecd955324bfea13$var$fixedCss = null;
const $0ecd955324bfea13$var$listCss = null;
const $0ecd955324bfea13$var$containerCss = null;
const $0ecd955324bfea13$var$desktopTitleCss = null;
const $0ecd955324bfea13$var$mobileIconCss = null;
const $0ecd955324bfea13$var$mobileExpandableButtonCss = null;
const $0ecd955324bfea13$var$mobileNavContentCss = null;
const $0ecd955324bfea13$var$mobileNavContentCollapsedCss = null;
const $0ecd955324bfea13$var$mobileInnerContentCss = null;

});

parcelRegister("5uGt2", function(module, exports) {
$parcel$export(module.exports, "useTabsContext", function () { return (parcelRequire("aeZV4")).useTabsContext; });
$parcel$export(module.exports, "Tabs", function () { return (parcelRequire("aeZV4")).Tabs; });
$parcel$export(module.exports, "DraggableTabList", function () { return (parcelRequire("6Iidb")).DraggableTabList; });
$parcel$export(module.exports, "DraggableTab", function () { return (parcelRequire("4q5Ua")).DraggableTab; });
$parcel$export(module.exports, "TabPanel", function () { return (parcelRequire("kFhJA")).TabPanel; });
$parcel$export(module.exports, "TabsSection", function () { return (parcelRequire("7kpd6")).TabsSection; });
$parcel$export(module.exports, "mapChild", function () { return (parcelRequire("jgQie")).mapChild; });

var $aeZV4 = parcelRequire("aeZV4");

var $6Iidb = parcelRequire("6Iidb");

var $4q5Ua = parcelRequire("4q5Ua");

var $kFhJA = parcelRequire("kFhJA");

var $7kpd6 = parcelRequire("7kpd6");

var $jgQie = parcelRequire("jgQie");

});
parcelRegister("aeZV4", function(module, exports) {
$parcel$export(module.exports, "useTabsContext", function () { return $0f3c3abb0b914582$export$5c3d36c3adf0ba92; });
$parcel$export(module.exports, "Tabs", function () { return $0f3c3abb0b914582$export$b2539bed5023c21c; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $aHkxS = parcelRequire("aHkxS");

var $jgQie = parcelRequire("jgQie");
const $0f3c3abb0b914582$var$TabsContext = /*#__PURE__*/ (0, $gljCV.createContext)(null);
const $0f3c3abb0b914582$export$5c3d36c3adf0ba92 = ()=>{
    const context = (0, $gljCV.useContext)($0f3c3abb0b914582$var$TabsContext);
    if (!context) throw new Error("useTabsContext must be used within Tabs");
    return context;
};
let $0f3c3abb0b914582$var$nextId = 0;
const $0f3c3abb0b914582$export$b2539bed5023c21c = ({ id: id, initialTab: initialTab, loop: loop = true, children: children, useInViewOptionsContainer: useInViewOptionsContainer })=>{
    const [currentTab, setCurrentTab] = (0, $gljCV.useState)(initialTab !== null && initialTab !== void 0 ? initialTab : 0);
    const [userSelected, setUserSelected] = (0, $gljCV.useState)(false);
    const [focus, setFocus] = (0, $gljCV.useState)(false);
    const tabIds = (0, $gljCV.useRef)([]);
    const contextId = (0, $gljCV.useRef)(`:tabs:${id ? id : $0f3c3abb0b914582$var$nextId++}:`);
    const DEFAULT_IN_VIEW_THRESHOLD = 0.3;
    const { ref: containerScrollRef, inView: tabsContainerIsVisible } = (0, $jKShK.useInView)((0, $6ogO3._)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    }, useInViewOptionsContainer));
    const { ref: tabListScrollRef, inView: tabListIsVisible } = (0, $jKShK.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    });
    function getTabsCount() {
        let count = 0;
        (0, $jgQie.deepForEach)(children, (child)=>{
            if ((0, $jgQie.isTab)(child)) count++;
        });
        return count;
    }
    function getChildren() {
        let panelIndex = 0;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - getTabsCount();
        // Add ids if new tabs have been added
        // Don't bother removing ids, just keep them in case they are added again
        // This is more efficient, and keeps the uuid counter under control
        while(diff++ < 0)tabIds.current.push(`${contextId.current}${tabIds.current.length}`);
        // Map children to dynamically setup refs
        return (0, $jgQie.deepMap)(children, (child)=>{
            var _window_document_activeElement;
            let result = child;
            // Check if the window is available
            const windowAvailable = !!window && !!window.document && !!window.document.activeElement;
            // Get the active element id
            const activeElementId = windowAvailable ? (_window_document_activeElement = window.document.activeElement) === null || _window_document_activeElement === void 0 ? void 0 : _window_document_activeElement.id : null;
            // Clone TabList and Tab components to have refs
            if ((0, $jgQie.isTabList)(child)) {
                let listIndex = 0;
                // Figure out if the current focus in the DOM is set on a Tab
                // If it is we should keep the focus on the next selected tab
                let wasTabFocus = false;
                if (windowAvailable && activeElementId) // Check if the active element is a tab
                wasTabFocus = (0, $gljCV.Children).toArray(child.props.children).filter((0, $jgQie.isTab)).some((_, i)=>{
                    return activeElementId === `tab${tabIds.current[i]}`;
                });
                result = /*#__PURE__*/ (0, $gljCV.cloneElement)(child, {
                    children: (0, $jgQie.deepMap)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    child.props.children, (tab)=>{
                        const selected = currentTab === listIndex;
                        const props = {
                            id: tabIds.current[listIndex],
                            tabIndex: listIndex,
                            focus: selected && (focus || wasTabFocus)
                        };
                        listIndex++;
                        return /*#__PURE__*/ (0, $gljCV.cloneElement)(tab, props);
                    })
                });
            } else if ((0, $jgQie.isTabPanel)(child)) {
                // Preserve existing props (like hideTabPanelRole) when cloning
                const existingProps = child.props || {};
                const props = (0, $dPABA._)((0, $6ogO3._)({}, existingProps), {
                    id: tabIds.current[panelIndex],
                    panelIndex: panelIndex
                });
                panelIndex++;
                result = /*#__PURE__*/ (0, $gljCV.cloneElement)(child, props);
            }
            return result;
        });
    }
    const goToTab = (tabIndex)=>{
        if (tabIndex === undefined) return;
        setCurrentTab(tabIndex);
    };
    const isCurrentTab = (tabIndex)=>{
        return tabIndex === currentTab;
    };
    const goToNextTab = (0, $gljCV.useCallback)(()=>{
        if (currentTab + 1 < tabIds.current.length) goToTab(currentTab + 1);
        else if (loop) goToTab(0);
    }, [
        loop,
        currentTab
    ]);
    const goToPrevTab = (0, $gljCV.useCallback)(()=>{
        if (currentTab - 1 >= 0) goToTab(currentTab - 1);
        else if (loop) goToTab(tabIds.current.length - 1);
    }, [
        loop,
        currentTab
    ]);
    const goToFirstTab = ()=>{
        goToTab(0);
    };
    const goToLastTab = ()=>{
        goToTab(tabIds.current.length - 1);
    };
    const onKeyDown = (e)=>{
        if (e.code === "ArrowLeft" || e.code === "ArrowUp") goToPrevTab();
        else if (e.code === "ArrowRight" || e.code === "ArrowDown") goToNextTab();
        else if (e.code === "End") // Select last tab (End key)
        goToFirstTab();
        else if (e.code === "Home") // Select first tab (Home key)
        goToLastTab();
        else return;
        setUserSelected(true);
        setFocus(true);
        // This prevents scrollbars from moving around
        e.preventDefault();
    };
    // Reset the userSelected state when the section is visible again
    (0, $gljCV.useEffect)(()=>{
        if (tabsContainerIsVisible) setUserSelected(false);
    }, [
        tabsContainerIsVisible
    ]);
    // Reinitialize analytics when the tab changes
    // this is needed because the content wasn't rendered before
    (0, $gljCV.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        currentTab
    ]);
    const containerStyles = null;
    return /*#__PURE__*/ (0, $dypTs.jsx)($0f3c3abb0b914582$var$TabsContext.Provider, {
        value: {
            currentTab: currentTab,
            userSelected: userSelected,
            goToTab: goToTab,
            isCurrentTab: isCurrentTab,
            goToNextTab: goToNextTab,
            goToPrevTab: goToPrevTab,
            goToFirstTab: goToFirstTab,
            goToLastTab: goToLastTab,
            onKeyDown: onKeyDown,
            tabsContainerIsVisible: tabsContainerIsVisible,
            tabListIsVisible: tabListIsVisible,
            tabListScrollRef: tabListScrollRef
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            ref: containerScrollRef,
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulp1jfw _1reo15vq _18m915vq"
            ]),
            children: getChildren()
        })
    });
};

});
parcelRegister("jgQie", function(module, exports) {
$parcel$export(module.exports, "isTab", function () { return $5fe887815c1bacdb$export$bdc9792d96913679; });
$parcel$export(module.exports, "isTabList", function () { return $5fe887815c1bacdb$export$9c326233b9ae5588; });
$parcel$export(module.exports, "isTabPanel", function () { return $5fe887815c1bacdb$export$9e12445c79db89b; });
$parcel$export(module.exports, "mapChild", function () { return $5fe887815c1bacdb$export$886f34b49305b07b; });
$parcel$export(module.exports, "deepMap", function () { return $5fe887815c1bacdb$export$ce7eaaed37329a1b; });
$parcel$export(module.exports, "deepForEach", function () { return $5fe887815c1bacdb$export$519ada94592b97fc; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $gljCV = parcelRequire("gljCV");
function $5fe887815c1bacdb$var$makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const $5fe887815c1bacdb$export$bdc9792d96913679 = $5fe887815c1bacdb$var$makeTypeChecker("Tab");
const $5fe887815c1bacdb$export$9c326233b9ae5588 = $5fe887815c1bacdb$var$makeTypeChecker("TabList");
const $5fe887815c1bacdb$export$9e12445c79db89b = $5fe887815c1bacdb$var$makeTypeChecker("TabPanel");
const $5fe887815c1bacdb$export$dbaa4172856e20ab = (element)=>!!element.type && typeof element.type === "function";
function $5fe887815c1bacdb$var$isTabChild(child) {
    return $5fe887815c1bacdb$export$bdc9792d96913679(child) || $5fe887815c1bacdb$export$9c326233b9ae5588(child) || $5fe887815c1bacdb$export$9e12445c79db89b(child);
}
function $5fe887815c1bacdb$export$886f34b49305b07b(child, additionalProps) {
    if (child === null) return null;
    // Only pass additionalProps to functional components
    // React.cloneElement will throw an error if you pass additionalProps to a dom component like div
    if ($5fe887815c1bacdb$export$dbaa4172856e20ab(child)) return (0, $gljCV.cloneElement)(child, (0, $6ogO3._)({}, child.props, additionalProps));
    return child;
}
function $5fe887815c1bacdb$export$ce7eaaed37329a1b(children, callback) {
    return (0, $gljCV.Children).map(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return null;
        if ($5fe887815c1bacdb$var$isTabChild(child)) return callback(child, index);
        if (child && child.props && child.props.children && typeof child.props.children === "object") // Clone the child that has children and map them too
        return (0, $gljCV.cloneElement)(child, (0, $dPABA._)((0, $6ogO3._)({}, child.props), {
            children: $5fe887815c1bacdb$export$ce7eaaed37329a1b(child.props.children, callback)
        }));
        return child;
    });
}
function $5fe887815c1bacdb$export$519ada94592b97fc(children, callback) {
    return (0, $gljCV.Children).forEach(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return;
        if ($5fe887815c1bacdb$export$bdc9792d96913679(child) || $5fe887815c1bacdb$export$9e12445c79db89b(child)) callback(child, index);
        else if (child && child.props && child.props.children && typeof child.props.children === "object") {
            if ($5fe887815c1bacdb$export$9c326233b9ae5588(child)) callback(child, index);
            $5fe887815c1bacdb$export$519ada94592b97fc(child.props.children, callback);
        }
    });
}

});


parcelRegister("6Iidb", function(module, exports) {
$parcel$export(module.exports, "DraggableTabList", function () { return $5334c6b54e489af6$export$dbb4ac5a817c6612; });
/* draggable-tab-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
parcelRequire("5uGt2");
var $aeZV4 = parcelRequire("aeZV4");
const $5334c6b54e489af6$export$dbb4ac5a817c6612 = ({ alignment: alignment = "start", tabSize: // @ts-ignore
tabSize = "large", children: children })=>{
    const containerRef = (0, $gljCV.useRef)(null);
    const mouseDown = (0, $gljCV.useRef)(false);
    const startX = (0, $gljCV.useRef)(0);
    const scrollLeft = (0, $gljCV.useRef)(0);
    const canDrag = (0, $gljCV.useRef)(false);
    const { onKeyDown: onKeyDown } = (0, $aeZV4.useTabsContext)();
    const startDragging = (mouse, touch)=>{
        var _containerRef_current;
        if (!canDrag.current) return;
        // Start listening for mouseup and mousemove events outside of the tab list
        document.addEventListener("mouseup", stopDragging);
        document.addEventListener("mousemove", move);
        mouseDown.current = true;
        var _ref;
        startX.current = (_ref = touch && touch.touches[0] ? touch.touches[0].clientX : mouse === null || mouse === void 0 ? void 0 : mouse.clientX) !== null && _ref !== void 0 ? _ref : 0;
        var _containerRef_current_scrollLeft;
        scrollLeft.current = (_containerRef_current_scrollLeft = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.scrollLeft) !== null && _containerRef_current_scrollLeft !== void 0 ? _containerRef_current_scrollLeft : 0;
    };
    const stopDragging = ()=>{
        if (!canDrag.current) return;
        // Stop listening for mouseup and mousemove events
        document.removeEventListener("mouseup", stopDragging);
        document.removeEventListener("mousemove", move);
        mouseDown.current = false;
    };
    const move = (mouse, touch)=>{
        if (!canDrag.current || !mouseDown.current || !containerRef.current) return;
        let dragAmount = 0;
        if (touch && touch.changedTouches[0]) dragAmount = touch.changedTouches[0].clientX - startX.current;
        else if (mouse) dragAmount = mouse.clientX - startX.current;
        containerRef.current.scrollLeft = scrollLeft.current - dragAmount;
    };
    (0, $gljCV.useEffect)(()=>{
        const updateCanDrag = ()=>{
            if (containerRef.current) {
                const container = containerRef.current;
                canDrag.current = container.scrollWidth > container.clientWidth;
            }
        };
        const setStartingPoint = ()=>{
            if (containerRef.current) {
                if (canDrag.current) {
                    const tabPanels = document.querySelector(".tab-panels");
                    const tabPanelsStyle = tabPanels && window.getComputedStyle(tabPanels);
                    containerRef.current.setAttribute("style", `padding-left: calc(${tabPanelsStyle === null || tabPanelsStyle === void 0 ? void 0 : tabPanelsStyle.marginLeft} + ${tabPanelsStyle === null || tabPanelsStyle === void 0 ? void 0 : tabPanelsStyle.paddingLeft});`);
                } else if (alignment === "start") containerRef.current.setAttribute("style", "margin-inline: 0px; padding-inline: 0px;");
            }
        };
        if (!containerRef.current) return;
        const observer = new ResizeObserver(()=>{
            updateCanDrag();
            setStartingPoint();
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    });
    const wrapperStyle = null;
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_1reo15vq _p12f1osq _195g1wug _18zrzwfg _11q81vi7 _su071wqb _3hzp1wqb"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            // @ts-ignore
            onTouchStart: (e)=>startDragging(undefined, e),
            // @ts-ignore
            onMouseDown: (e)=>startDragging(e),
            // @ts-ignore
            onTouchEnd: (e)=>{
                // @ts-ignore
                move(undefined, e);
                stopDragging();
            },
            // @ts-ignore
            onTouchMove: (e)=>move(undefined, e),
            onKeyDown: onKeyDown,
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1y6m _1bah1y6m _1n261q9c _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _1bsb1ns9 _p12f1osq _1moupxbi _zulp1ejb",
                "tab-list"
            ]),
            tabIndex: -1,
            role: "tablist",
            children: children
        })
    });
};
const $5334c6b54e489af6$var$tabsContainerStyles = null;
$5334c6b54e489af6$export$dbb4ac5a817c6612.tabsRole = "TabList";

});

parcelRegister("4q5Ua", function(module, exports) {
$parcel$export(module.exports, "DraggableTab", function () { return $2726a747230786c6$export$3a29ca89d63c5c20; });
/* draggable-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("5uGt2");
var $aeZV4 = parcelRequire("aeZV4");
// eslint-disable-next-line complexity
const $2726a747230786c6$export$3a29ca89d63c5c20 = (_param)=>{
    var { id: id, focus: focus, tabIndex: tabIndex, title: title, iconUrl: iconUrl, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", label: label, dataEventProps: dataEventProps, className: className, enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false } = _param, props = (0, $aPnCa._)(_param, [
        "id",
        "focus",
        "tabIndex",
        "title",
        "iconUrl",
        "tabSize",
        "bgColor",
        "label",
        "dataEventProps",
        "className",
        "enableRovoBorder",
        "enableResponsiveTabSize"
    ]);
    const { goToTab: goToTab, isCurrentTab: isCurrentTab, userSelected: userSelected } = (0, $aeZV4.useTabsContext)();
    const startX = (0, $gljCV.useRef)(0);
    const tabRef = /*#__PURE__*/ (0, $gljCV.createRef)();
    const isTabSelected = isCurrentTab(tabIndex);
    (0, $gljCV.useEffect)(()=>{
        if (!tabRef.current || !tabRef.current.parentElement || !tabRef.current.parentElement.scrollTo || !tabRef.current.parentElement.parentElement || !tabRef.current.parentElement.parentElement.scrollTo) return;
        // Scroll to the selected tab if it's not in view
        if (isTabSelected) {
            var _tabRef_current_parentElement;
            if ((_tabRef_current_parentElement = tabRef.current.parentElement) === null || _tabRef_current_parentElement === void 0 ? void 0 : _tabRef_current_parentElement.parentElement) {
                // calculate the offset to center the tab in the parent
                const offsetLeft = tabRef.current.offsetLeft - tabRef.current.parentElement.offsetLeft - tabRef.current.parentElement.offsetWidth / 2 + tabRef.current.offsetWidth / 2;
                tabRef.current.parentElement.parentElement.scrollTo({
                    left: offsetLeft,
                    top: 0,
                    behavior: "smooth"
                });
            }
            if (focus) tabRef.current.focus({
                preventScroll: true
            });
        }
        if (isTabSelected && dataEventProps && userSelected) tabRef.current.dispatchEvent(new Event("select"));
    }, [
        tabRef,
        isTabSelected,
        focus,
        userSelected,
        dataEventProps
    ]);
    const onMouseDown = (e)=>{
        var _props_onMouseDown;
        var _e_clientX;
        startX.current = (_e_clientX = e.clientX) !== null && _e_clientX !== void 0 ? _e_clientX : 0;
        (_props_onMouseDown = props.onMouseDown) === null || _props_onMouseDown === void 0 ? void 0 : _props_onMouseDown.call(props, e);
    };
    const onClick = (0, $gljCV.useCallback)((e)=>{
        var _props_onClick;
        if (Math.abs(e.clientX - startX.current) > 15) // Prevent click event if user is dragging
        return;
        (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props, e);
        if (isTabSelected) return;
        goToTab(tabIndex);
    }, [
        isTabSelected,
        tabIndex,
        goToTab,
        props
    ]);
    const onKeyDown = (e)=>{
        if (e.code === "Space" || e.code === "Enter") {
            goToTab(tabIndex);
            e.preventDefault();
        }
    };
    const tabColor = bgColor === "bgWhite" ? (0, $kbpa7.wacToken)("color.neutral.light200") : (0, $kbpa7.wacToken)("color.neutral.light0");
    const tabStyles = null;
    const rovoBorderStyles = null;
    const borderStyles = null;
    const largeTabStyles = null;
    const smallTabStyles = null;
    const iconTabStyles = null;
    const iconLargeTabStyles = null;
    const iconSmallTabStyles = null;
    const responsiveIconTabStyles = null;
    const iconLargeContainerStyles = null;
    const iconSmallContainerStyles = null;
    const responsiveIconContainerStyles = null;
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", (0, $dPABA._)((0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, props), {
        // @ts-ignore
        ref: tabRef,
        // @ts-ignore
        className: className,
        id: `tab${id}`,
        "aria-selected": isTabSelected,
        "aria-controls": `panel${id}`,
        "aria-label": label,
        title: label,
        // @ts-ignore
        onMouseDown: onMouseDown,
        // @ts-ignore
        onClick: onClick,
        // @ts-ignore
        onKeyDown: onKeyDown,
        role: "tab",
        tabIndex: -1
    }), dataEventProps), {
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("button", {
            className: (0, $2jatx.default)([
                "_o5721q9c _1ul9ymf6 _bfhk1jrh _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko17td _19itq75r _80omtlke _4cvx17la _8y9r1hlo",
                iconUrl && "_2lx21bp4 _2rkoi2wt _1wyb1j6v",
                iconUrl && enableRovoBorder ? "_1h6d1j28 _1s79mzrp _1esp1ws1 _494pusvi _iusibx47" : "_1npj1ybm _1s7917la",
                iconUrl && enableResponsiveTabSize && "_4t3i1n2x _1ul9176v _1yt437zh _1xlocmky _1d2y11ux _6ytt139i",
                !iconUrl && tabSize === "large" && "_ca0qdlk8 _u5f31f4h _n3tddlk8 _19bv1f4h _vwz41f4h _4t3i1wqb _1wyb1cby",
                !iconUrl && tabSize === "small" && "_1yt41c98 _vwz4v47k _4t3i1ylp _1wyb1j6v",
                iconUrl && !enableResponsiveTabSize && tabSize === "large" && "_4t3icmky _1ul911ux _1yt4139i",
                iconUrl && !enableResponsiveTabSize && tabSize === "small" && "_4t3i1n2x _1ul9176v _1yt437zh",
                `${isTabSelected ? "currentTab" : ""}`
            ]),
            // how to adjust for different page? or just remove?
            "data-product-key": "template",
            "data-event": "clicked",
            "data-event-component": "button",
            "data-event-container": "tabsMenu",
            "data-label": title,
            style: {
                "--_7aj7gm": (0, $6ZVlx.default)(tabColor),
                "--_514je1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.pill")),
                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
            },
            children: [
                iconUrl && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        !enableResponsiveTabSize && tabSize === "large" && "_4t3ickbl _1bsbckbl",
                        !enableResponsiveTabSize && tabSize === "small" && "_4t3i10mc _1bsb10mc",
                        enableResponsiveTabSize && "_4t3i10mc _1bsb10mc _1xlockbl _14b5ckbl",
                        "default-icon"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                        src: `${iconUrl || ""}`,
                        alt: "",
                        draggable: false
                    })
                }),
                title
            ]
        })
    }));
};
$2726a747230786c6$export$3a29ca89d63c5c20.tabsRole = "Tab";

});

parcelRegister("kFhJA", function(module, exports) {
$parcel$export(module.exports, "TabPanel", function () { return $73f95d72bd57759d$export$3d96ec278d3efce4; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $lTkkF = parcelRequire("lTkkF");
parcelRequire("5uGt2");
var $jgQie = parcelRequire("jgQie");
var $aeZV4 = parcelRequire("aeZV4");
const $73f95d72bd57759d$var$hidePanelStyle = null;
const $73f95d72bd57759d$export$3d96ec278d3efce4 = (_param)=>{
    var { forceRender: forceRender, children: children, panelIndex: panelIndex, id: id, hideTabPanelRole: hideTabPanelRole } = _param, props = (0, $aPnCa._)(_param, [
        "forceRender",
        "children",
        "panelIndex",
        "id",
        "hideTabPanelRole"
    ]);
    const { isCurrentTab: isCurrentTab } = (0, $aeZV4.useTabsContext)();
    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? "active-panel" : "";
    const { panelId: panelId, tabId: tabId } = (0, $lTkkF.generateSafeIds)(id, panelIndex);
    const originalChildrenCount = (0, $gljCV.Children).count(children);
    const shouldHideRole = hideTabPanelRole !== undefined ? hideTabPanelRole : originalChildrenCount === 0;
    const { css: existingCss } = props, propsWithoutCss = (0, $aPnCa._)(props, [
        "css"
    ]);
    const filteredProps = Object.fromEntries(Object.entries(propsWithoutCss).filter(([key])=>!key.startsWith("aria-") && key !== "role"));
    if (!shouldHideRole) return /*#__PURE__*/ (0, $dypTs.jsx)("div", (0, $dPABA._)((0, $6ogO3._)({}, filteredProps), {
        id: panelId,
        "aria-labelledby": tabId,
        "aria-hidden": !isTabSelected,
        role: "tabpanel",
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        children: (0, $gljCV.Children).map(children, (child)=>{
            return (0, $jgQie.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    }));
    const cssProp = [
        !isTabSelected && !forceRender && $73f95d72bd57759d$var$hidePanelStyle
    ];
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        id: panelId,
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        "aria-labelledby": undefined,
        "aria-hidden": undefined,
        role: undefined,
        children: (0, $gljCV.Children).map(children, (child)=>{
            return (0, $jgQie.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
};
$73f95d72bd57759d$export$3d96ec278d3efce4.tabsRole = "TabPanel";

});

parcelRegister("7kpd6", function(module, exports) {
$parcel$export(module.exports, "TabsSection", function () { return $55e394e1b826b27b$export$502de1d4d55224c1; });
/* tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
parcelRequire("gljCV");
parcelRequire("5uGt2");
var $4q5Ua = parcelRequire("4q5Ua");
var $6Iidb = parcelRequire("6Iidb");
var $kFhJA = parcelRequire("kFhJA");
var $aeZV4 = parcelRequire("aeZV4");
const $55e394e1b826b27b$export$502de1d4d55224c1 = ({ alignment: alignment = "start", tabsData: tabsData, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false })=>{
    const sectionStyles = null;
    const fullWidthContainerStyles = null;
    const enableIconTabs = tabsData.every((tab)=>tab.iconUrl);
    return /*#__PURE__*/ (0, $dypTs.jsx)("section", {
        id: "tabs",
        className: (0, $2jatx.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsxs)((0, $aeZV4.Tabs), {
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)((0, $6Iidb.DraggableTabList), {
                    tabSize: tabSize,
                    alignment: alignment,
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $4q5Ua.DraggableTab), {
                            tabIndex: index,
                            title: tab.title,
                            iconUrl: enableIconTabs ? tab.iconUrl : undefined,
                            tabSize: tabSize,
                            bgColor: bgColor,
                            className: "round-tab",
                            enableRovoBorder: enableIconTabs && enableRovoBorder,
                            enableResponsiveTabSize: enableIconTabs && enableResponsiveTabSize
                        }, index))
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        tabSize === "large" && "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _1reoewfl _18m9ewfl _bozgzwfg _y4tizwfg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
                        "tab-panels"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $kFhJA.TabPanel), {
                            panelIndex: index,
                            id: tab.id || `tab-${index}`,
                            children: tab.tabComponent
                        }, index))
                })
            ]
        })
    });
};

});





parcelRegister("jrpGZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("k1kqo")).default; });

var $k1kqo = parcelRequire("k1kqo");

});
parcelRegister("k1kqo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $adfabc9115480b1c$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $2fk4i = parcelRequire("2fk4i");

var $lTkkF = parcelRequire("lTkkF");

var $kooLp = parcelRequire("kooLp");
const $adfabc9115480b1c$var$getBodyText = (props)=>{
    if (!props.body && !props.richText) return undefined;
    if (props.richText) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
        text: props.richText
    });
    return props.body;
};
const $adfabc9115480b1c$var$UniformCard = (props)=>{
    var _props_linkUrl;
    var _props_linkUrl_toString;
    const localizedHref = (0, $kooLp.useLocalizedHref)((_props_linkUrl_toString = (_props_linkUrl = props.linkUrl) === null || _props_linkUrl === void 0 ? void 0 : _props_linkUrl.toString()) !== null && _props_linkUrl_toString !== void 0 ? _props_linkUrl_toString : "");
    var _props_imageAlt;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Card), {
        align: props.alignment,
        orientation: props.orientation,
        columns: props.columns,
        background: props.background,
        eyebrow: props.eyebrow ? props.eyebrow : undefined,
        logo: props.logo,
        title: props.title ? props.title : undefined,
        titleAs: props.titleAs,
        body: $adfabc9115480b1c$var$getBodyText(props),
        callToAction: props.linkUrl && props.linkText ? {
            text: props.linkText,
            href: localizedHref,
            dataEventProps: {
                "data-product-key": "uniform",
                "data-event-component": "linkButton",
                "data-event-container": "card",
                "data-event": "clicked"
            }
        } : undefined,
        image: props.imageUrl ? {
            image: {
                src: props.imageUrl,
                alt: (_props_imageAlt = props.imageAlt) !== null && _props_imageAlt !== void 0 ? _props_imageAlt : ""
            }
        } : undefined,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize
            }
        } : undefined,
        spotIllustrationUrl: props.spotIllustrationUrl
    });
};
var $adfabc9115480b1c$export$2e2bcd8739ae039 = $adfabc9115480b1c$var$UniformCard;

});


parcelRegister("l95R2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("jswU3")).default; });

var $jswU3 = parcelRequire("jswU3");

});
parcelRegister("jswU3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f6d4cfc38fdffaa9$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $6jr7X = parcelRequire("6jr7X");

var $kU0PA = parcelRequire("kU0PA");

var $jfojT = parcelRequire("jfojT");
const $f6d4cfc38fdffaa9$var$UniformCollectionPricingHero = (props)=>{
    if (props.collectionType === "teamwork") return /*#__PURE__*/ (0, $dypTs.jsx)((0, $jfojT.TeamworkCollectionPricingHero), {});
    if (props.collectionType === "strategy") return /*#__PURE__*/ (0, $dypTs.jsx)((0, $kU0PA.StrategyCollectionPricingHero), {});
    if (props.collectionType === "service") return /*#__PURE__*/ (0, $dypTs.jsx)((0, $6jr7X.ServiceCollectionPricingHero), {});
    return null;
};
var $f6d4cfc38fdffaa9$export$2e2bcd8739ae039 = $f6d4cfc38fdffaa9$var$UniformCollectionPricingHero;

});
parcelRegister("6jr7X", function(module, exports) {
$parcel$export(module.exports, "ServiceCollectionPricingHero", function () { return $17930c441541a572$export$5eff9997197d8e50; });

var $dypTs = parcelRequire("dypTs");

var $e0LCf = parcelRequire("e0LCf");
const $17930c441541a572$export$5eff9997197d8e50 = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $e0LCf.CollectionPricingHero), {
        orientation: "vertical",
        collectionImage: {
            height: 48,
            width: 168,
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wq7706lsya8q6fb1sj2k15h48h450ssr.svg",
            alt: "Service Collection"
        },
        products: [
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7jcq40x67167gax15ux7b27r5r575tk5.svg",
                    alt: "Jira Service Management"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/466ke7l5j3i276s3p7k5660c525ru38d.svg",
                    alt: "Customer Service Management"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8hgm0up275i80h6m7b5j3f8t68a7fcp4.svg",
                    alt: "Assets"
                }
            },
            {
                name: "Rovo",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6kq772n08c357g2p82f8bnw824do06dn.svg",
                    alt: "Rovo"
                }
            }
        ]
    });
};

});

parcelRegister("kU0PA", function(module, exports) {
$parcel$export(module.exports, "StrategyCollectionPricingHero", function () { return $0f9946b2ee41705a$export$4a5cc933f6e8553a; });

var $dypTs = parcelRequire("dypTs");

var $e0LCf = parcelRequire("e0LCf");
const $0f9946b2ee41705a$export$4a5cc933f6e8553a = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $e0LCf.CollectionPricingHero), {
        collectionImage: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5j2mvlle35t45d0e48ye5tqpoe0m63gu.svg",
            alt: "Strategy Collection"
        },
        products: [
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/hd3m515u7j3s37rldpf0dgeb7m383j4s.svg",
                    alt: "Align"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/241h1u1khig63kccl1fe3hisqom3q007/fl_keep_metadata/Apps-Talent.svg",
                    alt: "Talent"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/24e3l0ul76q4fpa4l2mmc7t00k202322.svg",
                    alt: "Focus"
                }
            }
        ]
    });
};

});



parcelRegister("iBGmF", function(module, exports) {
$parcel$export(module.exports, "UniformColumnLayout", function () { return (parcelRequire("82Z9J")).UniformColumnLayout; });
$parcel$export(module.exports, "UniformSubColumnLayout", function () { return (parcelRequire("82Z9J")).UniformSubColumnLayout; });
parcelRequire("82Z9J");

});
parcelRegister("82Z9J", function(module, exports) {
$parcel$export(module.exports, "UniformColumnLayout", function () { return $3f1a8340323fe0b9$export$23133ddca0202abb; });
$parcel$export(module.exports, "UniformSubColumnLayout", function () { return $3f1a8340323fe0b9$export$8807233e43f557a9; });
/* column-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("gljCV");

var $01zo5 = parcelRequire("01zo5");
const $3f1a8340323fe0b9$var$baseStyle = null;
const $3f1a8340323fe0b9$var$fullWidthStyles = null;
const $3f1a8340323fe0b9$var$layout10 = null;
const $3f1a8340323fe0b9$var$layout8 = null;
// For 8-4 the following is equivalent to having a 12 column grid
// where the first child is `gridColumn: 1 / span 8` and the second is `9 / -1`
const $3f1a8340323fe0b9$var$layout84 = null;
const $3f1a8340323fe0b9$var$layout48 = null;
const $3f1a8340323fe0b9$var$layout93 = null;
const $3f1a8340323fe0b9$var$layout39 = null;
const $3f1a8340323fe0b9$var$layout66 = null;
const $3f1a8340323fe0b9$var$layout75 = null;
const $3f1a8340323fe0b9$var$layout57 = null;
const $3f1a8340323fe0b9$var$layout336 = null;
const $3f1a8340323fe0b9$var$layout633 = null;
const $3f1a8340323fe0b9$var$layout444 = null;
const $3f1a8340323fe0b9$var$layout3333 = null;
const $3f1a8340323fe0b9$var$layout222222 = null;
const $3f1a8340323fe0b9$var$layoutArticle = null;
const $3f1a8340323fe0b9$var$resetListStyles = null;
const $3f1a8340323fe0b9$var$slotWrapper = ({ items: items })=>{
    return items.map((element, index)=>{
        return /*#__PURE__*/ (0, $dypTs.jsx)("li", {
            children: element
        }, index);
    });
};
const $3f1a8340323fe0b9$export$23133ddca0202abb = ({ layout: layout = "12", paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = "normal", renderAsList: renderAsList, children: children })=>{
    var _paddingTopv2_mobile, _paddingTopv2_tablet, _ref, // @ts-ignore
    _paddingTopv2_desktop, _ref1, _ref2;
    const paddingTopObject = {
        // @ts-ignore
        mobile: (_paddingTopv2_mobile = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _paddingTopv2_mobile !== void 0 ? _paddingTopv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref = (_paddingTopv2_tablet = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _paddingTopv2_tablet !== void 0 ? _paddingTopv2_tablet : paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref !== void 0 ? _ref : "0",
        desktop: (_ref2 = (_ref1 = (_paddingTopv2_desktop = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.desktop) !== null && _paddingTopv2_desktop !== void 0 ? _paddingTopv2_desktop : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _ref1 !== void 0 ? _ref1 : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
    var _paddingBottomv2_mobile, _paddingBottomv2_tablet, _ref3, // @ts-ignore
    _paddingBottomv2_desktop, _ref4, _ref5;
    const paddingBottomObject = {
        // @ts-ignore
        mobile: (_paddingBottomv2_mobile = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _paddingBottomv2_mobile !== void 0 ? _paddingBottomv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref3 = (_paddingBottomv2_tablet = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _paddingBottomv2_tablet !== void 0 ? _paddingBottomv2_tablet : paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref3 !== void 0 ? _ref3 : "0",
        desktop: (_ref5 = (_ref4 = (_paddingBottomv2_desktop = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.desktop) !== null && _paddingBottomv2_desktop !== void 0 ? _paddingBottomv2_desktop : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _ref4 !== void 0 ? _ref4 : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref5 !== void 0 ? _ref5 : "0"
    };
    const paddingStyles = null;
    const alignmentStyles = null;
    const Container = renderAsList !== null && renderAsList !== void 0 ? renderAsList : "div";
    return /*#__PURE__*/ (0, $dypTs.jsx)(Container, {
        className: (0, $2jatx.default)([
            renderAsList && "_qtt815ep _18zridpf _1e7yidpf _go4ridpf _omn3idpf _s22yidpf _1eg6idpf _1xnlidpf _53osidpf _138kidpf",
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _13ltwklj _1vsw1vi7 _99hyidpf",
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
            "_1q51aqwo _85i51jtx _1waf136c _1yd317nz _26vx1ut2 _40tu7014",
            "_4cvr1ekp",
            layout === "10" && "_1j8bcx6w _klsv179g",
            layout === "8" && "_1j8bcx6w _klsveqnf",
            layout === "8-4" && "_19smexmx _1j8b1890",
            layout === "4-8" && "_19smexmx _1j8bi0c8",
            layout === "9-3" && "_1i4gqiai _1j8b1i9f",
            layout === "3-9" && "_1i4gqiai _1j8bvfzv",
            layout === "7-5" && "_13wb12kr _1j8bkxgm",
            layout === "5-7" && "_13wb12kr _1j8bdq95",
            layout === "6-6" && "_1j8bwxkt",
            layout === "4-4-4" && "_1j8b16hb",
            layout === "3-3-3-3" && "_1j8bwxkt _1rqt1ezz",
            layout === "2-2-2-2-2-2" && "_yv0ewxkt _1j8b1g7m",
            layout === "6-3-3" && "_1i4gqiai _1j8b1jr3",
            layout === "3-3-6" && "_1i4gqiai _1j8bmdi6",
            layout === "article" && "_z9r4exmx _1rqti0c8"
        ]),
        style: {
            "--_x9jeny": (0, $6ZVlx.default)("var(--ds-space-" + paddingTopObject.mobile + ")"),
            "--_15jk1js": (0, $6ZVlx.default)("var(--ds-space-" + paddingBottomObject.mobile + ")"),
            "--_d48zib": (0, $6ZVlx.default)("var(--ds-space-" + paddingTopObject.tablet + ")"),
            "--_8w0mk6": (0, $6ZVlx.default)("var(--ds-space-" + paddingBottomObject.tablet + ")"),
            "--_1l28e2h": (0, $6ZVlx.default)("var(--ds-space-" + paddingTopObject.desktop + ")"),
            "--_14v99j0": (0, $6ZVlx.default)("var(--ds-space-" + paddingBottomObject.desktop + ")"),
            "--_1813xhc": (0, $6ZVlx.default)(verticalAlignment)
        },
        children: children ? children : /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
            name: "content",
            wrapperComponent: renderAsList ? $3f1a8340323fe0b9$var$slotWrapper : undefined
        })
    });
};
const $3f1a8340323fe0b9$export$8807233e43f557a9 = ({ layout: layout = "12", paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = "normal", renderAsList: renderAsList, children: children })=>{
    var _paddingTopv2_mobile, _paddingTopv2_tablet, _ref, // @ts-ignore
    _paddingTopv2_desktop, _ref1, _ref2;
    const paddingTopObject = {
        // @ts-ignore
        mobile: (_paddingTopv2_mobile = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _paddingTopv2_mobile !== void 0 ? _paddingTopv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref = (_paddingTopv2_tablet = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _paddingTopv2_tablet !== void 0 ? _paddingTopv2_tablet : paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref !== void 0 ? _ref : "0",
        desktop: (_ref2 = (_ref1 = (_paddingTopv2_desktop = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.desktop) !== null && _paddingTopv2_desktop !== void 0 ? _paddingTopv2_desktop : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _ref1 !== void 0 ? _ref1 : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
    var _paddingBottomv2_mobile, _paddingBottomv2_tablet, _ref3, // @ts-ignore
    _paddingBottomv2_desktop, _ref4, _ref5;
    const paddingBottomObject = {
        // @ts-ignore
        mobile: (_paddingBottomv2_mobile = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _paddingBottomv2_mobile !== void 0 ? _paddingBottomv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref3 = (_paddingBottomv2_tablet = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _paddingBottomv2_tablet !== void 0 ? _paddingBottomv2_tablet : paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref3 !== void 0 ? _ref3 : "0",
        // @ts-ignore
        desktop: (_ref5 = (_ref4 = (_paddingBottomv2_desktop = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.desktop) !== null && _paddingBottomv2_desktop !== void 0 ? _paddingBottomv2_desktop : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _ref4 !== void 0 ? _ref4 : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref5 !== void 0 ? _ref5 : "0"
    };
    const paddingStyles = null;
    const alignmentStyles = null;
    const Container = renderAsList !== null && renderAsList !== void 0 ? renderAsList : "div";
    return /*#__PURE__*/ (0, $dypTs.jsx)(Container, {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _13ltwklj _1vsw1vi7 _99hyidpf",
            "_1q51aqwo _85i51jtx _1waf136c _1yd317nz _26vx1ut2 _40tu7014",
            "_4cvr1ekp",
            renderAsList && "_qtt815ep _18zridpf _1e7yidpf _go4ridpf _omn3idpf _s22yidpf _1eg6idpf _1xnlidpf _53osidpf _138kidpf",
            layout === "10" && "_1j8bcx6w _klsv179g",
            layout === "8" && "_1j8bcx6w _klsveqnf",
            layout === "8-4" && "_19smexmx _1j8b1890",
            layout === "4-8" && "_19smexmx _1j8bi0c8",
            layout === "9-3" && "_1i4gqiai _1j8b1i9f",
            layout === "3-9" && "_1i4gqiai _1j8bvfzv",
            layout === "7-5" && "_13wb12kr _1j8bkxgm",
            layout === "5-7" && "_13wb12kr _1j8bdq95",
            layout === "6-6" && "_1j8bwxkt",
            layout === "4-4-4" && "_1j8b16hb",
            layout === "3-3-3-3" && "_1j8bwxkt _1rqt1ezz",
            layout === "2-2-2-2-2-2" && "_yv0ewxkt _1j8b1g7m",
            layout === "6-3-3" && "_1i4gqiai _1j8b1jr3",
            layout === "3-3-6" && "_1i4gqiai _1j8bmdi6"
        ]),
        style: {
            "--_x9jeny": (0, $6ZVlx.default)("var(--ds-space-" + paddingTopObject.mobile + ")"),
            "--_15jk1js": (0, $6ZVlx.default)("var(--ds-space-" + paddingBottomObject.mobile + ")"),
            "--_d48zib": (0, $6ZVlx.default)("var(--ds-space-" + paddingTopObject.tablet + ")"),
            "--_8w0mk6": (0, $6ZVlx.default)("var(--ds-space-" + paddingBottomObject.tablet + ")"),
            "--_1l28e2h": (0, $6ZVlx.default)("var(--ds-space-" + paddingTopObject.desktop + ")"),
            "--_14v99j0": (0, $6ZVlx.default)("var(--ds-space-" + paddingBottomObject.desktop + ")"),
            "--_1813xhc": (0, $6ZVlx.default)(verticalAlignment)
        },
        children: children ? children : /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
            name: "content",
            wrapperComponent: renderAsList ? $3f1a8340323fe0b9$var$slotWrapper : undefined
        })
    });
}; // Both components are exported as named exports above

});


parcelRegister("fB1rt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("9eDC1")).default; });

var $9eDC1 = parcelRequire("9eDC1");

});
parcelRegister("9eDC1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f9940d7299757e5$export$2e2bcd8739ae039; });
/* confluence-animated-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $01zo5 = parcelRequire("01zo5");

var $8e22h = parcelRequire("8e22h");

var $cc8iN = parcelRequire("cc8iN");

var $ahmPu = parcelRequire("ahmPu");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $4f9940d7299757e5$var$sectionCss = null;
const $4f9940d7299757e5$var$cardContainerCss = null;
const $4f9940d7299757e5$var$cardCss = null;
const $4f9940d7299757e5$var$cardTextCss = null;
const $4f9940d7299757e5$var$cardHeadingCss = null;
const $4f9940d7299757e5$var$cardBodyTextCss = null;
const $4f9940d7299757e5$var$controlButtonStyles = null;
const $4f9940d7299757e5$var$videoContainerCss = null;
const $4f9940d7299757e5$export$235b37640a653467 = ({ title: title, bodytext: bodytext, image: image, altText: altText })=>{
    const videoRef = (0, $gljCV.useRef)(null);
    const [isPlaying, setPlaying] = (0, $gljCV.useState)(false);
    const intl = (0, $8e22h.default)();
    const prefersReducedMotion = typeof window !== "undefined" ? window.matchMedia("(prefers-reduced-motion: reduce)").matches : false;
    const togglePlay = ()=>{
        if (videoRef.current) {
            if (isPlaying) videoRef.current.pause();
            else videoRef.current.play().catch(()=>{
            // Ignore error likely due to autoplay restrictions or browser power saving
            });
        }
    };
    const handleVideoPlay = ()=>setPlaying(true);
    const handleVideoPause = ()=>setPlaying(false);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz _kqswh2mm _1k9hgrho _1mj31wqb _162p1nty _1xjr1nty _1scc1gha _1nr41gha _1axucs5v _15z31nut _hauj1nut _188c150m _y5pt150m _11za1o02 _1rgq1o02 _tnzz120m _s118120m _ikf21klr _18zx1klr _zcbv1osq _mezj1osq _12l01wug _bna71wug _eq9p15vq _pzs515vq _175j15vq _dknm15vq _1gbl1wug _1cr61wug _qpgx1wug _1hlx1wug _1d2pidpf _1874idpf _s93b1wug _10ew1wug _1th61xym _k9x81xym _1wi11m52 _1biu1m52 _ldg0vwyg _dzwgvwyg _8wcmcd5j _d3lpcd5j _1dhb1cd0 _t1ov1cd0 _1sdaagmp _ktt3agmp",
            "single-hero-card"
        ]),
        style: {
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: "text-container",
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_gxfkidpf _tfg1idpf _16yqidpf _15zyidpf _14dwidpf _1u6jidpf _1ikgidpf _1p3yidpf _1niwidpf _a15ridpf _12k0idpf _1fx6idpf _104aidpf _10pqidpf _5ybeidpf _1avnidpf _1cmpidpf _174lidpf _tlu6idpf _kopkidpf _4s33idpf _lychidpf _zzhoidpf _x9vnidpf _65gh10nf _18ko10nf _17ie10nf _1dlt10nf _1t9o10nf _1x5u10nf _1g4p1ejb _1l3z1ejb _1qkw1ejb _8znu1ejb _vh191ejb _ret01ejb _kgcl1nn1 _1m1k1nn1 _b08d1nn1 _1bau1nn1 _zmdp1nn1 _1r881nn1",
                            "_kdam16zr _19pkidpf _2hwxidpf _otyr1kwk _18u0idpf _v5644yh6 _pxcp4jg8 _60qani7l _1kpj1qqw",
                            "card-text card-heading"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformRichTextNode), {
                            node: title["root"] || title
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1axaidpf _420lidpf _195sidpf _thjjidpf _jhbppxbi _1yq31k8s _zcsk1nn1",
                            "_kdam16zr _19pkidpf _2hwxidpf _otyr1kwk _18u0idpf _v5644yh6 _pxcp4jg8 _60qani7l _1kpj1qqw",
                            "card-text card-body"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformRichTextNode), {
                            node: bodytext["root"] || bodytext
                        })
                    })
                ]
            }),
            image.includes(".mp4") ? /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _npsn1dfr _1y2k1osq _z18o1osq",
                    "imagery video video-container"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("video", {
                        ref: videoRef,
                        src: image,
                        autoPlay: !prefersReducedMotion,
                        muted: true,
                        loop: true,
                        playsInline: true,
                        onPlay: handleVideoPlay,
                        onPause: handleVideoPause,
                        onLoadedMetadata: ()=>{
                            if (videoRef.current && !prefersReducedMotion) videoRef.current.play().catch(()=>{
                            // Ignore error likely due to autoplay restrictions or browser power saving
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                        className: (0, $2jatx.default)([
                            "_80omtlke _tzy41ou4 _bfhk1j28 _syazcd5j _19it1axk _2rko17td _4t3i1ul9 _1bsb1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1pbyegat _rjxppxbi _u7co1jfw _16l4kb7n _w8l5dlk8",
                            "control-button"
                        ]),
                        onClick: togglePlay,
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                            "--_514je1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.pill"))
                        },
                        children: isPlaying ? /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc8iN))), {
                            label: intl.formatMessage({
                                id: "uniform-video.pause",
                                defaultMessage: "Pause"
                            })
                        }) : /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                            label: intl.formatMessage({
                                id: "uniform-video.play",
                                defaultMessage: "Play"
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                src: image,
                alt: altText
            })
        ]
    });
};
const $4f9940d7299757e5$var$UniformConfluenceAnimatedHero = ({ confluenceHeroCards: confluenceHeroCards, imagesWidth: imagesWidth, imagesHeight: imagesHeight, flattenData: flattenData = true })=>{
    if (flattenData) confluenceHeroCards = (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    confluenceHeroCards);
    const [inview, setInview] = (0, $gljCV.useState)(false);
    const [hasScrolled, setHasScrolled] = (0, $gljCV.useState)(false);
    const [moveUpValue, setMoveUpValue] = (0, $gljCV.useState)(120);
    const containerRef = (0, $gljCV.useRef)(null);
    (0, $gljCV.useEffect)(()=>{
        const handleScroll = ()=>{
            if (window.scrollY <= 50) {
                setInview(false);
                setHasScrolled(false);
                return;
            } else setHasScrolled(true);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0, $gljCV.useEffect)(()=>{
        if (!hasScrolled || !containerRef.current) return;
        const io = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) setInview(true);
            });
        }, {
            threshold: 0.5
        });
        io.observe(containerRef.current);
        return ()=>{
            io.disconnect();
        };
    }, [
        hasScrolled
    ]);
    (0, $gljCV.useEffect)(()=>{
        var _document_fonts_ready, _document_fonts, _document;
        const updateMoveUpValue = ()=>{
            if (!containerRef.current) return;
            const textContainers = containerRef.current.querySelectorAll(".text-container");
            let maxHeight = 0;
            textContainers.forEach((container)=>{
                const height = container.offsetHeight;
                maxHeight = Math.max(maxHeight, height);
            });
            const calculatedMoveUp = maxHeight + 16;
            setMoveUpValue(calculatedMoveUp);
        };
        const timeoutId = setTimeout(updateMoveUpValue, 100);
        (_document = document) === null || _document === void 0 ? void 0 : (_document_fonts = _document.fonts) === null || _document_fonts === void 0 ? void 0 : (_document_fonts_ready = _document_fonts.ready) === null || _document_fonts_ready === void 0 ? void 0 : _document_fonts_ready.then(updateMoveUpValue);
        window.addEventListener("resize", updateMoveUpValue);
        return ()=>{
            clearTimeout(timeoutId);
            window.removeEventListener("resize", updateMoveUpValue);
        };
    }, []);
    return /*#__PURE__*/ (0, $dypTs.jsx)("section", {
        className: (0, $2jatx.default)([
            "_11q71ybm _v5641r9r _lwq31qpa _ia4wwomy _mbuvwomy",
            "scroll-hero" + (inview ? " inview" : " outview")
        ]),
        style: {
            "--moveup": `-${moveUpValue}px`,
            "--imagesWidth": imagesWidth,
            "--imagesHeight": imagesHeight,
            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            ref: containerRef,
            className: (0, $2jatx.default)([
                "_1e0c11p5 _1bsb1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _zulp14hz _1dsl1tcg _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx _1vsw1vi7 _1j8b16hb _1wafpxbi _1bah1h6o _1ojfg8ja _3qvcg8ja _1utg36zz _1fjs36zz _12n71qqw _xlt1xncg _131yxncg _bkwyglyw _xon5glyw _128dglyw _q8ukglyw _4y3qglyw _uzo21qqw",
                inview ? "inview" : "outview"
            ]),
            style: {
                "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
            },
            children: confluenceHeroCards.map((card, index)=>/*#__PURE__*/ (0, $dypTs.jsx)($4f9940d7299757e5$export$235b37640a653467, {
                    title: card.cardTitle,
                    bodytext: card.cardDescription,
                    image: card.cardImageOrVideo,
                    altText: card.cardImageAlt
                }, index))
        })
    });
};
var $4f9940d7299757e5$export$2e2bcd8739ae039 = $4f9940d7299757e5$var$UniformConfluenceAnimatedHero;

});


parcelRegister("c3MyV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("hStuA")).default; });

var $hStuA = parcelRequire("hStuA");

});
parcelRegister("hStuA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $70c5c0076527144c$export$2e2bcd8739ae039; });
/* connector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("iBGmF");
var $82Z9J = parcelRequire("82Z9J");

var $84eO5 = parcelRequire("84eO5");

var $gIZTy = parcelRequire("gIZTy");
const $70c5c0076527144c$var$UniformConnector = ({ title: title, text: text, linkText: linkText, linkHref: linkHref, customerQuotes: customerQuotes, mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos, flattenData: flattenData = true })=>{
    if (flattenData) {
        customerQuotes = (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        customerQuotes);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mobileLogos = (0, $f2QWG.flattenValues)(mobileLogos);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tabletLogos = (0, $f2QWG.flattenValues)(tabletLogos);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        desktopLogos = (0, $f2QWG.flattenValues)(desktopLogos);
    }
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1rjc1epz _bfhk1hlo _1e0c1txw _2lx21bp4 _zulpoahv"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)((0, $82Z9J.UniformColumnLayout), {
                layout: "5-7",
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_cg41cd5j _125xcd5j _xsmr1h6o",
                            "contentBlock"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_1pfhxy5q _6rthu2gc _476dze3t"
                                ]),
                                children: title
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1mouze3t"
                                ]),
                                children: text
                            }),
                            linkText && linkHref && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfh1ejb _6rthxy5q _srwz1ejb"
                                ]),
                                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Link), {
                                    text: linkText,
                                    href: linkHref,
                                    type: "primary",
                                    bgColor: "bgBlackBlue"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $84eO5.CustomerQuoteCarousel), {
                        customerQuotes: customerQuotes
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $gIZTy.LogosMarquee), {
                mobileLogos: mobileLogos,
                tabletLogos: tabletLogos,
                desktopLogos: desktopLogos
            })
        ]
    });
};
var $70c5c0076527144c$export$2e2bcd8739ae039 = $70c5c0076527144c$var$UniformConnector;
const $70c5c0076527144c$var$containerCss = null;
const $70c5c0076527144c$var$lightTextCss = null;
const $70c5c0076527144c$var$titleCss = null;
const $70c5c0076527144c$var$textCss = null;
const $70c5c0076527144c$var$linkCss = null;

});
parcelRegister("84eO5", function(module, exports) {
$parcel$export(module.exports, "CustomerQuoteCarousel", function () { return $3fdd3ed06a9e888d$export$abab76d12bbd8406; });
/* customer-quote-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $7IesZ = parcelRequire("7IesZ");

var $9BG80 = parcelRequire("9BG80");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $3fdd3ed06a9e888d$var$messages = {
    previousSlide: {
        id: "customer-quote-carousel.previous-slide",
        defaultMessage: "Previous slide"
    },
    nextSlide: {
        id: "customer-quote-carousel.previous-slide",
        defaultMessage: "Previous slide"
    }
};
const $3fdd3ed06a9e888d$export$abab76d12bbd8406 = ({ customerQuotes: customerQuotes })=>{
    const [activeQuoteIndex, setactiveQuoteIndex] = (0, $gljCV.useState)(0);
    const prevSlide = ()=>{
        if (activeQuoteIndex > 0) setactiveQuoteIndex(activeQuoteIndex - 1);
    };
    const nextSlide = ()=>{
        if (activeQuoteIndex < customerQuotes.length - 1) setactiveQuoteIndex(activeQuoteIndex + 1);
    };
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _4t3i1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                "aria-hidden": true,
                className: (0, $2jatx.default)([
                    "_nd5lgbua",
                    "_1yt4xy5q _15tx1ejb"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _4t3i1ns9",
                        "_1q5188uy"
                    ]),
                    children: customerQuotes.map((customerQuote, index)=>/*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_nd5lgbua",
                                "_3um015vq",
                                "_tfwpidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.PullQuote), {
                                quote: customerQuote.quote,
                                authorName: customerQuote.advocateName,
                                authorDetails: customerQuote.advocateJobTitle
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_2rkovwyg _bfhk1nc2 _1yt4xy5q _4t3i1ns9 _1e0c1txw _2lx21bp4 _zulp1ejb _15tx1ejb",
                    "_cg4111ib _125x11ib _1tjq11ib",
                    "_nd5lgbua"
                ]),
                style: {
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                    "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100")),
                    "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000"))
                },
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bah1yb4 _4cvr1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c11p5 _4t3i1ns9"
                                ]),
                                children: customerQuotes.map(({ companyLogo: companyLogo }, index)=>/*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                        "aria-hidden": index !== activeQuoteIndex,
                                        className: (0, $2jatx.default)([
                                            "_nd5lgbua _3um015tv _1bsb11ux _4t3i1ylp"
                                        ]),
                                        style: {
                                            "--_neqv2r": (0, $6ZVlx.default)(index === activeQuoteIndex ? "visible" : "hidden")
                                        },
                                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                                            // @ts-ignore
                                            src: companyLogo[0].src,
                                            // @ts-ignore
                                            alt: companyLogo[0].alt,
                                            style: {
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                                objectPosition: "left"
                                            }
                                        })
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulputpp"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                                        onClick: prevSlide,
                                        disabled: activeQuoteIndex === 0,
                                        "aria-label": intl.formatMessage($3fdd3ed06a9e888d$var$messages.previousSlide),
                                        className: (0, $2jatx.default)([
                                            "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke _1x1a73ad _v42d73ad _1tc8pmk4 _64781yg0"
                                        ]),
                                        style: {
                                            "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000")),
                                            "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                        },
                                        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3"
                                            ]),
                                            style: {
                                                "--_qeag6c": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark400")),
                                                "--_138lqrp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark500"))
                                            },
                                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7IesZ))), {
                                                label: intl.formatMessage($3fdd3ed06a9e888d$var$messages.previousSlide)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_cg4111ib _125x11ib _1tjq11ib",
                                            "_1bsb183y _1mouidpf"
                                        ]),
                                        style: {
                                            "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000"))
                                        },
                                        children: `${activeQuoteIndex + 1}/${customerQuotes.length}`
                                    }),
                                    /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                                        onClick: nextSlide,
                                        disabled: activeQuoteIndex === customerQuotes.length - 1,
                                        "aria-label": intl.formatMessage($3fdd3ed06a9e888d$var$messages.nextSlide),
                                        className: (0, $2jatx.default)([
                                            "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke _1x1a73ad _v42d73ad _1tc8pmk4 _64781yg0"
                                        ]),
                                        style: {
                                            "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000")),
                                            "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                        },
                                        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3"
                                            ]),
                                            style: {
                                                "--_qeag6c": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark400")),
                                                "--_138lqrp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark500"))
                                            },
                                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                                label: intl.formatMessage($3fdd3ed06a9e888d$var$messages.nextSlide)
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _4t3i1ns9",
                            "_tfwpidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.PullQuote), {
                            // @ts-ignore
                            quote: customerQuotes[activeQuoteIndex].quote,
                            authorName: // @ts-ignore
                            customerQuotes[activeQuoteIndex].advocateName,
                            authorDetails: // @ts-ignore
                            customerQuotes[activeQuoteIndex].advocateJobTitle
                        })
                    })
                ]
            })
        ]
    });
};
const $3fdd3ed06a9e888d$var$lightTextCss = null;
const $3fdd3ed06a9e888d$var$carouselContainerCss = null;
const $3fdd3ed06a9e888d$var$logoAndButtonContainerCss = null;
const $3fdd3ed06a9e888d$var$gridCss = null;
const $3fdd3ed06a9e888d$var$overlapGridItemCss = null;
const $3fdd3ed06a9e888d$var$buttonsContainerCss = null;
const $3fdd3ed06a9e888d$var$slideNumberCss = null;
const $3fdd3ed06a9e888d$var$buttonCss = null;
const $3fdd3ed06a9e888d$var$chevronCirlceCss = null;
const $3fdd3ed06a9e888d$var$hiddenCarouselContainerCss = null;
const $3fdd3ed06a9e888d$var$hiddenQuoteCss = null;
const $3fdd3ed06a9e888d$var$visibilityHiddenCss = null;
const $3fdd3ed06a9e888d$var$overrideQuotePadding = null;

});

parcelRegister("gIZTy", function(module, exports) {
$parcel$export(module.exports, "LogosMarquee", function () { return $f3a6a4b5e6fcc957$export$143c39d1bfa1977e; });
/* logos-marquee.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $cc8iN = parcelRequire("cc8iN");

var $ahmPu = parcelRequire("ahmPu");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("iBGmF");
var $82Z9J = parcelRequire("82Z9J");
const $f3a6a4b5e6fcc957$var$Logo = ({ src: src, href: href, alt: alt, ariaHidden: ariaHidden, tabIndex: tabIndex })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("li", {
        "aria-hidden": ariaHidden,
        children: /*#__PURE__*/ (0, $dypTs.jsx)("a", {
            href: href,
            tabIndex: tabIndex,
            className: (0, $2jatx.default)([
                "_1e0c1txw _bfhk1nc2 _2rkovwyg _irr3gc2p"
            ]),
            style: {
                "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100")),
                "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                "--_1jncskl": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark300"))
            },
            children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3i1wqb _1bsb1wqb _19pk19bv _2hwx19bv _otyr19bv _18u019bv"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                    src: src,
                    alt: alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            })
        })
    });
};
const $f3a6a4b5e6fcc957$export$143c39d1bfa1977e = ({ mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos })=>{
    const [running, setRunning] = (0, $gljCV.useState)(true);
    tabletLogos = (tabletLogos === null || tabletLogos === void 0 ? void 0 : tabletLogos.length) === 0 ? desktopLogos : tabletLogos;
    mobileLogos = (mobileLogos === null || mobileLogos === void 0 ? void 0 : mobileLogos.length) === 0 ? desktopLogos : mobileLogos;
    // @ts-ignore
    const mobileLogosLength = mobileLogos.length;
    // @ts-ignore
    const tabletLogosLength = tabletLogos.length;
    const desktopLogosLength = desktopLogos.length;
    mobileLogos = [
        // @ts-ignore
        ...mobileLogos,
        ...mobileLogos,
        ...mobileLogos,
        ...mobileLogos
    ];
    tabletLogos = [
        ...tabletLogos,
        ...tabletLogos,
        ...tabletLogos,
        ...tabletLogos
    ];
    desktopLogos = [
        ...desktopLogos,
        ...desktopLogos,
        ...desktopLogos,
        ...desktopLogos
    ];
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _kqswh2mm _1e0c1txw _2lx21bp4 _zulputpp"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $82Z9J.UniformColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _1e0c1txw _1bahh9n0"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                        onClick: ()=>setRunning((r)=>!r),
                        className: (0, $2jatx.default)([
                            "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3 _1tjq11ib"
                            ]),
                            style: {
                                "--_qeag6c": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark400")),
                                "--_138lqrp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark500")),
                                "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000"))
                            },
                            children: running ? /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc8iN))), {
                                label: intl.formatMessage({
                                    id: "connector-logo-marquee.pause",
                                    defaultMessage: "Pause"
                                })
                            }) : /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                                label: intl.formatMessage({
                                    id: "connector-logo-marquee.play",
                                    defaultMessage: "Play"
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _p12f1s5k _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1reo15vq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _o5721q9c",
                            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                            "_y44vc8cz _1y0c4ukn",
                            "_16uvtrqk",
                            "_181nglyw"
                        ]),
                        style: {
                            "--_1ikxs8u": (0, $6ZVlx.default)(running ? "running" : "paused")
                        },
                        children: mobileLogos.map((logo, index)=>{
                            const isOriginal = index < mobileLogosLength;
                            return /*#__PURE__*/ (0, $dypTs.jsx)($f3a6a4b5e6fcc957$var$Logo, (0, $6ogO3._)({
                                ariaHidden: !isOriginal,
                                tabIndex: isOriginal ? 0 : -1
                            }, logo), index);
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _o5721q9c",
                            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                            "_y44v7abo _1y0c4ukn",
                            "_16uvtrqk",
                            "_dm25glyw _sugaglyw"
                        ]),
                        style: {
                            "--_1ikxs8u": (0, $6ZVlx.default)(running ? "running" : "paused")
                        },
                        children: tabletLogos.map((logo, index)=>{
                            const isOriginal = index < tabletLogosLength;
                            return /*#__PURE__*/ (0, $dypTs.jsx)($f3a6a4b5e6fcc957$var$Logo, (0, $6ogO3._)({
                                ariaHidden: !isOriginal,
                                tabIndex: isOriginal ? 0 : -1
                            }, logo), index);
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _o5721q9c",
                            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                            "_y44vhu9l _1y0c4ukn",
                            "_16uvtrqk",
                            "_1mjbglyw"
                        ]),
                        style: {
                            "--_1ikxs8u": (0, $6ZVlx.default)(running ? "running" : "paused")
                        },
                        children: desktopLogos.map((logo, index)=>{
                            const isOriginal = index < desktopLogosLength;
                            return /*#__PURE__*/ (0, $dypTs.jsx)($f3a6a4b5e6fcc957$var$Logo, (0, $6ogO3._)({
                                ariaHidden: !isOriginal,
                                tabIndex: isOriginal ? 0 : -1
                            }, logo), index);
                        })
                    })
                ]
            })
        ]
    });
};
const $f3a6a4b5e6fcc957$var$linkCss = null;
const $f3a6a4b5e6fcc957$var$logoCss = null;
const $f3a6a4b5e6fcc957$var$listCss = null;
const $f3a6a4b5e6fcc957$var$marqueeContainerCss = null;
const $f3a6a4b5e6fcc957$var$marqueeButtonContainerCss = null;
const $f3a6a4b5e6fcc957$var$marqueeButtonCss = null;
const $f3a6a4b5e6fcc957$var$buttonCirlceCss = null;
const $f3a6a4b5e6fcc957$var$listContainerCss = null;
const $f3a6a4b5e6fcc957$var$animationKeyframesCss = null;
const $f3a6a4b5e6fcc957$var$pauseOnHoverCss = null;
const $f3a6a4b5e6fcc957$var$desktopCss = null;
const $f3a6a4b5e6fcc957$var$tabletCss = null;
const $f3a6a4b5e6fcc957$var$mobileCss = null;

});



parcelRegister("kXH46", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("8MWwK")).default; });

var $8MWwK = parcelRequire("8MWwK");

});
parcelRegister("8MWwK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a017d13ccc1f2d6e$export$2e2bcd8739ae039; });
/* container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $gljCV = parcelRequire("gljCV");

var $01zo5 = parcelRequire("01zo5");

var $kbpa7 = parcelRequire("kbpa7");

var $lTkkF = parcelRequire("lTkkF");

var $6ltia = parcelRequire("6ltia");

var $32ng3 = parcelRequire("32ng3");

var $j6FQw = parcelRequire("j6FQw");
const $a017d13ccc1f2d6e$var$UniformContainer = ({ spacing: spacing, horizontalAlignment: horizontalAlignment = "default", verticalAlignment: verticalAlignment = "default", orientation: orientation = {
    mobile: "vertical"
}, gapv2: gapv2 = {
    mobile: "0"
}, hat: hat, pants: pants, backgroundColor: backgroundColor, extendBackgroundColor: extendBackgroundColor, sticky: sticky = false, responsiveHiding: responsiveHiding, overflow: overflow = "visible", label: label })=>{
    var _composition_data, _spacing_mobile, _spacing_mobile1, _spacing_mobile2, _spacing_mobile3, _spacing_mobile4, _spacing_mobile5, _spacing_mobile6, _spacing_mobile7, _spacing_tablet, _spacing_mobile8, _spacing_tablet1, _spacing_mobile9, _spacing_tablet2, _spacing_mobile10, _spacing_tablet3, _spacing_mobile11, _spacing_tablet4, _spacing_mobile12, _spacing_tablet5, _spacing_mobile13, _spacing_tablet6, _spacing_mobile14, _spacing_tablet7, _spacing_mobile15, _spacing_desktop, _spacing_tablet8, _spacing_mobile16, _spacing_desktop1, _spacing_tablet9, _spacing_mobile17, _spacing_desktop2, _spacing_tablet10, _spacing_mobile18, _spacing_desktop3, _spacing_tablet11, _spacing_mobile19, _spacing_desktop4, _spacing_tablet12, _spacing_mobile20, _spacing_desktop5, _spacing_tablet13, _spacing_mobile21, _spacing_desktop6, _spacing_tablet14, _spacing_mobile22, _spacing_desktop7, _spacing_tablet15, _spacing_mobile23;
    const composition = (0, $01zo5.useUniformCurrentComposition)();
    const compositionId = composition === null || composition === void 0 ? void 0 : (_composition_data = composition.data) === null || _composition_data === void 0 ? void 0 : _composition_data._id;
    const tracker = (0, $j6FQw.useScrollTracking)(label !== null && label !== void 0 ? label : "", {
        dwellTimeEnabled: true,
        additionalAttributes: {
            compositionId: compositionId
        }
    });
    var _spacing_mobile_marginTop, _spacing_mobile_marginBottom, _spacing_mobile_marginLeft, _spacing_mobile_marginRight, _spacing_mobile_paddingTop, _spacing_mobile_paddingBottom, _spacing_mobile_paddingLeft, _spacing_mobile_paddingRight, _spacing_tablet_marginTop, _ref, _spacing_tablet_marginBottom, _ref1, _spacing_tablet_marginLeft, _ref2, _spacing_tablet_marginRight, _ref3, _spacing_tablet_paddingTop, _ref4, _spacing_tablet_paddingBottom, _ref5, _spacing_tablet_paddingLeft, _ref6, _spacing_tablet_paddingRight, _ref7, _spacing_desktop_marginTop, _ref8, _ref9, _spacing_desktop_marginBottom, _ref10, _ref11, _spacing_desktop_marginLeft, _ref12, _ref13, _spacing_desktop_marginRight, _ref14, _ref15, _spacing_desktop_paddingTop, _ref16, _ref17, _spacing_desktop_paddingBottom, _ref18, _ref19, _spacing_desktop_paddingLeft, _ref20, _ref21, _spacing_desktop_paddingRight, _ref22, _ref23;
    const spacingObject = {
        mobile: {
            marginTop: (_spacing_mobile_marginTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile = spacing.mobile) === null || _spacing_mobile === void 0 ? void 0 : _spacing_mobile.marginTop) !== null && _spacing_mobile_marginTop !== void 0 ? _spacing_mobile_marginTop : "0",
            marginBottom: (_spacing_mobile_marginBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile1 = spacing.mobile) === null || _spacing_mobile1 === void 0 ? void 0 : _spacing_mobile1.marginBottom) !== null && _spacing_mobile_marginBottom !== void 0 ? _spacing_mobile_marginBottom : "0",
            marginLeft: (_spacing_mobile_marginLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile2 = spacing.mobile) === null || _spacing_mobile2 === void 0 ? void 0 : _spacing_mobile2.marginLeft) !== null && _spacing_mobile_marginLeft !== void 0 ? _spacing_mobile_marginLeft : "0",
            marginRight: (_spacing_mobile_marginRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile3 = spacing.mobile) === null || _spacing_mobile3 === void 0 ? void 0 : _spacing_mobile3.marginRight) !== null && _spacing_mobile_marginRight !== void 0 ? _spacing_mobile_marginRight : "0",
            paddingTop: (_spacing_mobile_paddingTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile4 = spacing.mobile) === null || _spacing_mobile4 === void 0 ? void 0 : _spacing_mobile4.paddingTop) !== null && _spacing_mobile_paddingTop !== void 0 ? _spacing_mobile_paddingTop : "0",
            paddingBottom: (_spacing_mobile_paddingBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile5 = spacing.mobile) === null || _spacing_mobile5 === void 0 ? void 0 : _spacing_mobile5.paddingBottom) !== null && _spacing_mobile_paddingBottom !== void 0 ? _spacing_mobile_paddingBottom : "0",
            paddingLeft: (_spacing_mobile_paddingLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile6 = spacing.mobile) === null || _spacing_mobile6 === void 0 ? void 0 : _spacing_mobile6.paddingLeft) !== null && _spacing_mobile_paddingLeft !== void 0 ? _spacing_mobile_paddingLeft : "0",
            paddingRight: (_spacing_mobile_paddingRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile7 = spacing.mobile) === null || _spacing_mobile7 === void 0 ? void 0 : _spacing_mobile7.paddingRight) !== null && _spacing_mobile_paddingRight !== void 0 ? _spacing_mobile_paddingRight : "0"
        },
        tablet: {
            marginTop: (_ref = (_spacing_tablet_marginTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet = spacing.tablet) === null || _spacing_tablet === void 0 ? void 0 : _spacing_tablet.marginTop) !== null && _spacing_tablet_marginTop !== void 0 ? _spacing_tablet_marginTop : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile8 = spacing.mobile) === null || _spacing_mobile8 === void 0 ? void 0 : _spacing_mobile8.marginTop) !== null && _ref !== void 0 ? _ref : "0",
            marginBottom: (_ref1 = (_spacing_tablet_marginBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet1 = spacing.tablet) === null || _spacing_tablet1 === void 0 ? void 0 : _spacing_tablet1.marginBottom) !== null && _spacing_tablet_marginBottom !== void 0 ? _spacing_tablet_marginBottom : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile9 = spacing.mobile) === null || _spacing_mobile9 === void 0 ? void 0 : _spacing_mobile9.marginBottom) !== null && _ref1 !== void 0 ? _ref1 : "0",
            marginLeft: (_ref2 = (_spacing_tablet_marginLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet2 = spacing.tablet) === null || _spacing_tablet2 === void 0 ? void 0 : _spacing_tablet2.marginLeft) !== null && _spacing_tablet_marginLeft !== void 0 ? _spacing_tablet_marginLeft : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile10 = spacing.mobile) === null || _spacing_mobile10 === void 0 ? void 0 : _spacing_mobile10.marginLeft) !== null && _ref2 !== void 0 ? _ref2 : "0",
            marginRight: (_ref3 = (_spacing_tablet_marginRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet3 = spacing.tablet) === null || _spacing_tablet3 === void 0 ? void 0 : _spacing_tablet3.marginRight) !== null && _spacing_tablet_marginRight !== void 0 ? _spacing_tablet_marginRight : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile11 = spacing.mobile) === null || _spacing_mobile11 === void 0 ? void 0 : _spacing_mobile11.marginRight) !== null && _ref3 !== void 0 ? _ref3 : "0",
            paddingTop: (_ref4 = (_spacing_tablet_paddingTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet4 = spacing.tablet) === null || _spacing_tablet4 === void 0 ? void 0 : _spacing_tablet4.paddingTop) !== null && _spacing_tablet_paddingTop !== void 0 ? _spacing_tablet_paddingTop : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile12 = spacing.mobile) === null || _spacing_mobile12 === void 0 ? void 0 : _spacing_mobile12.paddingTop) !== null && _ref4 !== void 0 ? _ref4 : "0",
            paddingBottom: (_ref5 = (_spacing_tablet_paddingBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet5 = spacing.tablet) === null || _spacing_tablet5 === void 0 ? void 0 : _spacing_tablet5.paddingBottom) !== null && _spacing_tablet_paddingBottom !== void 0 ? _spacing_tablet_paddingBottom : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile13 = spacing.mobile) === null || _spacing_mobile13 === void 0 ? void 0 : _spacing_mobile13.paddingBottom) !== null && _ref5 !== void 0 ? _ref5 : "0",
            paddingLeft: (_ref6 = (_spacing_tablet_paddingLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet6 = spacing.tablet) === null || _spacing_tablet6 === void 0 ? void 0 : _spacing_tablet6.paddingLeft) !== null && _spacing_tablet_paddingLeft !== void 0 ? _spacing_tablet_paddingLeft : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile14 = spacing.mobile) === null || _spacing_mobile14 === void 0 ? void 0 : _spacing_mobile14.paddingLeft) !== null && _ref6 !== void 0 ? _ref6 : "0",
            paddingRight: (_ref7 = (_spacing_tablet_paddingRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet7 = spacing.tablet) === null || _spacing_tablet7 === void 0 ? void 0 : _spacing_tablet7.paddingRight) !== null && _spacing_tablet_paddingRight !== void 0 ? _spacing_tablet_paddingRight : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile15 = spacing.mobile) === null || _spacing_mobile15 === void 0 ? void 0 : _spacing_mobile15.paddingRight) !== null && _ref7 !== void 0 ? _ref7 : "0"
        },
        desktop: {
            marginTop: (_ref9 = (_ref8 = (_spacing_desktop_marginTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop = spacing.desktop) === null || _spacing_desktop === void 0 ? void 0 : _spacing_desktop.marginTop) !== null && _spacing_desktop_marginTop !== void 0 ? _spacing_desktop_marginTop : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet8 = spacing.tablet) === null || _spacing_tablet8 === void 0 ? void 0 : _spacing_tablet8.marginTop) !== null && _ref8 !== void 0 ? _ref8 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile16 = spacing.mobile) === null || _spacing_mobile16 === void 0 ? void 0 : _spacing_mobile16.marginTop) !== null && _ref9 !== void 0 ? _ref9 : "0",
            marginBottom: (_ref11 = (_ref10 = (_spacing_desktop_marginBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop1 = spacing.desktop) === null || _spacing_desktop1 === void 0 ? void 0 : _spacing_desktop1.marginBottom) !== null && _spacing_desktop_marginBottom !== void 0 ? _spacing_desktop_marginBottom : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet9 = spacing.tablet) === null || _spacing_tablet9 === void 0 ? void 0 : _spacing_tablet9.marginBottom) !== null && _ref10 !== void 0 ? _ref10 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile17 = spacing.mobile) === null || _spacing_mobile17 === void 0 ? void 0 : _spacing_mobile17.marginBottom) !== null && _ref11 !== void 0 ? _ref11 : "0",
            marginLeft: (_ref13 = (_ref12 = (_spacing_desktop_marginLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop2 = spacing.desktop) === null || _spacing_desktop2 === void 0 ? void 0 : _spacing_desktop2.marginLeft) !== null && _spacing_desktop_marginLeft !== void 0 ? _spacing_desktop_marginLeft : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet10 = spacing.tablet) === null || _spacing_tablet10 === void 0 ? void 0 : _spacing_tablet10.marginLeft) !== null && _ref12 !== void 0 ? _ref12 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile18 = spacing.mobile) === null || _spacing_mobile18 === void 0 ? void 0 : _spacing_mobile18.marginLeft) !== null && _ref13 !== void 0 ? _ref13 : "0",
            marginRight: (_ref15 = (_ref14 = (_spacing_desktop_marginRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop3 = spacing.desktop) === null || _spacing_desktop3 === void 0 ? void 0 : _spacing_desktop3.marginRight) !== null && _spacing_desktop_marginRight !== void 0 ? _spacing_desktop_marginRight : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet11 = spacing.tablet) === null || _spacing_tablet11 === void 0 ? void 0 : _spacing_tablet11.marginRight) !== null && _ref14 !== void 0 ? _ref14 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile19 = spacing.mobile) === null || _spacing_mobile19 === void 0 ? void 0 : _spacing_mobile19.marginRight) !== null && _ref15 !== void 0 ? _ref15 : "0",
            paddingTop: (_ref17 = (_ref16 = (_spacing_desktop_paddingTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop4 = spacing.desktop) === null || _spacing_desktop4 === void 0 ? void 0 : _spacing_desktop4.paddingTop) !== null && _spacing_desktop_paddingTop !== void 0 ? _spacing_desktop_paddingTop : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet12 = spacing.tablet) === null || _spacing_tablet12 === void 0 ? void 0 : _spacing_tablet12.paddingTop) !== null && _ref16 !== void 0 ? _ref16 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile20 = spacing.mobile) === null || _spacing_mobile20 === void 0 ? void 0 : _spacing_mobile20.paddingTop) !== null && _ref17 !== void 0 ? _ref17 : "0",
            paddingBottom: (_ref19 = (_ref18 = (_spacing_desktop_paddingBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop5 = spacing.desktop) === null || _spacing_desktop5 === void 0 ? void 0 : _spacing_desktop5.paddingBottom) !== null && _spacing_desktop_paddingBottom !== void 0 ? _spacing_desktop_paddingBottom : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet13 = spacing.tablet) === null || _spacing_tablet13 === void 0 ? void 0 : _spacing_tablet13.paddingBottom) !== null && _ref18 !== void 0 ? _ref18 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile21 = spacing.mobile) === null || _spacing_mobile21 === void 0 ? void 0 : _spacing_mobile21.paddingBottom) !== null && _ref19 !== void 0 ? _ref19 : "0",
            paddingLeft: (_ref21 = (_ref20 = (_spacing_desktop_paddingLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop6 = spacing.desktop) === null || _spacing_desktop6 === void 0 ? void 0 : _spacing_desktop6.paddingLeft) !== null && _spacing_desktop_paddingLeft !== void 0 ? _spacing_desktop_paddingLeft : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet14 = spacing.tablet) === null || _spacing_tablet14 === void 0 ? void 0 : _spacing_tablet14.paddingLeft) !== null && _ref20 !== void 0 ? _ref20 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile22 = spacing.mobile) === null || _spacing_mobile22 === void 0 ? void 0 : _spacing_mobile22.paddingLeft) !== null && _ref21 !== void 0 ? _ref21 : "0",
            paddingRight: (_ref23 = (_ref22 = (_spacing_desktop_paddingRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop7 = spacing.desktop) === null || _spacing_desktop7 === void 0 ? void 0 : _spacing_desktop7.paddingRight) !== null && _spacing_desktop_paddingRight !== void 0 ? _spacing_desktop_paddingRight : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet15 = spacing.tablet) === null || _spacing_tablet15 === void 0 ? void 0 : _spacing_tablet15.paddingRight) !== null && _ref22 !== void 0 ? _ref22 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile23 = spacing.mobile) === null || _spacing_mobile23 === void 0 ? void 0 : _spacing_mobile23.paddingRight) !== null && _ref23 !== void 0 ? _ref23 : "0"
        }
    };
    const marginStyles = null;
    const paddingStyles = null;
    (0, $gljCV.useEffect)(()=>{
        (0, $lTkkF.updateStickyNavOffset)();
    }, []);
    const hiddenMobileStyle = null;
    const hiddenTabletStyle = null;
    const hiddenDesktopStyle = null;
    // determine text color based on background color luminance
    const getTextColor = (bgColor)=>{
        if (!bgColor) return undefined;
        try {
            // white text for dark backgrounds, dark text for light backgrounds
            return (0, $6ltia.isDarkColor)(bgColor) ? (0, $kbpa7.wacToken)("color.neutral.light0") : (0, $kbpa7.wacToken)("color.primary.black");
        } catch (error) {
            // invalid color format, return undefined to use default
            console.error("Invalid backgroundColor format:", bgColor, error);
            return undefined;
        }
    };
    const textColor = getTextColor(backgroundColor);
    const colorStyle = null;
    var _gapv2_mobile, _gapv2_tablet, _ref24, _gapv2_desktop, _ref25, _ref26;
    const gapObject = {
        mobile: (_gapv2_mobile = gapv2.mobile) !== null && _gapv2_mobile !== void 0 ? _gapv2_mobile : "0",
        tablet: (_ref24 = (_gapv2_tablet = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _gapv2_tablet !== void 0 ? _gapv2_tablet : gapv2.mobile) !== null && _ref24 !== void 0 ? _ref24 : "0",
        desktop: (_ref26 = (_ref25 = (_gapv2_desktop = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.desktop) !== null && _gapv2_desktop !== void 0 ? _gapv2_desktop : gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _ref25 !== void 0 ? _ref25 : gapv2.mobile) !== null && _ref26 !== void 0 ? _ref26 : "0"
    };
    const innerStyle = null;
    const innerStyleFullHeight = null;
    const orientationObject = {
        mobile: orientation.mobile || "vertical",
        tablet: (orientation === null || orientation === void 0 ? void 0 : orientation.tablet) || orientation.mobile || "vertical",
        desktop: (orientation === null || orientation === void 0 ? void 0 : orientation.desktop) || (orientation === null || orientation === void 0 ? void 0 : orientation.tablet) || orientation.mobile || "vertical"
    };
    const orientationStyle = null;
    const verticalAlignmentValue = verticalAlignment === "center" ? "center" : verticalAlignment === "end" ? "flex-end" : "flex-start";
    const horizontalAlignmentValue = horizontalAlignment === "center" ? "center" : horizontalAlignment === "start" ? "flex-start" : horizontalAlignment === "end" ? "flex-end" : "initial";
    const hiddenOnMobile = responsiveHiding === null || responsiveHiding === void 0 ? void 0 : responsiveHiding.includes("mobile");
    const hiddenOnTablet = responsiveHiding === null || responsiveHiding === void 0 ? void 0 : responsiveHiding.includes("tablet");
    const hiddenOnDesktop = responsiveHiding === null || responsiveHiding === void 0 ? void 0 : responsiveHiding.includes("desktop");
    const overflowStyle = null;
    const outerHeightFullStyle = null;
    const responsiveSectionDividerHeightsStyles = null;
    const extendedBackgroundColorComponent = /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1bsbauwl _4t3i1cn3 _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s _11q7wvjo",
            hat && "_1kt9b3bt _cfu11ule _kfgt1m3o _1s6kwvjo",
            hat && "_1cs8h2mm _iajm18y9",
            hat && hat === "high-right" ? "_tgsmkyn1" : hat === "high-left" ? "_tgsmvrmp" : "_tgsmcdv4",
            pants && "_aetrb3bt _1ywu1ule _1qdg1aiy _16r2wvjo",
            pants && "_18poh2mm _19nq1osq",
            pants && hat && "_18poh2mm _19nq1e6p",
            pants && pants === "high-right" ? "_1oj4snn3" : pants === "high-left" ? "_1oj4df5m" : "_1oj41mhh"
        ])
    });
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        ref: (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7603UniformPageDwellTime) && label ? tracker === null || tracker === void 0 ? void 0 : tracker.ref : null,
        className: (0, $2jatx.default)([
            "_vhvk1xho _wsfyeyca _11nbax5h _tqhlzoxj _9s88d2ta _1rcb14zp",
            "_1pfhanyo _6rthpu7k _ahbq5tu6 _12l21ubn _kiya1jt3 _1ob9vj1y _1ywm6esm _1lva1cm9 _1mt1153n _1tntw79i _3l1a4z27 _161b1c8k",
            "_14lsaxbu _9if11u00",
            verticalAlignment === "end" && "_4t3i1osq",
            hat && !extendBackgroundColor && "_1kt9b3bt _cfu11ule _kfgt1m3o _1s6kwvjo",
            hat && !extendBackgroundColor && hat === "high-right" ? "_tgsmkyn1" : hat === "high-left" ? "_tgsmvrmp" : "_tgsmcdv4",
            pants && !extendBackgroundColor && "_aetrb3bt _1ywu1ule _1qdg1aiy _16r2wvjo",
            pants && !extendBackgroundColor && pants === "high-right" ? "_1oj4snn3" : pants === "high-left" ? "_1oj4df5m" : "_1oj41mhh",
            hiddenOnMobile && "_sugaglyw",
            hiddenOnTablet && "_kzviglyw",
            hiddenOnDesktop && "_dm25glyw",
            "_1idncgrn",
            extendBackgroundColor && "_kqswh2mm",
            extendBackgroundColor && hat && "_1q511m3o",
            extendBackgroundColor && pants && "_85i51aiy"
        ]),
        style: {
            "--_9ux5rl": (0, $6ZVlx.default)(hat ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).mobile}px` : "0px"),
            "--_eu2x2b": (0, $6ZVlx.default)(pants ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).mobile}px` : "0px"),
            "--_up8d13": (0, $6ZVlx.default)(hat ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).tablet}px` : "0px"),
            "--_alf06v": (0, $6ZVlx.default)(pants ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).tablet}px` : "0px"),
            "--_138i2bk": (0, $6ZVlx.default)(hat ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).desktop}px` : "0px"),
            "--_1r8eu8k": (0, $6ZVlx.default)(pants ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).desktop}px` : "0px"),
            "--_gbj3vn": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.marginTop + ")"),
            "--_1ml8i62": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.marginBottom + ")"),
            "--_eitxkt": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.marginLeft + ")"),
            "--_17oyghn": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.marginRight + ")"),
            "--_13w6wc6": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.marginTop + ")"),
            "--_1g7gc60": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.marginBottom + ")"),
            "--_1w7fn9j": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.marginLeft + ")"),
            "--_y26vmc": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.marginRight + ")"),
            "--_12q7gcg": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.marginTop + ")"),
            "--_1unjz24": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.marginBottom + ")"),
            "--_6sej3x": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.marginLeft + ")"),
            "--_4gatm0": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.marginRight + ")"),
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_srel9g": (0, $6ZVlx.default)(textColor),
            "--_lyok2l": (0, $6ZVlx.default)(overflow)
        },
        children: [
            extendBackgroundColor && extendedBackgroundColorComponent,
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_11q7wvjo _1bsb1osq _1e0c1txw _zulp1a6y _19wggsi3 _pdlmxbqd",
                    verticalAlignment === "end" && "_4t3i1osq",
                    extendBackgroundColor && "_bfhk1j28 _kqswh2mm _1pbykb7n",
                    "_1q5117qr _85i51lcc _bozg1k1r _y4ti1one _1wafbrnf _1yd32emj _1wfq1myb _15vt1nm0 _26vx19ue _40tu16pv _d2ik8srg _exxmep75",
                    "_1e0c1txw _2lx22h65 _1lp71tnc _1inip4d6",
                    orientationObject.mobile === "horizontal" && "_4cvrop21 _1bah8u0b",
                    orientationObject.tablet === "horizontal" && "_q8t5op21 _e8gh8u0b",
                    orientationObject.desktop === "horizontal" && "_1jsvop21 _msup8u0b",
                    orientationObject.mobile === "vertical" && "_4cvr8u0b _1bahop21",
                    orientationObject.tablet === "vertical" && "_q8t58u0b _e8ghop21",
                    orientationObject.desktop === "vertical" && "_1jsv8u0b _msupop21",
                    sticky && "_kqsw1if8 _152txohi"
                ]),
                style: {
                    "--_rkv8x9": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.mobile + ")"),
                    "--_9wptik": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.tablet + ")"),
                    "--_3wdyhk": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.desktop + ")"),
                    "--_16fd4zu": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.paddingTop + ")"),
                    "--_1j5swcl": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.paddingBottom + ")"),
                    "--_u69j6n": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.paddingLeft + ")"),
                    "--_o2jkov": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.paddingRight + ")"),
                    "--_703coj": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.paddingTop + ")"),
                    "--_1fsgwhq": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.paddingBottom + ")"),
                    "--_13hg674": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.paddingLeft + ")"),
                    "--_1qs0f4o": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.paddingRight + ")"),
                    "--_pqmqgy": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.paddingTop + ")"),
                    "--_1ybsets": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.paddingBottom + ")"),
                    "--_okopco": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.paddingLeft + ")"),
                    "--_x42pdd": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.paddingRight + ")"),
                    "--_pv2ypa": (0, $6ZVlx.default)(orientationObject.mobile === "horizontal" ? "row" : "column"),
                    "--_dek1s0": (0, $6ZVlx.default)(orientationObject.tablet === "horizontal" ? "row" : "column"),
                    "--_1ng513r": (0, $6ZVlx.default)(orientationObject.desktop === "horizontal" ? "row" : "column"),
                    "--_7phn4c": (0, $6ZVlx.default)(verticalAlignmentValue),
                    "--_7e5uq9": (0, $6ZVlx.default)(horizontalAlignmentValue)
                },
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
                    name: "component"
                })
            })
        ]
    });
};
const $a017d13ccc1f2d6e$var$hatCommonStyle = null;
const $a017d13ccc1f2d6e$var$extendedBackgroundColorHatStyle = null;
const $a017d13ccc1f2d6e$var$hatHighLeft = null;
const $a017d13ccc1f2d6e$var$hatHighRight = null;
const $a017d13ccc1f2d6e$var$hatPolygon = null;
const $a017d13ccc1f2d6e$var$pantsCommonStyle = null;
const $a017d13ccc1f2d6e$var$extendedBackgroundColorPantsStyle = null;
const $a017d13ccc1f2d6e$var$extendedBackgroundColorPantsWithHatStyle = null;
const $a017d13ccc1f2d6e$var$pantsHighLeft = null;
const $a017d13ccc1f2d6e$var$pantsHighRight = null;
const $a017d13ccc1f2d6e$var$pantsPolygon = null;
var $a017d13ccc1f2d6e$export$2e2bcd8739ae039 = $a017d13ccc1f2d6e$var$UniformContainer;

});


parcelRegister("8NuGV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("5nbaa")).default; });

var $5nbaa = parcelRequire("5nbaa");

});
parcelRegister("5nbaa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d2a96969d170342b$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $dZNgt = parcelRequire("dZNgt");

var $2fk4i = parcelRequire("2fk4i");

var $lTkkF = parcelRequire("lTkkF");

var $kooLp = parcelRequire("kooLp");
const $d2a96969d170342b$var$UniformContentBlock = (props)=>{
    var _props_linkHref, _props_buttonHref;
    var _props_linkHref_path;
    const localizedLinkHref = (0, $kooLp.useLocalizedHref)((_props_linkHref_path = (_props_linkHref = props.linkHref) === null || _props_linkHref === void 0 ? void 0 : _props_linkHref.path) !== null && _props_linkHref_path !== void 0 ? _props_linkHref_path : "");
    var _props_buttonHref_path;
    const localizedButtonHref = (0, $kooLp.useLocalizedHref)((_props_buttonHref_path = (_props_buttonHref = props.buttonHref) === null || _props_buttonHref === void 0 ? void 0 : _props_buttonHref.path) !== null && _props_buttonHref_path !== void 0 ? _props_buttonHref_path : "");
    const callToActionProps = $d2a96969d170342b$var$transformCtaProps((0, $dPABA._)((0, $6ogO3._)({}, props), {
        linkHref: props.linkHref ? {
            path: localizedLinkHref
        } : undefined,
        buttonHref: props.buttonHref ? {
            path: localizedButtonHref
        } : undefined
    }));
    var _props_imageAlt, _props_iconAlt;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.ContentBlock), {
        title: props.title,
        text: props.richText ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : props.text,
        titleAs: props.titleAs,
        headingLevel: props.headingLevel,
        logo: props.logo,
        eyebrow: props.eyebrow,
        alignment: props.alignment,
        callToActionProps: callToActionProps,
        pictureProps: props.imageUrl ? {
            image: {
                src: props.imageUrl,
                alt: (_props_imageAlt = props.imageAlt) !== null && _props_imageAlt !== void 0 ? _props_imageAlt : ""
            }
        } : undefined,
        spotIllustrationUrl: props.spotIllustrationUrl,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize,
                alt: (_props_iconAlt = props.iconAlt) !== null && _props_iconAlt !== void 0 ? _props_iconAlt : ""
            }
        } : undefined,
        orientation: props.orientation,
        columns: props.columns,
        backgroundColor: props.backgroundColor,
        hat: props.hat,
        pants: props.pants
    });
};
function $d2a96969d170342b$var$transformCtaProps({ buttonHref: buttonHref, buttonLabel: buttonLabel, buttonVariant: buttonVariant, linkHref: linkHref, linkText: linkText, linkType: linkType }) {
    const isButton = !!(buttonHref === null || buttonHref === void 0 ? void 0 : buttonHref.path) && !!buttonLabel;
    const isLink = !!(linkHref === null || linkHref === void 0 ? void 0 : linkHref.path) && !!linkText;
    if (isButton || isLink) {
        const ctaProps = {
            button: isButton ? {
                href: buttonHref.path,
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event-component": "linkButton",
                    "data-event-container": "contentBlock",
                    "data-event": "clicked",
                    "data-label": buttonLabel
                }
            } : undefined,
            buttonText: buttonLabel !== null && buttonLabel !== void 0 ? buttonLabel : undefined,
            buttonVariant: buttonVariant !== null && buttonVariant !== void 0 ? buttonVariant : undefined,
            link: isLink ? {
                href: linkHref.path,
                text: linkText,
                type: linkType,
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event-component": "linkButton",
                    "data-event-container": "contentBlock",
                    "data-event": "clicked",
                    "data-label": linkText
                }
            } : undefined
        };
        return ctaProps;
    }
    return undefined;
}
var $d2a96969d170342b$export$2e2bcd8739ae039 = $d2a96969d170342b$var$UniformContentBlock;

});


parcelRegister("jdYL5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("cDjwJ")).default; });

var $cDjwJ = parcelRequire("cDjwJ");

});
parcelRegister("cDjwJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b49d11c3d700c7d0$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $f2QWG = parcelRequire("f2QWG");

var $56vQu = parcelRequire("56vQu");
const $b49d11c3d700c7d0$export$760d8d36b06866af = (props)=>{
    const statProps = (0, $6ogO3._)({}, props);
    statProps.stats = (0, $f2QWG.flattenValues)(props.stats);
    return statProps;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b49d11c3d700c7d0$var$UniformCustomerStat = (props)=>{
    const statProps = $b49d11c3d700c7d0$export$760d8d36b06866af(props);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $56vQu.CustomerDetailsStats), (0, $6ogO3._)({}, statProps));
};
var $b49d11c3d700c7d0$export$2e2bcd8739ae039 = $b49d11c3d700c7d0$var$UniformCustomerStat;

});


parcelRegister("mh7Fj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gl1tq")).default; });

var $gl1tq = parcelRequire("gl1tq");

});
parcelRegister("gl1tq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2fb2f2d214994b84$export$2e2bcd8739ae039; });
/* customer-stories-details-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");

var $32ng3 = parcelRequire("32ng3");

var $j6FQw = parcelRequire("j6FQw");
parcelRequire("dBPyX");
var $b9OTp = parcelRequire("b9OTp");

var $avaxs = parcelRequire("avaxs");
const $2fb2f2d214994b84$var$heroContainerCss = null;
const $2fb2f2d214994b84$export$74f30557f8a70c45 = ({ title: title, subtitle: subtitle, imgSrc: imgSrc, imgAlt: imgAlt, quote: quote, author: author, role: role, company: company })=>{
    var _composition_data;
    const composition = (0, $01zo5.useUniformCurrentComposition)();
    const compositionId = composition === null || composition === void 0 ? void 0 : (_composition_data = composition.data) === null || _composition_data === void 0 ? void 0 : _composition_data._id;
    const tracker = (0, $j6FQw.useScrollTracking)("UniformCustomerStoriesDetailsHero", {
        dwellTimeEnabled: true,
        additionalAttributes: {
            compositionId: compositionId
        }
    });
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        ref: (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7603UniformPageDwellTime) ? tracker === null || tracker === void 0 ? void 0 : tracker.ref : null,
        className: (0, $2jatx.default)([
            "_1e0c11p5 _1bah1yb4 _1pfhxy5q _p12f1osq _vchhusvi _zulp1tcg _1bsb1osq _yv0ei47z _pdlmzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $b9OTp.default), {
                title: title,
                subtitle: subtitle,
                alignment: imgSrc ? "left" : "center"
            }),
            quote && /*#__PURE__*/ (0, $dypTs.jsx)((0, $avaxs.default), {
                imgSrc: imgSrc,
                imgAlt: imgAlt,
                quote: quote,
                author: author,
                role: role,
                company: company
            })
        ]
    });
};
var $2fb2f2d214994b84$export$2e2bcd8739ae039 = $2fb2f2d214994b84$export$74f30557f8a70c45;

});
parcelRegister("dBPyX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("b9OTp")).default; });

var $b9OTp = parcelRequire("b9OTp");

});
parcelRegister("b9OTp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $134c9de5826b2c34$export$2e2bcd8739ae039; });
/* hero-intro.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
const $134c9de5826b2c34$var$UniformHeroIntro = ({ title: title, subtitle: subtitle, alignment: alignment })=>{
    const heroContainer = null;
    const textCss = null;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_y3gnoues _yv0ecx6w _1e0c11p5 _gy1p1tcg _1rqtaigu _ikjdzwfg"
        ]),
        style: {
            "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_6rthidpf _yyhy13k5 _1e3c9kbg"
                ]),
                style: {
                    "--_1gb0l6x": (0, $6ZVlx.default)(alignment == "center" ? "2" : "1")
                },
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_6rthidpf _yyhy13k5 _1e3c9kbg",
                    "body-lg"
                ]),
                style: {
                    "--_1gb0l6x": (0, $6ZVlx.default)(alignment == "center" ? "2" : "1")
                },
                children: subtitle
            })
        ]
    });
};
var $134c9de5826b2c34$export$2e2bcd8739ae039 = $134c9de5826b2c34$var$UniformHeroIntro;

});


parcelRegister("avaxs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d76d7b05240d3961$export$2e2bcd8739ae039; });
/* customer-stories-details-hero-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");

var $HMZ3r = parcelRequire("HMZ3r");

var $2fk4i = parcelRequire("2fk4i");

var $32ng3 = parcelRequire("32ng3");

var $j6FQw = parcelRequire("j6FQw");
const $d76d7b05240d3961$var$quoteBodyCss = null;
const $d76d7b05240d3961$var$quoteStylingWithImage = null;
const $d76d7b05240d3961$var$quoteStylingNoImage = null;
const $d76d7b05240d3961$var$imageCss = null;
const $d76d7b05240d3961$var$quoteContainerStyles = null;
const $d76d7b05240d3961$export$d35b0bc1e0617ca6 = ({ imgSrc: imgSrc, imgAlt: imgAlt, quote: quote, author: author, role: role, company: company })=>{
    var _composition_data;
    const composition = (0, $01zo5.useUniformCurrentComposition)();
    const compositionId = composition === null || composition === void 0 ? void 0 : (_composition_data = composition.data) === null || _composition_data === void 0 ? void 0 : _composition_data._id;
    const tracker = (0, $j6FQw.useScrollTracking)("UniformCustomerStoriesDetailsHeroQuote", {
        dwellTimeEnabled: true,
        additionalAttributes: {
            compositionId: compositionId
        }
    });
    const authorDetails = [
        role,
        company
    ].filter(Boolean).join(", ");
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        ref: (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7603UniformPageDwellTime) ? tracker === null || tracker === void 0 ? void 0 : tracker.ref : null,
        className: (0, $2jatx.default)([
            "_1e0c11p5 _yv0ecx6w _zulp1tcg _4cvr1h6o _6a6zv2br _1rqtaigu _pdlmzwfg"
        ]),
        children: [
            imgSrc && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1461kb7n _f0zu1ohn _nw6ekb7n _1jpu1mrw _uhi5kb7n _eao7qfx8"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $HMZ3r.default), {
                    contentType: /* Since we do not pass in the direct Contentful image via Uniform,
      this uses a rough assumption to trigger a webp transformation */ imgSrc.endsWith(".png") ? "image/png" : undefined,
                    src: imgSrc,
                    alt: imgAlt !== null && imgAlt !== void 0 ? imgAlt : "",
                    style: {
                        maxWidth: "100%"
                    },
                    baseWidth: 440
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1461kb7n _f0zu1mrw _1vb6grf3",
                    imgSrc ? "_1e3c1gti" : "_1e3ceqnf"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.PullQuote), {
                    quote: quote !== null && quote !== void 0 ? quote : "",
                    authorName: author !== null && author !== void 0 ? author : "",
                    authorDetails: authorDetails,
                    alignment: imgSrc ? "start" : "center",
                    size: "large",
                    variant: "basic"
                })
            })
        ]
    });
};
var $d76d7b05240d3961$export$2e2bcd8739ae039 = $d76d7b05240d3961$export$d35b0bc1e0617ca6;

});



parcelRegister("kueIh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("hvVOW")).default; });

var $hvVOW = parcelRequire("hvVOW");

});
parcelRegister("hvVOW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $34f3707412098f34$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $i1SI4 = parcelRequire("i1SI4");
const $34f3707412098f34$var$transformImage = (props, alt)=>{
    var _props_file, _props_file1, _props_file_details_image, _props_file_details, _props_file2, _props_file_details_image1, _props_file_details1, _props_file3;
    if (!props) return undefined;
    return {
        contentType: (_props_file = props.file) === null || _props_file === void 0 ? void 0 : _props_file.contentType,
        src: (_props_file1 = props.file) === null || _props_file1 === void 0 ? void 0 : _props_file1.url,
        alt: alt !== null && alt !== void 0 ? alt : "",
        baseWidth: 500,
        width: (_props_file2 = props.file) === null || _props_file2 === void 0 ? void 0 : (_props_file_details = _props_file2.details) === null || _props_file_details === void 0 ? void 0 : (_props_file_details_image = _props_file_details.image) === null || _props_file_details_image === void 0 ? void 0 : _props_file_details_image.width,
        height: (_props_file3 = props.file) === null || _props_file3 === void 0 ? void 0 : (_props_file_details1 = _props_file3.details) === null || _props_file_details1 === void 0 ? void 0 : (_props_file_details_image1 = _props_file_details1.image) === null || _props_file_details_image1 === void 0 ? void 0 : _props_file_details_image1.height
    };
};
const $34f3707412098f34$var$transformCta = (linkUrl, linkText)=>{
    if (linkUrl && linkText) return {
        url: linkUrl,
        text: linkText
    };
    return undefined;
};
const $34f3707412098f34$var$transformProps = (props)=>{
    var _props_theme;
    return {
        bgColor: (_props_theme = props.theme) !== null && _props_theme !== void 0 ? _props_theme : "white",
        testimonials: props.quotes.map((quote)=>{
            var _fields_advocateCta__fields, _fields_advocateCta_, _fields_advocateCta, _fields_advocateCta__fields1, _fields_advocateCta_1, _fields_advocateCta1, _fields_organization_fields_logo_, _fields_organization_fields_logo, _fields_organization_fields, _fields_organization, _fields_organization_fields1, _fields_organization1, _fields_advocateHeadshot;
            const fields = quote.fields;
            const linkUrl = (_fields_advocateCta = fields.advocateCta) === null || _fields_advocateCta === void 0 ? void 0 : (_fields_advocateCta_ = _fields_advocateCta[0]) === null || _fields_advocateCta_ === void 0 ? void 0 : (_fields_advocateCta__fields = _fields_advocateCta_.fields) === null || _fields_advocateCta__fields === void 0 ? void 0 : _fields_advocateCta__fields.ctaUrl;
            const linkText = (_fields_advocateCta1 = fields.advocateCta) === null || _fields_advocateCta1 === void 0 ? void 0 : (_fields_advocateCta_1 = _fields_advocateCta1[0]) === null || _fields_advocateCta_1 === void 0 ? void 0 : (_fields_advocateCta__fields1 = _fields_advocateCta_1.fields) === null || _fields_advocateCta__fields1 === void 0 ? void 0 : _fields_advocateCta__fields1.ctaButtonText;
            return {
                logo: $34f3707412098f34$var$transformImage((_fields_organization = fields.organization) === null || _fields_organization === void 0 ? void 0 : (_fields_organization_fields = _fields_organization.fields) === null || _fields_organization_fields === void 0 ? void 0 : (_fields_organization_fields_logo = _fields_organization_fields.logo) === null || _fields_organization_fields_logo === void 0 ? void 0 : (_fields_organization_fields_logo_ = _fields_organization_fields_logo[0]) === null || _fields_organization_fields_logo_ === void 0 ? void 0 : _fields_organization_fields_logo_.fields, (_fields_organization1 = fields.organization) === null || _fields_organization1 === void 0 ? void 0 : (_fields_organization_fields1 = _fields_organization1.fields) === null || _fields_organization_fields1 === void 0 ? void 0 : _fields_organization_fields1.organizationNameExternal),
                name: fields.advocateName,
                title: fields.advocateJobTitle,
                image: $34f3707412098f34$var$transformImage((_fields_advocateHeadshot = fields.advocateHeadshot) === null || _fields_advocateHeadshot === void 0 ? void 0 : _fields_advocateHeadshot.fields),
                quote: fields.advocateQuote,
                link: $34f3707412098f34$var$transformCta(linkUrl, linkText)
            };
        }).filter((quote)=>{
            return !!quote.logo && !!quote.name && !!quote.title && !!quote.image && !!quote.quote;
        })
    };
};
const $34f3707412098f34$var$UniformCustomerTestimonials = (props)=>{
    //TODO GWP-6632: add CTA links, and ensure they are localized in each panel
    const transformed = $34f3707412098f34$var$transformProps(props);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $i1SI4.CustomerTestimonials), {
        bgColor: transformed.bgColor,
        testimonials: transformed.testimonials
    });
};
var $34f3707412098f34$export$2e2bcd8739ae039 = $34f3707412098f34$var$UniformCustomerTestimonials;

});


parcelRegister("2Uect", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("2540f")).default; });

var $2540f = parcelRequire("2540f");

});
parcelRegister("2540f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b007b6ae3baf0cb1$export$2e2bcd8739ae039; });
/* download-row.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $kbpa7 = parcelRequire("kbpa7");
const $b007b6ae3baf0cb1$var$rowStyle = null;
const $b007b6ae3baf0cb1$var$versionContainerStyle = null;
const $b007b6ae3baf0cb1$var$releaseNotesStyle = null;
const $b007b6ae3baf0cb1$var$cellStyle = null;
const $b007b6ae3baf0cb1$var$firstCellStyle = null;
const $b007b6ae3baf0cb1$var$UniformDownloadRow = ({ size: size, date: date })=>{
    return /*#__PURE__*/ (0, $dypTs.jsxs)("tr", {
        className: (0, $2jatx.default)([
            "_vwz4kb7n _ect4q6fz _syazvejh _yq5hcfaq _btyzidpf _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _179r1gln"
        ]),
        style: {
            "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "_y3gn1e5h",
                    "p"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
                            name: "version"
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("small", {
                            className: (0, $2jatx.default)([
                                "_1wyb1wqq _1pfhi2wt"
                            ]),
                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
                                name: "releaseNotes"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "p"
                ]),
                children: size
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "p"
                ]),
                children: date
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "p"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
                    name: "format"
                })
            })
        ]
    });
};
var $b007b6ae3baf0cb1$export$2e2bcd8739ae039 = $b007b6ae3baf0cb1$var$UniformDownloadRow;

});


parcelRegister("gkej5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("j6nXt")).default; });

var $j6nXt = parcelRequire("j6nXt");

});
parcelRegister("j6nXt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $368a77dca296ff8b$export$2e2bcd8739ae039; });
/* download-table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $kbpa7 = parcelRequire("kbpa7");
const $368a77dca296ff8b$var$containerStyle = null;
const $368a77dca296ff8b$var$titleStyle = null;
const $368a77dca296ff8b$var$tableStyle = null;
const $368a77dca296ff8b$var$headStyle = null;
const $368a77dca296ff8b$var$bodyStyle = null;
const $368a77dca296ff8b$var$UniformDownloadTable = ({ title: title })=>{
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyr7vkz _18u0idpf _k48p8n31 _1wyb1q5e"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("table", {
                className: (0, $2jatx.default)([
                    "_vwz4kb7n _ect4q6fz _syazvejh _1bsb1osq _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _yq5hcfaq _btyzidpf _6rth1tcg"
                ]),
                style: {
                    "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                },
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("thead", {
                        className: (0, $2jatx.default)([
                            "_vwz4kb7n _ect4q6fz _syazvejh _yq5hcfaq _btyzidpf _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _n7zlzv82 _1fr819bv _1160ftgi _lxpr19bv _il49ftgi _xhev1h6o _7dd61e5h"
                        ]),
                        style: {
                            "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000")),
                            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                        },
                        children: /*#__PURE__*/ (0, $dypTs.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $dypTs.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)("strong", {
                                        children: "Version"
                                    })
                                }),
                                /*#__PURE__*/ (0, $dypTs.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)("strong", {
                                        children: "Size"
                                    })
                                }),
                                /*#__PURE__*/ (0, $dypTs.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)("strong", {
                                        children: "Build Date"
                                    })
                                }),
                                /*#__PURE__*/ (0, $dypTs.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)("strong", {
                                        children: "Format"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("tbody", {
                        className: (0, $2jatx.default)([
                            "_vwz4kb7n _ect4q6fz _syazvejh _yq5hcfaq _btyzidpf _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1a0z87ef _1czs19bv _ayjoftgi _7zpg19bv _3m4tftgi _1omd150w _ue36cd5j"
                        ]),
                        style: {
                            "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000")),
                            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
                            name: "downloadrow"
                        })
                    })
                ]
            })
        ]
    });
};
var $368a77dca296ff8b$export$2e2bcd8739ae039 = $368a77dca296ff8b$var$UniformDownloadTable;

});


parcelRegister("9Ldi7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("jK7xK")).default; });

var $jK7xK = parcelRequire("jK7xK");

});
parcelRegister("jK7xK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dd4891ef82d7897a$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $9NH4m = parcelRequire("9NH4m");
const $dd4891ef82d7897a$var$UniformEnhancedBanner = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $9NH4m.EnhancedBanner), (0, $6ogO3._)({}, props));
};
var $dd4891ef82d7897a$export$2e2bcd8739ae039 = $dd4891ef82d7897a$var$UniformEnhancedBanner;

});


parcelRegister("856b3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b78c67bf5af211c6$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $01zo5 = parcelRequire("01zo5");

var $g3AHF = parcelRequire("g3AHF");

var $lTkkF = parcelRequire("lTkkF");
const $b78c67bf5af211c6$var$UniformExpand = (props)=>{
    var _props_eventDataName, _props_expandedLabelText;
    const expandProps = {
        eventDataName: (_props_eventDataName = props.eventDataName) !== null && _props_eventDataName !== void 0 ? _props_eventDataName : undefined,
        chevronColor: props.chevronColor,
        boldLabel: props.richText ? false : props.boldLabel,
        label: props.richText ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : props.label,
        expandedLabelText: (_props_expandedLabelText = props.expandedLabelText) !== null && _props_expandedLabelText !== void 0 ? _props_expandedLabelText : null
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $g3AHF.Expand), (0, $dPABA._)((0, $6ogO3._)({}, expandProps), {
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
            name: "contents"
        })
    }));
};
var $b78c67bf5af211c6$export$2e2bcd8739ae039 = $b78c67bf5af211c6$var$UniformExpand;

});

parcelRegister("48xZO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("2bofd")).default; });

var $2bofd = parcelRequire("2bofd");

});
parcelRegister("2bofd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6173395c20c30f5b$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $01zo5 = parcelRequire("01zo5");

var $Fp3mL = parcelRequire("Fp3mL");

var $9rnwe = parcelRequire("9rnwe");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");
const $6173395c20c30f5b$var$UniformExperiment = (props)=>{
    var _Object_entries_find;
    const { experimentId: experimentId, override: override, postExperimentationMode: postExperimentationMode } = props;
    const context = (0, $9rnwe.useWAEContextSafe)();
    if (postExperimentationMode) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: experimentId,
        group: "Test",
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
            name: "treatment"
        })
    });
    const experiment = (_Object_entries_find = Object.entries((0, $ea4mV.experiments)).find(([, value])=>value.experimentName === experimentId)) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1];
    if (override && (context === null || context === void 0 ? void 0 : context.wacEnvironment) !== "production") return /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
        name: override
    });
    if (!experiment) return (context === null || context === void 0 ? void 0 : context.wacEnvironment) === "production" ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
        name: "control"
    }) : /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $Fp3mL.ManifestErrorMessage), {
                id: experimentId
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
                name: "control"
            })
        ]
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const experimentStatus = (0, $ea4mV.useExperiment)(experiment);
    const showTreatment = experimentStatus.type === "enrolled" && experimentStatus.value;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
        name: showTreatment ? "treatment" : "control"
    });
};
var $6173395c20c30f5b$export$2e2bcd8739ae039 = $6173395c20c30f5b$var$UniformExperiment;

});
parcelRegister("Fp3mL", function(module, exports) {
$parcel$export(module.exports, "ManifestErrorMessage", function () { return $080833fa2bf97116$export$702dc26c1a322512; });

var $dypTs = parcelRequire("dypTs");

var $8S1MN = parcelRequire("8S1MN");
const $080833fa2bf97116$export$702dc26c1a322512 = ({ id: id })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $dypTs.Fragment), {
        children: id.length === 0 ? null : /*#__PURE__*/ (0, $dypTs.jsx)((0, $8S1MN.default), {
            appearance: "error",
            isDismissible: true,
            children: /*#__PURE__*/ (0, $dypTs.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("strong", {
                        children: "Manifest entry not found for:"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $dypTs.jsx)("code", {
                        children: id
                    }),
                    ". Rendering control slot."
                ]
            })
        })
    });
};

});



parcelRegister("kGRnr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("3VYCw")).default; });

var $3VYCw = parcelRequire("3VYCw");

});
parcelRegister("3VYCw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9b2cb92c2df40e8d$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $01zo5 = parcelRequire("01zo5");

var $Fp3mL = parcelRequire("Fp3mL");

var $9rnwe = parcelRequire("9rnwe");

var $32ng3 = parcelRequire("32ng3");
const $9b2cb92c2df40e8d$var$UniformFeatureGate = (props)=>{
    var _Object_entries_find;
    const { featureGateId: featureGateId, override: override } = props;
    const context = (0, $9rnwe.useWAEContextSafe)();
    const featureGate = (_Object_entries_find = Object.entries((0, $32ng3.featureFlags)).find(([, value])=>value.featureFlagName === featureGateId)) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1];
    if (override && (context === null || context === void 0 ? void 0 : context.wacEnvironment) !== "production") return /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
        name: override
    });
    if (!featureGate) return (context === null || context === void 0 ? void 0 : context.wacEnvironment) === "production" ? null : /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $Fp3mL.ManifestErrorMessage), {
                id: featureGateId
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
                name: "control"
            })
        ]
    });
    const showTreatment = (0, $32ng3.checkFeatureFlagGate)(featureGate);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
        name: showTreatment ? "treatment" : "control"
    });
};
var $9b2cb92c2df40e8d$export$2e2bcd8739ae039 = $9b2cb92c2df40e8d$var$UniformFeatureGate;

});


parcelRegister("7uMUN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("g0xMT")).default; });

var $g0xMT = parcelRequire("g0xMT");

});
parcelRegister("g0xMT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ff1fa21ab21004e$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");
parcelRequire("l1i8p");
var $anFhN = parcelRequire("anFhN");

var $lTkkF = parcelRequire("lTkkF");
const $3ff1fa21ab21004e$var$UniformFeaturesHighlight = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $anFhN.FeaturesHighlight), {
        title: props.title,
        description: props.richText ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : props.description,
        linkText: props.linkText,
        linkHref: props.linkHref,
        feature1Eyebrow: props.feature1Eyebrow,
        feature1Title: props.feature1Title,
        feature1Body: props.feature1RichText ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.feature1RichText
        }) : props.feature1Body,
        feature1ImageSrc: props.feature1ImageSrc,
        feature1ImageAltText: props.feature1ImageAltText,
        feature2Eyebrow: props.feature2Eyebrow,
        feature2Title: props.feature2Title,
        feature2Body: props.feature2RichText ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.feature2RichText
        }) : props.feature2Body,
        feature2ImageSrc: props.feature2ImageSrc,
        feature2ImageAltText: props.feature2ImageAltText,
        feature3Eyebrow: props.feature3Eyebrow,
        feature3Title: props.feature3Title,
        feature3Body: props.feature3RichText ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.feature3RichText
        }) : props.feature3Body,
        feature3ImageSrc: props.feature3ImageSrc,
        feature3ImageAltText: props.feature3ImageAltText
    });
};
var $3ff1fa21ab21004e$export$2e2bcd8739ae039 = $3ff1fa21ab21004e$var$UniformFeaturesHighlight;

});


parcelRegister("kENrP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("3E3Vm")).default; });

var $3E3Vm = parcelRequire("3E3Vm");

});
parcelRegister("3E3Vm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1e4a9912bada85e5$export$2e2bcd8739ae039; });

var $8LaTa = parcelRequire("8LaTa");
var $1e4a9912bada85e5$export$2e2bcd8739ae039 = (0, $8LaTa.GlobalFooter);

});


parcelRegister("lwwc5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("7d42O")).default; });

var $7d42O = parcelRequire("7d42O");

});
parcelRegister("7d42O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c0a87c7a69a87c04$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $hcVGp = parcelRequire("hcVGp");
const $c0a87c7a69a87c04$var$UniformGlobalNav = ({ productKey: // This productKey is used for UFO instrumentation
// This prop is standardized to the value `uniform`
// See ldr/0018-set-standard-uniform-globalnav-productkey.md for more details
productKey = "uniform", isShowTryNowLink: isShowTryNowLink = true })=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $hcVGp.GlobalNav), {
        productKey: productKey,
        isShowTryNowLink: isShowTryNowLink
    });
var $c0a87c7a69a87c04$export$2e2bcd8739ae039 = $c0a87c7a69a87c04$var$UniformGlobalNav;

});


parcelRegister("6Xg4D", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("f7IMH")).default; });

var $f7IMH = parcelRequire("f7IMH");

});
parcelRegister("f7IMH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0c2ad3f3cc2c800b$export$2e2bcd8739ae039; });
/* heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $dZNgt = parcelRequire("dZNgt");

var $kbpa7 = parcelRequire("kbpa7");

var $faxYF = parcelRequire("faxYF");
var $0c2ad3f3cc2c800b$var$GestureLineType = /*#__PURE__*/ function(GestureLineType) {
    GestureLineType["UNDERLINE_SQUIGGLE"] = "underline-squiggle";
    GestureLineType["EYELASH"] = "eyelash";
    return GestureLineType;
}($0c2ad3f3cc2c800b$var$GestureLineType || {});
const $0c2ad3f3cc2c800b$var$UniformHeading = ({ text: text, uniformRichText: uniformRichText, customRichText: customRichText, alignment: alignment = "start", wordWrap: wordWrap })=>{
    const [headingRef, textColor] = (0, $faxYF.useStylePropertyVariableValueFromParent)("--dxp-container-text-color");
    const baseHeadingCss = null;
    const headingCss = [
        baseHeadingCss,
        wordWrap && null
    ];
    function resolveUniformRichText({ node: node, children: children }) {
        const nodeIsBold = (node)=>{
            return node.type === "text" && (0, $dZNgt.getRichTextTagsFromTextFormat)(node.format).includes("strong");
        };
        const richTextValueHasBold = (value)=>{
            let hasBold = false;
            (0, $dZNgt.walkRichTextTree)(value, (node)=>{
                if (nodeIsBold(node)) hasBold = true;
            });
            return hasBold;
        };
        const hasBoldText = richTextValueHasBold(node);
        return /*#__PURE__*/ (0, $dypTs.jsx)("h1", {
            ref: headingRef,
            className: (0, $2jatx.default)([
                "_1mouidpf _y3gnoues",
                wordWrap && "_ct361wug",
                hasBoldText ? "h1-contrast" : ""
            ]),
            style: (0, $dPABA._)((0, $6ogO3._)({}, textColor ? {
                color: textColor
            } : undefined), {
                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
            }),
            children: children
        });
    }
    function resolveUniformRichTextRenderer(node) {
        if (node.type === "paragraph") return resolveUniformRichText;
        return undefined;
    }
    const customRichTextIsConsideredEmpty = (customRichTextPropValue)=>{
        return !customRichTextPropValue || customRichTextPropValue.plainText === "";
    };
    const renderCustomRichText = ()=>{
        const nodeIsBold = (node)=>{
            return node.type === "bold";
        };
        const walkCustomRichTextTree = (node, callBack)=>{
            callBack(node);
            if (node.children) node.children.forEach((child)=>{
                walkCustomRichTextTree(child, callBack);
            });
        };
        const customRichTextValueHasBold = (value)=>{
            let hasBold = false;
            walkCustomRichTextTree(value, (node)=>{
                if (nodeIsBold(node)) hasBold = true;
            });
            return hasBold;
        };
        const hasBoldText = ()=>{
            let hasBold = false;
            customRichText === null || customRichText === void 0 ? void 0 : customRichText.content.forEach((node)=>{
                if (customRichTextValueHasBold(node)) hasBold = true;
            });
            return hasBold;
        };
        const renderCustomRichTextNode = (node, index)=>{
            switch(node.type){
                case "bold":
                    var _node_children;
                    return /*#__PURE__*/ (0, $dypTs.jsx)("strong", {
                        children: (_node_children = node.children) === null || _node_children === void 0 ? void 0 : _node_children.map((child, childIndex)=>renderCustomRichTextNode(child, childIndex))
                    }, index);
                case "underline-squiggle":
                    var _node_children1;
                    return /*#__PURE__*/ (0, $dypTs.jsxs)("span", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm"
                        ]),
                        children: [
                            $0c2ad3f3cc2c800b$var$getGestureLine(node.type, node.color),
                            (_node_children1 = node.children) === null || _node_children1 === void 0 ? void 0 : _node_children1.map((child, childIndex)=>renderCustomRichTextNode(child, childIndex))
                        ]
                    }, index);
                case "eyelash":
                    var _node_children2;
                    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)("br", {}),
                            /*#__PURE__*/ (0, $dypTs.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm"
                                ]),
                                children: [
                                    $0c2ad3f3cc2c800b$var$getGestureLine(node.type, node.color),
                                    (_node_children2 = node.children) === null || _node_children2 === void 0 ? void 0 : _node_children2.map((child, childIndex)=>renderCustomRichTextNode(child, childIndex))
                                ]
                            }, index)
                        ]
                    });
                case "text":
                default:
                    return /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        children: node.text || ""
                    }, index);
            }
        };
        return /*#__PURE__*/ (0, $dypTs.jsx)("h1", {
            ref: headingRef,
            className: (0, $2jatx.default)([
                "_1mouidpf _y3gnoues",
                wordWrap && "_ct361wug",
                hasBoldText() ? "h1-contrast" : ""
            ]),
            style: (0, $dPABA._)((0, $6ogO3._)({}, textColor ? {
                color: textColor
            } : undefined), {
                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
            }),
            children: customRichText === null || customRichText === void 0 ? void 0 : customRichText.content.map((node, index)=>renderCustomRichTextNode(node, index))
        });
    };
    return !(0, $dZNgt.isRichTextValueConsideredEmpty)(uniformRichText) ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformRichText), {
        parameterId: "uniformRichText",
        resolveRichTextRenderer: resolveUniformRichTextRenderer
    }) : !customRichTextIsConsideredEmpty(customRichText) ? renderCustomRichText() : /*#__PURE__*/ (0, $dypTs.jsx)("h1", {
        ref: headingRef,
        className: (0, $2jatx.default)([
            "_1mouidpf _y3gnoues",
            wordWrap && "_ct361wug"
        ]),
        style: (0, $dPABA._)((0, $6ogO3._)({}, textColor ? {
            color: textColor
        } : undefined), {
            "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
        }),
        children: text
    });
};
const $0c2ad3f3cc2c800b$var$getGestureLine = (gestureLine, gestureColor)=>{
    switch(gestureLine){
        case "underline-squiggle":
            return /*#__PURE__*/ (0, $dypTs.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "168",
                height: "16",
                viewBox: "0 0 168 16",
                fill: "none",
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_kqswstnw _u7comgjw _1e021ssb _t9eczr6s"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                    d: "M2.28772 11.6604C3.27772 12.0304 4.34772 11.9903 5.35772 11.8503C7.39772 11.5403 9.37772 10.8704 11.5877 10.1904C12.1377 9.84043 12.2377 9.88052 12.0577 9.53052C12.1777 9.40052 12.3777 9.17054 12.2377 9.05054C11.7477 8.23054 13.1677 7.92036 13.7077 7.62036C13.8777 8.38036 14.7577 8.34047 15.9677 7.98047C16.3177 7.88047 16.4477 7.83054 16.7777 7.80054C17.1377 7.75054 17.5177 7.69037 17.9177 7.63037C18.6977 7.55037 19.5677 7.43051 20.3677 7.52051C21.1777 7.59051 21.9477 7.82033 22.5477 8.34033C23.1577 8.85033 23.5977 9.61033 23.9377 10.3403C24.2777 11.0803 24.5277 11.7703 24.7977 12.3303C25.0477 12.8903 25.3077 13.2605 25.4377 13.4805C25.2677 13.7805 25.3077 14.2403 25.6877 14.5603C25.8477 14.7603 26.1177 14.8404 26.3877 14.9504C26.6777 15.0204 26.9977 15.0505 27.3177 15.0405C27.9777 14.9905 28.6077 14.7703 29.1477 14.6003C29.6277 14.4003 30.0777 14.2805 30.4177 14.2905C30.3777 14.3905 29.9477 14.8704 29.8977 14.9504C30.2677 15.0804 31.5877 14.5504 33.0877 13.6204C34.5877 12.6804 36.3277 11.3904 37.8377 10.1504C40.8877 7.70039 43.2477 5.65034 41.7577 7.85034C42.9077 7.23034 44.1177 6.56054 45.3277 5.80054C45.6277 5.61054 45.9377 5.42047 46.2477 5.23047L46.4577 5.10034L46.5577 5.05054C46.6177 5.02054 46.6877 4.98046 46.7477 4.97046H46.9577C46.9577 4.97046 47.0077 4.99048 47.0677 4.99048L47.3177 4.97046C47.6477 4.93046 47.9577 4.97046 48.2877 4.97046C49.5577 5.03046 50.7077 5.27036 51.5177 5.87036C52.3577 6.43036 53.0377 7.39032 53.8677 8.83032C54.2877 9.54032 54.7477 10.3605 55.4377 11.2405C56.1177 12.1105 57.1877 13.1003 58.5577 13.5903C58.8977 13.6903 59.2377 13.8104 59.5777 13.8804C59.9077 13.9304 60.2477 13.9705 60.5877 14.0005C61.2077 14.0005 61.8677 14.0004 62.4177 13.8804C62.6977 13.8304 62.9977 13.7905 63.2677 13.7205L64.0477 13.5005C64.5877 13.3605 65.0377 13.1605 65.5277 12.9805C69.2577 11.4205 72.3477 9.28033 75.4077 7.09033L77.3177 5.68042L78.2877 5.3103C78.6577 5.1603 78.9877 5.13052 79.3377 5.03052C79.5177 4.97052 79.6677 4.96045 79.8177 4.96045L80.2677 4.92041C80.4177 4.90041 80.5077 4.95044 80.6377 4.95044C80.7577 4.96044 80.8877 4.9505 80.9677 5.0105C81.3577 5.0805 81.7077 5.38037 82.1877 5.88037C83.1277 6.87037 84.1977 8.90048 86.2677 10.2405C86.7977 10.5505 87.3177 10.8705 87.8977 11.0505C88.1777 11.1505 88.4677 11.2603 88.7477 11.3403L89.6277 11.5005L90.1877 11.5903C90.3777 11.6103 90.5577 11.6904 90.7377 11.6204L91.7777 11.4004L93.0077 11.1504C99.5477 9.79039 105.978 9.92039 111.408 10.6504L111.248 10.4805C111.418 10.5405 111.958 10.4604 112.088 10.6704C113.168 10.3804 115.148 10.2204 116.858 10.1104C118.568 9.99035 120.008 9.98047 120.008 9.98047L126.178 9.68042C126.178 9.68042 128.828 10.0004 132.038 10.1804C135.248 10.3504 139.018 10.3505 141.168 9.75049C146.538 9.91049 151.978 9.90038 157.378 9.14038C157.378 9.14038 157.798 9.06042 158.458 8.93042C159.108 8.76042 159.998 8.50045 160.938 8.21045C161.878 7.90045 162.878 7.63048 163.728 7.24048C164.578 6.84048 165.308 6.46038 165.738 6.14038C166.818 5.34038 167.398 4.60032 167.398 4.08032C167.398 3.56032 166.798 3.26034 165.488 3.35034C164.838 3.40034 164.008 3.5403 162.978 3.8103C161.958 4.0903 160.678 4.30047 159.188 4.73047C159.108 4.69047 158.848 4.68034 158.798 4.60034C155.658 5.58034 152.388 5.81031 149.118 5.82031C147.488 5.85031 145.828 5.71044 144.178 5.70044C142.518 5.66044 140.838 5.55033 139.138 5.59033C139.218 5.88033 138.988 6.11045 138.788 5.96045L138.868 5.60034C134.278 6.20034 131.478 4.87037 127.188 5.88037C127.188 5.88037 127.698 5.43041 127.708 5.42041C124.088 5.28041 120.148 5.02035 115.968 4.86035C111.798 4.67035 107.398 4.61033 102.918 4.84033C101.798 4.92033 100.678 5.00032 99.5477 5.08032C98.4277 5.18032 97.2977 5.37051 96.1777 5.52051L94.4977 5.7605L92.8277 6.12036L91.1677 6.49048L90.4477 6.65039C90.5277 6.65039 90.4077 6.67039 90.3977 6.65039C90.3677 6.65039 90.3977 6.65037 90.3277 6.63037L90.0777 6.60034C89.8977 6.60034 89.7877 6.50046 89.6377 6.47046C89.3377 6.41046 89.1177 6.22034 88.8477 6.10034C88.3577 5.76034 87.8377 5.20043 87.2377 4.44043C86.6277 3.70043 85.9777 2.69047 84.7877 1.73047C84.5377 1.49047 84.1477 1.29032 83.8277 1.08032C83.4977 0.860322 83.1177 0.720332 82.7377 0.590332C81.9677 0.270332 81.2177 0.260439 80.4877 0.200439C80.5177 0.210439 80.5577 0.240498 80.5977 0.260498L80.5477 0.310303C80.8177 0.380303 81.2077 0.480342 81.6777 0.600342C82.1377 0.700342 82.7077 1.02054 83.2677 1.30054C84.3877 2.00054 85.2177 3.07043 85.7777 3.94043C86.3577 4.84043 86.7577 5.54052 87.1077 6.03052C87.4577 6.48052 87.6877 6.76048 87.6877 6.74048C86.5777 6.38048 85.6577 5.36052 84.6977 4.28052C84.1877 3.75052 83.6877 3.17048 82.9877 2.74048C82.3277 2.26048 81.5077 2.01037 80.6977 1.88037C79.8977 1.79037 79.0677 1.79041 78.3077 1.92041C77.4877 1.99041 76.8377 2.21041 76.0077 2.42041L75.6577 2.52051C75.5477 2.57051 75.4477 2.64045 75.3377 2.71045L74.8077 3.03052L73.9177 3.58032C73.3277 3.96032 72.7577 4.34047 72.1877 4.73047L71.9477 4.32031C72.9277 3.67031 73.7977 2.95035 74.5077 2.36035L74.6377 2.25049L74.8677 2.07031C75.0177 1.96031 75.1377 1.82049 75.2977 1.75049C75.5977 1.62049 75.8977 1.48039 76.0577 1.40039C76.4177 1.22039 76.7177 1.06042 76.9377 0.93042C76.6377 1.02042 76.3377 1.10043 76.0177 1.19043C75.8277 1.25043 75.6377 1.31036 75.4477 1.37036L75.0877 1.49048C74.9677 1.55048 74.8677 1.63044 74.7577 1.70044C74.2077 2.06044 73.6377 2.43031 73.0377 2.82031C71.9577 3.52031 70.7877 4.26048 69.5577 4.99048C68.3377 5.72048 67.0477 6.48035 65.7477 7.11035C64.4677 7.75035 63.1077 8.35031 61.9777 8.57031C61.4477 8.66031 60.9377 8.7304 60.6677 8.6604C60.3877 8.6004 60.2477 8.55031 59.9677 8.32031C59.6977 8.10031 59.3477 7.66033 58.9677 7.09033C58.5877 6.53033 58.1977 5.88043 57.7177 5.19043C56.8077 3.83043 55.4277 2.36054 53.8077 1.55054C52.1877 0.720537 50.5777 0.550342 49.3377 0.600342C49.3977 0.690342 49.6377 0.730479 49.9777 0.740479C50.3177 0.770479 50.7777 0.8304 51.2477 0.9104C51.7177 1.0204 52.2077 1.20043 52.5777 1.44043C52.9477 1.71043 53.2077 2.02036 53.2477 2.37036C52.0777 1.73036 50.7777 1.51044 49.5877 1.45044L48.6977 1.43042L47.8477 1.50049C47.5677 1.52049 47.2777 1.53032 47.0177 1.58032C46.6977 1.63032 46.3777 1.67046 46.0677 1.72046C46.0177 1.53046 46.0977 1.40053 46.2577 1.29053C46.3377 1.24053 46.4377 1.19039 46.5477 1.15039C46.6377 1.11039 46.7077 1.0903 46.7977 1.0603C47.1377 0.950303 47.5377 0.960381 47.6577 0.890381C47.5377 0.880381 47.3277 0.840352 47.0677 0.860352C46.9377 0.860352 46.7877 0.870371 46.6277 0.880371C46.3877 0.900371 46.1277 0.930439 45.8477 0.950439C45.6977 0.960439 45.5477 0.980488 45.3777 1.00049L45.1277 1.02051C45.0477 1.05051 44.9877 1.11039 44.9177 1.15039C44.6377 1.35039 44.3377 1.56053 44.0177 1.79053C43.6377 2.05053 43.2077 2.3404 42.7477 2.6604C40.9377 3.9104 38.5277 5.5904 35.7377 7.4104C34.3477 8.3304 32.8477 9.23033 31.3077 10.0903C30.9277 10.2903 30.5377 10.4804 30.1477 10.6804C29.7677 10.8504 29.3877 11.0204 28.9977 11.1904L28.4577 11.3704L28.1877 11.4705L28.0877 11.4905C27.9377 11.5305 27.8877 11.5305 27.8177 11.5205C27.6677 11.5205 27.5777 11.3805 27.5377 11.2505L27.2377 10.2505C27.0977 9.76049 26.9177 9.1703 26.6777 8.5603C26.4377 7.9403 26.0877 7.27035 25.6277 6.61035C25.3577 6.29035 25.0977 5.96041 24.7877 5.67041C24.4577 5.40041 24.1377 5.09038 23.7677 4.89038C22.2977 3.98038 20.7377 3.74048 19.4877 3.74048C18.1677 3.71048 17.0877 3.89035 15.9277 4.11035C15.7477 4.16035 15.5177 4.15049 15.3077 4.25049L14.7377 4.49048L13.9977 4.83032C13.5277 5.06032 13.0777 5.2805 12.6577 5.5105C10.9577 6.4105 9.43772 7.26043 8.02772 7.94043C6.62772 8.62043 5.32772 9.14035 4.32772 9.36035C3.83772 9.47035 3.42772 9.49046 3.18772 9.47046C2.95772 9.46046 2.81772 9.42033 2.64772 9.34033C2.36772 9.20033 2.02772 8.68046 1.82772 8.22046C1.59772 7.77046 1.46772 7.39051 1.29772 7.27051C1.13772 7.14051 0.99772 7.24036 0.86772 7.62036C0.73772 8.01036 0.61772 8.68038 0.80772 9.64038C0.63772 9.58038 0.44772 9.51041 0.28772 9.42041C0.58772 10.4404 1.30772 11.3504 2.30772 11.7004L2.28772 11.6604Z",
                    fill: (0, $kbpa7.wacToken)(`color.${gestureColor}`)
                })
            });
        case "eyelash":
            return /*#__PURE__*/ (0, $dypTs.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "117",
                height: "117",
                viewBox: "0 0 117 117",
                fill: "none",
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_kqswstnw _rjxp120u _152txmi2 _1bsb1wug _4t3i1vuk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M25.93 74.8872C25.1564 75.4245 12.3829 73.151 16.0089 71.2258C17.2313 70.3577 18.3652 70.4522 18.7372 71.7455C19.127 69.2416 21.5364 72.5841 22.7056 71.7691C22.3041 70.0211 25.7765 73.6706 25.115 71.8518C38.9455 69.9857 66.6537 86.9815 32.7862 76.7356C36.1641 75.956 32.987 75.2593 31.4693 75.6431C33.6248 77.8813 27.306 75.9325 26.1426 75.1589C28.1032 75.2061 24.8788 73.5526 25.9359 74.8813L25.93 74.8872Z",
                        fill: (0, $kbpa7.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M51.0103 53.7517C49.2092 53.6395 41.6974 41.3562 40.7526 40.187C39.1994 37.311 43.345 37.0866 44.0123 39.5374C44.3489 39.9566 45.5123 43.4468 46.3568 41.9527C49.8823 42.7263 50.3548 48.9624 53.3311 49.3522C52.8528 50.173 53.9039 51.1533 53.6618 51.7025C54.5476 51.608 55.0377 52.795 54.8251 52.9013C58.5987 55.978 53.898 59.604 51.8784 55.1867C51.7248 55.3757 50.6973 54.5961 51.0102 53.7635L51.0103 53.7517Z",
                        fill: (0, $kbpa7.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M96.948 30.7506C98.5602 32.788 98.4539 30.6385 97.6566 29.6523C96.198 31.477 96.2098 27.2133 96.6999 26.1208C96.7885 26.5637 97.5562 26.6346 97.4263 25.7133C95.5838 26.5637 94.0779 14.9005 98.5661 19.991C98.5779 20.1918 97.0838 20.4457 97.5739 20.6287C99.8121 19.9851 98.4007 21.9989 98.2767 22.5363C99.4578 22.3945 98.4066 23.0087 98.9086 23.0855C100.438 22.2764 98.0641 25.5598 99.57 24.6681C102.245 27.0834 99.564 32.7408 101.962 34.5478C99.44 36.2545 104.241 44.3981 98.8437 41.6462C97.3378 38.0734 96.3988 35.1147 96.948 30.7506Z",
                        fill: (0, $kbpa7.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M67.6391 11.4579C71.2001 10.1291 71.1824 18.2727 72.8891 20.2983C75.2808 22.7136 85.4263 50.3746 77.5308 43.7665C74.5308 35.3689 70.6037 29.0087 68.2533 18.3672C67.7454 16.6664 65.0643 11.5051 67.6391 11.4579Z",
                        fill: (0, $kbpa7.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        d: "M43.5337 100.854C45.9077 103.617 48.5592 99.584 50.7796 101.828C54.2166 106.222 27.3351 110.663 27.7485 105.737C28.6757 101.551 41.7739 102.826 43.5337 100.854Z",
                        fill: (0, $kbpa7.wacToken)(`color.${gestureColor}`)
                    })
                ]
            });
        default:
            return null;
    }
};
var $0c2ad3f3cc2c800b$export$2e2bcd8739ae039 = $0c2ad3f3cc2c800b$var$UniformHeading;

});
parcelRegister("faxYF", function(module, exports) {
$parcel$export(module.exports, "useStylePropertyVariableValueFromParent", function () { return $21111e3490530253$export$a43348ac9682b5fa; });

var $gljCV = parcelRequire("gljCV");
const $21111e3490530253$export$a43348ac9682b5fa = (cssVariableName)=>{
    const ref = (0, $gljCV.useRef)(null);
    const [propertyValue, setPropertyValue] = (0, $gljCV.useState)();
    (0, $gljCV.useEffect)(()=>{
        if (!ref.current) return;
        let element = ref.current;
        let depth = 0;
        const maxDepth = 20; // prevent infinite loops
        while(element && depth < maxDepth){
            const computedStyle = getComputedStyle(element);
            const value = computedStyle.getPropertyValue(cssVariableName).trim();
            if (value && value !== "") {
                setPropertyValue(value);
                return;
            }
            element = element.parentElement;
            depth++;
        }
        setPropertyValue(undefined);
    }, [
        cssVariableName
    ]);
    return [
        ref,
        propertyValue
    ];
};

});



parcelRegister("86Uds", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("jGtmE")).default; });

var $jGtmE = parcelRequire("jGtmE");

});
parcelRegister("jGtmE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b0cf533147eaa151$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $01zo5 = parcelRequire("01zo5");
parcelRequire("l1i8p");
var $us1N6 = parcelRequire("us1N6");
const $b0cf533147eaa151$var$renderHeroCarousel = ({ items: items })=>{
    // First pass to work through Uniform setting empty to "" vs undefined that underlying component expects
    // eslint-disable-next-line complexity
    const transformed = items.map((heroSlide)=>{
        var _heroSlide_props_children_props_data, _heroSlide_props_children_props, _heroSlide_props_children, _heroSlide_props, _params_id, _params_tabEyebrow, _params_tabLabel, _params_title, _params_body, _params_buttonText, _params_buttonHref, _params_buttonText1, _params_buttonHref1, _params_buttonAriaLabel, _params_linkText, _params_linkHref, _params_linkText1, _params_linkHref1, _params_linkType, _params_linkAriaLabel, _params_bgColor, _params_imageLarge, _params_alignment;
        const params = (_heroSlide_props = heroSlide.props) === null || _heroSlide_props === void 0 ? void 0 : (_heroSlide_props_children = _heroSlide_props.children) === null || _heroSlide_props_children === void 0 ? void 0 : (_heroSlide_props_children_props = _heroSlide_props_children.props) === null || _heroSlide_props_children_props === void 0 ? void 0 : (_heroSlide_props_children_props_data = _heroSlide_props_children_props.data) === null || _heroSlide_props_children_props_data === void 0 ? void 0 : _heroSlide_props_children_props_data.parameters;
        return {
            id: ((_params_id = params.id) === null || _params_id === void 0 ? void 0 : _params_id.value) || undefined,
            eyebrow: ((_params_tabEyebrow = params.tabEyebrow) === null || _params_tabEyebrow === void 0 ? void 0 : _params_tabEyebrow.value) || undefined,
            title: (params === null || params === void 0 ? void 0 : (_params_tabLabel = params.tabLabel) === null || _params_tabLabel === void 0 ? void 0 : _params_tabLabel.value) || undefined,
            panel: {
                title: ((_params_title = params.title) === null || _params_title === void 0 ? void 0 : _params_title.value) || undefined,
                body: ((_params_body = params.body) === null || _params_body === void 0 ? void 0 : _params_body.value) || undefined,
                primaryCallToAction: ((_params_buttonText = params.buttonText) === null || _params_buttonText === void 0 ? void 0 : _params_buttonText.value) && ((_params_buttonHref = params.buttonHref) === null || _params_buttonHref === void 0 ? void 0 : _params_buttonHref.value) ? {
                    "text": (_params_buttonText1 = params.buttonText) === null || _params_buttonText1 === void 0 ? void 0 : _params_buttonText1.value,
                    "href": (_params_buttonHref1 = params.buttonHref) === null || _params_buttonHref1 === void 0 ? void 0 : _params_buttonHref1.value,
                    "aria-label": ((_params_buttonAriaLabel = params.buttonAriaLabel) === null || _params_buttonAriaLabel === void 0 ? void 0 : _params_buttonAriaLabel.value) || undefined
                } : undefined,
                secondaryCallToAction: ((_params_linkText = params.linkText) === null || _params_linkText === void 0 ? void 0 : _params_linkText.value) && ((_params_linkHref = params.linkHref) === null || _params_linkHref === void 0 ? void 0 : _params_linkHref.value) ? {
                    text: (_params_linkText1 = params.linkText) === null || _params_linkText1 === void 0 ? void 0 : _params_linkText1.value,
                    href: (_params_linkHref1 = params.linkHref) === null || _params_linkHref1 === void 0 ? void 0 : _params_linkHref1.value,
                    type: ((_params_linkType = params.linkType) === null || _params_linkType === void 0 ? void 0 : _params_linkType.value) || undefined,
                    ariaLabel: ((_params_linkAriaLabel = params.linkAriaLabel) === null || _params_linkAriaLabel === void 0 ? void 0 : _params_linkAriaLabel.value) || undefined
                } : undefined,
                bgColor: ((_params_bgColor = params.bgColor) === null || _params_bgColor === void 0 ? void 0 : _params_bgColor.value) || undefined,
                bgImage: {
                    lg: ((_params_imageLarge = params.imageLarge) === null || _params_imageLarge === void 0 ? void 0 : _params_imageLarge.value) || undefined
                },
                layout: ((_params_alignment = params.alignment) === null || _params_alignment === void 0 ? void 0 : _params_alignment.value) || undefined
            }
        };
    });
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $us1N6.HeroCarousel), {
        tabsData: transformed
    });
};
const $b0cf533147eaa151$var$UniformHeroCarousel = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
            name: "tabdata",
            wrapperComponent: $b0cf533147eaa151$var$renderHeroCarousel
        })
    });
};
var $b0cf533147eaa151$export$2e2bcd8739ae039 = $b0cf533147eaa151$var$UniformHeroCarousel;

});


parcelRegister("ewf1g", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("2XwEb")).default; });

var $2XwEb = parcelRequire("2XwEb");

});
parcelRegister("2XwEb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3bc05aa7eb0605f5$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $8J2ZV = parcelRequire("8J2ZV");

var $kooLp = parcelRequire("kooLp");
const $3bc05aa7eb0605f5$var$UniformHeroSection = (props)=>{
    var _props_buttonHref;
    var _props_buttonHref_path;
    const localizedButtonHref = (0, $kooLp.useLocalizedHref)((_props_buttonHref_path = (_props_buttonHref = props.buttonHref) === null || _props_buttonHref === void 0 ? void 0 : _props_buttonHref.path) !== null && _props_buttonHref_path !== void 0 ? _props_buttonHref_path : "");
    var _props_layout, _props_imageAlt;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $8J2ZV.default), {
        heading: props.heading,
        subheading: props.subheading,
        layout: (_props_layout = props.layout) !== null && _props_layout !== void 0 ? _props_layout : "image-right",
        // @ts-ignore
        backgroundColor: props.backgroundColor,
        callToActionProps: props.buttonHref && props.buttonLabel ? {
            text: props.buttonLabel,
            href: localizedButtonHref
        } : undefined,
        imageProps: props.imageUrl ? {
            src: props.imageUrl,
            alt: (_props_imageAlt = props.imageAlt) !== null && _props_imageAlt !== void 0 ? _props_imageAlt : ""
        } : undefined,
        secondaryImageProps: props.secondaryImageUrl ? {
            src: props.secondaryImageUrl,
            alt: ""
        } : undefined
    });
};
var $3bc05aa7eb0605f5$export$2e2bcd8739ae039 = $3bc05aa7eb0605f5$var$UniformHeroSection;

});


parcelRegister("Q6uLA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("2oS3p")).default; });

var $2oS3p = parcelRequire("2oS3p");

});
parcelRegister("2oS3p", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e060563c171063cc$export$2e2bcd8739ae039; });
/* horizontal-divider.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $4OgEb = parcelRequire("4OgEb");

var $kbpa7 = parcelRequire("kbpa7");
const $e060563c171063cc$var$dividerStyle = null;
const $e060563c171063cc$var$UniformHorizontalDivider = ({ lineStyle: lineStyle = "solid" })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("hr", {
        role: "presentation",
        style: {
            borderBlockStart: `1px ${lineStyle} ${(0, $kbpa7.wacToken)("color.neutral.light400")}`
        },
        className: (0, $2jatx.default)([
            "_1bsb1osq _19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    });
};
$e060563c171063cc$var$UniformHorizontalDivider.propTypes = {
    lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string
};
var $e060563c171063cc$export$2e2bcd8739ae039 = $e060563c171063cc$var$UniformHorizontalDivider;

});


parcelRegister("bQ2Tp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("6JkkA")).default; });

var $6JkkA = parcelRequire("6JkkA");

});
parcelRegister("6JkkA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c1fa0ef514a5e9e$export$2e2bcd8739ae039; });
/* image.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $imIsw = parcelRequire("imIsw");
// eslint-disable-next-line complexity
const $5c1fa0ef514a5e9e$var$UniformImage = ({ source: source, altText: altText = "", width: width, maxWidth: maxWidth, height: height, maxHeight: maxHeight, objectFit: objectFit, objectPosition: objectPosition, tabletWidth: tabletWidth, desktopWidth: desktopWidth, tabletHeight: tabletHeight, desktopHeight: desktopHeight, makeCircle: makeCircle = false })=>{
    const imageStyle = {
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    const widthStyle = null;
    const heightStyle = null;
    const tabletWidthStyle = null;
    const desktopWidthStyle = null;
    const tabletHeightStyle = null;
    const desktopHeightStyle = null;
    // @ts-ignore
    const responsiveStyles = null;
    const makeCircleStyle = null;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), {
        image: {
            src: source,
            alt: altText
        },
        className: (0, $2jatx.default)([
            width && "_1bsbzdsf",
            height && "_4t3i1rot",
            tabletWidth && "_14b51mzn",
            desktopWidth && "_glte1k6c",
            tabletHeight && "_1xloa7f3",
            desktopHeight && "_165tbekw",
            makeCircle && "_2rko1ssb"
        ]),
        style: (0, $dPABA._)((0, $6ogO3._)({}, imageStyle), {
            "--_m5r7t4": (0, $6ZVlx.default)(width ? width : "auto"),
            "--_mzs5ed": (0, $6ZVlx.default)(height ? height : "auto"),
            "--_dwkr3u": (0, $6ZVlx.default)(tabletWidth ? tabletWidth : "auto"),
            "--_1mc860w": (0, $6ZVlx.default)(desktopWidth ? desktopWidth : "auto"),
            "--_1cta8t7": (0, $6ZVlx.default)(tabletHeight ? tabletHeight : "auto"),
            "--_1frmj6s": (0, $6ZVlx.default)(desktopHeight ? desktopHeight : "auto")
        })
    });
};
var $5c1fa0ef514a5e9e$export$2e2bcd8739ae039 = $5c1fa0ef514a5e9e$var$UniformImage;

});


parcelRegister("ctoCY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("1ij5s")).default; });

var $1ij5s = parcelRequire("1ij5s");

});
parcelRegister("1ij5s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $00ee4cee431699a0$export$2e2bcd8739ae039; });
/* image-v2.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2fk4i = parcelRequire("2fk4i");
// eslint-disable-next-line complexity
const $00ee4cee431699a0$var$UniformImageV2 = ({ source: source, altText: altText = "", width: width, maxWidth: maxWidth, height: height, maxHeight: maxHeight, objectFit: objectFit, objectPosition: objectPosition, tabletWidth: tabletWidth, desktopWidth: desktopWidth, tabletHeight: tabletHeight, desktopHeight: desktopHeight, makeCircle: makeCircle = false })=>{
    const imageStyle = {
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    const widthStyle = null;
    const heightStyle = null;
    const tabletWidthStyle = null;
    const desktopWidthStyle = null;
    const tabletHeightStyle = null;
    const desktopHeightStyle = null;
    // @ts-ignore
    const responsiveStyles = null;
    const makeCircleStyle = null;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
        src: source,
        alt: altText,
        className: (0, $2jatx.default)([
            width && "_1bsbzdsf",
            height && "_4t3i1rot",
            tabletWidth && "_14b51mzn",
            desktopWidth && "_glte1k6c",
            tabletHeight && "_1xloa7f3",
            desktopHeight && "_165tbekw",
            makeCircle && "_2rko1ssb"
        ]),
        style: (0, $dPABA._)((0, $6ogO3._)({}, imageStyle), {
            "--_m5r7t4": (0, $6ZVlx.default)(width ? width : "auto"),
            "--_mzs5ed": (0, $6ZVlx.default)(height ? height : "auto"),
            "--_dwkr3u": (0, $6ZVlx.default)(tabletWidth ? tabletWidth : "auto"),
            "--_1mc860w": (0, $6ZVlx.default)(desktopWidth ? desktopWidth : "auto"),
            "--_1cta8t7": (0, $6ZVlx.default)(tabletHeight ? tabletHeight : "auto"),
            "--_1frmj6s": (0, $6ZVlx.default)(desktopHeight ? desktopHeight : "auto")
        })
    });
};
var $00ee4cee431699a0$export$2e2bcd8739ae039 = $00ee4cee431699a0$var$UniformImageV2;

});


parcelRegister("4aqCo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("3jkl6")).default; });

var $3jkl6 = parcelRequire("3jkl6");

});
parcelRegister("3jkl6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26110392bbc93120$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $lAAJP = parcelRequire("lAAJP");
parcelRequire("l1i8p");
var $ifNiy = parcelRequire("ifNiy");

var $lTkkF = parcelRequire("lTkkF");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $26110392bbc93120$var$UniformIntegration = (props)=>{
    const { eyebrow: eyebrow, title: title, titleAs: titleAs, body: body, richText: richText, linkLabel: linkLabel, linkHref: linkHref, logos: logos, background: background, backgroundColor: backgroundColor, flipLayout: flipLayout } = (0, $lAAJP.flattenLogoProps)(props);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $ifNiy.Integration), {
        eyebrow: eyebrow,
        title: title,
        titleAs: titleAs,
        body: richText ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            text: richText
        }) : body,
        linkLabel: linkLabel,
        linkHref: linkHref,
        logos: logos,
        background: background,
        backgroundColor: backgroundColor,
        flipLayout: flipLayout
    });
};
var $26110392bbc93120$export$2e2bcd8739ae039 = $26110392bbc93120$var$UniformIntegration;

});
parcelRegister("lAAJP", function(module, exports) {
$parcel$export(module.exports, "flattenLogoProps", function () { return $a69aeb5889de0c02$export$ffc5469ebe0e6998; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $f2QWG = parcelRequire("f2QWG");
const $a69aeb5889de0c02$export$ffc5469ebe0e6998 = (props)=>{
    return (0, $dPABA._)((0, $6ogO3._)({}, props), {
        logos: (0, $f2QWG.flattenValues)(props.logos)
    });
};

});



parcelRegister("40haA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("bkhKq")).default; });

var $bkhKq = parcelRequire("bkhKq");

});
parcelRegister("bkhKq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b9780893fe5c6ce3$export$2e2bcd8739ae039; });
/* invisible-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
const $b9780893fe5c6ce3$var$UniformInvisibleContent = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        "data-content": props.content,
        className: (0, $2jatx.default)([
            "_1e0cglyw"
        ])
    });
};
var $b9780893fe5c6ce3$export$2e2bcd8739ae039 = $b9780893fe5c6ce3$var$UniformInvisibleContent;

});


parcelRegister("7LEgv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("6jbRM")).default; });

var $6jbRM = parcelRequire("6jbRM");

});
parcelRegister("6jbRM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3255cbe80369d8fd$export$2e2bcd8739ae039; });
/* jira-templates-tab-content-subgrid-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");
const $3255cbe80369d8fd$export$2f2a2862921598f6 = ()=>{
    const renderJiraTemplatesTabContent = ({ items: items })=>{
        return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulpv47k _dm2511p5 _dbjgidpf _1hvkidpf _isu4idpf _15qmidpf _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf _pdlm14hz _glte1osq _1vsw13cz _18jf188f _azss12kr _1rqt1we7"
            ]),
            children: items
        });
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
        name: "jiraTemplatesTabContent",
        wrapperComponent: renderJiraTemplatesTabContent
    });
};
var $3255cbe80369d8fd$export$2e2bcd8739ae039 = $3255cbe80369d8fd$export$2f2a2862921598f6;

});


parcelRegister("k2y5m", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("ks0ka")).default; });

var $ks0ka = parcelRequire("ks0ka");

});
parcelRegister("ks0ka", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6351c758da902f43$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $kooLp = parcelRequire("kooLp");

var $aIIww = parcelRequire("aIIww");

var $32ng3 = parcelRequire("32ng3");

var $iPPTB = parcelRequire("iPPTB");
const $6351c758da902f43$export$64bc9cd96d3d9a80 = (props)=>{
    let localizedHref = (0, $kooLp.useLocalizedHref)(props.href);
    const localizedPartnerDirectoryUrl = (0, $aIIww.useLocalizedPartnerDirectoryHref)(props.href);
    const checkGate = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwpUniformLinkLocalizePartnerDirectory);
    if (checkGate && props.href !== localizedPartnerDirectoryUrl) localizedHref = localizedPartnerDirectoryUrl;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $iPPTB.Link), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        "aria-label": props.text,
        href: localizedHref,
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "link",
            "data-event": "clicked"
        }
    }));
};
var $6351c758da902f43$export$2e2bcd8739ae039 = $6351c758da902f43$export$64bc9cd96d3d9a80;

});


parcelRegister("fChjk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("71BPb")).default; });

var $71BPb = parcelRequire("71BPb");

});
parcelRegister("71BPb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $abc24fa26164e237$export$2e2bcd8739ae039; });
/* list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("gljCV");

var $01zo5 = parcelRequire("01zo5");

var $e5xHH = parcelRequire("e5xHH");
const $abc24fa26164e237$var$UniformList = ({ gap: gap = "space.100", maxHeight: maxHeight, isHorizontal: isHorizontal = false })=>{
    const spaceTokenValue = (0, $e5xHH.spaceTokenValues)[gap];
    const listStyle = null;
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21q43 _zulpfogq _c71l1nve _1reo15vq _18m915vq"
        ]),
        style: {
            "--_edet6m": (0, $6ZVlx.default)(isHorizontal ? "row" : "column"),
            "--_e9ez6f": (0, $6ZVlx.default)("var(--ds-space-" + spaceTokenValue + ")"),
            "--_6stjzx": (0, $6ZVlx.default)(maxHeight ? maxHeight + "px" : "none")
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
            name: "listItems"
        })
    });
};
var $abc24fa26164e237$export$2e2bcd8739ae039 = $abc24fa26164e237$var$UniformList;

});


parcelRegister("zIzFT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("bmNwd")).default; });

var $bmNwd = parcelRequire("bmNwd");

});
parcelRegister("bmNwd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $68ad224476b69534$export$2e2bcd8739ae039; });
/* listv2.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $gljCV = parcelRequire("gljCV");

var $01zo5 = parcelRequire("01zo5");

var $4yv6j = parcelRequire("4yv6j");
// Helper functions to reduce complexity
const $68ad224476b69534$var$createResponsiveGapObject = (gapv2)=>{
    var _gapv2_mobile, _gapv2_tablet, _ref, _gapv2_desktop, _ref1, _ref2;
    return {
        mobile: (_gapv2_mobile = gapv2.mobile) !== null && _gapv2_mobile !== void 0 ? _gapv2_mobile : "0",
        tablet: (_ref = (_gapv2_tablet = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _gapv2_tablet !== void 0 ? _gapv2_tablet : gapv2.mobile) !== null && _ref !== void 0 ? _ref : "0",
        desktop: (_ref2 = (_ref1 = (_gapv2_desktop = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.desktop) !== null && _gapv2_desktop !== void 0 ? _gapv2_desktop : gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _ref1 !== void 0 ? _ref1 : gapv2.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
};
const $68ad224476b69534$var$createResponsiveOrientationObject = (orientation)=>({
        mobile: orientation.mobile || "vertical",
        tablet: orientation.tablet || orientation.mobile || "vertical",
        desktop: orientation.desktop || orientation.tablet || orientation.mobile || "vertical"
    });
const $68ad224476b69534$var$createResponsiveWrappedChildContentObject = (wrappedChildContent)=>({
        mobile: (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.mobile) || "nowrap",
        tablet: (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.tablet) || (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.mobile) || "nowrap",
        desktop: (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.desktop) || (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.tablet) || (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.mobile) || "nowrap"
    });
const $68ad224476b69534$var$createResponsiveJustifyContentObject = (justifyContent)=>({
        mobile: justifyContent.mobile || "flex-start",
        tablet: (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.tablet) || (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.mobile) || "flex-start",
        desktop: (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.desktop) || (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.tablet) || justifyContent.mobile || "flex-start"
    });
const $68ad224476b69534$var$getFlexWrapValue = (value)=>{
    if (value === "wrap") return "wrap";
    if (value === "wrap-reverse") return "wrap-reverse";
    return "nowrap";
};
const $68ad224476b69534$var$zeroMarginPadding = null;
const $68ad224476b69534$var$resetListStyles = null;
const $68ad224476b69534$var$createRenderListItems = (listType)=>{
    return ({ items: items })=>{
        // Only works for paired dt/dd items. Would need different solution for different structure
        if (listType === "dl") return items.map((item, index)=>{
            if (index % 2 === 0) return /*#__PURE__*/ (0, $dypTs.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("dt", {
                        children: item
                    }),
                    items[index + 1] && /*#__PURE__*/ (0, $dypTs.jsx)("dd", {
                        children: items[index + 1]
                    })
                ]
            }, index);
            return null;
        });
        if (listType === "ol") return items.map((item, index)=>/*#__PURE__*/ (0, $dypTs.jsxs)("li", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                    "_qtt8glyw _1e0c1txw _2lx21bp4 _zulp1crf _1lp7vrvc _q8t51q9y"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $4yv6j.ListItemNumber), {
                        value: index + 1
                    }),
                    item
                ]
            }, index));
        return items.map((item, index)=>/*#__PURE__*/ (0, $dypTs.jsx)("li", {
                className: (0, $2jatx.default)([
                    "_kkk2n7od _1e0c1txw",
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ]),
                children: item
            }, index));
    };
};
const $68ad224476b69534$var$UniformListV2 = ({ listType: listType, gapv2: gapv2 = {
    mobile: "0"
}, orientation: orientation = {
    mobile: "vertical"
}, wrappedChildContent: wrappedChildContent = {
    mobile: "nowrap"
}, justifyContent: justifyContent = {
    mobile: "flex-start"
} })=>{
    const gapObject = $68ad224476b69534$var$createResponsiveGapObject(gapv2);
    const orientationObject = $68ad224476b69534$var$createResponsiveOrientationObject(orientation);
    const wrappedChildContentObject = $68ad224476b69534$var$createResponsiveWrappedChildContentObject(wrappedChildContent);
    const justifyContentObject = $68ad224476b69534$var$createResponsiveJustifyContentObject(justifyContent);
    // css() calls must be inline for Compiled CSS static analysis
    const listStyle = null;
    const orientationStyle = null;
    const wrappedChildContentStyle = null;
    const justifyContentStyle = null;
    const renderListItems = $68ad224476b69534$var$createRenderListItems(listType);
    const ListTypeComponent = listType || "ul";
    return /*#__PURE__*/ (0, $dypTs.jsx)(ListTypeComponent, {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1a6y _19wggsi3 _pdlmxbqd",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            "_1hmt1wth _16wj1p3b _1q2jw4vn",
            "_1e0c1txw _2lx22h65 _1lp71tnc _1inip4d6",
            "_1e0c1txw _1n261g80 _zkhy1g80 _45zz1g80",
            "_1bahown3 _e8gh2fwo _msup1t9b"
        ]),
        style: {
            "--_rkv8x9": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.mobile + ")"),
            "--_9wptik": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.tablet + ")"),
            "--_3wdyhk": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.desktop + ")"),
            "--_pv2ypa": (0, $6ZVlx.default)(orientationObject.mobile === "horizontal" ? "row" : "column"),
            "--_dek1s0": (0, $6ZVlx.default)(orientationObject.tablet === "horizontal" ? "row" : "column"),
            "--_1ng513r": (0, $6ZVlx.default)(orientationObject.desktop === "horizontal" ? "row" : "column"),
            "--_vie9y1": (0, $6ZVlx.default)(justifyContentObject.mobile),
            "--_1rrey82": (0, $6ZVlx.default)(justifyContentObject.tablet),
            "--_pc7561": (0, $6ZVlx.default)(justifyContentObject.desktop)
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
            name: "listItems",
            wrapperComponent: renderListItems
        })
    });
};
var $68ad224476b69534$export$2e2bcd8739ae039 = $68ad224476b69534$var$UniformListV2;

});
parcelRegister("4yv6j", function(module, exports) {
$parcel$export(module.exports, "ListItemNumber", function () { return $5cbfb5c1496470c1$export$448080ad20b09ab8; });
/* list-item-number.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("gljCV");

var $kbpa7 = parcelRequire("kbpa7");
const $5cbfb5c1496470c1$export$448080ad20b09ab8 = (props)=>{
    const { value: value } = props;
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3ickbl _1bsbckbl _2rko1osq _11q76kkz _1e0c1txw _1bah1h6o _4cvr1h6o _syaz1tj6 _y3gn1h6o _ect41pz4 _1wybgktf _zg8l4jg8 _k48p1fw0 _vwz4183y"
        ]),
        style: {
            "--_1qa6cp7": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue200")),
            "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900")),
            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
        },
        children: value
    });
};

});



parcelRegister("eZkeB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("5c1uT")).default; });

var $5c1uT = parcelRequire("5c1uT");

});
parcelRegister("5c1uT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fd7e060da4850d2d$export$2e2bcd8739ae039; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
parcelRequire("l1i8p");
var $behZZ = parcelRequire("behZZ");

var $lAAJP = parcelRequire("lAAJP");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fd7e060da4850d2d$var$UniformLogos = (intakeProps)=>{
    const { title: title, logos: logos } = (0, $lAAJP.flattenLogoProps)(intakeProps);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpoahv _pdlmxncg _y3gn1h6o"
        ]),
        children: [
            title && /*#__PURE__*/ (0, $dypTs.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $behZZ.Logos), {
                logos: logos
            })
        ]
    });
};
var $fd7e060da4850d2d$export$2e2bcd8739ae039 = $fd7e060da4850d2d$var$UniformLogos;

});


parcelRegister("8sJj3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("f8O2Y")).default; });

var $f8O2Y = parcelRequire("f8O2Y");

});
parcelRegister("f8O2Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $684b9f8001657ce7$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $jE3Ci = parcelRequire("jE3Ci");
const $684b9f8001657ce7$export$d64e2f97651f7f4d = (props)=>{
    const appearance = props.color === "red" ? "danger" : props.color || "neutral";
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $jE3Ci.Lozenge), {
        appearance: appearance,
        text: props.text
    });
};
var $684b9f8001657ce7$export$2e2bcd8739ae039 = $684b9f8001657ce7$export$d64e2f97651f7f4d;

});


parcelRegister("6840w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("iSxa6")).default; });

var $iSxa6 = parcelRequire("iSxa6");

});
parcelRegister("iSxa6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d66bc09b4415831b$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");
parcelRequire("l1i8p");
var $euqle = parcelRequire("euqle");

var $lTkkF = parcelRequire("lTkkF");
const $d66bc09b4415831b$var$UniformMobileApp = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $euqle.MobileApp), {
        title: props.title,
        description: props.richText ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : props.description,
        linkLabel: props.linkLabel,
        linkHref: props.linkHref,
        imageSrc: props.imageSrc,
        imageAlt: props.imageAlt,
        appleAppStoreUrl: props.appleAppStoreUrl,
        googlePlayStoreUrl: props.googlePlayStoreUrl
    });
};
var $d66bc09b4415831b$export$2e2bcd8739ae039 = $d66bc09b4415831b$var$UniformMobileApp;

});


parcelRegister("9YhLi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("lATol")).default; });

var $lATol = parcelRequire("lATol");

});
parcelRegister("lATol", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5a6303ec758cb0a2$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $01zo5 = parcelRequire("01zo5");

var $60KY6 = parcelRequire("60KY6");
// Pass modalSize as the width directly to the Modal component
const $5a6303ec758cb0a2$var$UniformModal = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $60KY6.ModalLink), {
        modalTitle: props.modalTitle,
        modalCloseLabel: props.modalCloseLabel,
        ctaText: props.ctaText,
        modalWidth: props.modalSize,
        modalLinkType: props.modalLinkType,
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
            name: "modalContent"
        })
    });
};
var $5a6303ec758cb0a2$export$2e2bcd8739ae039 = $5a6303ec758cb0a2$var$UniformModal;

});
parcelRegister("60KY6", function(module, exports) {
$parcel$export(module.exports, "ModalLink", function () { return $6d4cc7ee45c7a136$export$cf363aa9ce73688b; });

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $iPPTB = parcelRequire("iPPTB");

var $660KI = parcelRequire("660KI");
const $6d4cc7ee45c7a136$export$cf363aa9ce73688b = ({ modalTitle: modalTitle, modalCloseLabel: modalCloseLabel, children: children, ctaText: ctaText, modalWidth: modalWidth, modalLinkType: modalLinkType = "modal" })=>{
    const [isOpen, setIsOpen] = (0, $gljCV.useState)(false);
    const openModal = (e)=>{
        e.preventDefault();
        setIsOpen(true);
    };
    const closeModal = (0, $gljCV.useCallback)(()=>setIsOpen(false), []);
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $iPPTB.Link), {
                onClick: openModal,
                "aria-label": "modal-link",
                text: ctaText,
                href: "#modal-section",
                type: modalLinkType
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $660KI.Modal), {
                closeModal: closeModal,
                closeLabel: modalCloseLabel,
                title: modalTitle,
                isOpen: isOpen,
                width: modalWidth,
                children: children
            })
        ]
    });
};

});



parcelRegister("7s9SJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("3E1lH")).default; });

var $3E1lH = parcelRequire("3E1lH");

});
parcelRegister("3E1lH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d007356a760321ff$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $01zo5 = parcelRequire("01zo5");

var $1pIeE = parcelRequire("1pIeE");

var $l8kCZ = parcelRequire("l8kCZ");

var $jMhSx = parcelRequire("jMhSx");

var $8LaTa = parcelRequire("8LaTa");

var $l2QYX = parcelRequire("l2QYX");

var $f2RFx = parcelRequire("f2RFx");

var $jcRhI = parcelRequire("jcRhI");

var $h1dGc = parcelRequire("h1dGc");

var $6VSBC = parcelRequire("6VSBC");

var $atyps = parcelRequire("atyps");

var $lgKym = parcelRequire("lgKym");

var $hCHU3 = parcelRequire("hCHU3");

var $1iUL9 = parcelRequire("1iUL9");

var $g2lQR = parcelRequire("g2lQR");

var $aYwTu = parcelRequire("aYwTu");

var $8IN8s = parcelRequire("8IN8s");

var $cimg4 = parcelRequire("cimg4");

var $aYVVm = parcelRequire("aYVVm");

var $4c8eJ = parcelRequire("4c8eJ");

var $1K6kz = parcelRequire("1K6kz");

var $3wzIU = parcelRequire("3wzIU");

var $cQSG9 = parcelRequire("cQSG9");

var $cF9FY = parcelRequire("cF9FY");

var $32ng3 = parcelRequire("32ng3");

var $17RBn = parcelRequire("17RBn");

var $lpEyw = parcelRequire("lpEyw");

var $8xC9Z = parcelRequire("8xC9Z");
const $d007356a760321ff$export$6955bcca4cd3539f = (props)=>{
    var _component_slots;
    const { component: component, siteSelectorProductKey: siteSelectorProductKey, siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix } = props;
    const fullSiteSelectorProductKey = siteSelectorProductKey === "jira-service-management" ? "jira-servicedesk.ondemand" : `${siteSelectorProductKey}.ondemand`;
    const locale = (0, $17RBn.useLocale)();
    const isBootIntercom = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp5381AddIntercomWidgetToUniform);
    const intercomAppId = locale === "ja" ? "p0ww63i2" : "";
    var _component_slots_content;
    const contentSlot = (_component_slots_content = (_component_slots = component.slots) === null || _component_slots === void 0 ? void 0 : _component_slots["content"]) !== null && _component_slots_content !== void 0 ? _component_slots_content : [];
    const pageHasGlobalNavComponent = !!contentSlot.find((content)=>content.type === "globalNav");
    const pageHasGlobalFooterComponent = !!contentSlot.find((content)=>content.type === "globalFooter");
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $l8kCZ.IntercomProvider), {
        appId: intercomAppId,
        triggerBoot: isBootIntercom,
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $1pIeE.default), {
                children: /*#__PURE__*/ (0, $dypTs.jsxs)((0, $8xC9Z.OptionalSiteSelectorContextProvider), {
                    siteSelectorProductKey: fullSiteSelectorProductKey,
                    siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix,
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.TypographyStyles), {
                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
                                name: "enhancedBannerSlot"
                            })
                        }),
                        !pageHasGlobalNavComponent && /*#__PURE__*/ (0, $dypTs.jsx)($d007356a760321ff$export$f24150b9675a2c65, {
                            component: component
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.TypographyStyles), {
                            children: /*#__PURE__*/ (0, $dypTs.jsx)("main", {
                                id: "content",
                                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
                                    name: "content"
                                })
                            })
                        })
                    ]
                })
            }),
            !pageHasGlobalFooterComponent && /*#__PURE__*/ (0, $dypTs.jsx)($d007356a760321ff$export$1b198b648cc5b0ce, {
                component: component
            })
        ]
    });
};
const $d007356a760321ff$export$f24150b9675a2c65 = ({ component: component })=>{
    const pageNavType = component.parameters && component.parameters["nav"] && component.parameters["nav"].value;
    let pageNav;
    switch(pageNavType){
        case "confluence":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $hCHU3.default), {});
            break;
        case "bitbucket":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $atyps.BitbucketNav), {});
            break;
        case "confluence-template-experiment":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $1iUL9.ConfluenceTemplateHeaderContainer), {});
            break;
        case "enterprise":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $6VSBC.default), {});
            break;
        case "jira-software":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $8IN8s.default), {});
            break;
        case "jira-service-management":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $aYVVm.default), {});
            break;
        case "jira-product-discovery":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $aYwTu.default), {});
            break;
        case "gwp-7880-jira-software-templates-experiment":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $cimg4.default), {});
            break;
        case "gwp-7880-jira-service-management-templates-experiment":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $4c8eJ.default), {});
            break;
        case "compass":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $lgKym.CompassNav), {});
            break;
        case "atlassian-access":
        case "guard":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $g2lQR.GuardNav), {});
            break;
        case "rovo":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $3wzIU.RovoNav), {});
            break;
        case "rovo-dev":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $lpEyw.RovoDevNav), {});
            break;
        case "loom":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $1K6kz.LoomNav), {});
            break;
        case "teamwork-collection":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $h1dGc.TeamworkCollectionNavbar), {});
            break;
        case "strategy-collection":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $f2RFx.StrategyCollectionNavbar), {});
            break;
        case "service-collection":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $jcRhI.ServiceCollectionNavbar), {});
            break;
        case "sourcetree-app":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $cF9FY.SourcetreeAppNav), {});
            break;
        case "global-nav-no-try-now-cta":
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $l2QYX.default), {
                productKey: "uniform",
                isShowTryNowLink: false
            });
            break;
        case "none":
            break;
        case "global":
        default:
            pageNav = /*#__PURE__*/ (0, $dypTs.jsx)((0, $l2QYX.default), {
                productKey: "uniform",
                isShowTryNowLink: true
            });
            break;
    }
    return pageNav;
};
const $d007356a760321ff$export$1b198b648cc5b0ce = ({ component: component })=>{
    const pageFooterType = component.parameters && component.parameters["footer"] && component.parameters["footer"].value;
    let pageFooter;
    switch(pageFooterType){
        case "sourcetree-app":
            pageFooter = /*#__PURE__*/ (0, $dypTs.jsx)((0, $cQSG9.SourcetreeAppFooter), {});
            break;
        case "none":
            break;
        case "global":
        default:
            pageFooter = /*#__PURE__*/ (0, $dypTs.jsx)((0, $8LaTa.GlobalFooter), {});
            break;
    }
    return pageFooter;
};
var $d007356a760321ff$export$2e2bcd8739ae039 = $d007356a760321ff$export$6955bcca4cd3539f;

});
parcelRegister("1pIeE", function(module, exports) {
$parcel$export(module.exports, "useProductTemplateContext", function () { return $c8bd6f25249f43f7$export$9aa15cd8273c8730; });
$parcel$export(module.exports, "default", function () { return $c8bd6f25249f43f7$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");
const $c8bd6f25249f43f7$var$ProductTemplateContext = /*#__PURE__*/ (0, $gljCV.createContext)({
    template: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTemplate: ()=>{}
});
const $c8bd6f25249f43f7$export$d254455f6d2132ac = ({ children: children })=>{
    const [template, setTemplate] = (0, $gljCV.useState)(null);
    const value = (0, $gljCV.useMemo)(()=>({
            template: template,
            setTemplate: setTemplate
        }), [
        template
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)($c8bd6f25249f43f7$var$ProductTemplateContext.Provider, {
        value: value,
        children: children
    });
};
const $c8bd6f25249f43f7$export$9aa15cd8273c8730 = ()=>{
    const context = (0, $gljCV.useContext)($c8bd6f25249f43f7$var$ProductTemplateContext);
    if (!context) throw new Error("useProductTemplateContext must be used within a ProductTemplateContextProvider");
    return context;
};
var $c8bd6f25249f43f7$export$2e2bcd8739ae039 = $c8bd6f25249f43f7$export$d254455f6d2132ac;

});

parcelRegister("jcRhI", function(module, exports) {
$parcel$export(module.exports, "ServiceCollectionNavbar", function () { return $db358e19517c36a2$export$21a8ade06194f818; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $l2QYX = parcelRequire("l2QYX");

var $lVpxp = parcelRequire("lVpxp");

var $dahOu = parcelRequire("dahOu");
const $db358e19517c36a2$export$21a8ade06194f818 = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $l2QYX.GlobalNav), {
        productKey: "home",
        compoundNav: (0, $dPABA._)((0, $6ogO3._)({}, (0, $lVpxp.CollectionsCompoundSubNavProps)()), {
            ctaUrl: (0, $dahOu.CTA_URL_PATH)
        })
    });
};

});
parcelRegister("dahOu", function(module, exports) {
$parcel$export(module.exports, "CTA_URL_PATH", function () { return $98017d3276cdfe68$export$d5587a12d9eea1dc; });
const $98017d3276cdfe68$export$d5587a12d9eea1dc = "/collections/service#contact";

});


parcelRegister("cimg4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c26c977f7fa25d25$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $1pIeE = parcelRequire("1pIeE");

var $iHYHa = parcelRequire("iHYHa");

var $8IN8s = parcelRequire("8IN8s");
const $c26c977f7fa25d25$var$JiraSoftwareNavUniform = ()=>{
    const { template: template } = (0, $1pIeE.useProductTemplateContext)();
    const { openModalForTemplate: openModalForTemplate } = (0, $iHYHa.useSiteSelectorContext)();
    const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = (0, $gljCV.useState)(false);
    const openModalForTemplateClickAction = (0, $gljCV.useMemo)(()=>{
        return (event)=>{
            event.preventDefault();
            event.stopPropagation();
            openModalForTemplate({
                templateId: template === null || template === void 0 ? void 0 : template.templateId,
                templateName: template === null || template === void 0 ? void 0 : template.templateName,
                productKey: template === null || template === void 0 ? void 0 : template.productKey
            });
        };
    }, [
        openModalForTemplate,
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    (0, $gljCV.useEffect)(()=>{
        if ((template === null || template === void 0 ? void 0 : template.templateId) && (template === null || template === void 0 ? void 0 : template.templateName) && (template === null || template === void 0 ? void 0 : template.productKey)) setIsUseOpenCrossFlow(true);
    }, [
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $8IN8s.default), {
        productNavCtaCTAClickFunction: openModalForTemplateClickAction,
        isUseOpenCrossFlow: isUseOpenCrossFlow
    });
};
$c26c977f7fa25d25$var$JiraSoftwareNavUniform.displayName = "JiraSoftwareNavUniform";
var $c26c977f7fa25d25$export$2e2bcd8739ae039 = $c26c977f7fa25d25$var$JiraSoftwareNavUniform;

});

parcelRegister("4c8eJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a1b68c0ea2ce93d4$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $1pIeE = parcelRequire("1pIeE");

var $iHYHa = parcelRequire("iHYHa");

var $aYVVm = parcelRequire("aYVVm");
const $a1b68c0ea2ce93d4$var$JiraServiceManagementSoftwareNavV2Uniform = ()=>{
    const { template: template } = (0, $1pIeE.useProductTemplateContext)();
    const { openModalForTemplate: openModalForTemplate } = (0, $iHYHa.useSiteSelectorContext)();
    const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = (0, $gljCV.useState)(false);
    const openModalForTemplateClickAction = (0, $gljCV.useMemo)(()=>{
        return (event)=>{
            event.preventDefault();
            event.stopPropagation();
            openModalForTemplate({
                templateId: template === null || template === void 0 ? void 0 : template.templateId,
                templateName: template === null || template === void 0 ? void 0 : template.templateName,
                productKey: template === null || template === void 0 ? void 0 : template.productKey
            });
        };
    }, [
        openModalForTemplate,
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    (0, $gljCV.useEffect)(()=>{
        if ((template === null || template === void 0 ? void 0 : template.templateId) && (template === null || template === void 0 ? void 0 : template.templateName) && (template === null || template === void 0 ? void 0 : template.productKey)) setIsUseOpenCrossFlow(true);
    }, [
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $aYVVm.default), {
        productNavCtaCTAClickFunction: openModalForTemplateClickAction,
        isUseOpenCrossFlow: isUseOpenCrossFlow
    });
};
$a1b68c0ea2ce93d4$var$JiraServiceManagementSoftwareNavV2Uniform.displayName = "JiraServiceManagementSoftwareNavV2Uniform";
var $a1b68c0ea2ce93d4$export$2e2bcd8739ae039 = $a1b68c0ea2ce93d4$var$JiraServiceManagementSoftwareNavV2Uniform;

});

parcelRegister("cQSG9", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppFooter", function () { return $8415a60865fc69c3$export$e1512df89103926d; });
/* sourcetree-app-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $qW9Nb = parcelRequire("qW9Nb");

var $8LmPp = parcelRequire("8LmPp");
const $8415a60865fc69c3$var$globalFooterStyle = null;
const $8415a60865fc69c3$var$globalFooterContentContainerStyle = null;
const $8415a60865fc69c3$export$e1512df89103926d = ()=>/*#__PURE__*/ (0, $dypTs.jsx)("footer", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _11q7cd5j _1e0c1txw _2lx2vrvc _1bah1h6o"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_bfhkcd5j _1rjcpxbi _1e0c1txw _2lx21bp4 _zulppxbi _1bsb1osq _195g1tcg _dm251txw _10jx1fra _owpuidpf _xtn71wqb"
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)((0, $8LmPp.SourcetreeAppFooterTop), {}),
                /*#__PURE__*/ (0, $dypTs.jsx)((0, $qW9Nb.SourcetreeAppFooterBottom), {})
            ]
        })
    });

});
parcelRegister("qW9Nb", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppFooterBottom", function () { return $e18ab648d292d24b$export$89b0be2f0f7ea8dd; });
/* sourcetree-app-footer-bottom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $jPf4p = parcelRequire("jPf4p");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");
// ==================================================================
// CSS styling
// ==================================================================
const $e18ab648d292d24b$var$containerStyle = null;
const $e18ab648d292d24b$var$linkStyle = null;
const $e18ab648d292d24b$var$copyrightStyle = null;
const $e18ab648d292d24b$var$linksAndLanguageStyle = null;
const $e18ab648d292d24b$var$listStyle = null;
const $e18ab648d292d24b$var$bottomViewAllLinkLiAnchorStyle = null;
// ==================================================================
// Rendering Functions
// ==================================================================
const $e18ab648d292d24b$var$BottomLinks = ()=>{
    const intl = (0, $8e22h.default)();
    (0, $gljCV.useEffect)(()=>{
        var _window_AtlOneTrustWrapper, _window;
        if ((_window = window) === null || _window === void 0 ? void 0 : (_window_AtlOneTrustWrapper = _window.AtlOneTrustWrapper) === null || _window_AtlOneTrustWrapper === void 0 ? void 0 : _window_AtlOneTrustWrapper.updatePolicyLinks) window.AtlOneTrustWrapper.updatePolicyLinks();
    }, []);
    const bottomLinks = [
        {
            text: intl.formatMessage({
                id: "sourcetreeapp.globalfooter.bottom.privacy-policy",
                defaultMessage: "Privacy policy"
            }),
            href: (0, $kooLp.useLocalizedHref)("/legal/privacy-policy"),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: "sourcetreeapp.globalfooter.bottom.notice-at-collection",
                defaultMessage: "Notice at Collection"
            }),
            href: (0, $kooLp.useLocalizedHref)("/legal/privacy-policy#additional-disclosures-for-ca-residents"),
            isOneTrustWrapped: true
        },
        {
            text: intl.formatMessage({
                id: "sourcetreeapp.globalfooter.bottom.terms",
                defaultMessage: "Terms of use"
            }),
            href: (0, $kooLp.useLocalizedHref)("/legal/cloud-terms-of-service"),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: "sourcetreeapp.globalfooter.bottom.trust.security",
                defaultMessage: "Trust & security"
            }),
            href: (0, $kooLp.useLocalizedHref)("/legal/atlassian-customer-agreement#intro"),
            isOneTrustWrapped: false
        }
    ];
    const bottomViewAllLink = {
        text: intl.formatMessage({
            id: "sourcetreeapp.globalfooter.bottom.view-all-products",
            defaultMessage: "View all Atlassian products"
        }),
        href: "http://www.atlassian.com/software",
        bgColor: "bgWhite"
    };
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
        children: [
            bottomLinks.map((bottomLink)=>{
                if (bottomLink.isOneTrustWrapped) return /*#__PURE__*/ (0, $dypTs.jsx)("li", {
                    className: "link-wrapper atl-policy-link-container",
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jPf4p.LinkWithIcon), {
                        linkText: bottomLink.text,
                        href: bottomLink.href,
                        type: "anchor",
                        isHaveIcon: false,
                        isUsePlainSpanTagForLinkText: true,
                        className: (0, $2jatx.default)([
                            "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1hlo _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw",
                            "atl-policy-link"
                        ]),
                        spanLinkTextClassName: "atl-policy-link-text",
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        }
                    })
                }, bottomLink.text);
                else return /*#__PURE__*/ (0, $dypTs.jsx)("li", {
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Link), {
                        text: bottomLink.text,
                        href: bottomLink.href,
                        type: "anchor",
                        bgColor: "bgColored",
                        "aria-label": "footer-link",
                        className: (0, $2jatx.default)([
                            "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1hlo _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        }
                    })
                }, bottomLink.text);
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("li", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Link), {
                    text: bottomViewAllLink.text,
                    href: bottomViewAllLink.href,
                    type: "primary",
                    bgColor: "bgColored",
                    "aria-label": "footer-link",
                    className: (0, $2jatx.default)([
                        "_syaz1hlo _1wyboxwj _4bfu1r31 _1hmsglyw _ajmmnqa1 _1dyz1a1y _ect4kipj _1a3b1r31 _9oik1r31 _1ydc1r31 _4fpr8stv _1bnx8stv _1x288stv _5goinqa1 _jf4cnqa1 _1726nqa1 _1ygbqgpo"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                    }
                })
            }, bottomViewAllLink.text.trim().replace(" ", "-"))
        ]
    });
};
const $e18ab648d292d24b$var$copyRightYear = new Date().getFullYear();
const $e18ab648d292d24b$export$89b0be2f0f7ea8dd = ({ className: className })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $g1rTV.default), {
        name: "global-footer-v2-bottom",
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rjc1tcg _18zrpxbi _1e0c1txw _2lx21bp4 _zulpxy5q _su071ady _19wgxy5q _owpu1tcg _1inivrvc _msup1yb4 _1jsv1h6o",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    "data-testid": "footer-copyright",
                    className: (0, $2jatx.default)([
                        "_syaz1yg0 _vwz4f6fq _4t3if6fq _1wybdlk8 _10hl1h6o"
                    ]),
                    style: {
                        "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                    },
                    children: [
                        "Copyright \xa9 ",
                        $e18ab648d292d24b$var$copyRightYear,
                        " Atlassian"
                    ]
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $g1rTV.default), {
                        name: "global-footer-v2-bottom-links",
                        children: /*#__PURE__*/ (0, $dypTs.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $dypTs.jsx)($e18ab648d292d24b$var$BottomLinks, {})
                        })
                    })
                })
            ]
        })
    });
};

});

parcelRegister("8LmPp", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppFooterTop", function () { return $f9eec892615b5033$export$e7a002b3133bbe21; });
/* sourcetree-app-footer-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $aejAB = parcelRequire("aejAB");

var $1ka2O = parcelRequire("1ka2O");

var $huLm0 = parcelRequire("huLm0");
// ==================================================================
// CSS styling
// ==================================================================
const $f9eec892615b5033$var$containerStyle = null;
const $f9eec892615b5033$var$linksWrapperStyle = null;
const $f9eec892615b5033$export$26b6a80e48da8316 = {
    margin: "0",
    padding: "0",
    border: "0",
    fontSize: "100%",
    verticalAlign: "baseline"
};
// ==================================================================
// Rendering Functions
// ==================================================================
const $f9eec892615b5033$var$headerContainerStyle = null;
const $f9eec892615b5033$var$listOfLinksColumnHeaderStyle = null;
const $f9eec892615b5033$var$listOfLinksUlStyle = null;
const $f9eec892615b5033$var$textStyle = null;
const $f9eec892615b5033$var$connectTextStyle = null;
const $f9eec892615b5033$var$socialButtonStandardStyle = null;
const $f9eec892615b5033$var$socialButtonsStyle = null;
const $f9eec892615b5033$var$twitterLinkStyle = null;
const $f9eec892615b5033$var$facebookLinkStyle = null;
const $f9eec892615b5033$var$socialButtonsListStyle = null;
const $f9eec892615b5033$var$socialButtonsGroupStyle = null;
const $f9eec892615b5033$var$sourcetreeTextStyle = null;
const $f9eec892615b5033$var$ConnectColumn = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3izwfg _1pfhze3t _6rthxy5q _1e0c1txw _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wybw1gv _o10x10nf _1p1dangw _syazr2ho _k48p53lb _ect48q0o",
                        "eyebrow-md"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                    },
                    children: "Connect with us"
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthidpf _qtt8glyw"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_k48p1nn1 _1wyb1j6v _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _syaz1mpp _s7n41q9y"
                    ]),
                    children: "Sign up for Git articles and resources:"
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $huLm0.default), {}),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5721q9c"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_k48p1nn1 _1wyb1j6v _syaz1mpp _s7n41q9y"
                            ]),
                            children: "Connect with Sourcetree"
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsxs)("ul", {
                            className: (0, $2jatx.default)([
                                "_vwz4kb7n _syazvejh _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _bozgidpf _qtt8glyw _1aaxusic _ahbq19bv"
                            ]),
                            style: {
                                "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $dypTs.jsx)("li", {
                                    className: (0, $2jatx.default)([
                                        "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2"
                                    ]),
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)("a", {
                                        href: "https://www.facebook.com/Atlassian",
                                        title: "Atlassian on Facebook",
                                        className: (0, $2jatx.default)([
                                            "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2 _syaz1yg0 _1wyboxwj _vwz4rrl5 _12l27vkz _azhwdzkh _11q71tu0 _1lrw1osq"
                                        ]),
                                        style: {
                                            "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                        },
                                        children: "Facebook"
                                    })
                                }),
                                /*#__PURE__*/ (0, $dypTs.jsx)("li", {
                                    className: (0, $2jatx.default)([
                                        "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2"
                                    ]),
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)("a", {
                                        href: "https://twitter.com/sourcetree",
                                        title: "Follow us on Twitter",
                                        className: (0, $2jatx.default)([
                                            "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2 _syaz1yg0 _1wyboxwj _vwz4rrl5 _12l27vkz _azhwdzkh _11q713k9 _1lrw1osq"
                                        ]),
                                        style: {
                                            "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                        },
                                        children: "Twitter"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $f9eec892615b5033$export$e7a002b3133bbe21 = ()=>{
    const intl = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    const resourcesLinkList = {
        headerText: intl.formatMessage({
            id: "sourcetreeapp.top.resources",
            defaultMessage: "Resources"
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.support",
                    defaultMessage: "Support"
                }),
                href: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.support.link",
                    defaultMessage: "https://support.atlassian.com/sourcetree"
                })
            },
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.documentation",
                    defaultMessage: "Documentation"
                }),
                href: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.documentation.link",
                    defaultMessage: "https://confluence.atlassian.com/get-started-with-sourcetree"
                })
            },
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.about.atlassian",
                    defaultMessage: "About Atlassian"
                }),
                href: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.about.atlassian.link",
                    defaultMessage: "https://www.atlassian.com/company"
                })
            },
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.download.archive",
                    defaultMessage: "Download archive"
                }),
                href: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.download.archive.link",
                    defaultMessage: "https://sourcetreeapp.com/download-archives"
                })
            }
        ]
    };
    const sourcetreeAppLinkList = {
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.top.blog",
                    defaultMessage: "Blog"
                }),
                href: (0, $kooLp.useLocalizedHref)("/blog/sourcetree")
            }
        ]
    };
    // Adding pdf to french locale for compliance
    if (location.pathname.startsWith("/fr")) sourcetreeAppLinkList.listOfLinks.push({
        text: `Index de l'\xe9galit\xe9 professionnelle`,
        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
        href: "https://wac-cdn.atlassian.com/misc-assets/pdfs/2024-France-Gender-Equality-Index.pdf"
    });
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $g1rTV.default), {
        name: "global-footer-sourcetreeapp-top",
        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            className: (0, $2jatx.default)([
                "_bfhk1rga _1rjc1tcg _18zrpxbi _2rko16cp _1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _umua1ady _owpu1tcg"
            ]),
            style: {
                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
            },
            children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_nd5lrwmx _1e0c11p5 _yv0ehkll _zulpxy5q _1da71t02 _bcla1tcg _kd3kckbl _1rqt1raq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $aejAB.LinkListContainer), (0, $dPABA._)((0, $6ogO3._)({}, sourcetreeAppLinkList), {
                        logoType: "sourcetreeapp"
                    })),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $aejAB.LinkListContainer), (0, $6ogO3._)({}, resourcesLinkList)),
                    /*#__PURE__*/ (0, $dypTs.jsx)($f9eec892615b5033$var$ConnectColumn, {})
                ]
            })
        })
    });
};

});
parcelRegister("huLm0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $97b566dc024060a4$export$2e2bcd8739ae039; });
/* sourcetree-app-mailing-list-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $fJP6M = parcelRequire("fJP6M");

var $8xVSo = parcelRequire("8xVSo");

var $1ka2O = parcelRequire("1ka2O");
const $97b566dc024060a4$var$inputContainerStyle = null;
const $97b566dc024060a4$var$errorStyles = null;
const $97b566dc024060a4$var$inputStyle = null;
const $97b566dc024060a4$var$searchInputContainerStyle = null;
const $97b566dc024060a4$var$validateEmail = (email)=>{
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
const $97b566dc024060a4$export$d8d3a333528c91a5 = ()=>{
    const location = (0, $1ka2O.useLocation)();
    const intl = (0, $8e22h.default)();
    const emptyEmailError = intl.formatMessage({
        id: "SourcetreeAppFooter.top.emptyEmailError",
        defaultMessage: "This field is required"
    });
    const invalidEmailError = intl.formatMessage({
        id: "SourcetreeAppFooter.top.invalidEmailError",
        defaultMessage: "This field requires a valid email address"
    });
    const [errorMessage, setErrorMessage] = (0, $gljCV.useState)("");
    const [isValidatingEmail] = (0, $gljCV.useState)(false);
    const [emailInput, setEmailInput] = (0, $gljCV.useState)("");
    const [honeypotInput, setHoneypotInput] = (0, $gljCV.useState)("");
    const [signupSuccess, setSignupSuccess] = (0, $gljCV.useState)(false);
    const [consentConfig, setConsentConfig] = (0, $gljCV.useState)();
    (0, $gljCV.useEffect)(()=>{
        if (isValidatingEmail) {
            if (emailInput === "") setErrorMessage(emptyEmailError);
            else $97b566dc024060a4$var$validateEmail(emailInput) ? setErrorMessage("") : setErrorMessage(invalidEmailError);
        }
    }, [
        isValidatingEmail,
        emailInput,
        emptyEmailError,
        invalidEmailError
    ]);
    (0, $gljCV.useEffect)(()=>{
        getConsentConfig();
    }, []);
    const getConsentConfig = async ()=>{
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const consentConfigUrl = `${stargateUrl}/preferencesV2/consent-config`;
        await fetch(consentConfigUrl, {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json; charset=UTF-8"
            },
            method: "POST"
        }).then((response)=>response.json()).then((data)=>setConsentConfig(data)).catch(()=>{
            console.error("Failed to fetch consent config");
        });
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (emailInput === "") {
            setErrorMessage(emptyEmailError);
            return;
        }
        if (!$97b566dc024060a4$var$validateEmail(emailInput)) return;
        if (honeypotInput) return;
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const postUrl = `${stargateUrl}/preferencesV2/update`;
        // These are hardcoded values that are required by the endpoint.
        // https://bitbucket.org/atlassian/magnolia-resources/annotate/f65b7a5bf31677bcde32caa3305364c7ffb88808/resources/js/components/generic/exact-target-formV2.ts?at=qa
        await fetch(postUrl, {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json; charset=UTF-8"
            },
            method: "POST",
            body: JSON.stringify({
                consentCheckboxValue: true,
                consentLabelText: "",
                email: emailInput,
                formId: "2ed5d5c4-fe00-4259-a4e0-e82e997a371b",
                formUrl: location.href,
                locale: (consentConfig === null || consentConfig === void 0 ? void 0 : consentConfig.locale) || "UNKNOWN",
                privacyPolicyText: "",
                site: "atlassian"
            })
        }).then(()=>setSignupSuccess(true)).catch(()=>{
            setErrorMessage(intl.formatMessage({
                id: "SourcetreeApp.top.signupError",
                defaultMessage: "There was a server error submitting."
            }));
        });
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)($97b566dc024060a4$export$b59b70495d14eb0, {
        errorMessage: errorMessage,
        emailInput: emailInput,
        setEmailInput: setEmailInput,
        setHoneypotInput: setHoneypotInput,
        signupSuccess: signupSuccess,
        handleSubmit: handleSubmit
    });
};
const $97b566dc024060a4$var$buttonStyle = null;
const $97b566dc024060a4$export$b59b70495d14eb0 = (props)=>{
    const { errorMessage: errorMessage, emailInput: emailInput, setEmailInput: setEmailInput, setHoneypotInput: setHoneypotInput, signupSuccess: signupSuccess, handleSubmit: handleSubmit } = props;
    const intl = (0, $8e22h.default)();
    const subscribeText = intl.formatMessage({
        id: "SourcetreeAppFooter.top.subscribe",
        defaultMessage: "Subscribe"
    });
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        children: [
            !signupSuccess && /*#__PURE__*/ (0, $dypTs.jsx)("form", {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1y6m _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1o8l _y3gn1e5h _1bsb1osq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $dypTs.jsx)((0, $8xVSo.TextInput), {
                                    name: "email",
                                    value: emailInput,
                                    id: "email",
                                    testId: "email",
                                    label: "",
                                    placeholder: "email@example.com",
                                    onChangeHandler: setEmailInput,
                                    validation: (value)=>{
                                        if (value === "") return [
                                            false,
                                            intl.formatMessage({
                                                id: "SourcetreeAppFooter.top.emptyEmailError",
                                                defaultMessage: "This field is required"
                                            })
                                        ];
                                        else if (!$97b566dc024060a4$var$validateEmail(value)) return [
                                            false,
                                            intl.formatMessage({
                                                id: "SourcetreeAppFooter.top.invalidEmailError",
                                                defaultMessage: "This field requires a valid email address"
                                            })
                                        ];
                                        return [
                                            true,
                                            ""
                                        ];
                                    },
                                    className: (0, $2jatx.default)([
                                        "_16jlkb7n _1o9zkb7n _i0dlf1ug"
                                    ])
                                }),
                                errorMessage && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_syaz1du8 _1wyboqnp _zg8l4jg8 _k48p1nn1 _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfh1y44"
                                    ]),
                                    children: errorMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0cglyw"
                            ]),
                            children: /*#__PURE__*/ (0, $dypTs.jsx)("input", {
                                type: "text",
                                name: "list name",
                                "aria-label": "keep this field blank",
                                onChange: (e)=>setHoneypotInput(e.target.value)
                            })
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $fJP6M.default), {
                            type: "secondary",
                            text: subscribeText,
                            inputType: "submit",
                            dataEventProps: {
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-product-key": "sourcetreeapp",
                                "data-event-container": "button"
                            },
                            size: "large",
                            color: "whiteblue",
                            "aria-label": subscribeText,
                            className: (0, $2jatx.default)([
                                "_ahbq7vkz _1pfh1y44"
                            ])
                        })
                    ]
                })
            }),
            signupSuccess && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                    id: "SourcetreeApp.top.signup-success",
                    defaultMessage: "Thanks for signing up!"
                })
            })
        ]
    });
};
var $97b566dc024060a4$export$2e2bcd8739ae039 = $97b566dc024060a4$export$d8d3a333528c91a5;

});



parcelRegister("cF9FY", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppNav", function () { return $f790ae6eedb0a62d$export$5ba9b99d6060872; });
/* sourcetree-app-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $hnmMQ = parcelRequire("hnmMQ");
const $f790ae6eedb0a62d$var$stickyWrapperStyle = null;
const $f790ae6eedb0a62d$var$imktNavbarStyle = null;
const $f790ae6eedb0a62d$var$containerFluidStyle = null;
const $f790ae6eedb0a62d$var$rowStyle = null;
const $f790ae6eedb0a62d$var$columnStyle = null;
const $f790ae6eedb0a62d$var$titleWrapperStyle = null;
const $f790ae6eedb0a62d$var$rightNavStyle = null;
const $f790ae6eedb0a62d$var$linkStyle = null;
const $f790ae6eedb0a62d$var$logoStyle = null;
const $f790ae6eedb0a62d$export$5ba9b99d6060872 = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_vwz4kb7n _vchhusvi _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1f491mrw"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)("nav", {
            className: (0, $2jatx.default)([
                "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1e0c1ule _1f491mrw _1bsb1osq"
            ]),
            children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _bfhkcd5j _16qs1cd0 _12l21wug _ahbq1wug _1ul91osq _11rm1hrf _kqswh2mm _c71l11ux _1reo15vq _18m915vq _1pby1406 _1tket9kd"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _ahbq1wug _12l21wug _p12f1fra"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1aax1e5h _1tket94y _bozg7vkz _y4ti7vkz _kqswh2mm _1bsb1osq _1e0c1txw _2lx2vrvc _1n261g80 _4cvr1h6o _1bah1yb4"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1e0c1txw _2lx2vrvc _4cvr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $dypTs.jsx)("a", {
                                    href: "/",
                                    className: (0, $2jatx.default)([
                                        "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _syaz17la _1e0c1ule _1gjfrbkw _4t3i1wqb _4bfu1r31 _1hmsglyw _ajmmnqa1"
                                    ]),
                                    style: {
                                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                    },
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $hnmMQ.Picture), {
                                        image: {
                                            src: "https://wac-cdn.atlassian.com/dam/jcr:f32681c1-355d-4806-b29c-319b0c6ecb06/Sourcetree-blue.svg?cdnVersion=3108",
                                            alt: "Sourcetree logo"
                                        },
                                        className: (0, $2jatx.default)([
                                            "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _syaz17la _4t3i1ul9 _p12f1osq _6rth7vkz _s7n4yfq0 _kqswh2mm _152t1ssb _t9ec1i34 _lcxvglyw"
                                        ]),
                                        style: {
                                            height: "30px",
                                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _85i5o7ao _1q51o7ao"
                                ]),
                                children: /*#__PURE__*/ (0, $dypTs.jsxs)((0, $lqyi6.Button), {
                                    variant: "primary",
                                    color: "blue",
                                    href: "https://product-downloads.atlassian.com/software/sourcetree/ga/Sourcetree_4.2.14_297.zip",
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "navbar",
                                        "data-product-key": "sourcetreeapp",
                                        "data-label-english": "Download free"
                                    },
                                    children: [
                                        " ",
                                        "Download free"
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};

});

parcelRegister("lpEyw", function(module, exports) {
$parcel$export(module.exports, "RovoDevNav", function () { return $ce46063e2c74000e$export$446da800ffd5a425; });

var $dypTs = parcelRequire("dypTs");

var $8e22h = parcelRequire("8e22h");

var $imIsw = parcelRequire("imIsw");

var $kooLp = parcelRequire("kooLp");

var $l2QYX = parcelRequire("l2QYX");
const $ce46063e2c74000e$export$446da800ffd5a425 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=devai");
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/rovo-dev/pricing");
    const documentationHref = (0, $kooLp.useLocalizedHref)("https://support.atlassian.com/rovo/docs/work-with-rovo-dev-agents");
    const logo = /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/d888ipg7v6w1c6x4xfb578gfiw5238d0.svg",
            alt: "Rovo Dev"
        },
        style: {
            height: "26px"
        }
    });
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $l2QYX.ProductPageSubNav), {
        productLogoUrl: "/software/rovo-dev",
        productLogo: logo,
        productLogoAriaLabel: intl.formatMessage({
            id: "RovoDevNav.productLogoAriaLabel",
            defaultMessage: "Rovo Dev logo"
        }),
        mobileCtaText: intl.formatMessage({
            id: "RovoDevNav.tryItFree",
            defaultMessage: "Try it Free"
        }),
        navigationTrynowCtaText: intl.formatMessage({
            id: "RovoDevNav.tryItFree",
            defaultMessage: "Try it Free"
        }),
        mobileCtaUrl: signupLink,
        mobileLogo: logo,
        productPageNavLinks: [
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "RovoDevNav.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "rovo-dev",
                href: pricingHref
            },
            {
                globalLinksKey: "documentation",
                linkText: intl.formatMessage({
                    id: "RovoDevNav.documentation",
                    defaultMessage: "Documentation"
                }),
                hasSubnav: false,
                productKey: "rovo-dev",
                href: documentationHref
            }
        ],
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-rovo-dev",
                mobileLinksProps: [
                    {
                        globalLinksKey: "pricing",
                        linkText: intl.formatMessage({
                            id: "RovoDevNav.pricing",
                            defaultMessage: "Pricing"
                        }),
                        hasSubnav: false,
                        productKey: "rovo-dev",
                        href: pricingHref
                    },
                    {
                        globalLinksKey: "documentation",
                        linkText: intl.formatMessage({
                            id: "RovoDevNav.documentation",
                            defaultMessage: "Documentation"
                        }),
                        hasSubnav: false,
                        productKey: "rovo-dev",
                        href: documentationHref
                    }
                ]
            }
        ]
    });
};

});

parcelRegister("8xC9Z", function(module, exports) {
$parcel$export(module.exports, "OptionalSiteSelectorContextProvider", function () { return $770969627e2933b5$export$ef73016e54e00d81; });

var $dypTs = parcelRequire("dypTs");

var $lFwc0 = parcelRequire("lFwc0");
const $770969627e2933b5$export$ef73016e54e00d81 = (props)=>{
    const { siteSelectorProductKey: siteSelectorProductKey, siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix, children: children } = props;
    if (!siteSelectorProductKey) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $dypTs.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $lFwc0.SiteSelectorContextProvider), {
        productKey: siteSelectorProductKey,
        analyticsPrefix: siteSelectorAnalyticsPrefix !== null && siteSelectorAnalyticsPrefix !== void 0 ? siteSelectorAnalyticsPrefix : siteSelectorProductKey,
        internalLinkAfterIdentity: siteSelectorProductKey === "confluence.ondemand" ? "/team-playbook/plays/choose-your-site" : undefined,
        children: children
    });
};

});



parcelRegister("QTohK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("7xYdG")).default; });

var $7xYdG = parcelRequire("7xYdG");

});
parcelRegister("7xYdG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8abc8eb98b0d0a1c$export$2e2bcd8739ae039; });
/* pagination.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $sGleB = parcelRequire("sGleB");
const $8abc8eb98b0d0a1c$var$centerStyles = null;
const $8abc8eb98b0d0a1c$var$UniformPagination = (props)=>{
    // Generate pages array from total pages
    const pagesArray = Array.from({
        length: props.pages
    }, (_, i)=>i + 1);
    // For now, using defaults until page logic is implemented
    const selectedIndex = 0;
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $sGleB.Pagination), {
            pages: pagesArray,
            selectedIndex: selectedIndex
        })
    });
};
var $8abc8eb98b0d0a1c$export$2e2bcd8739ae039 = $8abc8eb98b0d0a1c$var$UniformPagination;

});


parcelRegister("4YNFt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gebIf")).default; });

var $gebIf = parcelRequire("gebIf");

});
parcelRegister("gebIf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $88f904a45e3c98a2$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $2smMv = parcelRequire("2smMv");

var $B5GRx = parcelRequire("B5GRx");
const $88f904a45e3c98a2$var$UniformPanel = (props)=>{
    var _props_description;
    const panelProps = {
        panelType: props.panelType,
        label: props.label,
        description: props.richText ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
            name: null,
            text: props.richText
        }) : (_props_description = props.description) !== null && _props_description !== void 0 ? _props_description : null
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2smMv.Panel), (0, $6ogO3._)({}, panelProps));
};
var $88f904a45e3c98a2$export$2e2bcd8739ae039 = $88f904a45e3c98a2$var$UniformPanel;

});


parcelRegister("3Fbib", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("9tius")).default; });

var $9tius = parcelRequire("9tius");

});
parcelRegister("9tius", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bc353b3611f7f2c4$export$2e2bcd8739ae039; });
/* personalization-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $gljCV = parcelRequire("gljCV");

var $01zo5 = parcelRequire("01zo5");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $ea4mV = parcelRequire("ea4mV");

var $32ng3 = parcelRequire("32ng3");

var $eRzlV = parcelRequire("eRzlV");

var $k9ZIM = parcelRequire("k9ZIM");

var $4L5aK = parcelRequire("4L5aK");

var $3o1l4 = parcelRequire("3o1l4");
var $bc353b3611f7f2c4$var$VariantsStatus = /*#__PURE__*/ function(VariantsStatus) {
    VariantsStatus["NO_VARIANT_MATCH"] = "no_variant_match";
    VariantsStatus["VARIANTS_AVAILABLE"] = "variants_available";
    VariantsStatus["FETCHING_SEGMENTS"] = "fetching_segments";
    VariantsStatus["SEGMENT_FETCH_ERROR"] = "segment_fetch_error";
    VariantsStatus["MISSING_USER_SEGMENTS"] = "missing_user_segments";
    VariantsStatus["PERSONALIZATION_DISABLED"] = "personalization_disabled";
    VariantsStatus["NOT_ENROLLED_IN_EXPERIMENT"] = "not_enrolled_in_experiment";
    return VariantsStatus;
}($bc353b3611f7f2c4$var$VariantsStatus || {});
const $bc353b3611f7f2c4$var$VariantSelector = (props)=>{
    return(// this should only be one item, but the SlotWrapper expects an array
    /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).Fragment, {
        children: props.items.map((item, index)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).Fragment, {
                children: item
            }, `variant-${index}`))
    }));
};
// Helper function to render default slot
const $bc353b3611f7f2c4$var$renderDefaultSlot = (variantStatus, setRenderMessage)=>{
    const messages = {
        ["no_variant_match"]: "No variants match. Rendering Default",
        ["missing_user_segments"]: "No User Segments acquired. Rendering Default",
        ["personalization_disabled"]: "Personalization is disabled. Rendering Default",
        ["segment_fetch_error"]: "Error fetching User Segments. Rendering Default",
        ["not_enrolled_in_experiment"]: "User not enrolled in experiment. Rendering Default",
        ["fetching_segments"]: "Fetching User Segments. Temporarily rendering Default",
        // never invoked, but needed to satisfy the type system s
        ["variants_available"]: ""
    };
    setRenderMessage(messages[variantStatus]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
        name: "default",
        wrapperComponent: $bc353b3611f7f2c4$var$VariantSelector
    });
};
// Helper function to find matching variant index
const $bc353b3611f7f2c4$var$findMatchingVariant = (variantCandidates, personalizationSegmentValues)=>{
    if (!personalizationSegmentValues) return -1;
    return variantCandidates.findIndex((variantCandidate)=>{
        var _variantCandidate_parameters_personalizationSegment, _variantCandidate_parameters;
        // all user segments specified by the Author in the variant (product, job function, domain type, etc.)
        const segments = (_variantCandidate_parameters = variantCandidate.parameters) === null || _variantCandidate_parameters === void 0 ? void 0 : (_variantCandidate_parameters_personalizationSegment = _variantCandidate_parameters["personalizationSegment"]) === null || _variantCandidate_parameters_personalizationSegment === void 0 ? void 0 : _variantCandidate_parameters_personalizationSegment.value;
        // check if all segments match the user's profile
        return segments.every(({ segmentType: segmentType, value: segmentTargets })=>{
            const userValueForThisSegment = personalizationSegmentValues[segmentType];
            // if the user doesn't have a value for this segment, it can't match
            if (!userValueForThisSegment) return false;
            // handle owned products differently, since it's an array of products.
            if (segmentType === (0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS) // we want to check if any of the user's owned products match one of the author-defined segment's value
            return segmentTargets.some((product)=>userValueForThisSegment.includes(product));
            // for all other single-valued segments, simply check if the user's value
            return segmentTargets.includes(userValueForThisSegment || "");
        });
    });
};
// Helper function to get final personalization values
const $bc353b3611f7f2c4$var$getFinalPersonalizationValues = (userSegments, overrides)=>{
    const finalValues = (0, $dPABA._)((0, $6ogO3._)({}, userSegments, (overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides) ? overrides : {}), {
        useOverrides: (overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides) || false,
        enrollInExperiment: (overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment) || false
    });
    return finalValues;
};
const $bc353b3611f7f2c4$var$ExperimentallyPersonalizedSection = ({ experimentId: experimentId, setVariantStatus: setVariantStatus, overrides: overrides, setRenderMessage: setRenderMessage, variantComponent: variantComponent })=>{
    const experimentStatus = (0, $ea4mV.useExperiment)({
        experimentName: experimentId,
        parameterName: "enrolled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>typeof value === "boolean"
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Personalization Experiment - configured in Uniform",
            expectedReleaseDate: "unknown - configured in Uniform",
            expectedRuntime: "unknown - configured in Uniform",
            context: {
                urls: []
            }
        }
    });
    const showTreatment = experimentStatus.type === "enrolled" && experimentStatus.value;
    (0, $gljCV.useEffect)(()=>{
        if (!showTreatment && !(overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment)) {
            if (setVariantStatus) setVariantStatus("not_enrolled_in_experiment");
        }
    }, [
        showTreatment,
        overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment,
        setVariantStatus
    ]);
    if (!showTreatment && !(overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment)) return $bc353b3611f7f2c4$var$renderDefaultSlot("not_enrolled_in_experiment", setRenderMessage);
    return variantComponent;
};
// Helper function to validate personalization prerequisites
const $bc353b3611f7f2c4$var$validatePersonalizationPrerequisites = (shouldPersonalize, userSegments, userSegmentStatus, error, overrides)=>{
    if (userSegmentStatus !== "complete") return {
        isValid: false,
        status: "fetching_segments"
    };
    if (!shouldPersonalize) return {
        isValid: false,
        status: "personalization_disabled"
    };
    if (!userSegments) return {
        isValid: false,
        status: "missing_user_segments"
    };
    if (error && !(overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides)) return {
        isValid: false,
        status: "segment_fetch_error"
    };
    return {
        isValid: true
    };
};
// Helper function to create variant component
const $bc353b3611f7f2c4$var$createVariantComponent = (chosenVariantIndex)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
        name: "variants",
        wrapperComponent: (slotProps)=>$bc353b3611f7f2c4$var$VariantSelector((0, $dPABA._)((0, $6ogO3._)({}, slotProps), {
                items: [
                    slotProps.items[chosenVariantIndex]
                ]
            }))
    });
// Helper function to set render message for variant
const $bc353b3611f7f2c4$var$setVariantRenderMessage = (variantCandidates, chosenVariantIndex, overrides, setRenderMessage)=>{
    const variantName = $bc353b3611f7f2c4$var$getCurrentVariantName(variantCandidates, chosenVariantIndex);
    const sourceType = (overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides) ? "Overrides" : "User Segments";
    setRenderMessage(`Rendering "${variantName}" Variant based on ${sourceType}`);
};
const $bc353b3611f7f2c4$var$getCurrentVariantName = (variantCandidates, chosenVariantIndex)=>{
    var _variantCandidates_chosenVariantIndex_parameters_variantName, _variantCandidates_chosenVariantIndex_parameters, _variantCandidates_chosenVariantIndex;
    return ((_variantCandidates_chosenVariantIndex = variantCandidates[chosenVariantIndex]) === null || _variantCandidates_chosenVariantIndex === void 0 ? void 0 : (_variantCandidates_chosenVariantIndex_parameters = _variantCandidates_chosenVariantIndex.parameters) === null || _variantCandidates_chosenVariantIndex_parameters === void 0 ? void 0 : (_variantCandidates_chosenVariantIndex_parameters_variantName = _variantCandidates_chosenVariantIndex_parameters["variantName"]) === null || _variantCandidates_chosenVariantIndex_parameters_variantName === void 0 ? void 0 : _variantCandidates_chosenVariantIndex_parameters_variantName.value) || "unknown";
};
const $bc353b3611f7f2c4$var$PersonalizedSection = (props)=>{
    var _composition_data;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $k9ZIM.useAnalyticsClient)();
    const [selectedVariantKey, setSelectedVariantKey] = (0, $gljCV.useState)(null);
    const [variantStatus, setVariantStatus] = (0, $gljCV.useState)(null);
    const [renderedExperience, setRenderedExperience] = (0, $gljCV.useState)(null);
    const { data: userSegments, error: error, status: userSegmentStatus } = (0, $3o1l4.useUserSegments)();
    const shouldPersonalize = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).uniformPersonalizationEnabled);
    const composition = (0, $01zo5.useUniformCurrentComposition)();
    const compositionId = composition === null || composition === void 0 ? void 0 : (_composition_data = composition.data) === null || _composition_data === void 0 ? void 0 : _composition_data._id;
    // Memoize slots to prevent infinite loops
    const variantSlots = (0, $gljCV.useMemo)(()=>{
        var _props_component_slots;
        var _props_component_slots_variants;
        return (_props_component_slots_variants = (_props_component_slots = props.component.slots) === null || _props_component_slots === void 0 ? void 0 : _props_component_slots["variants"]) !== null && _props_component_slots_variants !== void 0 ? _props_component_slots_variants : [];
    }, [
        props.component.slots
    ]);
    // Send metrics once when variant changes
    (0, $gljCV.useEffect)(()=>{
        const validation = $bc353b3611f7f2c4$var$validatePersonalizationPrerequisites(shouldPersonalize, userSegments, userSegmentStatus, error, props.overrides);
        if (!validation.isValid) {
            setSelectedVariantKey("default_experience");
            setVariantStatus(validation.status);
            setRenderedExperience($bc353b3611f7f2c4$var$renderDefaultSlot(validation.status, props.setRenderMessage));
            return;
        }
        // Process personalization logic
        const personalizationValues = $bc353b3611f7f2c4$var$getFinalPersonalizationValues(userSegments, props.overrides);
        const chosenVariantIndex = $bc353b3611f7f2c4$var$findMatchingVariant(variantSlots, personalizationValues);
        // Check if variant was found
        if (chosenVariantIndex < 0) {
            setSelectedVariantKey("default_experience");
            setVariantStatus("no_variant_match");
            setRenderedExperience($bc353b3611f7f2c4$var$renderDefaultSlot("no_variant_match", props.setRenderMessage));
            return;
        }
        const variantName = $bc353b3611f7f2c4$var$getCurrentVariantName(variantSlots, chosenVariantIndex);
        setSelectedVariantKey(variantName);
        setVariantStatus("variants_available");
        $bc353b3611f7f2c4$var$setVariantRenderMessage(variantSlots, chosenVariantIndex, props.overrides, props.setRenderMessage);
        const variantComponent = $bc353b3611f7f2c4$var$createVariantComponent(chosenVariantIndex);
        setRenderedExperience(variantComponent);
        // Handle experimental personalization
        if (props.experimentId) setRenderedExperience(/*#__PURE__*/ (0, $dypTs.jsx)($bc353b3611f7f2c4$var$ExperimentallyPersonalizedSection, {
            containerName: props.containerName,
            setRenderMessage: props.setRenderMessage,
            setVariantStatus: setVariantStatus,
            experimentId: props.experimentId,
            variantComponent: variantComponent,
            overrides: props.overrides,
            component: props.component
        }));
        return;
    }, [
        error,
        props.overrides,
        props.setRenderMessage,
        props.experimentId,
        props.containerName,
        props.component,
        shouldPersonalize,
        userSegmentStatus,
        userSegments,
        variantSlots,
        setVariantStatus
    ]);
    (0, $gljCV.useEffect)(()=>{
        if (!selectedVariantKey || !variantStatus) return;
        if (analyticsClient) createAnalyticsEvent({
            name: "waePersonalizationVariantRender",
            action: "personalizationVariantRender",
            actionSubject: "uniformPage",
            eventType: "screen",
            source: window.location.pathname,
            attributes: {
                containerName: props.containerName,
                path: window.location.pathname,
                compositionId: compositionId,
                variantName: selectedVariantKey,
                status: variantStatus
            }
        }).fire();
    }, [
        compositionId,
        createAnalyticsEvent,
        selectedVariantKey,
        props.containerName,
        variantStatus,
        analyticsClient
    ]);
    return renderedExperience;
};
const $bc353b3611f7f2c4$var$UniformPersonalizationContainer = (props)=>{
    const isProd = (0, $eRzlV.isProduction)();
    const [overrides, setOverrides] = (0, $gljCV.useState)({
        useOverrides: false,
        enrollInExperiment: false
    });
    const [renderMessage, setRenderMessage] = (0, $gljCV.useState)("");
    const [isContainerHovered, setIsContainerHovered] = (0, $gljCV.useState)(false);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        onMouseEnter: !isProd ? ()=>setIsContainerHovered(true) : undefined,
        onMouseLeave: !isProd ? ()=>setIsContainerHovered(false) : undefined,
        className: (0, $2jatx.default)([
            "_kqswh2mm _19itv6l3 _2rko1m5y _1yt41tub _v564u973 _1qs911pv"
        ]),
        style: {
            "--_1k5ts5z": (0, $6ZVlx.default)(!isProd && isContainerHovered ? `2px solid ${(0, $kbpa7.wacToken)("color.extended.blue300")}` : "2px solid transparent"),
            "--_1r0zder": (0, $6ZVlx.default)(!isProd ? (0, $kbpa7.wacToken)("corner.radius.card") : "0"),
            "--_15yoqdp": (0, $6ZVlx.default)(!isProd ? "var(--ds-space-100, 8px)" : "0"),
            "--_i1pnuw": (0, $6ZVlx.default)(!isProd ? "border-color 0.2s ease" : "none"),
            "--_hiqpr4": (0, $6ZVlx.default)(!isProd ? {
                border: `2px solid ${(0, $kbpa7.wacToken)("color.extended.blue300")}`
            } : {})
        },
        children: [
            !isProd && /*#__PURE__*/ (0, $dypTs.jsx)((0, $4L5aK.PersonalizationOverrideControls), {
                values: overrides,
                setValues: setOverrides,
                renderMessage: renderMessage,
                isContainerHovered: isContainerHovered
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)($bc353b3611f7f2c4$var$PersonalizedSection, (0, $dPABA._)((0, $6ogO3._)({}, props), {
                overrides: overrides,
                setRenderMessage: setRenderMessage,
                experimentId: props.experimentId
            }))
        ]
    });
};
var $bc353b3611f7f2c4$export$2e2bcd8739ae039 = $bc353b3611f7f2c4$var$UniformPersonalizationContainer;

});
parcelRegister("4L5aK", function(module, exports) {
$parcel$export(module.exports, "PersonalizationOverrideControls", function () { return $0a7d65259cee0cad$export$3509149ef9c5f46; });
/* personalization-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $gljCV = parcelRequire("gljCV");
parcelRequire("lDnuT");
var $LDFpB = parcelRequire("LDFpB");

var $9qukn = parcelRequire("9qukn");

var $8xVSo = parcelRequire("8xVSo");

var $kbpa7 = parcelRequire("kbpa7");

var $3o1l4 = parcelRequire("3o1l4");
const $0a7d65259cee0cad$var$JOB_FUNCTION = [
    {
        value: "engineering",
        label: "Engineering"
    },
    {
        value: "product management",
        label: "Product Management"
    },
    {
        value: "design",
        label: "Design"
    },
    {
        value: "data science",
        label: "Data Science"
    },
    {
        value: "marketing",
        label: "Marketing"
    },
    {
        value: "sales",
        label: "Sales"
    },
    {
        value: "human resources",
        label: "Human Resources"
    },
    {
        value: "finance",
        label: "Finance"
    },
    {
        value: "operations",
        label: "Operations"
    },
    {
        value: "legal",
        label: "Legal"
    },
    {
        value: "customer success",
        label: "Customer Success"
    },
    {
        value: "executive",
        label: "Executive"
    },
    {
        value: "other",
        label: "Other"
    },
    {
        value: "information technology",
        label: "Information Technology"
    },
    {
        value: "customer service",
        label: "Customer Service"
    },
    {
        value: "program management",
        label: "Program Management"
    },
    {
        value: "c-suite",
        label: "C-Suite"
    }
];
const $0a7d65259cee0cad$var$PRODUCT_OPTIONS = [
    {
        value: "jira-software",
        label: "Jira"
    },
    {
        value: "confluence",
        label: "Confluence"
    },
    {
        value: "jira-servicedesk",
        label: "JSM"
    },
    {
        value: "loom",
        label: "Loom"
    },
    {
        value: "jira-product-discovery",
        label: "JPD"
    },
    {
        value: "rovo.ondemand",
        label: "Rovo"
    }
];
const $0a7d65259cee0cad$var$PersonalizationControlPanel = ({ values: values, handleSelectChange: handleSelectChange })=>{
    var _JOB_FUNCTION_find;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                onClick: (e)=>{
                    const target = e.target;
                    if (target.type === "checkbox") handleSelectChange("enrollInExperiment", target.checked);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleSelectChange("enrollInExperiment", !values.enrollInExperiment);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $LDFpB.Checkbox), {
                    id: "enrollInExperiment",
                    name: "enrollInExperiment",
                    value: "enrollInExperiment",
                    label: "Enroll in Experiment Treatment?",
                    checked: values.enrollInExperiment
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                onClick: (e)=>{
                    const target = e.target;
                    if (target.type === "checkbox") handleSelectChange("useOverrides", target.checked);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleSelectChange("useOverrides", !values.useOverrides);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $LDFpB.Checkbox), {
                    id: "useOverrides",
                    name: "useOverrides",
                    value: "useOverrides",
                    label: "Use Overrides?",
                    checked: values.useOverrides
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $9qukn.DropdownSelector), {
                    name: (0, $3o1l4.UserSegmentTypes).LOGIN_STATUS,
                    id: (0, $3o1l4.UserSegmentTypes).LOGIN_STATUS,
                    label: "Login Status",
                    options: [
                        {
                            value: "loggedIn",
                            label: "Logged In"
                        },
                        {
                            value: "loggedOut",
                            label: "Logged Out"
                        }
                    ],
                    defaultValue: {
                        value: values[(0, $3o1l4.UserSegmentTypes).LOGIN_STATUS] || "",
                        label: values[(0, $3o1l4.UserSegmentTypes).LOGIN_STATUS] === "loggedIn" ? "Logged In" : "Logged Out"
                    },
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $3o1l4.UserSegmentTypes).LOGIN_STATUS, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $8xVSo.TextInput), {
                    id: "geolocation",
                    name: (0, $3o1l4.UserSegmentTypes).GEOLOCATION,
                    label: "Geolocation",
                    placeholder: "e.g. US, UK, AU",
                    value: values[(0, $3o1l4.UserSegmentTypes).GEOLOCATION],
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $3o1l4.UserSegmentTypes).GEOLOCATION, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $9qukn.DropdownSelector), {
                    name: (0, $3o1l4.UserSegmentTypes).JOB_FUNCTION,
                    id: (0, $3o1l4.UserSegmentTypes).JOB_FUNCTION,
                    label: "Job Function",
                    options: $0a7d65259cee0cad$var$JOB_FUNCTION.map((entry)=>({
                            value: entry.value,
                            label: entry.label
                        })),
                    defaultValue: {
                        value: values[(0, $3o1l4.UserSegmentTypes).JOB_FUNCTION] || "",
                        label: ((_JOB_FUNCTION_find = $0a7d65259cee0cad$var$JOB_FUNCTION.find((e)=>{
                            return e.value === values[(0, $3o1l4.UserSegmentTypes).JOB_FUNCTION];
                        })) === null || _JOB_FUNCTION_find === void 0 ? void 0 : _JOB_FUNCTION_find.label) || "test"
                    },
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $3o1l4.UserSegmentTypes).JOB_FUNCTION, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $9qukn.DropdownSelector), {
                    name: (0, $3o1l4.UserSegmentTypes).DOMAIN_TYPE,
                    id: (0, $3o1l4.UserSegmentTypes).DOMAIN_TYPE,
                    label: "Domain Type",
                    options: [
                        {
                            value: "BUSINESS",
                            label: "Business"
                        },
                        {
                            value: "PERSONAL",
                            label: "Personal"
                        }
                    ],
                    defaultValue: {
                        value: values[(0, $3o1l4.UserSegmentTypes).DOMAIN_TYPE] || "",
                        label: values[(0, $3o1l4.UserSegmentTypes).DOMAIN_TYPE] === "BUSINESS" ? "Business" : "Personal"
                    },
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $3o1l4.UserSegmentTypes).DOMAIN_TYPE, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("label", {
                        htmlFor: (0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS,
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _syaz5k8o _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                        ]),
                        style: {
                            "--_1ntr8rj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark200"))
                        },
                        children: "Owned Products"
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1n261g80 _zulp1b66 _1yt4u2gc _19it1nj5 _2rko1y44 _1tke1ylp _4cvr1h6o"
                        ]),
                        style: {
                            "--_19aes6n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark700"))
                        },
                        children: [
                            {
                                value: "jira-software",
                                label: "Jira"
                            },
                            {
                                value: "confluence",
                                label: "Confluence"
                            },
                            {
                                value: "bitbucket",
                                label: "Bitbucket"
                            },
                            {
                                value: "compass",
                                label: "Compass"
                            },
                            {
                                value: "jira-product-discovery",
                                label: "Jira Product Discovery"
                            },
                            {
                                value: "statuspage",
                                label: "Statuspage"
                            },
                            {
                                value: "loom",
                                label: "Loom"
                            },
                            {
                                value: "compass",
                                label: "Compass"
                            },
                            {
                                value: "rovo.ondemand",
                                label: "Rovo"
                            },
                            {
                                value: "trello",
                                label: "Trello"
                            }
                        ].map((product)=>{
                            var _values_UserSegmentTypes_OWNED_PRODUCTS;
                            const isSelected = Array.isArray(values[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS]) ? (_values_UserSegmentTypes_OWNED_PRODUCTS = values[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS]) === null || _values_UserSegmentTypes_OWNED_PRODUCTS === void 0 ? void 0 : _values_UserSegmentTypes_OWNED_PRODUCTS.includes(product.value) : values[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS] === product.value;
                            return /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    const currentProducts = Array.isArray(values[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS]) ? values[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS] || [] : values[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS] ? [
                                        values[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS]
                                    ] : [];
                                    let updatedProducts;
                                    if (isSelected) updatedProducts = currentProducts.filter((p)=>p !== product.value);
                                    else updatedProducts = [
                                        ...currentProducts,
                                        product.value
                                    ];
                                    handleSelectChange((0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS, updatedProducts);
                                },
                                className: (0, $2jatx.default)([
                                    "_1yt418iy _bfhkl9kt _syaz1o9l _19itglyw _2rko1y44 _80omtlke _1wyboxwj _irr31nu1"
                                ]),
                                style: {
                                    "--_3kul7g": (0, $6ZVlx.default)(isSelected ? (0, $kbpa7.wacToken)("color.extended.blue300") : (0, $kbpa7.wacToken)("color.neutral.light200")),
                                    "--_8buy8y": (0, $6ZVlx.default)(isSelected ? (0, $kbpa7.wacToken)("color.neutral.light0") : (0, $kbpa7.wacToken)("color.neutral.dark200")),
                                    "--_1pblbmt": (0, $6ZVlx.default)(isSelected ? (0, $kbpa7.wacToken)("color.extended.blue400") : (0, $kbpa7.wacToken)("color.neutral.light300"))
                                },
                                children: product.label
                            }, product.value);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("label", {
                        htmlFor: (0, $3o1l4.UserSegmentTypes).CLUSTER_TAG,
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _syaz5k8o _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                        ]),
                        style: {
                            "--_1ntr8rj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark200"))
                        },
                        children: "Anchor/Cluster Tag"
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("input", {
                        id: (0, $3o1l4.UserSegmentTypes).CLUSTER_TAG,
                        "data-testid": (0, $3o1l4.UserSegmentTypes).CLUSTER_TAG,
                        type: "text",
                        value: values[(0, $3o1l4.UserSegmentTypes).CLUSTER_TAG],
                        onChange: (event)=>{
                            handleSelectChange((0, $3o1l4.UserSegmentTypes).CLUSTER_TAG, event.target.value.toLowerCase());
                        },
                        className: (0, $2jatx.default)([
                            "_1bsb1osq"
                        ])
                    })
                ]
            }),
            [
                {
                    segmentType: (0, $3o1l4.UserSegmentTypes).FIRST_RECOMMENDATION,
                    label: "First Recommendation",
                    defaultValue: "jira",
                    defaultLabel: "Jira"
                },
                {
                    segmentType: (0, $3o1l4.UserSegmentTypes).SECOND_RECOMMENDATION,
                    label: "Second Recommendation",
                    defaultValue: "confluence",
                    defaultLabel: "Confluence"
                },
                {
                    segmentType: (0, $3o1l4.UserSegmentTypes).THIRD_RECOMMENDATION,
                    label: "Third Recommendation",
                    defaultValue: "jsm",
                    defaultLabel: "JSM"
                },
                {
                    segmentType: (0, $3o1l4.UserSegmentTypes).FOURTH_RECOMMENDATION,
                    label: "Fourth Recommendation",
                    defaultValue: "loom",
                    defaultLabel: "Loom"
                }
            ].map(({ segmentType: segmentType, label: label, defaultValue: defaultValue, defaultLabel: defaultLabel })=>{
                const selectedValue = values[segmentType] || defaultValue;
                const selectedOption = $0a7d65259cee0cad$var$PRODUCT_OPTIONS.find((opt)=>opt.value === selectedValue);
                return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $9qukn.DropdownSelector), {
                        name: segmentType,
                        id: segmentType,
                        label: label,
                        options: $0a7d65259cee0cad$var$PRODUCT_OPTIONS,
                        defaultValue: {
                            value: selectedValue,
                            label: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || defaultLabel
                        },
                        onChangeHandler: (value)=>{
                            handleSelectChange(segmentType, value);
                        }
                    })
                }, segmentType);
            })
        ]
    });
};
const $0a7d65259cee0cad$export$3509149ef9c5f46 = ({ values: values, setValues: setValues, renderMessage: renderMessage, isContainerHovered: isContainerHovered })=>{
    const [isVisible, setIsVisible] = (0, $gljCV.useState)(false);
    const handleSelectChange = (field, value)=>{
        setValues((0, $dPABA._)((0, $6ogO3._)({}, values), {
            [field]: value
        }));
    };
    // Only show the dog-ear when container is hovered
    if (!isContainerHovered) return null;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        onMouseEnter: ()=>setIsVisible(true),
        onMouseLeave: ()=>setIsVisible(false),
        onFocus: ()=>setIsVisible(true),
        onBlur: ()=>setIsVisible(false),
        role: "button",
        tabIndex: 0,
        "data-testid": "personalization-controls",
        className: (0, $2jatx.default)([
            "_kqswstnw _152t12gs _1e0212gs _1bsb1lmt _4t3i1n85 _1pbyzo7u"
        ]),
        style: {
            "--_6q42yv": (0, $6ZVlx.default)(isVisible ? "320px" : "auto"),
            "--_1j9tq0n": (0, $6ZVlx.default)(isVisible ? "400px" : "auto")
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                title: "Personalization Controls",
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tidpf _1e02idpf _1pby3ced _1bsbckbl _4t3ickbl _80omtlke _v5641hdd _tzy413ze _t9ec13e0"
                ]),
                style: {
                    "--_ymxjy5": (0, $6ZVlx.default)(isContainerHovered ? 1 : 0),
                    "--_51sge": (0, $6ZVlx.default)(isContainerHovered ? "scale(1)" : "scale(0.8)")
                },
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tidpf _1e02idpf _1bsbckbl _4t3ickbl _bfhk1mxb _2rko1dia _v5641hdd _16qs1s6v _irr3cqtm"
                        ]),
                        style: {
                            "--_9qtbdu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue300")),
                            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                            "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800")),
                            "--_r4erkq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue400"))
                        }
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152t1ssb _1e021ssb _t9ec1ooe _syazcd5j _1wyb7vkz _vwz4kb7n _lcxvglyw _w19j12yu"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                            "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800"))
                        },
                        children: "\uD83D\uDC65"
                    })
                ]
            }),
            isVisible && /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _152t1ex1 _1e02ftgi _1bsb1178 _1pby1rya _1yt4pxbi _bfhkcd5j _2rkovwyg _16qsswb1 _19it1nj5"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                    "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800")),
                    "--_19aes6n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark700"))
                },
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("h3", {
                        className: (0, $2jatx.default)([
                            "_18s819a1 _1wybbzd7 _syaz5k8o"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                            "--_1ntr8rj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark200"))
                        },
                        children: "Personalization Controls"
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_18s8h2s3 _1yt412x7 _1wyboqnp _syazgc2p _bfhkjzbh _2rko1y44 _19itacih"
                        ]),
                        style: {
                            "--_1jncskl": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark300")),
                            "--_1bsbd8h": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.yellow100")),
                            "--_1oxqp4m": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.yellow300"))
                        },
                        children: "These controls and the blue border are only visible in pre-production environments"
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)($0a7d65259cee0cad$var$PersonalizationControlPanel, {
                        values: values,
                        handleSelectChange: handleSelectChange
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1pfhutpp _1yt4u2gc _bfhk1ybm _syazgc2p"
                        ]),
                        style: {
                            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100")),
                            "--_1jncskl": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark300"))
                        },
                        children: renderMessage
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("lDnuT", function(module, exports) {
$parcel$export(module.exports, "Checkbox", function () { return (parcelRequire("LDFpB")).Checkbox; });

var $LDFpB = parcelRequire("LDFpB");

});
parcelRegister("LDFpB", function(module, exports) {
$parcel$export(module.exports, "Checkbox", function () { return $5d7641ed610c7620$export$48513f6b9f8ce62d; });
/* checkbox.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
const $5d7641ed610c7620$var$textStyle = null;
const $5d7641ed610c7620$var$containerStyle = null;
const $5d7641ed610c7620$var$checkboxStyle = null;
const $5d7641ed610c7620$export$48513f6b9f8ce62d = (props)=>{
    const { id: id, name: name, value: value, label: label, color: color = "light", accentColor: accentColor = "#0065ff", disabled: disabled, testId: testId, checked: checked, indeterminate: indeterminate, className: className } = props;
    const ref = (0, $gljCV.useRef)(null);
    (0, $gljCV.useEffect)(()=>{
        if (ref.current) {
            if (indeterminate) ref.current.indeterminate = indeterminate;
            else ref.current.checked = checked || false;
        }
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _4cvr1y6m _ca0qyh40 _u5f3idpf _n3tdyh40 _19bvidpf _vwz4bs82",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("input", {
                id: id,
                type: "checkbox",
                "data-testid": testId ? testId : id,
                style: {
                    accentColor: accentColor
                },
                ref: ref,
                name: name,
                value: value,
                disabled: disabled || false,
                className: (0, $2jatx.default)([
                    "_s7n4nkob _1bsb7vkz _4t3i7vkz _19pk1y44 _2hwxidpf _otyridpf _18u0idpf _1372tlke _d0altlke _jomr3739 _irr33739"
                ])
            }),
            label && /*#__PURE__*/ (0, $dypTs.jsx)("label", {
                style: {
                    color: color == "dark" ? "#172b4d" : "#5e6c84"
                },
                htmlFor: id,
                className: (0, $2jatx.default)([
                    "_80omtlke _1wyboxwj _k48p1nn1 _ahbqftgi"
                ]),
                children: label
            })
        ]
    });
};

});





parcelRegister("gC9ew", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("aT8t4")).default; });

var $aT8t4 = parcelRequire("aT8t4");

});
parcelRegister("aT8t4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $779847b443bf05b9$export$2e2bcd8739ae039; });
/* price-calculator.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $4G0xh = parcelRequire("4G0xh");

var $kbpa7 = parcelRequire("kbpa7");

var $8bW04 = parcelRequire("8bW04");

var $gJe05 = parcelRequire("gJe05");
parcelRequire("hEIeM");
var $44bDI = parcelRequire("44bDI");
var $5TIjy = parcelRequire("5TIjy");
parcelRequire("hEIeM");
var $MgH7i = parcelRequire("MgH7i");
parcelRequire("b9I0b");
var $fEBe5 = parcelRequire("fEBe5");

var $aLva8 = parcelRequire("aLva8");

var $fhn1A = parcelRequire("fhn1A");

var $9evy5 = parcelRequire("9evy5");

var $juRep = parcelRequire("juRep");
const $779847b443bf05b9$var$RecommendationTracker = ({ plan: plan, index: index, onRecommendedChange: onRecommendedChange })=>{
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: plan.fields.sku
    });
    (0, $gljCV.useEffect)(()=>{
        onRecommendedChange(index, state.recommended);
    }, [
        index,
        state.recommended,
        onRecommendedChange
    ]);
    return null;
};
const $779847b443bf05b9$var$PricingCalculatorContent = ({ comparePlansData: comparePlansData, urlSlug: urlSlug, selectedCardIndex: selectedCardIndex, setSelectedCardIndex: setSelectedCardIndex, disclaimer: disclaimer, omitInputs: omitInputs, numSections: numSections })=>{
    const intl = (0, $8e22h.default)();
    const handleRecommendedChange = (0, $gljCV.useCallback)((index, isRecommended)=>{
        if (isRecommended) setSelectedCardIndex(index);
    }, [
        setSelectedCardIndex
    ]);
    const unitsLabel = $779847b443bf05b9$var$useUnitsLabel(comparePlansData);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            comparePlansData.length > 1 && comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $dypTs.jsx)($779847b443bf05b9$var$RecommendationTracker, {
                    plan: planData,
                    index: index,
                    onRecommendedChange: handleRecommendedChange
                }, `tracker-${planData.fields.sku}`)),
            !omitInputs && /*#__PURE__*/ (0, $dypTs.jsx)((0, $MgH7i.PricingCalculatorInputs), {
                unitCountLabel: intl.formatMessage($9evy5.units.teamSizePrompt),
                unitsLabel: unitsLabel,
                dataProductKey: (0, $4G0xh.urlSlugToDataProductKey)[urlSlug]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $8bW04.PricingCards), {
                // must set the number of sections here if removing the bottom section
                // could also infer this from planData's getFeaturesList(fields.highlightedFeaturesContainer)
                numSections: numSections,
                selectedCardIndex: selectedCardIndex ? selectedCardIndex + 1 : 1,
                children: comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $juRep.PricingCalculatorCard), {
                        showBannerText: comparePlansData.length > 1,
                        planData: planData,
                        urlSlug: urlSlug,
                        index: index,
                        isSingleCard: comparePlansData.length === 1
                    }, planData.fields.sku))
            }),
            disclaimer && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_p12frdnh _k48p1nn1 _vwz4gktf _1wybdlk8 _syaz1hlo _1yt4utpp _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                    },
                    children: disclaimer
                })
            })
        ]
    });
};
const $779847b443bf05b9$var$disclaimerContainerCss = null;
const $779847b443bf05b9$var$disclaimerCss = null;
const $779847b443bf05b9$var$DEFAULT_SELECTED_CARD_INDEX = 2;
const $779847b443bf05b9$var$UniformPricingCalculator = (props)=>{
    var _comparePlansData__fields, _comparePlansData_;
    const { comparePlansData: comparePlansData, urlSlug: urlSlug, disclaimer: disclaimer } = props;
    const [selectedCardIndex, setSelectedCardIndex] = (0, $gljCV.useState)($779847b443bf05b9$var$DEFAULT_SELECTED_CARD_INDEX);
    const providerResult = (0, $fhn1A.useProviderProps)({
        plans: comparePlansData,
        product: urlSlug
    });
    if (providerResult.status === "pending") return /*#__PURE__*/ (0, $dypTs.jsx)((0, $5TIjy.LoadingSpinner), {});
    if (providerResult.status === "error") return null; // todo: fire an event @bsparks GWP-6943
    if (providerResult.status !== "ready") return null; // this should never happen due to checks above, but fixes type error
    const { config: config, inputValues: inputValues } = providerResult.props;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $aLva8.PricingCalculatorContextProvider), {
        config: config,
        inputValues: inputValues,
        children: /*#__PURE__*/ (0, $dypTs.jsx)($779847b443bf05b9$var$PricingCalculatorContent, {
            comparePlansData: comparePlansData,
            urlSlug: urlSlug,
            selectedCardIndex: selectedCardIndex,
            setSelectedCardIndex: setSelectedCardIndex,
            disclaimer: disclaimer,
            numSections: (0, $44bDI.getFeaturesList)(comparePlansData === null || comparePlansData === void 0 ? void 0 : (_comparePlansData_ = comparePlansData[0]) === null || _comparePlansData_ === void 0 ? void 0 : (_comparePlansData__fields = _comparePlansData_.fields) === null || _comparePlansData__fields === void 0 ? void 0 : _comparePlansData__fields.highlightedFeaturesContainer) === undefined ? 1 : 2,
            omitInputs: !config.billingCycleConfig.monthly && !config.billingCycleConfig.annual
        })
    });
};
var $779847b443bf05b9$export$2e2bcd8739ae039 = $779847b443bf05b9$var$UniformPricingCalculator;
function $779847b443bf05b9$var$useUnitsLabel(comparePlansData) {
    const intl = (0, $8e22h.default)();
    const hasAgents = comparePlansData.some((plan)=>{
        return [
            (0, $fEBe5.serviceCollectionOfferingSkus).free,
            (0, $fEBe5.serviceCollectionOfferingSkus).standard,
            (0, $fEBe5.serviceCollectionOfferingSkus).premium,
            (0, $fEBe5.serviceCollectionOfferingSkus).enterprise
        ].includes(plan.fields.sku);
    });
    if (hasAgents) return intl.formatMessage($9evy5.units.agentsUnitsLabel);
    return intl.formatMessage($9evy5.units.usersUnitsLabel);
}

});
parcelRegister("4G0xh", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_PRODUCT_KEY", function () { return $ceccdba2041bfa64$export$b65b36d21c9a62a9; });
$parcel$export(module.exports, "urlSlugToDataProductKey", function () { return $ceccdba2041bfa64$export$9c59efe722f16a54; });
const $ceccdba2041bfa64$export$e36fc9e5c75fc113 = "jiraSoftware";
const $ceccdba2041bfa64$export$b65b36d21c9a62a9 = "confluence";
const $ceccdba2041bfa64$export$b24966420407028a = "strategyCollection";
const $ceccdba2041bfa64$export$46061d552ba374f4 = "teamworkCollection";
const $ceccdba2041bfa64$export$e7e2043098922532 = "compass";
const $ceccdba2041bfa64$export$6648fdba742bde2c = "serviceCollection";
const $ceccdba2041bfa64$export$b3fce742f95b2633 = "atlassianGuard";
const $ceccdba2041bfa64$export$9c59efe722f16a54 = {
    jira: $ceccdba2041bfa64$export$e36fc9e5c75fc113,
    confluence: $ceccdba2041bfa64$export$b65b36d21c9a62a9,
    strategy: $ceccdba2041bfa64$export$b24966420407028a,
    teamwork: $ceccdba2041bfa64$export$46061d552ba374f4,
    compass: $ceccdba2041bfa64$export$e7e2043098922532,
    service: $ceccdba2041bfa64$export$6648fdba742bde2c,
    guard: $ceccdba2041bfa64$export$b3fce742f95b2633
};

});

parcelRegister("8bW04", function(module, exports) {
$parcel$export(module.exports, "PricingCards", function () { return $6b8bae1d092d0de9$export$eb5ade451900e238; });
/* pricing-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $6b8bae1d092d0de9$export$eb5ade451900e238 = (props)=>{
    const { selectedCardIndex: selectedCardIndex, children: children, numSections: numSections = 2, hasCalloutSlot: hasCalloutSlot, hasRangeSlot: hasRangeSlot, hasLinkSlot: hasLinkSlot, hasBannerSlot: hasBannerSlot } = props;
    const numberOfChildren = (0, $gljCV.Children).count(children);
    const getBorderProps = (childIndex, numSections)=>{
        if (numSections !== 1) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        return {
            topSectionStyle: {
                borderStartEndRadius: isFirstChild ? "0" : undefined,
                borderEndEndRadius: isFirstChild ? "0px" : undefined,
                borderStartStartRadius: isLastChild ? "0" : undefined,
                borderEndStartRadius: isLastChild ? "0px" : undefined
            }
        };
    };
    const getSelectedBorderProps = (childIndex)=>{
        if (selectedCardIndex === undefined || selectedCardIndex !== childIndex) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        const blackBorder = `1px solid ${(0, $kbpa7.wacToken)("color.primary.black")}`;
        return {
            topSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockStart: blackBorder,
                borderLeftRadius: "10px",
                borderTopRightRadius: numSections === 1 && isLastChild ? "20px" : undefined,
                borderBottomLeftRadius: numSections === 1 && isLastChild ? "0px" : undefined,
                borderBottomRightRadius: numSections === 1 && isFirstChild ? "0px" : undefined,
                borderRadius: numSections === 1 && !isFirstChild && !isLastChild ? `0px` : undefined,
                borderBottom: numSections === 1 ? blackBorder : undefined
            },
            bottomSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockEnd: blackBorder
            }
        };
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_2z054em0 _yv0e1579 _1e0c11p5 _wij21bp4 _1bsb1ns9 _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _glte1ns9 _1ao8yzqy _37tx5os2 _11nh5os2 _157nyzqy _1r9zyzqy _qrtggktf _bzkjkpzv _bi30wrl1 _x330kpzv _1q1tyzqy _14bpgktf _uedh18ji _sqhgyzqy _1bs9gktf _1o36gktf _r0rayzqy _23ugyzqy _4ezvyzqy",
            numSections !== 1 && "_1aqcftgi",
            "_1mjb1txw _na0i1bp4 _1s4p1osq _1a7ngktf _1xwygktf _9h3lyzqy _9rrkyzqy _18xwyzqy",
            numSections === 1 && "_pmhu1txs _ukazftgi _i370yzqy _1635yzqy"
        ]),
        style: {
            "--_wcq253": (0, $6ZVlx.default)(numSections),
            "--_1j6te2o": (0, $6ZVlx.default)(numberOfChildren),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
            "--_vgqxqn": (0, $6ZVlx.default)(numSections === 1 ? `1px solid ${(0, $kbpa7.wacToken)("color.neutral.light400")}` : undefined),
            "--_3ro2cj": (0, $6ZVlx.default)(numSections === 1 ? "0px" : "20px"),
            "--_14z1886": (0, $6ZVlx.default)(numSections === 1 ? "0px" : undefined),
            "--_1ecp6y0": (0, $6ZVlx.default)(numSections === 1 ? "20px" : undefined)
        },
        children: (0, $gljCV.Children).map(children, (child, index)=>{
            if (!child) return null;
            return /*#__PURE__*/ (0, $gljCV.cloneElement)(child, (0, $6ogO3._)({
                key: index,
                hasCalloutSlot: hasCalloutSlot,
                hasRangeSlot: hasRangeSlot,
                hasLinkSlot: hasLinkSlot,
                hasBannerSlot: hasBannerSlot
            }, index + 1 === selectedCardIndex ? getSelectedBorderProps(index + 1) : getBorderProps(index + 1, numSections)));
        })
    });
};

});

parcelRegister("gJe05", function(module, exports) {
$parcel$export(module.exports, "useCalculationState", function () { return $ffe53822942d34d9$export$5ac48a71a65a15bc; });

var $1CtPM = parcelRequire("1CtPM");

var $3V3tC = parcelRequire("3V3tC");
function $ffe53822942d34d9$export$5ac48a71a65a15bc(props) {
    const { offeringSku: offeringSku } = props;
    return {
        billingCycle: (0, $1CtPM.useSelector)($3V3tC.getBillingCycle),
        isUnitCountAboveMaxThreshold: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isUnitCountAboveMaxThreshold(ctx, offeringSku)),
        unitCountMin: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitCountMinThreshold(ctx, offeringSku)),
        isUnitCountBelowMinThreshold: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isUnitCountBelowMinThreshold(ctx, offeringSku)),
        price: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getFormattedPlanPrice(ctx, offeringSku)),
        recommended: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isOfferingRecommended(ctx, offeringSku)),
        unitCount: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitCount(ctx)),
        unitTierLowerBound: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitTierLowerBound(ctx, offeringSku)),
        unitTierUpperBound: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitTierUpperBound(ctx, offeringSku)),
        unitsAvailableInTier: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitsAvailableInTier(ctx, offeringSku)),
        numberFormatLocale: (0, $1CtPM.useSelector)($3V3tC.getNumberFormatLocale)
    };
}

});
parcelRegister("1CtPM", function(module, exports) {
$parcel$export(module.exports, "useUnitCount", function () { return $f242ee1b597a5061$export$856785685ba8098f; });
$parcel$export(module.exports, "useBillingCycle", function () { return $f242ee1b597a5061$export$ada282ac321ec3b9; });
$parcel$export(module.exports, "useSelector", function () { return $f242ee1b597a5061$export$2105062e25df4afe; });
$parcel$export(module.exports, "useCcpPricingData", function () { return $f242ee1b597a5061$export$97374d6e908d2c; });

var $gljCV = parcelRequire("gljCV");

var $dkcYJ = parcelRequire("dkcYJ");

var $aLva8 = parcelRequire("aLva8");
function $f242ee1b597a5061$export$856785685ba8098f() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $aLva8.usePricingCalculatorContext)();
    const { unitCount: unitCount } = inputValues;
    const changeUnitCount = (value)=>{
        return changeInputValues({
            unitCount: value
        });
    };
    return [
        unitCount,
        changeUnitCount
    ];
}
function $f242ee1b597a5061$export$ada282ac321ec3b9() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $aLva8.usePricingCalculatorContext)();
    const { billingCycle: billingCycle } = inputValues;
    const changeBillingCycle = (value)=>{
        return changeInputValues({
            billingCycle: value
        });
    };
    return [
        billingCycle,
        changeBillingCycle
    ];
}
function $f242ee1b597a5061$export$f3fe2cc7a9497569() {
    return (0, $aLva8.usePricingCalculatorContext)().calculationResult;
}
const $f242ee1b597a5061$export$2105062e25df4afe = (selector)=>{
    const context = (0, $aLva8.usePricingCalculatorContext)();
    return selector(context);
};
const $f242ee1b597a5061$var$PRODUCT_CATALOG_DELIVERY_KEY = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $f242ee1b597a5061$var$PRODUCT_CATALOG_SPACE = "3s3v3nq72la0";
const $f242ee1b597a5061$export$97374d6e908d2c = (props)=>{
    const { offeringSkus: offeringSkus, ssrData: ssrData } = props;
    const { fetchData: fetchData, status: fetchStatus, prices: clientSideData } = (0, $dkcYJ.useCCPPriceFinderData)(offeringSkus, $f242ee1b597a5061$var$PRODUCT_CATALOG_DELIVERY_KEY, $f242ee1b597a5061$var$PRODUCT_CATALOG_SPACE);
    const execFetch = (0, $gljCV.useCallback)(async ()=>{
        await fetchData();
    }, []);
    (0, $gljCV.useEffect)(()=>{
        if (!ssrData) execFetch();
    }, []);
    const status = $f242ee1b597a5061$var$getCcpPricingDataStatus({
        hasSsrData: !!ssrData,
        fetchStatus: fetchStatus
    });
    return {
        data: ssrData !== null && ssrData !== void 0 ? ssrData : clientSideData,
        status: status
    };
};
function $f242ee1b597a5061$var$getCcpPricingDataStatus(args) {
    const { fetchStatus: fetchStatus, hasSsrData: hasSsrData } = args;
    if (hasSsrData || fetchStatus === "complete") return "ready";
    if (fetchStatus === "idle" || fetchStatus === "fetching") return "pending";
    return "error";
}

});
parcelRegister("aLva8", function(module, exports) {
$parcel$export(module.exports, "usePricingCalculatorContext", function () { return $368a3b873d7337e6$export$cf6d27bb6377cd5b; });
$parcel$export(module.exports, "PricingCalculatorContextProvider", function () { return $368a3b873d7337e6$export$5a79cf764fd87278; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");
parcelRequire("7HfJk");
var $5CQu1 = parcelRequire("5CQu1");
var $8cfMz = parcelRequire("8cfMz");
const $368a3b873d7337e6$var$PricingCalculatorContext = /*#__PURE__*/ (0, $gljCV.createContext)(undefined);
const $368a3b873d7337e6$export$cf6d27bb6377cd5b = ()=>{
    const pricingCalculatorContext = (0, $gljCV.useContext)($368a3b873d7337e6$var$PricingCalculatorContext);
    if (!pricingCalculatorContext) throw new Error("usePricingCalculatorContext must be used within a PricingCalculatorProvider");
    return pricingCalculatorContext;
};
const $368a3b873d7337e6$export$5a79cf764fd87278 = (props)=>{
    const [inputValues, setInputValues] = (0, $gljCV.useState)(props.inputValues);
    const calculate = (0, $gljCV.useCallback)((v)=>{
        const { config: config } = props;
        const productCalculationInputs = (0, $8cfMz.getProductCalculationInputs)(config.planLimitConfigs, config.unitMinEnterprise, v.unitCount, v.billingCycle);
        return (0, $5CQu1.calculateProductPricing)(config.ccpPricingData, productCalculationInputs, config.currencyISOCode, config.localeISOCode);
    }, [
        props
    ]);
    const [calculationResult, setCalculationResult] = (0, $gljCV.useState)(()=>calculate(inputValues));
    // Recalculate when config (including currency) changes
    (0, $gljCV.useEffect)(()=>{
        const result = calculate(inputValues);
        setCalculationResult(result);
    }, [
        props.config,
        inputValues,
        calculate
    ]);
    const changeInputValues = (changes)=>{
        const nextValues = (0, $6ogO3._)({}, inputValues, changes);
        setInputValues(nextValues);
        const result = calculate(nextValues);
        setCalculationResult(result);
        return result;
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)($368a3b873d7337e6$var$PricingCalculatorContext.Provider, {
        value: {
            inputValues: inputValues,
            changeInputValues: changeInputValues,
            calculationResult: calculationResult,
            config: props.config
        },
        children: props.children
    });
};

});
parcelRegister("7HfJk", function(module, exports) {
$parcel$export(module.exports, "calculateProductPricing", function () { return (parcelRequire("5CQu1")).calculateProductPricing; });
$parcel$export(module.exports, "getProductCalculationInputs", function () { return (parcelRequire("8cfMz")).getProductCalculationInputs; });
parcelRequire("5CQu1");
parcelRequire("8cfMz");

});
parcelRegister("5CQu1", function(module, exports) {
$parcel$export(module.exports, "calculateProductPricing", function () { return $a686a54aa7deba91$export$6c0aa9d51dade71d; });

var $6ogO3 = parcelRequire("6ogO3");

var $1mbEv = parcelRequire("1mbEv");
const $a686a54aa7deba91$export$6c0aa9d51dade71d = (ccpPricingData, productCalculationInputs, currencyISOCode, localeISOCode)=>{
    const productPricing = [];
    for (const planCalculationInputs of productCalculationInputs){
        const { ccpOfferingSKU: ccpOfferingSKU, numUnits: numUnits, period: period } = planCalculationInputs;
        const planPricing = (0, $1mbEv.calculatePlanPricing)({
            ccpPricingData: ccpPricingData,
            ccpOfferingSKU: ccpOfferingSKU,
            numUnits: numUnits,
            period: period,
            currencyISOCode: currencyISOCode,
            localeISOCode: localeISOCode
        });
        productPricing.push((0, $6ogO3._)({
            // @ts-ignore
            offeringSku: ccpOfferingSKU
        }, planPricing));
    }
    return productPricing;
};

});
parcelRegister("1mbEv", function(module, exports) {
$parcel$export(module.exports, "calculatePlanPricing", function () { return $0f584d23bad95648$export$f9574505c9651410; });

var $6ogO3 = parcelRequire("6ogO3");

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");

var $1RK9J = parcelRequire("1RK9J");

var $aTHox = parcelRequire("aTHox");
parcelRequire("b9I0b");
var $9Nmuw = parcelRequire("9Nmuw");
const $0f584d23bad95648$var$hamsPricingDataStub = {};
const $0f584d23bad95648$var$hamsProductKeyStub = "";
function $0f584d23bad95648$export$f9574505c9651410(args) {
    const { ccpPricingData: ccpPricingData, ccpOfferingSKU: ccpOfferingSKU, period: period, numUnits: numUnits, currencyISOCode: currencyISOCode, localeISOCode: localeISOCode } = args;
    if (numUnits === 0) return (0, $6ogO3._)({
        offeringSku: ccpOfferingSKU
    }, (0, $1RK9J.getFreePriceCalc)(currencyISOCode));
    else {
        let getCcpTiers = undefined;
        if (ccpOfferingSKU === (0, $9Nmuw.rovoDevOfferingSkus).standard || ccpOfferingSKU === (0, $aTHox.bitbucketOfferingSkus).standard || ccpOfferingSKU === (0, $aTHox.bitbucketOfferingSkus).premium) // rovodev-standard price-plans contain both user and rovodev-credits charge-items
        // bitbucket-standard and bitbucket-premium price-plans contain both user and bitbucket-credits charge-items as well
        // so, we need to get the plan with the user charge-item
        // todo: GWP-8253 move out of reusable calc logic
        getCcpTiers = (pricingPlans)=>pricingPlans.items.find((item)=>item.chargeElement === "user");
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, $0f584d23bad95648$var$hamsPricingDataStub, period, currencyISOCode, ccpOfferingSKU, $0f584d23bad95648$var$hamsProductKeyStub, getCcpTiers);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            return (0, $6ogO3._)({
                offeringSku: ccpOfferingSKU
            }, (0, $1RK9J.getFreePriceCalc)(currencyISOCode));
        } else return (0, $6ogO3._)({
            offeringSku: ccpOfferingSKU
        }, (0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
}

});
parcelRegister("aTHox", function(module, exports) {
$parcel$export(module.exports, "BITBUCKET_DEFAULT_BILLING_CYCLE", function () { return $4c3894076c255a40$export$6e78cb64dcbedbb9; });
$parcel$export(module.exports, "BITBUCKET_DEFAULT_UNIT_COUNT", function () { return $4c3894076c255a40$export$36a5806a0e4fc360; });
$parcel$export(module.exports, "BITBUCKET_MIN_ENTERPRISE_USER_COUNT", function () { return $4c3894076c255a40$export$2b15976b7672c2da; });
$parcel$export(module.exports, "bitbucketOfferingSkus", function () { return $4c3894076c255a40$export$eeb88db779daf862; });
$parcel$export(module.exports, "BITBUCKET_SIGNUP_LIMIT", function () { return $4c3894076c255a40$export$4d264dc26702f23b; });
$parcel$export(module.exports, "bitbucketPlanLimitConfigs", function () { return $4c3894076c255a40$export$66d05a9262b43b7f; });
$parcel$export(module.exports, "bitbucketBillingCycleConfig", function () { return $4c3894076c255a40$export$f9cab01559b23739; });
const $4c3894076c255a40$export$6e78cb64dcbedbb9 = "MONTHLY";
const $4c3894076c255a40$export$36a5806a0e4fc360 = 5;
const $4c3894076c255a40$export$2b15976b7672c2da = 201;
const $4c3894076c255a40$export$eeb88db779daf862 = {
    free: "bitbucket-test-free",
    standard: "bitbucket-std",
    premium: "bitbucket-premium"
};
const $4c3894076c255a40$export$4d264dc26702f23b = 35000;
const $4c3894076c255a40$export$9a2735659d85fd7c = Object.values($4c3894076c255a40$export$eeb88db779daf862);
const $4c3894076c255a40$export$66d05a9262b43b7f = [
    {
        planName: "Free",
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.free,
        recommendationLimit: 0,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    },
    {
        planName: "Standard",
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.standard,
        recommendationLimit: 5,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    },
    {
        planName: "Premium",
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.premium,
        recommendationLimit: 100,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    }
];
const $4c3894076c255a40$export$f9cab01559b23739 = {
    monthly: true,
    annual: false
};

});

parcelRegister("b9I0b", function(module, exports) {
$parcel$export(module.exports, "jiraOfferingSkus", function () { return (parcelRequire("j1ORI")).jiraOfferingSkus; });
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_UNIT_COUNT", function () { return (parcelRequire("29JVp")).CONFLUENCE_DEFAULT_UNIT_COUNT; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return (parcelRequire("29JVp")).confluenceOfferingSkus; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return (parcelRequire("hGYMM")).strategyCollectionOfferingSkus; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return (parcelRequire("YmHME")).teamworkCollectionOfferingSkus; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return (parcelRequire("4utnL")).loomOfferingSkus; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return (parcelRequire("lc7EO")).jpdOfferingSkus; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return (parcelRequire("7dhmX")).compassOfferingSkus; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return (parcelRequire("44C4o")).guardOfferingSkus; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return (parcelRequire("fEBe5")).serviceCollectionOfferingSkus; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return (parcelRequire("9Nmuw")).rovoDevOfferingSkus; });
parcelRequire("j1ORI");
parcelRequire("29JVp");
parcelRequire("hGYMM");
parcelRequire("YmHME");
parcelRequire("4utnL");
parcelRequire("gcAZd");
parcelRequire("lc7EO");
parcelRequire("7dhmX");
parcelRequire("44C4o");
parcelRequire("fEBe5");
parcelRequire("9Nmuw");

});
parcelRegister("j1ORI", function(module, exports) {
$parcel$export(module.exports, "JIRA_DEFAULT_BILLING_CYCLE", function () { return $2a2b2c5bc611aa86$export$c34e5566df36b6ba; });
$parcel$export(module.exports, "JIRA_DEFAULT_UNIT_COUNT", function () { return $2a2b2c5bc611aa86$export$6521a918e64524fb; });
$parcel$export(module.exports, "JIRA_MIN_ENTERPRISE_USER_COUNT", function () { return $2a2b2c5bc611aa86$export$9aef50cd5f48bb38; });
$parcel$export(module.exports, "jiraOfferingSkus", function () { return $2a2b2c5bc611aa86$export$7529f2cfeec98447; });
$parcel$export(module.exports, "jiraPlanLimitConfigs", function () { return $2a2b2c5bc611aa86$export$3070b86c7bc28aea; });
const $2a2b2c5bc611aa86$export$c34e5566df36b6ba = "MONTHLY";
const $2a2b2c5bc611aa86$export$6521a918e64524fb = 300;
const $2a2b2c5bc611aa86$export$9aef50cd5f48bb38 = 801;
const $2a2b2c5bc611aa86$export$7529f2cfeec98447 = {
    free: "jira-software-free",
    standard: "jira-software-standard",
    premium: "jira-software-premium",
    enterprise: "jira-software-enterprise-sku"
};
const $2a2b2c5bc611aa86$export$b2b09200ca76754f = Object.values($2a2b2c5bc611aa86$export$7529f2cfeec98447);
const $2a2b2c5bc611aa86$export$3070b86c7bc28aea = [
    {
        planName: "Free",
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.free,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Standard",
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.standard,
        recommendationLimit: 10,
        signupLimit: 100000
    },
    {
        planName: "Premium",
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.premium,
        recommendationLimit: 250,
        signupLimit: 100000
    },
    {
        planName: "Enterprise",
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $2a2b2c5bc611aa86$export$9aef50cd5f48bb38
    }
];
const $2a2b2c5bc611aa86$export$7a133a10c706882b = {
    monthly: true,
    annual: true
};

});

parcelRegister("29JVp", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_BILLING_CYCLE", function () { return $1e226e69d394223a$export$d60dc2d142b5e9dd; });
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_UNIT_COUNT", function () { return $1e226e69d394223a$export$ab3750ec8101ffcc; });
$parcel$export(module.exports, "CONFLUENCE_MIN_ENTERPRISE_USER_COUNT", function () { return $1e226e69d394223a$export$f76a76b996ace375; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return $1e226e69d394223a$export$ffe6d3f38b5f7c3a; });
$parcel$export(module.exports, "confluencePlanLimitConfigs", function () { return $1e226e69d394223a$export$53fbba6eb29a73ad; });
const $1e226e69d394223a$export$d60dc2d142b5e9dd = "MONTHLY";
const $1e226e69d394223a$export$ab3750ec8101ffcc = 300;
const $1e226e69d394223a$export$f76a76b996ace375 = 801;
const $1e226e69d394223a$export$ffe6d3f38b5f7c3a = {
    free: "confluence-free",
    standard: "confluence-standard",
    premium: "confluence-premium",
    enterprise: "confluence-enterprise-sku"
};
const $1e226e69d394223a$export$39e8fbae2abd0443 = Object.values($1e226e69d394223a$export$ffe6d3f38b5f7c3a);
const $1e226e69d394223a$export$53fbba6eb29a73ad = [
    {
        planName: "Free",
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.free,
        recommendationLimit: 0,
        signupLimit: 150000
    },
    {
        planName: "Standard",
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.standard,
        recommendationLimit: 10,
        signupLimit: 150000
    },
    {
        planName: "Premium",
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.premium,
        recommendationLimit: 250,
        signupLimit: 150000
    },
    {
        planName: "Enterprise",
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.enterprise,
        recommendationLimit: 5000,
        signupLimit: 150000,
        minUnitCount: $1e226e69d394223a$export$f76a76b996ace375
    }
];
const $1e226e69d394223a$export$e8f1610e98745fd7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("hGYMM", function(module, exports) {
$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $45ceb3dd2bb22ad6$export$c00ddd271304729a; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $45ceb3dd2bb22ad6$export$27579c7f06007c25; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return $45ceb3dd2bb22ad6$export$8427e2db10f569be; });
$parcel$export(module.exports, "strategyCollectionPlanLimitConfigs", function () { return $45ceb3dd2bb22ad6$export$bc4927fbd68771ac; });
$parcel$export(module.exports, "strategyCollectionBillingCycleConfig", function () { return $45ceb3dd2bb22ad6$export$2225b2a65811f064; });
const $45ceb3dd2bb22ad6$export$c00ddd271304729a = "ANNUAL";
const $45ceb3dd2bb22ad6$export$27579c7f06007c25 = 50;
const $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a = 50;
const $45ceb3dd2bb22ad6$export$8427e2db10f569be = {
    enterprise: "strategy-collection-enterprise-sku"
};
const $45ceb3dd2bb22ad6$export$3b4c7d53b38ef615 = Object.values($45ceb3dd2bb22ad6$export$8427e2db10f569be);
const $45ceb3dd2bb22ad6$export$bc4927fbd68771ac = [
    {
        planName: "Enterprise",
        offeringSku: $45ceb3dd2bb22ad6$export$8427e2db10f569be.enterprise,
        recommendationLimit: 2000,
        signupLimit: 2000,
        minUnitCount: $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a
    }
];
const $45ceb3dd2bb22ad6$export$2225b2a65811f064 = {
    monthly: false,
    annual: true
};

});

parcelRegister("YmHME", function(module, exports) {
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $bf49a3d87bcf04a1$export$5784a04bb778d3c1; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $bf49a3d87bcf04a1$export$482604a575f7b4a5; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return $bf49a3d87bcf04a1$export$2e2107bfa20be1d8; });
$parcel$export(module.exports, "teamworkCollectionPlanLimitConfigs", function () { return $bf49a3d87bcf04a1$export$88bcddbae46dd5f1; });
$parcel$export(module.exports, "teamworkCollectionBillingCycleConfig", function () { return $bf49a3d87bcf04a1$export$5861c5ce06e1556; });
const $bf49a3d87bcf04a1$export$5784a04bb778d3c1 = "MONTHLY";
const $bf49a3d87bcf04a1$export$482604a575f7b4a5 = 300;
const $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2 = 801;
const $bf49a3d87bcf04a1$export$2e2107bfa20be1d8 = {
    free: "teamwork-collection-free-sku",
    standard: "teamwork-collection-standard-sku",
    premium: "teamwork-collection-premium-sku",
    enterprise: "teamwork-collection-enterprise-sku"
};
const $bf49a3d87bcf04a1$export$b61ab2c6a18de6d4 = Object.values($bf49a3d87bcf04a1$export$2e2107bfa20be1d8);
const $bf49a3d87bcf04a1$export$88bcddbae46dd5f1 = [
    {
        planName: "Free",
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.free,
        recommendationLimit: 0,
        signupLimit: 10
    },
    {
        planName: "Standard",
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.standard,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Premium",
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.premium,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Enterprise",
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2
    }
];
const $bf49a3d87bcf04a1$export$5861c5ce06e1556 = {
    monthly: true,
    annual: true
};

});

parcelRegister("4utnL", function(module, exports) {
$parcel$export(module.exports, "LOOM_DEFAULT_BILLING_CYCLE", function () { return $567bad4c99b6ec03$export$501dc9dfd5b2bde4; });
$parcel$export(module.exports, "LOOM_DEFAULT_UNIT_COUNT", function () { return $567bad4c99b6ec03$export$2aa1a93e0ac00fc; });
$parcel$export(module.exports, "LOOM_MIN_ENTERPRISE_USER_COUNT", function () { return $567bad4c99b6ec03$export$2a2f7d7a7ae18850; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return $567bad4c99b6ec03$export$a64578a63428ae96; });
$parcel$export(module.exports, "loomPlanLimitConfigs", function () { return $567bad4c99b6ec03$export$ed1379ed8713d252; });
$parcel$export(module.exports, "loomBillingCycleConfig", function () { return $567bad4c99b6ec03$export$d2bfeac6f7899675; });
const $567bad4c99b6ec03$export$501dc9dfd5b2bde4 = "MONTHLY";
const $567bad4c99b6ec03$export$2aa1a93e0ac00fc = 100;
const $567bad4c99b6ec03$export$2a2f7d7a7ae18850 = Infinity;
const $567bad4c99b6ec03$export$a64578a63428ae96 = {
    free: "loom-free-sku",
    business: "loom-business-sku",
    businessPlusAi: "loom-business-ai-sku",
    enterprise: "loom-enterprise-sku"
};
const $567bad4c99b6ec03$export$9f95f1c871571078 = Object.values($567bad4c99b6ec03$export$a64578a63428ae96);
const $567bad4c99b6ec03$export$ed1379ed8713d252 = [
    {
        planName: "Free",
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.free,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: "Business",
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.business,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: "Business + AI",
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.businessPlusAi,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: "Enterprise",
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.enterprise,
        recommendationLimit: Infinity,
        signupLimit: 50000
    }
];
const $567bad4c99b6ec03$export$d2bfeac6f7899675 = {
    monthly: true,
    annual: true
};

});

parcelRegister("gcAZd", function(module, exports) {
const $ff47f9ee8d194adc$export$be354061b07829a8 = "MONTHLY";
const $ff47f9ee8d194adc$export$2295858875312a6f = 75;
const $ff47f9ee8d194adc$export$66d53803b4a2565a = 201;
const $ff47f9ee8d194adc$export$38631f866342776a = {
    free: "jira-servicedesk-free",
    standard: "jira-servicedesk-standard",
    premium: "jira-servicedesk-premium",
    enterprise: "jira-servicedesk-enterprise-sku"
};
const $ff47f9ee8d194adc$export$efd16829e921ffb8 = Object.values($ff47f9ee8d194adc$export$38631f866342776a);
const $ff47f9ee8d194adc$export$9e62e4d7dc794618 = [
    {
        planName: "Free",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: "Enterprise",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000
    }
];
const $ff47f9ee8d194adc$export$34fbcdd33d5f7ba7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("lc7EO", function(module, exports) {
$parcel$export(module.exports, "JPD_DEFAULT_BILLING_CYCLE", function () { return $a2567840a72a8d9f$export$513f99bdcd3bd2; });
$parcel$export(module.exports, "JPD_DEFAULT_UNIT_COUNT", function () { return $a2567840a72a8d9f$export$503245d941330408; });
$parcel$export(module.exports, "JPD_MIN_ENTERPRISE_USER_COUNT", function () { return $a2567840a72a8d9f$export$4ebabaf17c585254; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return $a2567840a72a8d9f$export$400db592c8d58797; });
$parcel$export(module.exports, "jpdPlanLimitConfigs", function () { return $a2567840a72a8d9f$export$886e6b42d7675517; });
$parcel$export(module.exports, "jpdBillingCycleConfig", function () { return $a2567840a72a8d9f$export$370b1f24abd91670; });
const $a2567840a72a8d9f$export$513f99bdcd3bd2 = "MONTHLY";
const $a2567840a72a8d9f$export$503245d941330408 = 10;
const $a2567840a72a8d9f$export$4ebabaf17c585254 = 201;
const $a2567840a72a8d9f$export$400db592c8d58797 = {
    free: "jira-servicedesk-free",
    // jpd-free shares the same sku as jsm-free
    standard: "jira-product-discovery-standard",
    premium: "jira-product-discovery-premium-sku"
};
const $a2567840a72a8d9f$export$cf1798af40f51188 = Object.values($a2567840a72a8d9f$export$400db592c8d58797);
const $a2567840a72a8d9f$export$886e6b42d7675517 = [
    {
        planName: "Free",
        offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    }
];
const $a2567840a72a8d9f$export$370b1f24abd91670 = {
    monthly: true,
    annual: true
};

});

parcelRegister("7dhmX", function(module, exports) {
$parcel$export(module.exports, "COMPASS_DEFAULT_BILLING_CYCLE", function () { return $50757f59ceb0cbe4$export$2c789441f8bab310; });
$parcel$export(module.exports, "COMPASS_DEFAULT_UNIT_COUNT", function () { return $50757f59ceb0cbe4$export$887bc0e84eafd3c; });
$parcel$export(module.exports, "COMPASS_MIN_ENTERPRISE_USER_COUNT", function () { return $50757f59ceb0cbe4$export$862352663e0ac9d7; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return $50757f59ceb0cbe4$export$f93fb5caff8c778a; });
$parcel$export(module.exports, "compassPlanLimitConfigs", function () { return $50757f59ceb0cbe4$export$4df3b64d28e0d138; });
$parcel$export(module.exports, "compassBillingCycleConfig", function () { return $50757f59ceb0cbe4$export$e0b3f0eba764d747; });
const $50757f59ceb0cbe4$export$2c789441f8bab310 = "MONTHLY";
const $50757f59ceb0cbe4$export$887bc0e84eafd3c = 300;
const $50757f59ceb0cbe4$export$862352663e0ac9d7 = Infinity;
const $50757f59ceb0cbe4$export$f93fb5caff8c778a = {
    free: "compass-free",
    standard: "compass-standard",
    premium: "compass-premium-sku"
};
const $50757f59ceb0cbe4$export$74a0fd94f40ef5c5 = Object.values($50757f59ceb0cbe4$export$f93fb5caff8c778a);
const $50757f59ceb0cbe4$export$4df3b64d28e0d138 = [
    {
        planName: "Free",
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.free,
        recommendationLimit: 0,
        signupLimit: 3
    },
    {
        planName: "Standard",
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.standard,
        recommendationLimit: 3,
        signupLimit: 35000
    },
    {
        planName: "Premium",
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.premium,
        recommendationLimit: 250,
        signupLimit: 35000
    }
];
const $50757f59ceb0cbe4$export$e0b3f0eba764d747 = {
    monthly: true,
    annual: true
};

});

parcelRegister("44C4o", function(module, exports) {
$parcel$export(module.exports, "GUARD_DEFAULT_BILLING_CYCLE", function () { return $757a4e832c1a582d$export$9be98af08cc25cad; });
$parcel$export(module.exports, "GUARD_DEFAULT_UNIT_COUNT", function () { return $757a4e832c1a582d$export$d28097ea69640bd5; });
$parcel$export(module.exports, "GUARD_MIN_ENTERPRISE_USER_COUNT", function () { return $757a4e832c1a582d$export$13b500e201e8b319; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return $757a4e832c1a582d$export$91a420e9c7eb7c83; });
$parcel$export(module.exports, "guardPlanLimitConfigs", function () { return $757a4e832c1a582d$export$a2329ae21ff2ff84; });
$parcel$export(module.exports, "guardBillingCycleConfig", function () { return $757a4e832c1a582d$export$129a445945b6d9b3; });
const $757a4e832c1a582d$export$9be98af08cc25cad = "MONTHLY";
const $757a4e832c1a582d$export$d28097ea69640bd5 = 100;
const $757a4e832c1a582d$export$13b500e201e8b319 = Infinity;
const $757a4e832c1a582d$export$91a420e9c7eb7c83 = {
    standard: "atlassian-access-standard-sku",
    premium: "atlassian-guard-premium-addon-sku"
};
const $757a4e832c1a582d$export$159558c2b3d66b11 = Object.values($757a4e832c1a582d$export$91a420e9c7eb7c83);
const $757a4e832c1a582d$export$a2329ae21ff2ff84 = [
    {
        planName: "Standard",
        offeringSku: $757a4e832c1a582d$export$91a420e9c7eb7c83.standard,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: "Premium",
        offeringSku: $757a4e832c1a582d$export$91a420e9c7eb7c83.premium,
        recommendationLimit: 99,
        signupLimit: 50000
    }
];
const $757a4e832c1a582d$export$129a445945b6d9b3 = {
    monthly: true,
    annual: true
};

});

parcelRegister("fEBe5", function(module, exports) {
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $6246fc483000f258$export$9423de11a8a6dfa7; });
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $6246fc483000f258$export$515fa2affea780b3; });
$parcel$export(module.exports, "SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $6246fc483000f258$export$3df704b75c4818f2; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return $6246fc483000f258$export$84b191ede7d628ea; });
$parcel$export(module.exports, "serviceCollectionPlanLimitConfigs", function () { return $6246fc483000f258$export$29e5f53cb4f38894; });
$parcel$export(module.exports, "serviceCollectionBillingCycleConfig", function () { return $6246fc483000f258$export$7c96cfb0c18bfb05; });
const $6246fc483000f258$export$9423de11a8a6dfa7 = "MONTHLY";
const $6246fc483000f258$export$515fa2affea780b3 = 75;
const $6246fc483000f258$export$3df704b75c4818f2 = 201;
const $6246fc483000f258$export$84b191ede7d628ea = {
    free: "service-collection-free",
    standard: "service-collection-standard",
    premium: "service-collection-premium",
    enterprise: "service-collection-enterprise"
};
const $6246fc483000f258$export$953539e2774d6323 = Object.values($6246fc483000f258$export$84b191ede7d628ea);
const $6246fc483000f258$export$29e5f53cb4f38894 = [
    {
        planName: "Free",
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: "Enterprise",
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000,
        minUnitCount: $6246fc483000f258$export$3df704b75c4818f2
    }
];
const $6246fc483000f258$export$7c96cfb0c18bfb05 = {
    monthly: true,
    annual: true
};

});

parcelRegister("9Nmuw", function(module, exports) {
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_BILLING_CYCLE", function () { return $5113a0e17f25a106$export$f7b45b42f23a06a6; });
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_UNIT_COUNT", function () { return $5113a0e17f25a106$export$c80f45e98f559c29; });
$parcel$export(module.exports, "ROVO_DEV_MIN_ENTERPRISE_USER_COUNT", function () { return $5113a0e17f25a106$export$5cdb7bb84622bb8e; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return $5113a0e17f25a106$export$6a8477cfea6a8fb8; });
$parcel$export(module.exports, "rovoDevPlanLimitConfigs", function () { return $5113a0e17f25a106$export$93aaa2531823d54e; });
$parcel$export(module.exports, "rovoDevBillingCycleConfig", function () { return $5113a0e17f25a106$export$120b0272a23f9b21; });
const $5113a0e17f25a106$export$f7b45b42f23a06a6 = "MONTHLY";
const $5113a0e17f25a106$export$c80f45e98f559c29 = 10;
const $5113a0e17f25a106$export$5cdb7bb84622bb8e = Infinity;
const $5113a0e17f25a106$export$6a8477cfea6a8fb8 = {
    standard: "rovodev-standard"
};
const $5113a0e17f25a106$export$69f1beff4f684452 = Object.values($5113a0e17f25a106$export$6a8477cfea6a8fb8);
const $5113a0e17f25a106$export$93aaa2531823d54e = [
    {
        planName: "Standard",
        offeringSku: $5113a0e17f25a106$export$6a8477cfea6a8fb8.standard,
        recommendationLimit: Infinity,
        signupLimit: Infinity,
        minUnitCount: $5113a0e17f25a106$export$5cdb7bb84622bb8e
    }
];
const $5113a0e17f25a106$export$120b0272a23f9b21 = {
    monthly: false,
    annual: false
};

});




parcelRegister("8cfMz", function(module, exports) {
$parcel$export(module.exports, "getProductCalculationInputs", function () { return $2c139569c5386442$export$915d8a609f55f86e; });

var $hrGO1 = parcelRequire("hrGO1");
const $2c139569c5386442$export$915d8a609f55f86e = (productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    const getNumUnits = (planName, signupUnitLimit)=>{
        let adjNumUnits = 0;
        // following scenarios do not have pricing and should send a zero unit count,
        // the zero pricing will not be displayed and is needed only to retain the
        // correct array order of the pricing requests/responses
        // Free plan has no pricing
        const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
        // Enterprise plans do not have monthly pricing
        const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === "MONTHLY";
        // Enterprise plans have a minimum unit count
        const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
        const isOverSignupUnitLimit = unitCount > signupUnitLimit;
        if (![
            isFree,
            isMonthlyEnterprise,
            isUnmetUnitCountEnterprise,
            isOverSignupUnitLimit
        ].includes(true)) adjNumUnits = unitCount;
        // keep unit count to general maximum limit
        return Math.min(adjNumUnits, signupUnitLimit);
    };
    const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
            ccpOfferingSKU: offeringSku,
            hamsProductKey: undefined,
            numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
            period: billingCycle
        }));
    return planPriceReqs;
};

});




parcelRegister("3V3tC", function(module, exports) {
$parcel$export(module.exports, "getUnitCount", function () { return $964f907284a6b353$export$f188fc3b389e4986; });
$parcel$export(module.exports, "getBillingCycle", function () { return $964f907284a6b353$export$36cee2c7009ae4b; });
$parcel$export(module.exports, "hasAnnualBilling", function () { return $964f907284a6b353$export$101e70cd0fc05902; });
$parcel$export(module.exports, "hasMonthlyBilling", function () { return $964f907284a6b353$export$9adfa96ec47fe801; });
$parcel$export(module.exports, "isUnitCountAboveMaxThreshold", function () { return $964f907284a6b353$export$bdaa994f7aee683f; });
$parcel$export(module.exports, "getUnitCountMinThreshold", function () { return $964f907284a6b353$export$80145dc7d2cff456; });
$parcel$export(module.exports, "isUnitCountBelowMinThreshold", function () { return $964f907284a6b353$export$5566acad9364293b; });
$parcel$export(module.exports, "getNumberFormatLocale", function () { return $964f907284a6b353$export$3d36f1c8af14c3fb; });
$parcel$export(module.exports, "getCurrencyIsoCode", function () { return $964f907284a6b353$export$5052d5e5b6a90fdc; });
$parcel$export(module.exports, "isOfferingRecommended", function () { return $964f907284a6b353$export$d9589e71fc109cc; });
$parcel$export(module.exports, "getUnitTierLowerBound", function () { return $964f907284a6b353$export$f88112553e09e018; });
$parcel$export(module.exports, "getUnitTierUpperBound", function () { return $964f907284a6b353$export$6f3b3ca7764acc97; });
$parcel$export(module.exports, "getUnitsAvailableInTier", function () { return $964f907284a6b353$export$daa8dd568be987ed; });
$parcel$export(module.exports, "getFormattedPlanPrice", function () { return $964f907284a6b353$export$8808c13548cf959c; });
$parcel$export(module.exports, "getPricePlanId", function () { return $964f907284a6b353$export$235d4fbb478dfba0; });
const $964f907284a6b353$export$f188fc3b389e4986 = (ctx)=>ctx.inputValues.unitCount;
const $964f907284a6b353$export$36cee2c7009ae4b = (ctx)=>ctx.inputValues.billingCycle;
const $964f907284a6b353$export$101e70cd0fc05902 = (ctx)=>{
    return ctx.config.billingCycleConfig.annual;
};
const $964f907284a6b353$export$9adfa96ec47fe801 = (ctx)=>{
    return ctx.config.billingCycleConfig.monthly;
};
const $964f907284a6b353$export$bdaa994f7aee683f = (ctx, offeringSku)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const planLimitConfig = $964f907284a6b353$var$getPlanLimitConfig(ctx, offeringSku);
    return unitCount > planLimitConfig.signupLimit;
};
const $964f907284a6b353$export$80145dc7d2cff456 = (ctx, offeringSku)=>{
    const { minUnitCount: minUnitCount } = $964f907284a6b353$var$getPlanLimitConfig(ctx, offeringSku);
    return minUnitCount !== null && minUnitCount !== void 0 ? minUnitCount : 0;
};
const $964f907284a6b353$export$5566acad9364293b = (ctx, offeringSku)=>{
    const minUnitCount = $964f907284a6b353$export$80145dc7d2cff456(ctx, offeringSku);
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    return unitCount < minUnitCount;
};
const $964f907284a6b353$export$3a3e581c62c2c0f = (ctx)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const unitMinEnterprise = ctx.config.unitMinEnterprise;
    return unitCount >= unitMinEnterprise;
};
const $964f907284a6b353$var$getPlanLimitConfigs = (ctx)=>{
    return ctx.config.planLimitConfigs;
};
const $964f907284a6b353$var$getPlanLimitConfig = (ctx, offeringSku)=>{
    const planLimitConfigs = $964f907284a6b353$var$getPlanLimitConfigs(ctx);
    const planLimitConfig = planLimitConfigs.find((plan)=>plan.offeringSku === offeringSku);
    if (!planLimitConfig) throw new Error("unexpected empty value");
    return planLimitConfig;
};
const $964f907284a6b353$var$getPlanPriceResult = (ctx, offeringSku)=>{
    const planPriceResult = ctx.calculationResult.find((plan)=>plan.offeringSku === offeringSku);
    if (!planPriceResult) throw new Error("unexpected empty value");
    return planPriceResult;
};
const $964f907284a6b353$export$e3c7f1437cafb58a = (ctx, offeringSku)=>{
    const price = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return price.formattedTotalPrice;
};
const $964f907284a6b353$export$2aabcb5d2a5bee2b = (ctx, offeringSku)=>{
    const price = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return price.avgPerUnitPrice;
};
const $964f907284a6b353$export$10818dfc4986524e = (price)=>{
    return Math.round(price);
};
const $964f907284a6b353$export$2dd65b072d3a3106 = (price)=>{
    return Math.ceil(price);
};
const $964f907284a6b353$export$3d36f1c8af14c3fb = (ctx)=>{
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    const isJPY = currencyISOCode === "JPY";
    return isJPY ? "ja-JP" : "en-US";
};
const $964f907284a6b353$export$c86caf1be068fb8d = (ctx, price, options = {})=>{
    const numberFormatLocale = $964f907284a6b353$export$3d36f1c8af14c3fb(ctx);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    var _options_minimumFractionDigits, _options_minimumFractionDigits1;
    return new Intl.NumberFormat(numberFormatLocale, {
        style: "currency",
        currency: currencyISOCode,
        minimumFractionDigits: (_options_minimumFractionDigits = options.minimumFractionDigits) !== null && _options_minimumFractionDigits !== void 0 ? _options_minimumFractionDigits : 0,
        maximumFractionDigits: (_options_minimumFractionDigits1 = options.minimumFractionDigits) !== null && _options_minimumFractionDigits1 !== void 0 ? _options_minimumFractionDigits1 : 0
    }).format(price);
};
const $964f907284a6b353$export$b3a0d360c4444407 = (ctx, offeringSku)=>{
    const price = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return price.formattedAvgPerUnitPrice;
};
const $964f907284a6b353$export$d9589e71fc109cc = (ctx, offeringSku)=>{
    const recommendedOfferingSku = $964f907284a6b353$var$getRecommendedOfferingSku(ctx);
    return recommendedOfferingSku === offeringSku;
};
const $964f907284a6b353$var$getRecommendedOfferingSku = (ctx)=>{
    var _planLimitConfigs_recommendedPlanIdx;
    const getRecommendedPlanIdx = (unitCount, minUnitCounts)=>{
        const len = minUnitCounts.length - 1;
        return len - minUnitCounts.reverse().findIndex((minUnitCount)=>unitCount > minUnitCount);
    };
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const planLimitConfigs = $964f907284a6b353$var$getPlanLimitConfigs(ctx);
    const recommendedPlanIdx = getRecommendedPlanIdx(unitCount, planLimitConfigs.map((productPlan)=>productPlan.recommendationLimit));
    return (_planLimitConfigs_recommendedPlanIdx = planLimitConfigs[recommendedPlanIdx]) === null || _planLimitConfigs_recommendedPlanIdx === void 0 ? void 0 : _planLimitConfigs_recommendedPlanIdx.offeringSku;
};
const $964f907284a6b353$var$getUnformattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.breakdown.at(-1);
};
const $964f907284a6b353$export$f88112553e09e018 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.unitLimitLower;
};
const $964f907284a6b353$export$6f3b3ca7764acc97 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.unitLimitUpper;
};
const $964f907284a6b353$export$daa8dd568be987ed = (ctx, offeringSku)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const unitTierUpperBound = $964f907284a6b353$export$6f3b3ca7764acc97(ctx, offeringSku);
    return (unitTierUpperBound !== null && unitTierUpperBound !== void 0 ? unitTierUpperBound : 0) - unitCount;
};
/**
 * @deprecated
 */ const $964f907284a6b353$var$getFormattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.formattedBreakdown.at(-1);
};
const $964f907284a6b353$export$b1a3e695caa8081d = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.formattedUnitLimitLower;
};
const $964f907284a6b353$export$24bf67bcc0364ee6 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.formattedUnitLimitUpper;
};
const $964f907284a6b353$export$5052d5e5b6a90fdc = (ctx)=>ctx.config.currencyISOCode;
const $964f907284a6b353$export$8808c13548cf959c = (ctx, offeringSku)=>{
    const billingCycle = $964f907284a6b353$export$36cee2c7009ae4b(ctx);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    if (billingCycle === "ANNUAL") return $964f907284a6b353$export$e3c7f1437cafb58a(ctx, offeringSku);
    let price = $964f907284a6b353$export$2aabcb5d2a5bee2b(ctx, offeringSku);
    if (currencyISOCode === "JPY") {
        price = $964f907284a6b353$export$2dd65b072d3a3106(price);
        return $964f907284a6b353$export$c86caf1be068fb8d(ctx, price, {
            minimumFractionDigits: 0
        });
    }
    return $964f907284a6b353$export$c86caf1be068fb8d(ctx, price, {
        minimumFractionDigits: price === 0 || Number.isInteger(price) ? 0 : 2
    });
};
const $964f907284a6b353$export$235d4fbb478dfba0 = (ctx, args)=>{
    var _offering_defaultPricingPlans;
    const { offeringSku: offeringSku, edition: edition } = args;
    const offering = Object.values(ctx.config.ccpPricingData).find((offering)=>offering.sku === offeringSku);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    const billingCycle = $964f907284a6b353$export$36cee2c7009ae4b(ctx);
    // taken from `usePricingPlan` services/wac-web/src/components/wpl/pricing/src/price-finder/price-card/experiment-direct-buy/use-pricing-plan.tsx
    const defaultPricingPlan = offering === null || offering === void 0 ? void 0 : (_offering_defaultPricingPlans = offering.defaultPricingPlans) === null || _offering_defaultPricingPlans === void 0 ? void 0 : _offering_defaultPricingPlans.filter((item)=>item.currency.toLowerCase() == currencyISOCode.toLowerCase() && item.offeringName.toLowerCase() == edition.toLowerCase() && item.primaryCycle_name.toLowerCase() == billingCycle.toLowerCase() && item.status.toLowerCase() == "active");
    const lastPricingPlan = defaultPricingPlan === null || defaultPricingPlan === void 0 ? void 0 : defaultPricingPlan[defaultPricingPlan.length - 1];
    return (lastPricingPlan === null || lastPricingPlan === void 0 ? void 0 : lastPricingPlan.id) || "";
};

});


parcelRegister("hEIeM", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorInputs", function () { return (parcelRequire("MgH7i")).PricingCalculatorInputs; });
$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return (parcelRequire("kBDDI")).RovoDevStandardPriceCard; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return (parcelRequire("9hJtd")).ServiceCollectionEnterprisePriceCard; });
$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return (parcelRequire("9hJtd")).ServiceCollectionFreePriceCard; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return (parcelRequire("9hJtd")).ServiceCollectionPremiumPriceCard; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return (parcelRequire("9hJtd")).ServiceCollectionStandardPriceCard; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return (parcelRequire("v7O5E")).LoomBusinessPlusAiPriceCard; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return (parcelRequire("v7O5E")).LoomBusinessPriceCard; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return (parcelRequire("v7O5E")).LoomEnterprisePriceCard; });
$parcel$export(module.exports, "LoomFreePriceCard", function () { return (parcelRequire("v7O5E")).LoomFreePriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return (parcelRequire("1NsjC")).JiraProductDiscoveryFreePriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return (parcelRequire("1NsjC")).JiraProductDiscoveryPremiumPriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return (parcelRequire("1NsjC")).JiraProductDiscoveryStandardPriceCard; });
$parcel$export(module.exports, "LoadingSpinner", function () { return (parcelRequire("5TIjy")).LoadingSpinner; });
$parcel$export(module.exports, "PriceAltContainer", function () { return (parcelRequire("iXfHC")).PriceAltContainer; });
$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return (parcelRequire("9Osbp")).MonthlyEnterpriseMessage; });
$parcel$export(module.exports, "getFeaturesList", function () { return (parcelRequire("44bDI")).getFeaturesList; });
$parcel$export(module.exports, "UserTier", function () { return (parcelRequire("lbUj4")).UserTier; });
$parcel$export(module.exports, "UserTierExpanded", function () { return (parcelRequire("lbUj4")).UserTierExpanded; });
$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return (parcelRequire("7khdS")).useLocalizedCtaUrl; });
$parcel$export(module.exports, "useConfluenceDirectBuyExperiment", function () { return (parcelRequire("hzmwG")).useConfluenceDirectBuyExperiment; });
$parcel$export(module.exports, "ConfluenceDirectBuyButton", function () { return (parcelRequire("hzmwG")).ConfluenceDirectBuyButton; });
parcelRequire("MgH7i");

var $5TIjy = parcelRequire("5TIjy");

var $iXfHC = parcelRequire("iXfHC");

var $9Osbp = parcelRequire("9Osbp");

var $44bDI = parcelRequire("44bDI");

var $lbUj4 = parcelRequire("lbUj4");

var $7khdS = parcelRequire("7khdS");

var $hzmwG = parcelRequire("hzmwG");
parcelRequire("kBDDI");
parcelRequire("9hJtd");
parcelRequire("v7O5E");
parcelRequire("1NsjC");

});
parcelRegister("MgH7i", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorInputs", function () { return $884c8db4d1ecaa10$export$8c44531ca473ca22; });
/* pricing-calculator-inputs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $hrGO1 = parcelRequire("hrGO1");

var $9kpsh = parcelRequire("9kpsh");

var $4pGAV = parcelRequire("4pGAV");

var $kbpa7 = parcelRequire("kbpa7");

var $1CtPM = parcelRequire("1CtPM");

var $3V3tC = parcelRequire("3V3tC");
const $884c8db4d1ecaa10$export$8c44531ca473ca22 = (props)=>{
    const { unitCountLabel: unitCountLabel, unitsLabel: unitsLabel, dataProductKey: dataProductKey } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [billingCycle, setBillingCycle] = (0, $1CtPM.useBillingCycle)();
    const [unitCount, setUnitCount] = (0, $1CtPM.useUnitCount)();
    const hasMonthlyBilling = (0, $1CtPM.useSelector)($3V3tC.hasMonthlyBilling);
    const hasAnnualBilling = (0, $1CtPM.useSelector)($3V3tC.hasAnnualBilling);
    // @ts-ignore
    const { isVariation: isDirectBuyExperimentVariation } = (0, $9kpsh.useDirectBuyCohort)(dataProductKey);
    const [visualUnitCount, setVisualUnitCount] = (0, $gljCV.useState)(// @ts-ignore
    unitCount);
    (0, $gljCV.useEffect)(()=>{
        if (visualUnitCount !== "" && visualUnitCount > 0 && !Number.isNaN(visualUnitCount)) // @ts-ignore
        setUnitCount(visualUnitCount);
    }, [
        visualUnitCount
    ]);
    const handleUnitCountChange = (e)=>{
        const stringValue = e.target.value;
        if (stringValue === "") return setVisualUnitCount("");
        // validate max number of digits
        // default is 5
        // TODO: make this configurable
        if (stringValue.length > 6) return;
        const numberValue = parseInt(stringValue, 10);
        if (numberValue < 1) return;
        setVisualUnitCount(numberValue);
    };
    const handleUnitCountBlurChange = ()=>{
        // @ts-ignore
        if (visualUnitCount === "") setVisualUnitCount(unitCount);
        const data = {
            unitCount: unitCount,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: `${(0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox}_blurred`,
            eventComponent: "input",
            event: "blurred",
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox,
            action: "blurred",
            attributes: data,
            data: data
        }).fire();
    };
    const handleRadioChange = (billingCycle)=>{
        const data = {
            billingCycle: billingCycle,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            eventComponent: "radioButton",
            event: "clicked",
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            action: "clicked",
            attributes: data
        }).fire();
        setBillingCycle(billingCycle);
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fogza"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            className: (0, $2jatx.default)([
                "_p12f1kdj _19pk1wug _2hwx1wug _otyr1wug _18u01wug _b8yq1osq _3wvkidpf _1fbnidpf _1uby1wug _1t0ridpf"
            ]),
            children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_p12f1kdj _6rth1tcg _181n1txw _b8yq1osq _e8gh1h6o _19wgys9h"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _181n1ule"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)("label", {
                                htmlFor: "unit-count",
                                className: (0, $2jatx.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_12l2ftgi _syaz1hlo"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                },
                                children: unitCountLabel
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _15flidpf _1d2widpf _1svyidpf _seovidpf _1akoidpf _c7s7idpf _4puvidpf _1r3vidpf _181n116y _1t19kb7n _p7vbkb7n _1rhgf1ug"
                                ]),
                                children: /*#__PURE__*/ (0, $dypTs.jsx)("input", {
                                    id: "unit-count",
                                    type: "number",
                                    value: visualUnitCount,
                                    onChange: handleUnitCountChange,
                                    onBlur: handleUnitCountBlurChange,
                                    "data-event-component": "inputNumber",
                                    "data-event-container": "priceBlock",
                                    "data-event": "clicked",
                                    className: (0, $2jatx.default)([
                                        "_syazalr3 _k48p1nn1 _1wyb1j6v _vwz41tcg _12l214y2 _ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt _1bsb8ved _2rko1y44 _bfhk1hxd _19itglyw _13di444r _jh1sglyw _ji0mglyw"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsx)("label", {
                                htmlFor: "unit-term",
                                className: (0, $2jatx.default)([
                                    "_syaz1mpp _ect4bzd7 _1wyb1j6v _1dyznl7k _k48p1nn1 _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                },
                                children: unitsLabel
                            })
                        ]
                    }),
                    hasMonthlyBilling && hasAnnualBilling && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $4pGAV.RadioButtons), {
                            wrap: false,
                            dataProductKey: dataProductKey,
                            selectedButtonId: billingCycle,
                            onChange: handleRadioChange,
                            groupLabel: /*#__PURE__*/ (0, $dypTs.jsx)("legend", {
                                className: (0, $2jatx.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_1aax1e5h"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                                    id: "Pricing.priceFinderInputs.billMeText",
                                    defaultMessage: "Bill me:"
                                })
                            }),
                            buttons: [
                                {
                                    id: "MONTHLY",
                                    label: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                                        id: "Pricing.priceFinderInputs.monthly",
                                        defaultMessage: "Monthly"
                                    })
                                },
                                {
                                    id: "ANNUAL",
                                    label: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                                        id: "Pricing.pricingCalculatorInputs.anually",
                                        defaultMessage: "Annually"
                                    }),
                                    lozenge: {
                                        appearance: "blue",
                                        text: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                                            id: "Pricing.pricingCalculatorInputs.saveUpTo",
                                            defaultMessage: "SAVE UP TO 17%"
                                        })
                                    }
                                }
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $884c8db4d1ecaa10$var$labelStyles = null;
const $884c8db4d1ecaa10$var$legendStyles = null;
const $884c8db4d1ecaa10$var$inputTermStyle = null;
const $884c8db4d1ecaa10$var$inputCss = null;

});

parcelRegister("5TIjy", function(module, exports) {
$parcel$export(module.exports, "LoadingSpinner", function () { return $5e560a7364105b43$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $7qFQI = parcelRequire("7qFQI");
const $5e560a7364105b43$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4t3i1ogm _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            role: "alert",
            "aria-label": "Loading",
            "data-testid": "global-nav-user-profile-container-spinner",
            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $7qFQI.default), {})
        })
    });

});

parcelRegister("iXfHC", function(module, exports) {
$parcel$export(module.exports, "PriceAltContainer", function () { return $886eaf760740e014$export$4e62248194b0727b; });
/* price-alt-container.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
parcelRequire("gljCV");
const $886eaf760740e014$export$4e62248194b0727b = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", (0, $dPABA._)((0, $6ogO3._)({}, props), {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _y3gn1h6o"
        ]),
        children: props.children
    }));
};
const $886eaf760740e014$var$priceAltTextCss = null;

});

parcelRegister("9Osbp", function(module, exports) {
$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return $2abbf2119b6f777e$export$16f86c6a635bb9af; });
/* monthly-enterprise-message.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("gljCV");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");
const $2abbf2119b6f777e$export$16f86c6a635bb9af = (props)=>{
    const { switchToAnnual: switchToAnnual } = props;
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $iXfHC.PriceAltContainer), {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                type: "button",
                onClick: switchToAnnual,
                tabIndex: 0,
                "data-event-component": "linkButton",
                "data-event": "clicked",
                className: (0, $2jatx.default)([
                    "_bfhk1j28 _19itidpf _80omtlke _syaz17la _ect41kw7 _1wyb1kw7 _vwz4idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                },
                children: intl.formatMessage($9evy5.billedAnnually)
            }),
            "\xa0",
            intl.formatMessage($9evy5.switchToAnnualToViewEnterprise)
        ]
    });
};
const $2abbf2119b6f777e$var$buttonCss = null;

});
parcelRegister("9evy5", function(module, exports) {
$parcel$export(module.exports, "recommended", function () { return $b8ce4f4c86785928$export$bc5b8d0824876806; });
$parcel$export(module.exports, "units", function () { return $b8ce4f4c86785928$export$fe0319385f0cf5a7; });
$parcel$export(module.exports, "perUserPerMonth", function () { return $b8ce4f4c86785928$export$d8b49137e99effc2; });
$parcel$export(module.exports, "perYear", function () { return $b8ce4f4c86785928$export$5eae4ab34e5b16ae; });
$parcel$export(module.exports, "aboveUnitMaxThreshold", function () { return $b8ce4f4c86785928$export$bf2ba8467ff15aa5; });
$parcel$export(module.exports, "belowUnitMinThreshold", function () { return $b8ce4f4c86785928$export$2e64ce41e89d1e18; });
$parcel$export(module.exports, "billedAnnually", function () { return $b8ce4f4c86785928$export$9e1a6bb525180618; });
$parcel$export(module.exports, "switchToAnnualToViewEnterprise", function () { return $b8ce4f4c86785928$export$3277af2b318f7bfa; });
$parcel$export(module.exports, "enterpriseJpyMessage", function () { return $b8ce4f4c86785928$export$68a1387c7d0a683f; });

var $fnHPc = parcelRequire("fnHPc");
const $b8ce4f4c86785928$export$bc5b8d0824876806 = (0, $fnHPc.defineMessage)({
    id: "priceFinder.recommended",
    defaultMessage: "Recommended"
});
const $b8ce4f4c86785928$export$fe0319385f0cf5a7 = (0, $fnHPc.defineMessages)({
    teamSizePrompt: {
        id: "priceFinder.teamSizePrompt",
        defaultMessage: "Team Size:"
    },
    usersUnitsLabel: {
        id: "priceFinder.usersUnitsLabel",
        defaultMessage: "users"
    },
    agentsUnitsLabel: {
        id: "priceFinder.agentsUnitsLabel",
        defaultMessage: "agents"
    }
});
const $b8ce4f4c86785928$export$d8b49137e99effc2 = (0, $fnHPc.defineMessage)({
    id: "priceFinder.perUnitPerMonth",
    defaultMessage: "per user / month"
});
const $b8ce4f4c86785928$export$5eae4ab34e5b16ae = (0, $fnHPc.defineMessage)({
    id: "priceFinder.perYear",
    defaultMessage: "per year"
});
const $b8ce4f4c86785928$export$bf2ba8467ff15aa5 = (0, $fnHPc.defineMessages)({
    default: {
        id: "priceFinder.aboveUserMaxThreshold.default",
        defaultMessage: "Your user count exceeds this plan's limit"
    },
    cloudEnterprise: {
        id: "priceFinder.aboveUserMaxThreshold.cloudEnterprise",
        defaultMessage: "Talk to our sales team about pricing for Cloud Enterprise"
    },
    agents: {
        id: "priceFinder.aboveUserMaxThreshold.agents",
        defaultMessage: "Your agent count exceeds this plan's limit"
    },
    specificCount: {
        id: "priceFinder.aboveUserMaxThreshold.specificCount",
        defaultMessage: "For teams of more than {lowerLimit}, contact our sales team."
    },
    creators: {
        id: "priceFinder.aboveUserMaxThreshold.creators",
        defaultMessage: "Your creator count exceeds this plan's limit"
    }
});
const $b8ce4f4c86785928$export$2e64ce41e89d1e18 = (0, $fnHPc.defineMessages)({
    cloudEnterprise: {
        id: "priceFinder.belowUnitMinThreshold.cloudEnterprise",
        defaultMessage: "Enterprise plan pricing is available when you enter {minUnitCount} or more users above"
    }
});
const $b8ce4f4c86785928$export$9e1a6bb525180618 = (0, $fnHPc.defineMessage)({
    id: "priceFinder.billedAnnually",
    defaultMessage: "Billed annually."
});
const $b8ce4f4c86785928$export$3277af2b318f7bfa = (0, $fnHPc.defineMessage)({
    id: "priceFinder.switchToAnnualToViewEnterprise",
    defaultMessage: "Switch to Annual billing above to view Enterprise pricing."
});
const $b8ce4f4c86785928$export$68a1387c7d0a683f = (0, $fnHPc.defineMessage)({
    id: "priceFinder.enterpriseJpyMessage",
    defaultMessage: "For pricing details see FAQ below or talk to our sales team"
});

});


parcelRegister("44bDI", function(module, exports) {
$parcel$export(module.exports, "getFeaturesList", function () { return $b83af44fbf5738a9$export$501f60b80ced167; });
/* features-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $cXZQx = parcelRequire("cXZQx");

var $gVC4y = parcelRequire("gVC4y");
const $b83af44fbf5738a9$export$501f60b80ced167 = (highlightedFeaturesContainer)=>{
    return highlightedFeaturesContainer === null || highlightedFeaturesContainer === void 0 ? void 0 : highlightedFeaturesContainer.map((feature)=>({
            label: feature.fields.highlightedFeatureTitleExternal,
            details: feature.fields.highlightedFeatureDetails && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_q7gqdlk8"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $cXZQx.RichTextComponent), {
                    text: (0, $gVC4y.richTextToHTML)(// @ts-ignore
                    feature.fields.highlightedFeatureDetails)
                })
            }),
            lozengeText: feature.fields.highlightedLabel
        }));
};
const $b83af44fbf5738a9$var$featureDetailsCss = null;

});

parcelRegister("lbUj4", function(module, exports) {
$parcel$export(module.exports, "UserTier", function () { return $b9de452da2cf6ac9$export$cd4f9ca719669f8d; });
$parcel$export(module.exports, "UserTierExpanded", function () { return $b9de452da2cf6ac9$export$a4c8408bf932bb2; });
/* user-tier.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");
const $b9de452da2cf6ac9$export$cd4f9ca719669f8d = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, numberFormatLocale: numberFormatLocale = "en-US", unitType: unitType } = props;
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    if (unitType === "agent") return /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
        id: "PricingCalculator.agentTier.range",
        defaultMessage: "Agent tier: {lowerLimit} - {upperLimit}",
        values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        })
    });
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
        id: "PriceFunder.userTier.range",
        defaultMessage: "User tier: {lowerLimit} - {upperLimit}",
        values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        })
    });
};
const $b9de452da2cf6ac9$export$a4c8408bf932bb2 = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsInTier: unitsInTier, unitsAvailableInTier: unitsAvailableInTier, numberFormatLocale: numberFormatLocale = "en-US" } = props;
    const intl = (0, $8e22h.default)();
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.tier),
                    /*#__PURE__*/ (0, $dypTs.jsx)("br", {}),
                    formatNumber(unitLimitLower),
                    " - ",
                    formatNumber(unitLimitUpper)
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.filledSeats),
                    /*#__PURE__*/ (0, $dypTs.jsx)("br", {}),
                    formatNumber(unitsInTier)
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.availableSeats),
                    /*#__PURE__*/ (0, $dypTs.jsx)("br", {}),
                    formatNumber(unitsAvailableInTier)
                ]
            })
        ]
    });
};
const $b9de452da2cf6ac9$var$messages = (0, $fnHPc.defineMessages)({
    tier: {
        id: "PriceFinder.userTier.tier",
        defaultMessage: "Tier:"
    },
    filledSeats: {
        id: "PriceFinder.userTier.filledSeats",
        defaultMessage: "Filled seats:"
    },
    availableSeats: {
        id: "PriceFinder.userTier.availableSeats",
        defaultMessage: "Available seats:"
    }
});

});

parcelRegister("7khdS", function(module, exports) {
$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return $85c9ce8b07ea27f8$export$b5e9728b9b8ebe33; });

var $kooLp = parcelRequire("kooLp");
function $85c9ce8b07ea27f8$export$b5e9728b9b8ebe33(ctaFields) {
    var _ctaFields_ctaUrl;
    return (0, $kooLp.useLocalizedHref)((_ctaFields_ctaUrl = ctaFields === null || ctaFields === void 0 ? void 0 : ctaFields.ctaUrl) !== null && _ctaFields_ctaUrl !== void 0 ? _ctaFields_ctaUrl : "", {
        absolute: true
    });
}

});

parcelRegister("hzmwG", function(module, exports) {
$parcel$export(module.exports, "useConfluenceDirectBuyExperiment", function () { return $d70e6bd81ea628ad$export$fae015b2716f6f7; });
$parcel$export(module.exports, "ConfluenceDirectBuyButton", function () { return $d70e6bd81ea628ad$export$ac5f3af0a99903ed; });
// @ts-ignore

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $4G0xh = parcelRequire("4G0xh");

var $6N2Rf = parcelRequire("6N2Rf");

var $eYoKp = parcelRequire("eYoKp");
parcelRequire("b9I0b");
var $29JVp = parcelRequire("29JVp");

var $1CtPM = parcelRequire("1CtPM");

var $3V3tC = parcelRequire("3V3tC");
function $d70e6bd81ea628ad$export$fae015b2716f6f7(props) {
    const { sku: sku } = props;
    const billingCycle = (0, $1CtPM.useSelector)((0, $3V3tC.getBillingCycle));
    return (0, $eYoKp.useDirectBuyExperiment)(billingCycle, sku, Object.values((0, $29JVp.confluenceOfferingSkus)).includes(// @ts-ignore
    sku));
}
const $d70e6bd81ea628ad$export$ac5f3af0a99903ed = (props)=>{
    const { sku: sku, edition: edition } = props;
    const pricingPlanId = (0, $1CtPM.useSelector)((ctx)=>(0, $3V3tC.getPricePlanId)(ctx, {
            offeringSku: sku,
            edition: edition
        }));
    const unitCount = (0, $1CtPM.useSelector)((0, $3V3tC.getUnitCount));
    let planName;
    if (edition === "standard") planName = "Standard";
    if (edition === "premium") planName = "Premium";
    if (!pricingPlanId || !planName) return null;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $6N2Rf.BuyNowButtonExperiment), {
        defaultUnitCount: (0, $29JVp.CONFLUENCE_DEFAULT_UNIT_COUNT),
        unitCount: unitCount,
        pricingPlanId: pricingPlanId,
        edition: edition,
        dataProductKey: (0, $4G0xh.CONFLUENCE_PRODUCT_KEY),
        planName: planName
    });
};

});

parcelRegister("kBDDI", function(module, exports) {
$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return $429cde05ec573ae0$export$f0e8bcb2fb60056a; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $8e22h = parcelRequire("8e22h");

var $2Wido = parcelRequire("2Wido");
const $429cde05ec573ae0$export$f0e8bcb2fb60056a = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        isSingleCard: true,
        monthlyPerUserLabel: intl.formatMessage({
            id: "RovoDevStandardPriceCard.monthlyPerUserLabel",
            defaultMessage: "per developer / month"
        })
    }));
};

});
parcelRegister("2Wido", function(module, exports) {
$parcel$export(module.exports, "FreePriceCard", function () { return $fd07704e9f8e1231$export$75a717cafbbb6b29; });
$parcel$export(module.exports, "StandardPriceCard", function () { return $fd07704e9f8e1231$export$b2f3ad255eaef337; });
$parcel$export(module.exports, "PremiumPriceCard", function () { return $fd07704e9f8e1231$export$51a8509266751bd0; });
$parcel$export(module.exports, "EnterprisePriceCard", function () { return $fd07704e9f8e1231$export$ba2214b2dcd26743; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $8e22h = parcelRequire("8e22h");

var $BSG7c = parcelRequire("BSG7c");

var $2wDsW = parcelRequire("2wDsW");

var $lOlsU = parcelRequire("lOlsU");

var $8HBY7 = parcelRequire("8HBY7");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $gJe05 = parcelRequire("gJe05");
parcelRequire("hEIeM");
var $hzmwG = parcelRequire("hzmwG");
var $44bDI = parcelRequire("44bDI");
var $9Osbp = parcelRequire("9Osbp");
var $iXfHC = parcelRequire("iXfHC");
var $7khdS = parcelRequire("7khdS");
var $lbUj4 = parcelRequire("lbUj4");

var $1CtPM = parcelRequire("1CtPM");

var $9evy5 = parcelRequire("9evy5");

var $3V3tC = parcelRequire("3V3tC");
function $fd07704e9f8e1231$var$usePriceCardEvents(props) {
    const { productKey: productKey, edition: edition } = props;
    const tryIntent = (0, $2wDsW.useTryIntent)({
        containerId: (0, $BSG7c.PRICE_FINDER_CONTAINER),
        intentType: "button",
        productKey: productKey,
        edition: edition
    });
    const handleClickCta = (0, $lOlsU.useFirePricingPlanCtaEvent)({
        edition: edition,
        productKey: productKey,
        containerId: (0, $BSG7c.PRICE_FINDER_CONTAINER)
    });
    return {
        onClick: ()=>{
            tryIntent.onClick();
            handleClickCta();
        },
        onKeyDown: tryIntent.onKeyDown
    };
}
const $fd07704e9f8e1231$var$FREE_EDITION = "free";
const $fd07704e9f8e1231$export$75a717cafbbb6b29 = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: $fd07704e9f8e1231$var$FREE_EDITION
    });
    const dataEventPropsLabel = `${$fd07704e9f8e1231$var$FREE_EDITION}-get-it-now`;
    const { renderDirectBuyMatchSpace: renderDirectBuyMatchSpace } = (0, $hzmwG.useConfluenceDirectBuyExperiment)({
        sku: fields.sku
    });
    let buttonHref = ctaUrl;
    if ((0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).addSignupSourceToUrlsOnPricingPage)) {
        const urlWithSignupSource = new URL(ctaUrl, window.location.origin);
        urlWithSignupSource.searchParams.set("signupSource", "pricing");
        buttonHref = urlWithSignupSource.toString();
    }
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $8HBY7.PricingCard), {
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : state.recommended && intl.formatMessage($9evy5.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: state.price,
        hasUnitSlot: true,
        hasRangeSlot: props.hasRangeSlot !== undefined ? props.hasRangeSlot : state.billingCycle === "ANNUAL",
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonVariant: state.recommended ? "primary" : "secondary",
        buttonHref: buttonHref,
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $BSG7c.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        hasLinkSlot: renderDirectBuyMatchSpace,
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $fd07704e9f8e1231$var$STANDARD_EDITION = "standard";
const $fd07704e9f8e1231$var$PREMIUM_EDITION = "premium";
const $fd07704e9f8e1231$export$b2f3ad255eaef337 = (props)=>/*#__PURE__*/ (0, $dypTs.jsx)($fd07704e9f8e1231$var$CommonPriceCard, (0, $dPABA._)((0, $6ogO3._)({}, props), {
        edition: $fd07704e9f8e1231$var$STANDARD_EDITION
    }));
const $fd07704e9f8e1231$export$51a8509266751bd0 = (props)=>/*#__PURE__*/ (0, $dypTs.jsx)($fd07704e9f8e1231$var$CommonPriceCard, (0, $dPABA._)((0, $6ogO3._)({}, props), {
        edition: $fd07704e9f8e1231$var$PREMIUM_EDITION
    }));
// eslint-disable-next-line complexity
const $fd07704e9f8e1231$var$CommonPriceCard = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, tierLabelType: tierLabelType, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const dataEventPropsLabel = `${props.edition}-start-trial`;
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: props.edition
    });
    const { renderDirectBuyBtn: renderDirectBuyBtn } = (0, $hzmwG.useConfluenceDirectBuyExperiment)({
        sku: fields.sku
    });
    const priceAltElement = (()=>{
        if (state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined) return props.priceAltElementForAboveMaxThreshold;
        return null;
    })();
    let buttonHref = ctaUrl;
    if ((0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).addSignupSourceToUrlsOnPricingPage)) {
        const urlWithSignupSource = new URL(ctaUrl, window.location.origin);
        urlWithSignupSource.searchParams.set("signupSource", "pricing");
        buttonHref = urlWithSignupSource.toString();
    }
    var _props_monthlyPerUserLabel;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $8HBY7.PricingCard), {
        priceTestid: state.billingCycle === "ANNUAL" ? "annual-price" : "monthly-price",
        hasRangeSlot: state.isUnitCountAboveMaxThreshold && currencyIsoCode === "JPY" && state.billingCycle === "ANNUAL",
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : state.recommended && intl.formatMessage($9evy5.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: !state.isUnitCountAboveMaxThreshold && state.price,
        priceAltElement: state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined ? priceAltElement : /*#__PURE__*/ (0, $dypTs.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.default)
        }),
        unit: state.isUnitCountAboveMaxThreshold ? undefined : state.billingCycle === "MONTHLY" ? (_props_monthlyPerUserLabel = props.monthlyPerUserLabel) !== null && _props_monthlyPerUserLabel !== void 0 ? _props_monthlyPerUserLabel : intl.formatMessage($9evy5.perUserPerMonth) : intl.formatMessage($9evy5.perYear),
        hasUnitSlot: true,
        range: state.billingCycle === "ANNUAL" && !props.omitRange && !state.isUnitCountAboveMaxThreshold && /*#__PURE__*/ (0, $dypTs.jsx)((0, $lbUj4.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        }),
        tooltipContent: /*#__PURE__*/ (0, $dypTs.jsx)((0, $lbUj4.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        }),
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonHref: buttonHref,
        buttonDisabled: state.isUnitCountAboveMaxThreshold,
        buttonVariant: state.recommended || props.isSingleCard ? "primary" : "secondary",
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $BSG7c.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        link: renderDirectBuyBtn && /*#__PURE__*/ (0, $dypTs.jsx)((0, $hzmwG.ConfluenceDirectBuyButton), {
            sku: fields.sku,
            edition: props.edition
        }),
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $fd07704e9f8e1231$export$ba2214b2dcd26743 = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, showBannerText: showBannerText = true, isSingleCard: isSingleCard, tierLabelType: tierLabelType, customBannerText: customBannerText, isJpyPriceEnabled: isJpyPriceEnabled } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const [_, changeBillingCycle] = (0, $1CtPM.useBillingCycle)();
    const priceAltElement = (()=>{
        if (props.priceAltElement !== undefined) return props.priceAltElement;
        if (currencyIsoCode === "JPY" && !isJpyPriceEnabled) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.enterpriseJpyMessage)
        });
        if (state.billingCycle === "MONTHLY") return /*#__PURE__*/ (0, $dypTs.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: "24px"
            },
            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $9Osbp.MonthlyEnterpriseMessage), {
                switchToAnnual: ()=>changeBillingCycle("ANNUAL")
            })
        });
        if (state.isUnitCountAboveMaxThreshold) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: "48px"
            },
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.cloudEnterprise)
        });
        if (state.isUnitCountBelowMinThreshold) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: "48px"
            },
            children: intl.formatMessage($9evy5.belowUnitMinThreshold.cloudEnterprise, {
                minUnitCount: state.unitCountMin
            })
        });
        return null;
    })();
    const isPriceShown = !state.isUnitCountAboveMaxThreshold && !priceAltElement;
    let price = undefined;
    let range = undefined;
    let tooltipContent = undefined;
    if (isPriceShown) {
        price = state.price;
        range = /*#__PURE__*/ (0, $dypTs.jsx)((0, $lbUj4.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        });
        tooltipContent = /*#__PURE__*/ (0, $dypTs.jsx)((0, $lbUj4.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        });
    }
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const edition = "enterprise";
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: edition
    });
    const dataEventPropsLabel = `${edition}-contact-sales`;
    const { renderDirectBuyMatchSpace: renderDirectBuyMatchSpace } = (0, $hzmwG.useConfluenceDirectBuyExperiment)({
        sku: fields.sku
    });
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $8HBY7.PricingCard), {
        priceTestid: state.billingCycle === "ANNUAL" ? "annual-price" : "monthly-price",
        hasBannerSlot: true,
        hasRangeSlot: currencyIsoCode === "JPY" && state.billingCycle === "ANNUAL",
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : showBannerText && state.recommended && intl.formatMessage($9evy5.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: price,
        priceAltElement: priceAltElement,
        unit: // if a price alt element exists, there should be no unit
        priceAltElement ? undefined : !state.isUnitCountAboveMaxThreshold && !state.isUnitCountBelowMinThreshold ? intl.formatMessage($9evy5.perYear) : undefined,
        range: range,
        hasUnitSlot: // the unbounded text for the price alt element makes the unbounded
        currencyIsoCode === "JPY",
        tooltipContent: tooltipContent,
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonHref: ctaUrl,
        buttonVariant: state.recommended || isSingleCard ? "primary" : "secondary",
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $BSG7c.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        hasLinkSlot: renderDirectBuyMatchSpace,
        benefitsTitle: fields.highlightedFeaturesTitle,
        // in order for us to render just the top section fo a pricing card, the contentful data must be empty/undefined
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};

});
parcelRegister("BSG7c", function(module, exports) {
$parcel$export(module.exports, "PRICE_FINDER_CONTAINER", function () { return $d0bc5feae5415d38$export$c5526af38120e3f; });
const $d0bc5feae5415d38$export$c5526af38120e3f = "priceBlock";

});



parcelRegister("9hJtd", function(module, exports) {
$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return $e9537e62b8dac42c$export$ce09fc7b6ac40092; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return $e9537e62b8dac42c$export$84affe19123eb209; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return $e9537e62b8dac42c$export$1383d1ba03ed3746; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return $e9537e62b8dac42c$export$c277b80f2da61f89; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $8e22h = parcelRequire("8e22h");

var $2Wido = parcelRequire("2Wido");
const $e9537e62b8dac42c$export$ce09fc7b6ac40092 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.FreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $e9537e62b8dac42c$export$84affe19123eb209 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $e9537e62b8dac42c$export$1383d1ba03ed3746 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $e9537e62b8dac42c$export$c277b80f2da61f89 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.EnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};

});

parcelRegister("v7O5E", function(module, exports) {
$parcel$export(module.exports, "LoomFreePriceCard", function () { return $c7b8be01488760da$export$947796c8957ff6ff; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return $c7b8be01488760da$export$2a7af2744a13b8c2; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return $c7b8be01488760da$export$efaf4c20492b36b7; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return $c7b8be01488760da$export$d88b84b01ca5e441; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $8e22h = parcelRequire("8e22h");

var $1CtPM = parcelRequire("1CtPM");

var $2Wido = parcelRequire("2Wido");
const $c7b8be01488760da$var$OMIT_TIER_UNIT_THRESHOLD = 26;
const $c7b8be01488760da$export$947796c8957ff6ff = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.FreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        omitRange: omitRange,
        hasRangeSlot: omitRange ? false : undefined
    }));
};
const $c7b8be01488760da$export$2a7af2744a13b8c2 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        omitRange: omitRange
    }));
};
const $c7b8be01488760da$export$efaf4c20492b36b7 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    const intl = (0, $8e22h.default)();
    const customBannerText = intl.formatMessage({
        id: "LoomBusinessPlusAiPriceCard.mostPopular",
        defaultMessage: "Most popular"
    });
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        omitRange: omitRange,
        customBannerText: customBannerText
    }));
};
const $c7b8be01488760da$export$d88b84b01ca5e441 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.EnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        omitRange: omitRange,
        priceAltElement: /*#__PURE__*/ (0, $dypTs.jsx)("div", {})
    }));
};
const $c7b8be01488760da$var$useOmitRange = ()=>{
    const [billingCycle] = (0, $1CtPM.useBillingCycle)();
    const [unitCount] = (0, $1CtPM.useUnitCount)();
    return billingCycle === "ANNUAL" && unitCount < $c7b8be01488760da$var$OMIT_TIER_UNIT_THRESHOLD;
};

});

parcelRegister("1NsjC", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return $bb1064deffe4f718$export$9301352401a96395; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return $bb1064deffe4f718$export$f632b4bee5bd80fe; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return $bb1064deffe4f718$export$1fb355a43910f211; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $8e22h = parcelRequire("8e22h");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");

var $2Wido = parcelRequire("2Wido");
const $bb1064deffe4f718$export$9301352401a96395 = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.FreePriceCard), (0, $6ogO3._)({}, props));
};
const $bb1064deffe4f718$export$f632b4bee5bd80fe = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: "JiraProductDiscoveryPriceCard.perCreatorPerMonth",
            defaultMessage: "per creator / month"
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.creators)
        })
    }));
};
const $bb1064deffe4f718$export$1fb355a43910f211 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: "JiraProductDiscoveryPriceCard.perCreatorPerMonth",
            defaultMessage: "per creator / month"
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.creators)
        })
    }));
};

});


parcelRegister("fhn1A", function(module, exports) {
$parcel$export(module.exports, "useProviderProps", function () { return $00fd412ee2189aba$export$521c373ccc32c300; });
// @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $1XfW0 = parcelRequire("1XfW0");

var $hu3Tl = parcelRequire("hu3Tl");

var $aTHox = parcelRequire("aTHox");

var $7dhmX = parcelRequire("7dhmX");

var $29JVp = parcelRequire("29JVp");

var $44C4o = parcelRequire("44C4o");

var $j1ORI = parcelRequire("j1ORI");

var $lc7EO = parcelRequire("lc7EO");

var $4utnL = parcelRequire("4utnL");

var $9Nmuw = parcelRequire("9Nmuw");

var $fEBe5 = parcelRequire("fEBe5");

var $hGYMM = parcelRequire("hGYMM");

var $YmHME = parcelRequire("YmHME");

var $1CtPM = parcelRequire("1CtPM");
function $00fd412ee2189aba$export$521c373ccc32c300(props) {
    const { plans: plans, product: product } = props;
    const locale = (0, $1XfW0.useLocale)();
    const currencyISOCode = (0, $hu3Tl.getCurrencyFromUserLocale)(locale);
    const ssrData = plans.reduce((acc, plan)=>{
        return (0, $dPABA._)((0, $6ogO3._)({}, acc), {
            [plan.fields.sku]: plan.pricingPlan
        });
    }, {});
    const { data: ccpPricingData, status: status } = (0, $1CtPM.useCcpPricingData)({
        offeringSkus: plans.map((plan)=>plan.fields.sku),
        ssrData: ssrData
    });
    if (status === "error") return {
        status: "error"
    };
    if (status === "pending") return {
        status: "pending"
    };
    if (product === "jira") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $j1ORI.JIRA_DEFAULT_BILLING_CYCLE,
                unitCount: $j1ORI.JIRA_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $j1ORI.jiraPlanLimitConfigs,
                unitMinEnterprise: $j1ORI.JIRA_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === "confluence") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $29JVp.CONFLUENCE_DEFAULT_BILLING_CYCLE,
                unitCount: $29JVp.CONFLUENCE_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $29JVp.confluencePlanLimitConfigs,
                unitMinEnterprise: $29JVp.CONFLUENCE_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === "teamwork") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $YmHME.TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: $YmHME.TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $YmHME.teamworkCollectionPlanLimitConfigs,
                unitMinEnterprise: $YmHME.TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $YmHME.teamworkCollectionBillingCycleConfig
            }
        }
    };
    if (product === "guard") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $44C4o.GUARD_DEFAULT_BILLING_CYCLE,
                unitCount: $44C4o.GUARD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $44C4o.guardPlanLimitConfigs,
                unitMinEnterprise: $44C4o.GUARD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $44C4o.guardBillingCycleConfig
            }
        }
    };
    if (product === "bitbucket") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $aTHox.BITBUCKET_DEFAULT_BILLING_CYCLE,
                unitCount: $aTHox.BITBUCKET_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $aTHox.bitbucketPlanLimitConfigs,
                unitMinEnterprise: $aTHox.BITBUCKET_MIN_ENTERPRISE_USER_COUNT,
                // bitbucket only supports USD
                currencyISOCode: "USD",
                localeISOCode: locale,
                billingCycleConfig: $aTHox.bitbucketBillingCycleConfig
            }
        }
    };
    if (product === "strategy") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $hGYMM.STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: $hGYMM.STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $hGYMM.strategyCollectionPlanLimitConfigs,
                unitMinEnterprise: $hGYMM.STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $hGYMM.strategyCollectionBillingCycleConfig
            }
        }
    };
    if (product === "compass") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $7dhmX.COMPASS_DEFAULT_BILLING_CYCLE,
                unitCount: $7dhmX.COMPASS_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $7dhmX.compassPlanLimitConfigs,
                // not sure why this field is necessary
                unitMinEnterprise: $7dhmX.COMPASS_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $7dhmX.compassBillingCycleConfig
            }
        }
    };
    if (product === "service") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $fEBe5.SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: $fEBe5.SERVICE_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $fEBe5.serviceCollectionPlanLimitConfigs,
                unitMinEnterprise: $fEBe5.SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $fEBe5.serviceCollectionBillingCycleConfig
            }
        }
    };
    if (product === "rovo-dev") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $9Nmuw.ROVO_DEV_DEFAULT_BILLING_CYCLE,
                unitCount: $9Nmuw.ROVO_DEV_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $9Nmuw.rovoDevPlanLimitConfigs,
                unitMinEnterprise: $9Nmuw.ROVO_DEV_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $9Nmuw.rovoDevBillingCycleConfig
            }
        }
    };
    if (product === "loom") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $4utnL.LOOM_DEFAULT_BILLING_CYCLE,
                unitCount: $4utnL.LOOM_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $4utnL.loomPlanLimitConfigs,
                unitMinEnterprise: $4utnL.LOOM_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $4utnL.loomBillingCycleConfig
            }
        }
    };
    if (product === "product-discovery") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $lc7EO.JPD_DEFAULT_BILLING_CYCLE,
                unitCount: $lc7EO.JPD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $lc7EO.jpdPlanLimitConfigs,
                unitMinEnterprise: $lc7EO.JPD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $lc7EO.jpdBillingCycleConfig
            }
        }
    };
    throw new Error("unknown product");
}

});
parcelRegister("1XfW0", function(module, exports) {
"use strict";
var $16c7a96eeffbdd9b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $16c7a96eeffbdd9b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $16c7a96eeffbdd9b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$16c7a96eeffbdd9b$var$__exportStar((parcelRequire("dbu8X")), module.exports);

});
parcelRegister("dbu8X", function(module, exports) {
"use strict";
var $9993af4ecc11ada2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9993af4ecc11ada2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9993af4ecc11ada2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9993af4ecc11ada2$var$__exportStar((parcelRequire("d7zsU")), module.exports);

$9993af4ecc11ada2$var$__exportStar((parcelRequire("c09cG")), module.exports);

$9993af4ecc11ada2$var$__exportStar((parcelRequire("9sIvp")), module.exports);

$9993af4ecc11ada2$var$__exportStar((parcelRequire("4Hi5f")), module.exports);

});
parcelRegister("d7zsU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LOCALES = module.exports.LOCALE_REGISTRY = module.exports.DEFAULT_LOCALE = void 0;
module.exports.DEFAULT_LOCALE = "en";
module.exports.LOCALE_REGISTRY = Object.freeze({
    [module.exports.DEFAULT_LOCALE]: {
        label: "English"
    },
    de: {
        label: "Deutsch"
    },
    es: {
        label: "Espa\xf1ol"
    },
    fr: {
        label: "Fran\xe7ais"
    },
    it: {
        label: "Italiano"
    },
    ko: {
        label: "\uD55C\uAD6D\uC5B4"
    },
    nl: {
        label: "Nederlands"
    },
    ja: {
        label: "\u65E5\u672C\u8A9E"
    },
    pl: {
        label: "Polski"
    },
    br: {
        label: "Portugu\xeas"
    },
    ru: {
        label: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    zh: {
        label: "\u4E2D\u6587"
    }
});
module.exports.LOCALES = Object.keys(module.exports.LOCALE_REGISTRY);

});

parcelRegister("c09cG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLocale = $8bcc9fc4fdd32787$var$useLocale;

var $8e22h = parcelRequire("8e22h");
function $8bcc9fc4fdd32787$var$useLocale() {
    const intl = (0, $8e22h.default)();
    return intl.locale;
}

});

parcelRegister("9sIvp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLocalizedHref = $6e394074629606a1$var$useLocalizedHref;

var $d7zsU = parcelRequire("d7zsU");

var $c09cG = parcelRequire("c09cG");
function $6e394074629606a1$var$useLocalizedHref(href) {
    const locale = (0, $c09cG.useLocale)();
    if (locale === $d7zsU.DEFAULT_LOCALE) return href;
    else return `/${locale}${href}`;
}

});

parcelRegister("4Hi5f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_VALUES = void 0;

var $dypTs = parcelRequire("dypTs");
module.exports.DEFAULT_VALUES = Object.freeze({
    br: (0, $dypTs.jsx)("br", {}),
    p: (chunks)=>(0, $dypTs.jsx)("p", {
            children: chunks
        }),
    strong: (chunks)=>(0, $dypTs.jsx)("strong", {
            children: chunks
        }),
    span: (chunks)=>(0, $dypTs.jsx)("span", {
            children: chunks
        })
});

});




parcelRegister("juRep", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorCard", function () { return $1b9806dc7038eb23$export$14072311c149f96f; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $4G0xh = parcelRequire("4G0xh");
parcelRequire("hEIeM");
var $1NsjC = parcelRequire("1NsjC");
var $v7O5E = parcelRequire("v7O5E");
var $kBDDI = parcelRequire("kBDDI");
var $9hJtd = parcelRequire("9hJtd");

var $eCYOL = parcelRequire("eCYOL");

var $2Wido = parcelRequire("2Wido");

var $aTHox = parcelRequire("aTHox");
parcelRequire("b9I0b");
var $7dhmX = parcelRequire("7dhmX");
var $29JVp = parcelRequire("29JVp");
var $44C4o = parcelRequire("44C4o");
var $j1ORI = parcelRequire("j1ORI");
var $lc7EO = parcelRequire("lc7EO");
var $4utnL = parcelRequire("4utnL");
var $9Nmuw = parcelRequire("9Nmuw");
var $fEBe5 = parcelRequire("fEBe5");
var $hGYMM = parcelRequire("hGYMM");
var $YmHME = parcelRequire("YmHME");
const $1b9806dc7038eb23$export$14072311c149f96f = (props)=>{
    const sku = props.planData.fields.sku;
    const trackingProductKey = (0, $4G0xh.urlSlugToDataProductKey)[props.urlSlug];
    switch(sku){
        // Free
        case (0, $j1ORI.jiraOfferingSkus).free:
        case (0, $29JVp.confluenceOfferingSkus).free:
        case (0, $YmHME.teamworkCollectionOfferingSkus).free:
        case (0, $7dhmX.compassOfferingSkus).free:
        case (0, $aTHox.bitbucketOfferingSkus).free:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.FreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Standard
        case (0, $j1ORI.jiraOfferingSkus).standard:
        case (0, $29JVp.confluenceOfferingSkus).standard:
        case (0, $YmHME.teamworkCollectionOfferingSkus).standard:
        case (0, $44C4o.guardOfferingSkus).standard:
        case (0, $7dhmX.compassOfferingSkus).standard:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $aTHox.bitbucketOfferingSkus).standard:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $eCYOL.BitbucketStandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Premium
        case (0, $j1ORI.jiraOfferingSkus).premium:
        case (0, $29JVp.confluenceOfferingSkus).premium:
        case (0, $YmHME.teamworkCollectionOfferingSkus).premium:
        case (0, $44C4o.guardOfferingSkus).premium:
        case (0, $7dhmX.compassOfferingSkus).premium:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $aTHox.bitbucketOfferingSkus).premium:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $eCYOL.BitbucketPremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Enterprise
        case (0, $j1ORI.jiraOfferingSkus).enterprise:
        case (0, $29JVp.confluenceOfferingSkus).enterprise:
        case (0, $YmHME.teamworkCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.EnterprisePriceCard), (0, $6ogO3._)({}, props));
        case (0, $hGYMM.strategyCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.EnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                isJpyPriceEnabled: true
            }));
        // Custom, for any tier
        case (0, $9Nmuw.rovoDevOfferingSkus).standard:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $kBDDI.RovoDevStandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $fEBe5.serviceCollectionOfferingSkus).free:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $9hJtd.ServiceCollectionFreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $fEBe5.serviceCollectionOfferingSkus).standard:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $9hJtd.ServiceCollectionStandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $fEBe5.serviceCollectionOfferingSkus).premium:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $9hJtd.ServiceCollectionPremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $fEBe5.serviceCollectionOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $9hJtd.ServiceCollectionEnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $4utnL.loomOfferingSkus).free:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $v7O5E.LoomFreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $4utnL.loomOfferingSkus).business:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $v7O5E.LoomBusinessPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $4utnL.loomOfferingSkus).businessPlusAi:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $v7O5E.LoomBusinessPlusAiPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $4utnL.loomOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $v7O5E.LoomEnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $lc7EO.jpdOfferingSkus).free:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $1NsjC.JiraProductDiscoveryFreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $lc7EO.jpdOfferingSkus).standard:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $1NsjC.JiraProductDiscoveryStandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $lc7EO.jpdOfferingSkus).premium:
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $1NsjC.JiraProductDiscoveryPremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        default:
            // todo: @bsparks GWP-6943 fire an event for unexpected sku
            return null;
    }
};

});
parcelRegister("eCYOL", function(module, exports) {
$parcel$export(module.exports, "BitbucketStandardPriceCard", function () { return $cb5a2cb54b1cfed2$export$3f65201715c64fe0; });
$parcel$export(module.exports, "BitbucketPremiumPriceCard", function () { return $cb5a2cb54b1cfed2$export$3845e26e0454185b; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $8e22h = parcelRequire("8e22h");

var $aTHox = parcelRequire("aTHox");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");

var $2Wido = parcelRequire("2Wido");
const $cb5a2cb54b1cfed2$export$3f65201715c64fe0 = (props)=>{
    const intl = (0, $8e22h.default)();
    const formattedLimit = intl.formatNumber((0, $aTHox.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    }));
};
const $cb5a2cb54b1cfed2$export$3845e26e0454185b = (props)=>{
    const intl = (0, $8e22h.default)();
    const formattedLimit = intl.formatNumber((0, $aTHox.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    }));
};

});




parcelRegister("2cLcb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("eNJPT")).default; });

var $eNJPT = parcelRequire("eNJPT");

});
parcelRegister("eNJPT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $afccc8c3590eb47f$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");
parcelRequire("8gnuK");
var $gez9l = parcelRequire("gez9l");

var $UL5H4 = parcelRequire("UL5H4");
const $afccc8c3590eb47f$var$UniformPricingTable = (props)=>{
    const { tableData: tableData = [], planTitles: planTitles } = props;
    const effectivePlanTitles = planTitles.map(({ fields: fields })=>fields.planTitleExternal);
    const transformedSections = (0, $UL5H4.transformContentfulDataToTableData)(tableData, effectivePlanTitles);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $gez9l.Table), {
        header: {
            titles: [
                "",
                ...effectivePlanTitles
            ]
        },
        sections: transformedSections
    });
};
var $afccc8c3590eb47f$export$2e2bcd8739ae039 = $afccc8c3590eb47f$var$UniformPricingTable;

});
parcelRegister("8gnuK", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return (parcelRequire("gez9l")).Table; });
parcelRequire("gez9l");

});
parcelRegister("gez9l", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return $b9a064381be18ba2$export$54ec01a60f47d33d; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");
parcelRequire("18SlM");
var $bCM0B = parcelRequire("bCM0B");

var $g48EH = parcelRequire("g48EH");

var $6JrkM = parcelRequire("6JrkM");

var $kGTi3 = parcelRequire("kGTi3");

var $4XsF0 = parcelRequire("4XsF0");
const $b9a064381be18ba2$export$54ec01a60f47d33d = (props)=>{
    const { sections: sections, header: header } = props;
    const columnCount = (0, $4XsF0.getColumnCount)(sections);
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $bCM0B.Table), {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $6JrkM.Header), (0, $6ogO3._)({}, header)),
            /*#__PURE__*/ (0, $dypTs.jsx)("tbody", {
                children: sections.map((section, sectionIndex)=>{
                    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)((0, $kGTi3.SectionHeader), {
                                sectionTitle: section.title,
                                totalColumnCount: columnCount
                            }),
                            section.rows.map((row, rowIndex)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $g48EH.ContentRow), {
                                    row: row,
                                    rowKey: `${sectionIndex}-${rowIndex}`,
                                    columnTitles: header.titles
                                }, `${sectionIndex}-${rowIndex}`))
                        ]
                    }, sectionIndex);
                })
            })
        ]
    });
};

});
parcelRegister("18SlM", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return (parcelRequire("bCM0B")).Table; });
$parcel$export(module.exports, "Row", function () { return (parcelRequire("iHkC4")).Row; });
$parcel$export(module.exports, "RowCell", function () { return (parcelRequire("iHkC4")).RowCell; });
$parcel$export(module.exports, "RowHeaderCell", function () { return (parcelRequire("iHkC4")).RowHeaderCell; });
$parcel$export(module.exports, "Head", function () { return (parcelRequire("ddllp")).Head; });
$parcel$export(module.exports, "HeadCell", function () { return (parcelRequire("ddllp")).HeadCell; });
$parcel$export(module.exports, "HeadRow", function () { return (parcelRequire("ddllp")).HeadRow; });
$parcel$export(module.exports, "SectionHeader", function () { return (parcelRequire("1Ngjn")).SectionHeader; });
$parcel$export(module.exports, "SectionHeaderCell", function () { return (parcelRequire("1Ngjn")).SectionHeaderCell; });
parcelRequire("bCM0B");
parcelRequire("iHkC4");
parcelRequire("ddllp");
parcelRequire("1Ngjn");

});
parcelRegister("bCM0B", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return $d7db4f5719f45dfe$export$54ec01a60f47d33d; });
/* table.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
parcelRequire("gljCV");
const $d7db4f5719f45dfe$export$54ec01a60f47d33d = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("table", (0, $dPABA._)((0, $6ogO3._)({}, props), {
        className: (0, $2jatx.default)([
            "_2lx21bp4 _1kqm1n9t _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _y3gn1h6o _yq5hcfaq _btyzidpf _suga1txw _1e0c5mfb"
        ])
    }));
};
const $d7db4f5719f45dfe$var$tableCss = null;

});

parcelRegister("iHkC4", function(module, exports) {
$parcel$export(module.exports, "Row", function () { return $47273071d5195ae2$export$b59bdbef9ce70de2; });
$parcel$export(module.exports, "RowHeaderCell", function () { return $47273071d5195ae2$export$90b286dd97c43ca1; });
$parcel$export(module.exports, "RowCell", function () { return $47273071d5195ae2$export$502da2b9cfd708e5; });
/* row.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("gljCV");

var $kbpa7 = parcelRequire("kbpa7");
const $47273071d5195ae2$export$b59bdbef9ce70de2 = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("tr", (0, $dPABA._)((0, $6ogO3._)({}, props), {
        className: (0, $2jatx.default)([
            "_19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhkcd5j _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o _1ckvidpf _irr31rga _1o4gu1j4 _a5ztgktf _suga1txw _1gde1bp4"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        }
    }));
};
const $47273071d5195ae2$export$90b286dd97c43ca1 = (props)=>{
    const { children: children } = props, tdProps = (0, $aPnCa._)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)("td", (0, $dPABA._)((0, $6ogO3._)({}, tdProps), {
        className: (0, $2jatx.default)([
            "_y3gnv2br _16nmgktf _1w6hgktf _gtp7150w _1kmxdlk8 _1ggmdlk8 _1ykzdlk8 _1maedlk8",
            "_s7n4jp4b _1bah1yb4 _4cvr1h6o _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _1reo15vq"
            ]),
            children: children
        })
    }));
};
const $47273071d5195ae2$export$502da2b9cfd708e5 = (props)=>{
    const { children: children = null, columnTitle: columnTitle } = props, tdProps = (0, $aPnCa._)(props, [
        "children",
        "columnTitle"
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("td", (0, $dPABA._)((0, $6ogO3._)({}, tdProps), {
        className: (0, $2jatx.default)([
            "_s7n4jp4b _1bah1yb4 _4cvr1h6o _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_181nglyw"
                ]),
                children: columnTitle
            }),
            children
        ]
    }));
};
const $47273071d5195ae2$var$rowCss = null;
const $47273071d5195ae2$var$rowHeaderCellCss = null;
const $47273071d5195ae2$var$rowHeaderCellSpanCss = null;
const $47273071d5195ae2$var$cellCss = null;
const $47273071d5195ae2$var$cellColumnTitleCss = null;

});

parcelRegister("ddllp", function(module, exports) {
$parcel$export(module.exports, "Head", function () { return $7c69262acefc007f$export$e93312b7773dfcac; });
$parcel$export(module.exports, "HeadRow", function () { return $7c69262acefc007f$export$b008e842a2213343; });
$parcel$export(module.exports, "HeadCell", function () { return $7c69262acefc007f$export$4e8024263ace498b; });
/* head.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("gljCV");

var $kbpa7 = parcelRequire("kbpa7");
const $7c69262acefc007f$export$e93312b7773dfcac = (props)=>{
    const { stickyOffset: stickyOffset } = props;
    return /*#__PURE__*/ (0, $dypTs.jsx)("thead", (0, $dPABA._)((0, $6ogO3._)({}, props), {
        className: (0, $2jatx.default)([
            "_179ru1j4 _sugaglyw _1pbykb7n _11q7cd5j"
        ]),
        style: (0, $dPABA._)((0, $6ogO3._)({}, stickyOffset === undefined ? {} : {
            top: stickyOffset,
            position: "sticky"
        }), {
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        })
    }));
};
const $7c69262acefc007f$export$b008e842a2213343 = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("tr", (0, $dPABA._)((0, $6ogO3._)({}, props), {
        className: (0, $2jatx.default)([
            "_17gvangw _7dd6v2br"
        ])
    }));
};
const $7c69262acefc007f$export$4e8024263ace498b = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("th", (0, $dPABA._)((0, $6ogO3._)({}, props), {
        scope: "col",
        className: (0, $2jatx.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        }
    }));
};
const $7c69262acefc007f$var$headCss = null;
const $7c69262acefc007f$var$headRowCss = null;
const $7c69262acefc007f$var$headCellStyles = null;

});

parcelRegister("1Ngjn", function(module, exports) {
$parcel$export(module.exports, "SectionHeader", function () { return $66888825eec09a68$export$8adb256d999cd5a0; });
$parcel$export(module.exports, "SectionHeaderCell", function () { return $66888825eec09a68$export$32421cd0bed4993f; });
/* section.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("gljCV");

var $kbpa7 = parcelRequire("kbpa7");
const $66888825eec09a68$export$8adb256d999cd5a0 = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("tr", (0, $dPABA._)((0, $6ogO3._)({}, props), {
        className: (0, $2jatx.default)([
            "_syaz1hlo _2lx21bp4 _19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhk1rga _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o _sugaglyw"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        }
    }));
};
const $66888825eec09a68$export$32421cd0bed4993f = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("td", (0, $dPABA._)((0, $6ogO3._)({}, props), {
        className: (0, $2jatx.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        }
    }));
};
const $66888825eec09a68$var$sectionHeaderCss = null;
const $66888825eec09a68$var$sectionHeaderCellCss = null;

});


parcelRegister("g48EH", function(module, exports) {
$parcel$export(module.exports, "ContentRow", function () { return $ac91e2ba30ede3f0$export$47e3a1a30e4428e1; });

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");
parcelRequire("18SlM");
var $iHkC4 = parcelRequire("iHkC4");

var $8isd5 = parcelRequire("8isd5");
const $ac91e2ba30ede3f0$export$47e3a1a30e4428e1 = (props)=>{
    const { row: row, rowKey: rowKey, columnTitles: columnTitles } = props;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $iHkC4.Row), {
        children: row.map((cell, cellIndex)=>cellIndex === 0 ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $iHkC4.RowHeaderCell), {
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $8isd5.ContentCell), {
                    isRowHeader: true,
                    cellData: cell
                })
            }, cellIndex) : /*#__PURE__*/ (0, $dypTs.jsx)((0, $iHkC4.RowCell), {
                // @ts-ignore
                columnTitle: columnTitles[cellIndex],
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $8isd5.ContentCell), {
                    cellData: cell
                })
            }, cellIndex))
    }, rowKey);
};

});
parcelRegister("8isd5", function(module, exports) {
$parcel$export(module.exports, "ContentCell", function () { return $8982ab3500f1fdb0$export$6245b75abe178459; });

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");
parcelRequire("lhjKX");
var $eTFP3 = parcelRequire("eTFP3");
const $8982ab3500f1fdb0$export$6245b75abe178459 = (props)=>{
    const { cellData: cellData, isRowHeader: isRowHeader } = props;
    if (cellData === null) return null;
    switch(cellData.type){
        case "text":
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $eTFP3.CellTextContent), {
                data: cellData,
                isRowHeader: isRowHeader
            });
        case "check":
            // @ts-ignore
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $eTFP3.CellCheckContent), {
                data: cellData
            });
        case "expander":
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $eTFP3.CellExpanderContent), {
                data: cellData
            });
        case "hyperlink":
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $eTFP3.CellHyperlinkContent), {
                data: cellData
            });
        case "render":
            return /*#__PURE__*/ (0, $dypTs.jsx)((0, $eTFP3.CellRenderContent), {
                data: cellData
            });
        default:
            return null;
    }
};

});
parcelRegister("lhjKX", function(module, exports) {
$parcel$export(module.exports, "CellCheckContent", function () { return (parcelRequire("eTFP3")).CellCheckContent; });
$parcel$export(module.exports, "CellExpanderContent", function () { return (parcelRequire("eTFP3")).CellExpanderContent; });
$parcel$export(module.exports, "CellHyperlinkContent", function () { return (parcelRequire("eTFP3")).CellHyperlinkContent; });
$parcel$export(module.exports, "CellRenderContent", function () { return (parcelRequire("eTFP3")).CellRenderContent; });
$parcel$export(module.exports, "CellTextContent", function () { return (parcelRequire("eTFP3")).CellTextContent; });
parcelRequire("eTFP3");
parcelRequire("duSbA");

});
parcelRegister("eTFP3", function(module, exports) {
$parcel$export(module.exports, "CellTextContent", function () { return $e8d9f14b2e64d6e8$export$6336b55f7613eff7; });
$parcel$export(module.exports, "CellCheckContent", function () { return $e8d9f14b2e64d6e8$export$2ff19a9fa1e2bf3d; });
$parcel$export(module.exports, "CellExpanderContent", function () { return $e8d9f14b2e64d6e8$export$9df6260913c83267; });
$parcel$export(module.exports, "CellHyperlinkContent", function () { return $e8d9f14b2e64d6e8$export$baed7aa80eb77f27; });
$parcel$export(module.exports, "CellRenderContent", function () { return $e8d9f14b2e64d6e8$export$70b9bce915221e55; });
/* cell-variants.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
parcelRequire("gljCV");

var $g3AHF = parcelRequire("g3AHF");

var $iPPTB = parcelRequire("iPPTB");

var $jE3Ci = parcelRequire("jE3Ci");

var $1DMmy = parcelRequire("1DMmy");

var $5qLu8 = parcelRequire("5qLu8");
const $e8d9f14b2e64d6e8$export$6336b55f7613eff7 = (props)=>{
    const { data: data, isRowHeader: isRowHeader } = props;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _zulpu2gc",
            isRowHeader && "_bozg1ul9"
        ]),
        children: [
            data.check && !isRowHeader && /*#__PURE__*/ (0, $dypTs.jsx)((0, $1DMmy.Checkmark), {}),
            /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                className: (0, $2jatx.default)([
                    data.check && "_1q5171o5"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $5qLu8.TextContent), {
                    data: data.value
                })
            }),
            data.lozenge && /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jE3Ci.Lozenge), {
                    text: data.lozenge
                })
            })
        ]
    });
};
const $e8d9f14b2e64d6e8$export$2ff19a9fa1e2bf3d = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $1DMmy.Checkmark), {});
};
const $e8d9f14b2e64d6e8$export$9df6260913c83267 = (props)=>{
    const { data: data } = props;
    const label = data.lozenge ? /*#__PURE__*/ (0, $dypTs.jsxs)("span", {
        children: [
            data.label,
            " ",
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $jE3Ci.Lozenge), {
                text: data.lozenge
            })
        ]
    }) : data.label;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $g3AHF.Expand), {
        label: label,
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $5qLu8.TextContent), {
            data: data.body
        })
    });
};
const $e8d9f14b2e64d6e8$export$baed7aa80eb77f27 = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $iPPTB.Link), {
        // id={rowDescId} // todo
        text: props.data.label,
        href: props.data.href,
        type: "primary",
        className: (0, $2jatx.default)([
            "_1wybdlk8 _ahbq1y44"
        ])
    });
};
const $e8d9f14b2e64d6e8$export$70b9bce915221e55 = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("span", {
        children: props.data.render()
    });
};

});
parcelRegister("1DMmy", function(module, exports) {
$parcel$export(module.exports, "Checkmark", function () { return $1003cc83ff4b093a$export$4f481e0a96cfbed6; });
/* checkmark.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("gljCV");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $1003cc83ff4b093a$export$4f481e0a96cfbed6 = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("span", {
        "data-testid": "checkmark",
        className: (0, $2jatx.default)([
            "_bfhkl30o _2rko1ssb _syazcd5j _1e0c1o8l _1o9zidpf _k48p8n31 _vwz41tcg _y3gn1h6o _4t3i1tcg _1bsb1tcg"
        ]),
        style: {
            "--_1x006p6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime700")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Icon), {
            name: "featurecheckmark",
            size: "xs",
            color: (0, $kbpa7.wacToken)("color.neutral.light0")
        })
    });
};
const $1003cc83ff4b093a$var$containerInnerCss = null;

});

parcelRegister("5qLu8", function(module, exports) {
$parcel$export(module.exports, "TextContent", function () { return $b822ff1aa8b26f77$export$1b51c6466e79404f; });
/* text-content.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $lTkkF = parcelRequire("lTkkF");
const $b822ff1aa8b26f77$export$1b51c6466e79404f = (props)=>{
    const { data: data } = props;
    if (data.type === "plaintext") return /*#__PURE__*/ (0, $dypTs.jsx)("span", {
        className: (0, $2jatx.default)([
            "_y3gnv2br _1wybdlk8 _q7gqdlk8"
        ]),
        children: data.value
    });
    if (data.type === "richtext") return /*#__PURE__*/ (0, $dypTs.jsx)("span", {
        className: (0, $2jatx.default)([
            "_y3gnv2br _1wybdlk8 _q7gqdlk8"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            text: data.value
        })
    });
    throw new Error(`unknown text-content type: ${data.type}`);
};
const $b822ff1aa8b26f77$var$textCss = null;

});


parcelRegister("duSbA", function(module, exports) {

});




parcelRegister("6JrkM", function(module, exports) {
$parcel$export(module.exports, "Header", function () { return $394fde9636baf203$export$8b251419efc915eb; });
/* header.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("gljCV");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("18SlM");
var $ddllp = parcelRequire("ddllp");
const $394fde9636baf203$export$8b251419efc915eb = (props)=>{
    const { titles: titles, stickyOffset: stickyOffset } = props;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $ddllp.Head), {
        stickyOffset: stickyOffset,
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $ddllp.HeadRow), {
            children: titles.map((heading, index)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $ddllp.HeadCell), {
                    children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulpftgi _4cvr1y6m"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_syaz1hlo _k48p1fw0"
                            ]),
                            style: {
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                            },
                            children: heading
                        })
                    })
                }, index))
        })
    });
};
const $394fde9636baf203$var$headCellDivCss = null;
const $394fde9636baf203$var$headCellSpanCss = null;

});

parcelRegister("kGTi3", function(module, exports) {
$parcel$export(module.exports, "SectionHeader", function () { return $39b6b02b7cb66183$export$8adb256d999cd5a0; });
/* section-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("18SlM");
var $1Ngjn = parcelRequire("1Ngjn");
const $39b6b02b7cb66183$export$8adb256d999cd5a0 = (props)=>{
    const { sectionTitle: sectionTitle, totalColumnCount: totalColumnCount } = props;
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $1Ngjn.SectionHeader), {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $1Ngjn.SectionHeaderCell), {
                children: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_syaz1hlo _1bsb1osq _k48p8n31 _4t3i1wug _1e0c1ule _1i4q1hna"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                    },
                    children: sectionTitle
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $dypTs.Fragment), {
                children: Array(totalColumnCount - 1).fill("").map((_, idx)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $1Ngjn.SectionHeaderCell), {}, idx))
            })
        ]
    });
};
const $39b6b02b7cb66183$var$sectionHeaderSpanCss = null;

});

parcelRegister("4XsF0", function(module, exports) {
$parcel$export(module.exports, "getColumnCount", function () { return $fb75f3d0bfe9ee25$export$813bef8f01765aa1; });
function $fb75f3d0bfe9ee25$export$813bef8f01765aa1(sections) {
    return $fb75f3d0bfe9ee25$var$getColumnCountOfRowsOfSections(sections);
}
function $fb75f3d0bfe9ee25$var$getColumnCountOfRowsOfSections(sections) {
    if (sections.length === 0) throw new Error("sections count should be > 0");
    let columnCount;
    sections.forEach((section, index)=>{
        try {
            const columnCountOfRows = $fb75f3d0bfe9ee25$var$getColumnCountOfRows(section.rows);
            if (columnCount === undefined) columnCount = columnCountOfRows;
            else {
                if (columnCount !== columnCountOfRows) throw new Error(`inconsistent number of columns: section at index ${index} contains ${columnCountOfRows} columns; expected ${columnCount} columns based on previous section(s)`);
            }
        } catch (error) {
            // @ts-ignore
            throw new Error(`error at table section index ${index}`, {
                cause: error
            });
        }
    });
    if (columnCount === undefined) throw new Error("column count is undefined");
    return columnCount;
}
function $fb75f3d0bfe9ee25$var$getColumnCountOfRows(rows) {
    if (rows.length === 0) throw new Error("rows count should be > 0");
    let columnCount;
    rows.forEach((row, index)=>{
        if (columnCount === undefined) columnCount = row.length;
        else {
            if (row.length !== columnCount) throw new Error(`inconsistent number of columns: row at index ${index} contains ${row.length} columns; expected ${columnCount} columns based on previous row(s)`);
        }
    });
    if (columnCount === undefined) throw new Error("column count is undefined");
    if (columnCount === 0) throw new Error("columnCount should not be 0");
    return columnCount;
}

});



parcelRegister("UL5H4", function(module, exports) {
$parcel$export(module.exports, "transformContentfulDataToTableData", function () { return $b05fdcdb944104b1$export$d095b9a7d993b440; });
const $b05fdcdb944104b1$export$e28b7b712925a1 = (featureGroup)=>{
    const { fields: fields } = featureGroup;
    return fields.featureGroupTitleExternal;
};
const $b05fdcdb944104b1$export$74a00f18b9031fa7 = (featureFields)=>{
    return featureFields.featureNameExternal || "";
};
const $b05fdcdb944104b1$export$c2c44121b33af1d6 = (featureFields, planTitles)=>{
    // @ts-ignore
    return planTitles.map((planTitle, i)=>{
        var _featureFields_relevantPlan, // @ts-ignore
        _featureFields_featureAdditionalInformation_find, _featureFields_featureAdditionalInformation;
        const isRelevant = (_featureFields_relevantPlan = featureFields.relevantPlan) === null || _featureFields_relevantPlan === void 0 ? void 0 : _featureFields_relevantPlan.some((plan)=>{
            var _plan_fields;
            return ((_plan_fields = plan.fields) === null || _plan_fields === void 0 ? void 0 : _plan_fields.planTitleExternal) === planTitle;
        });
        const additionalInfo = featureFields === null || featureFields === void 0 ? void 0 : (_featureFields_featureAdditionalInformation = featureFields.featureAdditionalInformation) === null || _featureFields_featureAdditionalInformation === void 0 ? void 0 : (_featureFields_featureAdditionalInformation_find = _featureFields_featureAdditionalInformation.find(// @ts-ignore
        (info)=>{
            var _info_fields_relevantPlan, _info_fields;
            return !!((_info_fields = info.fields) === null || _info_fields === void 0 ? void 0 : (_info_fields_relevantPlan = _info_fields.relevantPlan) === null || _info_fields_relevantPlan === void 0 ? void 0 : _info_fields_relevantPlan.some((plan)=>{
                var _plan_fields;
                return ((_plan_fields = plan.fields) === null || _plan_fields === void 0 ? void 0 : _plan_fields.planTitleExternal) === planTitle;
            }));
        })) === null || _featureFields_featureAdditionalInformation_find === void 0 ? void 0 : _featureFields_featureAdditionalInformation_find.fields.featureAdditionalInformation;
        // 1. if there is featureAdditionalInformation, use that as type rich text (links, etc.)
        if (additionalInfo) return {
            type: "text",
            check: additionalInfo && isRelevant,
            value: {
                type: "richtext",
                value: additionalInfo
            }
        };
        // 2. if isRelevant, use type check with empty value
        if (isRelevant) return {
            type: "check"
        };
        // 3. otherwise, use type text with empty value
        return {
            type: "text",
            value: {
                type: "plaintext",
                value: ""
            }
        };
    });
};
const $b05fdcdb944104b1$export$4de3ae5ff94aba4 = (featureFields, featureName, descriptionText)=>{
    if (featureFields.relevantUrl) return {
        type: "hyperlink",
        label: featureName,
        href: featureFields.relevantUrl
    };
    if (descriptionText) return {
        type: "expander",
        label: featureName,
        lozenge: featureFields.callOut,
        body: {
            type: "richtext",
            value: descriptionText || featureName
        }
    };
    return {
        type: "text",
        value: {
            type: "plaintext",
            value: featureName
        },
        lozenge: featureFields.callOut,
        check: false
    };
};
const $b05fdcdb944104b1$export$6fa65ac9a366ed09 = (feature, planTitles)=>{
    const featureFields = feature.fields;
    // left side column link or label
    const featureName = $b05fdcdb944104b1$export$74a00f18b9031fa7(featureFields);
    // individual cells
    const planCells = $b05fdcdb944104b1$export$c2c44121b33af1d6(featureFields, planTitles);
    // left side column
    const featureCell = $b05fdcdb944104b1$export$4de3ae5ff94aba4(featureFields, featureName, featureFields.description);
    return [
        featureCell,
        ...planCells
    ];
};
const $b05fdcdb944104b1$export$11afdf5edf7de08e = (featureGroup, planTitles)=>{
    var _featureGroup_fields_features;
    const sectionTitle = $b05fdcdb944104b1$export$e28b7b712925a1(featureGroup);
    const rows = ((_featureGroup_fields_features = featureGroup.fields.features) === null || _featureGroup_fields_features === void 0 ? void 0 : _featureGroup_fields_features.map((feature)=>$b05fdcdb944104b1$export$6fa65ac9a366ed09(feature, planTitles))) || [];
    return {
        title: sectionTitle,
        rows: rows
    };
};
const $b05fdcdb944104b1$export$d095b9a7d993b440 = (contentfulData, planTitles)=>{
    return contentfulData.map((featureGroup)=>$b05fdcdb944104b1$export$11afdf5edf7de08e(featureGroup, planTitles));
};

});



parcelRegister("6OBcA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $001148e7ad74745e$export$2e2bcd8739ae039; });

var $lPMtR = parcelRequire("lPMtR");
var $001148e7ad74745e$export$2e2bcd8739ae039 = (0, $lPMtR.default);

});
parcelRegister("lPMtR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4e8bd012cc4b17f$export$2e2bcd8739ae039; });
/* product-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");
const $d4e8bd012cc4b17f$export$fef9b561ff2e7cb1 = ({ id: id, name: name, description: description, href: href, className: className, imgSrc: imgSrc, imgAlt: imgAlt, type: type = "secondary" })=>{
    const localizedHref = (0, $kooLp.useLocalizedHref)(href !== null && href !== void 0 ? href : "");
    if (typeof href === "undefined") return null;
    const formattedHref = (0, $kooLp.isLocalizableHref)(href) ? localizedHref : href;
    const iconSize = type === "primary" ? 44 : 32;
    let normalizedId;
    if (id === "jira-software") normalizedId = "jira";
    else if (id === "atlassian-access") normalizedId = "guard";
    else if (id) // The id for some products in Contentful have "-" in between (ex. jira-service-management), so we need to remove it to match data-product-key values in the global nav
    normalizedId = id.replace(/-/g, "");
    else normalizedId = name.replace(/ /g, "").toLowerCase();
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1mouu2gc _b27r17la",
            className
        ]),
        "data-testid": "wae-product-card",
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("a", {
            href: formattedHref,
            target: (0, $kooLp.isLocalizableHref)(href) ? "" : "_blank",
            rel: (0, $kooLp.isLocalizableHref)(href) ? "" : "noreferrer",
            "aria-label": name,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "customerStories",
            "data-product-key": normalizedId,
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1aax1e5h _12l2utpp _4cvr1h6o _1bah1h6o _4t3i1ady _1bsb1ady _1wpz1q9y"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), {
                        image: {
                            src: imgSrc !== null && imgSrc !== void 0 ? imgSrc : "https://dam-cdn.atl.orangelogic.com/AssetLink/5sd7w3j2d7rdm7354yi413c5s1eo6s10.webp",
                            alt: imgAlt !== null && imgAlt !== void 0 ? imgAlt : "",
                            width: iconSize,
                            height: iconSize
                        }
                    })
                }),
                /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpv77o _1q51v77o _1tke1ady",
                        "_1b2mvd4q _gp0igktf",
                        !description && "_1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: "h6",
                            children: name
                        }),
                        description && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: "body-sm",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
const $d4e8bd012cc4b17f$var$cardStyle = null;
const $d4e8bd012cc4b17f$var$iconStyle = null;
const $d4e8bd012cc4b17f$var$textContainerStyle = null;
const $d4e8bd012cc4b17f$var$noDescriptionStyle = null;
const $d4e8bd012cc4b17f$var$overrideTextStyling = null;
var $d4e8bd012cc4b17f$export$2e2bcd8739ae039 = $d4e8bd012cc4b17f$export$fef9b561ff2e7cb1;

});


parcelRegister("emoLr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("4oasi")).default; });

var $4oasi = parcelRequire("4oasi");

});
parcelRegister("4oasi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $222f1f27398983e7$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $dZNgt = parcelRequire("dZNgt");

var $klmj6 = parcelRequire("klmj6");

var $lTkkF = parcelRequire("lTkkF");

var $kooLp = parcelRequire("kooLp");
const $222f1f27398983e7$export$228b49acf1bf4a77 = (props)=>{
    var _props_linkHref, _props_buttonHref;
    var _props_linkHref_path;
    const localizedLinkHref = (0, $kooLp.useLocalizedHref)((_props_linkHref_path = (_props_linkHref = props.linkHref) === null || _props_linkHref === void 0 ? void 0 : _props_linkHref.path) !== null && _props_linkHref_path !== void 0 ? _props_linkHref_path : "");
    var _props_buttonHref_path;
    const localizedButtonHref = (0, $kooLp.useLocalizedHref)((_props_buttonHref_path = (_props_buttonHref = props.buttonHref) === null || _props_buttonHref === void 0 ? void 0 : _props_buttonHref.path) !== null && _props_buttonHref_path !== void 0 ? _props_buttonHref_path : "");
    const callToActionProps = $222f1f27398983e7$var$transformCtaProps((0, $dPABA._)((0, $6ogO3._)({}, props), {
        linkHref: props.linkHref ? {
            path: localizedLinkHref
        } : undefined,
        buttonHref: props.buttonHref ? {
            path: localizedButtonHref
        } : undefined
    }));
    var _props_imageAlt, _props_iconAlt;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $klmj6.ProductCardBlock), {
        title: props.title,
        text: props.richText ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : props.text,
        titleAs: props.titleAs,
        logo: props.logo,
        eyebrow: props.eyebrow,
        alignment: props.alignment,
        callToActionProps: callToActionProps,
        pictureProps: props.imageUrl ? {
            image: {
                src: props.imageUrl,
                alt: (_props_imageAlt = props.imageAlt) !== null && _props_imageAlt !== void 0 ? _props_imageAlt : ""
            }
        } : undefined,
        spotIllustrationUrl: props.spotIllustrationUrl,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize,
                alt: (_props_iconAlt = props.iconAlt) !== null && _props_iconAlt !== void 0 ? _props_iconAlt : ""
            }
        } : undefined,
        orientation: props.orientation,
        columns: props.columns,
        backgroundColor: props.backgroundColor
    });
};
function $222f1f27398983e7$var$transformCtaProps({ buttonHref: buttonHref, buttonLabel: buttonLabel, buttonVariant: buttonVariant, linkHref: linkHref, linkText: linkText, linkType: linkType }) {
    const isButton = !!(buttonHref === null || buttonHref === void 0 ? void 0 : buttonHref.path) && !!buttonLabel;
    const isLink = !!(linkHref === null || linkHref === void 0 ? void 0 : linkHref.path) && !!linkText;
    if (isButton || isLink) {
        const ctaProps = {
            button: isButton ? {
                href: buttonHref.path,
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event-component": "linkButton",
                    "data-event-container": "productCardBlock",
                    "data-event": "clicked",
                    "data-label": buttonLabel
                }
            } : undefined,
            buttonText: buttonLabel !== null && buttonLabel !== void 0 ? buttonLabel : undefined,
            buttonVariant: buttonVariant !== null && buttonVariant !== void 0 ? buttonVariant : undefined,
            link: isLink ? {
                href: linkHref.path,
                text: linkText,
                type: linkType,
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event-component": "linkButton",
                    "data-event-container": "productCardBlock",
                    "data-event": "clicked",
                    "data-label": linkText
                }
            } : undefined
        };
        return ctaProps;
    }
    return undefined;
}
var $222f1f27398983e7$export$2e2bcd8739ae039 = $222f1f27398983e7$export$228b49acf1bf4a77;

});
parcelRegister("klmj6", function(module, exports) {
$parcel$export(module.exports, "ProductCardBlock", function () { return $7ee1c2a1142c9873$export$c17e706797abe921; });
/* product-card-block.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $63bv7 = parcelRequire("63bv7");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");
const $7ee1c2a1142c9873$export$9bc3333acc9b342f = {
    jira: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.JiraIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Jira logo",
        text: "Jira"
    },
    jiraProductDiscovery: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.JiraProductDiscoveryIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Jira Product Discovery logo",
        text: "Jira Product Discovery"
    },
    jiraServiceManagement: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.JiraServiceManagementIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Jira Service Management logo",
        text: "Jira Service Management"
    },
    statuspage: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.StatuspageIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Statuspage logo",
        text: "Statuspage"
    },
    confluence: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.ConfluenceIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Confluence logo",
        text: "Confluence"
    },
    trello: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.TrelloIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Trello logo",
        text: "Trello"
    },
    loom: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.LoomIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Loom logo",
        text: "Loom"
    },
    bitbucket: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.BitbucketIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Bitbucket logo",
        text: "Bitbucket"
    },
    rovoDev: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/m075131gef201aeok8g484w063t363hc.svg",
        alt: "Rovo Dev logo",
        text: "Rovo Dev",
        image: true
    },
    compass: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.CompassIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Compass logo",
        text: "Compass"
    },
    guard: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.GuardIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Guard logo",
        text: "Guard"
    },
    focus: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.FocusIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Focus logo",
        text: "Focus"
    },
    talent: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.TalentIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Talent logo",
        text: "Talent"
    },
    rovo: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/qe401oio4a2o006h83v3861f5xg6gc76.svg",
        alt: "Rovo logo",
        text: "Rovo",
        image: true
    },
    jiraAlign: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.JiraAlignIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Jira Align logo",
        text: "Jira Align"
    },
    assets: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.AssetsIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Assets logo",
        text: "Assets"
    },
    customerServiceManagement: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.CustomerServiceManagementIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Customer Service Management logo",
        text: "Customer Service Management"
    },
    bamboo: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.BambooIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Bamboo logo",
        text: "Bamboo"
    },
    pipelines: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/w5y63772u3hv13stbj352ut7x2h001jf.svg",
        alt: "Pipelines logo",
        text: "Pipelines",
        image: true
    },
    dx: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1mx06b178gpdjg8u7kjg38ci80p80eln.svg",
        alt: "DX logo",
        text: "DX",
        image: true
    },
    sourcetree: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1o5et30ftpu1nt3m25bbcmg44k5apcr6.svg",
        alt: "SourceTree logo",
        text: "SourceTree",
        image: true
    },
    teamworkCollection: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/78ylq28783ef6w7c21vu5y84ngku10fx.svg",
        alt: "Teamwork Collection logo",
        height: 20
    },
    strategyCollection: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/h5mj8675hs2i21g7687jagjoax1uy14n.svg",
        alt: "Strategy Collection logo",
        height: 20
    },
    serviceCollection: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/f481qls2e2g883b2us2ek546yg4c44g1.svg",
        alt: "Service Collection logo",
        height: 20
    },
    softwareCollection: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1j5jdr1kj625ayo48v421j3o05hg8nkg.svg",
        alt: "Software Collection logo",
        height: 20
    },
    crowd: {
        src: /*#__PURE__*/ (0, $dypTs.jsx)((0, $63bv7.CrowdIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Crowd logo",
        text: "Crowd"
    }
};
const $7ee1c2a1142c9873$var$imageStyle = null;
const $7ee1c2a1142c9873$var$zeroMarginCss = null;
const $7ee1c2a1142c9873$var$hyphenStyles = null;
const $7ee1c2a1142c9873$var$iconSizes = {
    "x-small": 24,
    "small": 32,
    "medium": 48,
    "large": 64
};
const $7ee1c2a1142c9873$var$contentColumnsLayout = {
    10: {
        assetSpan: 3,
        contentStart: 2
    },
    // 10 columns content block means 3 columns for asset, 7 for text
    12: {
        assetSpan: 4,
        contentStart: 1
    }
};
const $7ee1c2a1142c9873$var$renderCta = ({ ctaProps: ctaProps, buttonSize: buttonSize, alignment: alignment, backgroundColor: backgroundColor, titleId: titleId, callToActionId: callToActionId })=>{
    var _ctaProps_buttonVariant;
    if ("button" in ctaProps && ctaProps.button !== undefined) return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1n261g80 _zulpv47k _4cvr1h6o _1bahmqo6 _e8gh6xil _msuptoro"
        ]),
        style: {
            "--_1n7hwam": (0, $6ZVlx.default)(typeof alignment === "string" ? alignment : alignment.mobile),
            "--_1szc1oo": (0, $6ZVlx.default)(typeof alignment === "string" ? alignment : alignment.tablet),
            "--_1gtp2l2": (0, $6ZVlx.default)(typeof alignment === "string" ? alignment : alignment.desktop)
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $lqyi6.Button), (0, $dPABA._)((0, $6ogO3._)({}, ctaProps.button), {
                size: buttonSize,
                variant: backgroundColor && backgroundColor === "#1868DB" && (ctaProps.buttonVariant === "primary" || !ctaProps.buttonVariant) ? "secondary" : (_ctaProps_buttonVariant = ctaProps.buttonVariant) !== null && _ctaProps_buttonVariant !== void 0 ? _ctaProps_buttonVariant : "primary",
                colorAgainst: backgroundColor === "#1868DB" ? "other" : "white",
                className: (0, $2jatx.default)([
                    "_i0dl1ris"
                ]),
                children: ctaProps.buttonText
            })),
            ctaProps.link && // eslint-disable-next-line @atlassian/a11y/anchor-has-content -- Link component renders text content via the text prop from ctaProps.link
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $iPPTB.Link), (0, $6ogO3._)({
                id: callToActionId,
                ariaLabelledby: `${callToActionId} ${titleId}`,
                type: "primary",
                bgColor: $7ee1c2a1142c9873$var$isDarkBackgroundColor(backgroundColor) ? "bgBlackBlue" : "bgWhite"
            }, ctaProps.link))
        ]
    });
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iPPTB.Link), (0, $6ogO3._)({
            id: callToActionId,
            ariaLabelledby: `${callToActionId} ${titleId}`,
            "aria-label": `${callToActionId} ${titleId}`,
            type: "primary",
            bgColor: $7ee1c2a1142c9873$var$isDarkBackgroundColor(backgroundColor) ? "bgBlackBlue" : "bgWhite"
        }, ctaProps.link))
    });
};
const $7ee1c2a1142c9873$var$renderIcon = (icon)=>{
    if (icon === null || icon === void 0 ? void 0 : icon.linkedIcon) {
        var _icon_linkedIcon;
        const linkedIconSize = (icon === null || icon === void 0 ? void 0 : (_icon_linkedIcon = icon.linkedIcon) === null || _icon_linkedIcon === void 0 ? void 0 : _icon_linkedIcon.size) ? $7ee1c2a1142c9873$var$iconSizes[icon.linkedIcon.size] : $7ee1c2a1142c9873$var$iconSizes["medium"];
        var _icon_linkedIcon_alt;
        return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), {
                image: {
                    src: icon.linkedIcon.url,
                    alt: (_icon_linkedIcon_alt = icon.linkedIcon.alt) !== null && _icon_linkedIcon_alt !== void 0 ? _icon_linkedIcon_alt : "",
                    width: linkedIconSize,
                    height: linkedIconSize
                }
            })
        });
    }
    if (icon === null || icon === void 0 ? void 0 : icon.iconComponent) return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        children: icon.iconComponent
    });
    return null;
};
const $7ee1c2a1142c9873$var$isDarkBackgroundColor = (color)=>{
    return color ? [
        "#1868DB",
        "#101214"
    ].includes(color) : false;
};
const $7ee1c2a1142c9873$export$c17e706797abe921 = (_param)=>{
    var { logo: logo, eyebrow: eyebrow, title: title, text: text, pictureProps: pictureProps, spotIllustrationUrl: spotIllustrationUrl, icon: icon, callToActionProps: callToActionProps, alignment: alignment = "start", orientation: orientation = "vertical", columns: columns = 10, backgroundColor: backgroundColor } = _param, props = (0, $aPnCa._)(_param, [
        "logo",
        "eyebrow",
        "title",
        "text",
        "pictureProps",
        "spotIllustrationUrl",
        "icon",
        "callToActionProps",
        "alignment",
        "orientation",
        "columns",
        "backgroundColor"
    ]);
    var _ProductCardBlockLogoLockups_logo, _ProductCardBlockLogoLockups_logo1, _ProductCardBlockLogoLockups_logo2, _ProductCardBlockLogoLockups_logo3, _ProductCardBlockLogoLockups_logo4, _ProductCardBlockLogoLockups_logo5;
    // hedge against the value being passed in as a string (the options in uniform can only be string values)
    // which would subsequently fail a string vs number check ie 10 === "10" is false
    const numColumns = Number(columns);
    const { titleAs: TitleComponent = "h3" } = props;
    const isSmallDetailStyling = [
        "h4"
    ].includes(TitleComponent);
    const isLargeTextStyling = TitleComponent === "h2";
    const buttonSize = isSmallDetailStyling ? "small" : "large";
    const uniqueId = (0, $gljCV.useId)();
    const titleId = (title ? title.replace(/\s+/g, "") : "title") + `-${uniqueId}`;
    const callToActionId = ((callToActionProps === null || callToActionProps === void 0 ? void 0 : callToActionProps.link) ? callToActionProps.link.text.replace(/\s+/g, "") : "call-to-action") + `-${uniqueId}`;
    const lightTextStyles = null;
    const textElement = typeof text === "string" ? /*#__PURE__*/ (0, $dypTs.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            $7ee1c2a1142c9873$var$isDarkBackgroundColor(backgroundColor) && "_125xcd5j _9wqlcd5j _1loecd5j _cg41cd5j _qliycd5j _1rhqcd5j",
            isLargeTextStyling ? "body-lg" : "body-md"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: text
    }) : text;
    const bgColorStyle = null;
    var _ProductCardBlockLogoLockups_logo_height, _ProductCardBlockLogoLockups_logo_height1;
    const textContent = /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb _1q511z08 _1bah1yb4 _1b1q1cw5 _4t3i1osq",
            $7ee1c2a1142c9873$var$isDarkBackgroundColor(backgroundColor) && "_125xcd5j _9wqlcd5j _1loecd5j _cg41cd5j _qliycd5j _1rhqcd5j"
        ]),
        style: {
            "--_jsl571": (0, $6ZVlx.default)(orientation === "horizontal" ? "var(--ds-space-100, 8px)" : undefined),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp1ejb"
                ]),
                children: [
                    logo && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1y6m _zulpu2gc"
                        ]),
                        children: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo] && "text" in $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo] ? /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
                            children: [
                                $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo].image ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), {
                                    image: {
                                        src: (_ProductCardBlockLogoLockups_logo = $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]) === null || _ProductCardBlockLogoLockups_logo === void 0 ? void 0 : _ProductCardBlockLogoLockups_logo.src,
                                        alt: (_ProductCardBlockLogoLockups_logo1 = $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]) === null || _ProductCardBlockLogoLockups_logo1 === void 0 ? void 0 : _ProductCardBlockLogoLockups_logo1.alt,
                                        height: (_ProductCardBlockLogoLockups_logo_height = (_ProductCardBlockLogoLockups_logo2 = $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]) === null || _ProductCardBlockLogoLockups_logo2 === void 0 ? void 0 : _ProductCardBlockLogoLockups_logo2.height) !== null && _ProductCardBlockLogoLockups_logo_height !== void 0 ? _ProductCardBlockLogoLockups_logo_height : 32
                                    }
                                }) : $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo].src,
                                /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_ect41pz4 _1wybqslr _zg8l4jg8 _k48p1nn1 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1ule"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                    },
                                    children: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo].text
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), {
                            image: {
                                src: (_ProductCardBlockLogoLockups_logo3 = $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]) === null || _ProductCardBlockLogoLockups_logo3 === void 0 ? void 0 : _ProductCardBlockLogoLockups_logo3.src,
                                alt: (_ProductCardBlockLogoLockups_logo4 = $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]) === null || _ProductCardBlockLogoLockups_logo4 === void 0 ? void 0 : _ProductCardBlockLogoLockups_logo4.alt,
                                height: (_ProductCardBlockLogoLockups_logo_height1 = (_ProductCardBlockLogoLockups_logo5 = $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]) === null || _ProductCardBlockLogoLockups_logo5 === void 0 ? void 0 : _ProductCardBlockLogoLockups_logo5.height) !== null && _ProductCardBlockLogoLockups_logo_height1 !== void 0 ? _ProductCardBlockLogoLockups_logo_height1 : 32
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulpu2gc",
                            "product-card-block-text-content"
                        ]),
                        children: [
                            eyebrow && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "_syazw8v6",
                                    isSmallDetailStyling ? "eyebrow-sm" : "eyebrow-md"
                                ]),
                                style: {
                                    "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                },
                                children: eyebrow
                            }),
                            title && /*#__PURE__*/ (0, $dypTs.jsx)(TitleComponent, {
                                id: titleId,
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "_ct361wug"
                                ]),
                                children: title
                            }),
                            text && textElement
                        ]
                    })
                ]
            }),
            callToActionProps && $7ee1c2a1142c9873$var$renderCta({
                ctaProps: callToActionProps,
                buttonSize: buttonSize,
                alignment: alignment,
                backgroundColor: backgroundColor,
                titleId: titleId,
                callToActionId: callToActionId
            })
        ]
    });
    const assetStyles = null;
    const horizontalSpotIllustrationStyles = null;
    const assetContent = pictureProps ? /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1b1q7d4p"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), (0, $dPABA._)((0, $6ogO3._)({}, pictureProps), {
            className: (0, $2jatx.default)([
                "_18zxcq2i _mezj1osq _bna71wug _1jpx1f51"
            ])
        }))
    }) : spotIllustrationUrl ? /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1b1q7d4p",
            "_181n1txw _q8t51h6o _e8gh1h6o"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), {
            image: {
                src: spotIllustrationUrl,
                alt: "",
                width: 236,
                height: 236
            }
        })
    }) : icon ? $7ee1c2a1142c9873$var$renderIcon(icon) : null;
    const gapBetweenIconAndText = null;
    const productCardPadding = null;
    if (orientation === "vertical") return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e1faxbu",
            "_1yt41ejb",
            "_y3gnmqo6 _uj6k6xil _10hltoro _1e0c1txw _2lx21bp4 _zulp1ejb _11q79r5u _4cvr1fhb _1bah1fhb _4t3i1osq",
            icon && "_zulppxbi",
            "_2rkovwyg _19ityzqy"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1n7hwam": (0, $6ZVlx.default)(typeof alignment === "string" ? alignment : alignment.mobile),
            "--_1szc1oo": (0, $6ZVlx.default)(typeof alignment === "string" ? alignment : alignment.tablet),
            "--_1gtp2l2": (0, $6ZVlx.default)(typeof alignment === "string" ? alignment : alignment.desktop),
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: [
            assetContent,
            textContent
        ]
    });
    const fullWidthGridStyles = null;
    const horizontalProductCard = /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1yt41ejb",
            "_195g1wug _p12f1osq _1bsb1osq _13ltwklj _1j8bcx6w _1vsw1vi7 _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg",
            "_1e1faxbu",
            "_kqswh2mm _1pbykb7n _1v6z18hw _1oyhxrvy",
            !backgroundColor && "_2rkovwyg _19ityzqy"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_vimf9d": (0, $6ZVlx.default)(orientation === "horizontal-reverse" ? $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["contentStart"] : $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["contentStart"] + $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["assetSpan"]),
            "--_1seowu7": (0, $6ZVlx.default)(numColumns - $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["assetSpan"]),
            "--_tnqi0k": (0, $6ZVlx.default)(orientation === "horizontal" ? $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["contentStart"] : $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["contentStart"] + numColumns - $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["assetSpan"]),
            "--_1u7gek8": (0, $6ZVlx.default)($7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["assetSpan"]),
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: [
            orientation === "horizontal" ? assetContent : null,
            textContent,
            orientation === "horizontal-reverse" ? assetContent : null
        ]
    });
    switch(numColumns){
        case 10:
        case 12:
            if (backgroundColor) return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e1faxbu",
                    "_2rkovwyg _19ityzqy",
                    "_1bsb1osq _kqswh2mm"
                ]),
                style: {
                    "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                },
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1bsbauwl _14b5zqdx _b8yq87gh _4t3i1osq _1e021ssb _t9eczr6s _11q79r5u _2rkovwyg"
                        ]),
                        style: {
                            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
                        }
                    }),
                    horizontalProductCard
                ]
            });
            return horizontalProductCard;
    }
};
const $7ee1c2a1142c9873$var$borderRadiusStyle = null;

});



parcelRegister("5h2w8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $60abb2db3cc87aa2$export$2e2bcd8739ae039; });

var $2fk4i = parcelRequire("2fk4i");
var $60abb2db3cc87aa2$export$2e2bcd8739ae039 = (0, $2fk4i.PullQuote);

});

parcelRegister("8Ocd4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("exkom")).default; });

var $exkom = parcelRequire("exkom");

});
parcelRegister("exkom", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5ee40bb10698e2e3$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $fboYQ = parcelRequire("fboYQ");

var $1xzPJ = parcelRequire("1xzPJ");

var $cwkIh = parcelRequire("cwkIh");

var $l5Cys = parcelRequire("l5Cys");
parcelRequire("deC8f");
var $3Nxop = parcelRequire("3Nxop");

var $7iwdN = parcelRequire("7iwdN");

var $7pPqA = parcelRequire("7pPqA");
const $5ee40bb10698e2e3$var$pageBasePath = (0, $7iwdN.CLOUD_BASE_PATH);
const $5ee40bb10698e2e3$var$UniformRoadmapFeatures = (props)=>{
    const { data: ssrData, roadmapFeaturesLocale: roadmapFeaturesLocale } = props;
    const { filters: filters, sortCriteria: sortCriteria, selectedFeature: selectedFeature } = (0, $gljCV.useMemo)(()=>{
        var _getQueryParamFromWindow;
        if (typeof window === "undefined") return {
            filters: (0, $7iwdN.emptyFilters),
            sortCriteria: undefined,
            selectedFeature: undefined
        };
        const filters = {
            category: (0, $7pPqA.getQueryParamFromWindow)("category"),
            search: (0, $7pPqA.getQueryParamFromWindow)("search"),
            status: (0, $7pPqA.getQueryParamFromWindow)("status"),
            selectedProduct: (0, $7pPqA.getQueryParamFromWindow)("selectedProduct")
        };
        const sortCriteria = {
            key: (0, $7pPqA.getQueryParamFromWindow)("sortBy")[0],
            direction: (0, $7pPqA.getQueryParamFromWindow)("sort")[0]
        };
        let selectedFeature;
        const slug = (0, $7pPqA.getSlugFromWindow)({
            basePath: $5ee40bb10698e2e3$var$pageBasePath
        });
        if (slug) selectedFeature = {
            pid: (_getQueryParamFromWindow = (0, $7pPqA.getQueryParamFromWindow)("p")) === null || _getQueryParamFromWindow === void 0 ? void 0 : _getQueryParamFromWindow[0],
            slug: slug
        };
        return {
            filters: filters,
            sortCriteria: sortCriteria,
            selectedFeature: selectedFeature
        };
    }, []);
    const { result: csrData } = (0, $fboYQ.useQuery)({
        locale: roadmapFeaturesLocale
    });
    var _csrData_roadmapFeatureCollection_items;
    const features = (_csrData_roadmapFeatureCollection_items = csrData === null || csrData === void 0 ? void 0 : csrData.roadmapFeatureCollection.items) !== null && _csrData_roadmapFeatureCollection_items !== void 0 ? _csrData_roadmapFeatureCollection_items : ssrData.roadmapFeatureCollection.items;
    var _ssrData_taxonomyRoadmapCategoryCollection_items_map, _ssrData_taxonomyRoadmapAppCollection_items_map, _ssrData_taxonomyRoadmapStatusCollection_items_map;
    const filterOptionsByKey = {
        category: (_ssrData_taxonomyRoadmapCategoryCollection_items_map = ssrData === null || ssrData === void 0 ? void 0 : ssrData.taxonomyRoadmapCategoryCollection.items.map((item)=>({
                value: item.queryParameter,
                label: item.roadmapCategoryNameExternal
            }))) !== null && _ssrData_taxonomyRoadmapCategoryCollection_items_map !== void 0 ? _ssrData_taxonomyRoadmapCategoryCollection_items_map : [],
        selectedProduct: (_ssrData_taxonomyRoadmapAppCollection_items_map = ssrData === null || ssrData === void 0 ? void 0 : ssrData.taxonomyRoadmapAppCollection.items.map((item)=>({
                value: item.filterQueryParam,
                label: item.roadmapAppNameExternal
            }))) !== null && _ssrData_taxonomyRoadmapAppCollection_items_map !== void 0 ? _ssrData_taxonomyRoadmapAppCollection_items_map : [],
        status: (_ssrData_taxonomyRoadmapStatusCollection_items_map = ssrData === null || ssrData === void 0 ? void 0 : ssrData.taxonomyRoadmapStatusCollection.items.map((item)=>({
                value: item.roadmapStatusNameExternal,
                label: item.roadmapStatusNameExternal
            }))) !== null && _ssrData_taxonomyRoadmapStatusCollection_items_map !== void 0 ? _ssrData_taxonomyRoadmapStatusCollection_items_map : []
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $7iwdN.RoadmapFeaturesContextProvider), {
        pageBasePath: $5ee40bb10698e2e3$var$pageBasePath,
        filters: filters,
        sortCriteria: sortCriteria,
        selectedFeature: selectedFeature,
        features: features,
        filterOptionsByKey: filterOptionsByKey,
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $l5Cys.Layout), {
            searchWithFilters: /*#__PURE__*/ (0, $dypTs.jsx)((0, $3Nxop.SearchWithFilters), {}),
            columnHeaders: /*#__PURE__*/ (0, $dypTs.jsx)((0, $cwkIh.ColumnHeaders), {}),
            cards: /*#__PURE__*/ (0, $dypTs.jsx)((0, $1xzPJ.Cards), {})
        })
    });
};
var $5ee40bb10698e2e3$export$2e2bcd8739ae039 = $5ee40bb10698e2e3$var$UniformRoadmapFeatures;

});
parcelRegister("fboYQ", function(module, exports) {
$parcel$export(module.exports, "useQuery", function () { return $e0787dfb3b69a913$export$dd0a697e1782aedd; });

var $gljCV = parcelRequire("gljCV");

var $hoxx0 = parcelRequire("hoxx0");
function $e0787dfb3b69a913$export$dd0a697e1782aedd(props) {
    const { locale: locale } = props;
    const [result, setResult] = (0, $gljCV.useState)(undefined);
    const [pending, setPending] = (0, $gljCV.useState)(false);
    (0, $gljCV.useEffect)(()=>{
        setPending(true);
        (0, $hoxx0.getRoadmapFeatures)({
            locale: locale,
            limit: (0, $hoxx0.ROADMAP_FEATURES_ALL_ITEMS_PAGE_SIZE)
        }).then(setResult).finally(()=>{
            setPending(false);
        });
    }, []);
    return {
        result: result,
        pending: pending
    };
}

});

parcelRegister("1xzPJ", function(module, exports) {
$parcel$export(module.exports, "Cards", function () { return $798cc825a6441e0c$export$c8d38e0dcc0f5a1; });
/* cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $2LBZM = parcelRequire("2LBZM");

var $20kWR = parcelRequire("20kWR");
const $798cc825a6441e0c$export$c8d38e0dcc0f5a1 = ()=>{
    const features = (0, $2LBZM.useFilteredAndSortedRoadmapFeatures)();
    if (!features) return null;
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb"
        ]),
        children: features.map((data)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $20kWR.Card), {
                data: data
            }, data.slug))
    });
};
const $798cc825a6441e0c$var$cardsCss = null;

});
parcelRegister("2LBZM", function(module, exports) {
$parcel$export(module.exports, "useFilteredAndSortedRoadmapFeatures", function () { return $ffa62b15e7d75df3$export$be6200d55ad2dcf6; });
$parcel$export(module.exports, "useSetFilter", function () { return $ffa62b15e7d75df3$export$a522d27da4074c2; });
$parcel$export(module.exports, "useFilter", function () { return $ffa62b15e7d75df3$export$3274cf84b703fff; });
$parcel$export(module.exports, "useSetSearch", function () { return $ffa62b15e7d75df3$export$a23792301e1faab8; });
$parcel$export(module.exports, "useSort", function () { return $ffa62b15e7d75df3$export$6292515ceca0b297; });
$parcel$export(module.exports, "useFilterOptions", function () { return $ffa62b15e7d75df3$export$e00e2ace74badd4e; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7iwdN = parcelRequire("7iwdN");

var $2OD6N = parcelRequire("2OD6N");

var $7pPqA = parcelRequire("7pPqA");
const $ffa62b15e7d75df3$export$be6200d55ad2dcf6 = ()=>{
    const { features: features, filters: filters, sortCriteria: sortCriteria } = (0, $7iwdN.useRoadmapFeaturesContext)();
    if (!features) return null;
    return (0, $2OD6N.getFilteredAndSortedRoadmapFeatures)({
        features: features,
        filters: filters,
        sortCriteria: sortCriteria
    });
};
const $ffa62b15e7d75df3$export$a522d27da4074c2 = ()=>{
    const { setFilters: setFilters } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function setFilter(filterKey, values) {
        (0, $7pPqA.setQueryParam)(filterKey, values);
        setFilters((prev)=>(0, $dPABA._)((0, $6ogO3._)({}, prev), {
                [filterKey]: values
            }));
    };
};
const $ffa62b15e7d75df3$export$7eba469e65994459 = ()=>{
    const { setFilters: setFilters } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function clearFilter(filterKey) {
        (0, $7pPqA.setQueryParam)(filterKey, []);
        setFilters((prev)=>(0, $dPABA._)((0, $6ogO3._)({}, prev), {
                [filterKey]: []
            }));
    };
};
const $ffa62b15e7d75df3$export$3274cf84b703fff = (filterKey)=>{
    const { filters: filters } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return filters[filterKey];
};
const $ffa62b15e7d75df3$export$a23792301e1faab8 = ()=>{
    const setFilter = $ffa62b15e7d75df3$export$a522d27da4074c2();
    return function setSearch(value) {
        setFilter("search", [
            value
        ]);
    };
};
const $ffa62b15e7d75df3$export$bd221a7c56b93941 = ()=>{
    const { filters: filters } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return filters.search[0];
};
const $ffa62b15e7d75df3$export$7e1378d2861c08e9 = ()=>{
    const ctx = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function setSelectedFeature(feature) {
        (0, $7pPqA.setQueryParam)("p", []);
        if (feature.pid) (0, $7pPqA.setQueryParam)("p", [
            feature.pid
        ]);
        (0, $7pPqA.setSlug)(feature.slug, {
            basePath: ctx.pageBasePath
        });
        ctx.setSelectedFeature(feature);
    };
};
const $ffa62b15e7d75df3$export$60c6c640e9838831 = ()=>(0, $7iwdN.useRoadmapFeaturesContext)().selectedFeature;
const $ffa62b15e7d75df3$export$848481c86eff5af3 = ()=>{
    const ctx = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function clearSelectedFeature() {
        (0, $7pPqA.setQueryParam)("p", []);
        (0, $7pPqA.clearSlug)({
            basePath: ctx.pageBasePath
        });
        ctx.setSelectedFeature(undefined);
    };
};
const $ffa62b15e7d75df3$export$5b8a3c885421eb7c = ()=>{
    const ctx = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function setSortCriteria(sortCriteria) {
        if (sortCriteria === undefined) {
            ctx.setSortCriteria(undefined);
            (0, $7pPqA.setQueryParams)({
                sortBy: [],
                sort: []
            });
            return;
        }
        const { key: key, direction: direction } = sortCriteria;
        ctx.setSortCriteria({
            key: key,
            direction: direction
        });
        (0, $7pPqA.setQueryParams)({
            sortBy: [
                key
            ],
            sort: [
                direction
            ]
        });
    };
};
const $ffa62b15e7d75df3$export$6292515ceca0b297 = (key)=>{
    const ctx = (0, $7iwdN.useRoadmapFeaturesContext)();
    const setSortCriteria = $ffa62b15e7d75df3$export$5b8a3c885421eb7c();
    if (!ctx.sortCriteria || ctx.sortCriteria.key !== key) return {
        sortDirection: undefined,
        onClick: ()=>{
            setSortCriteria({
                key: key,
                direction: "asc"
            });
        }
    };
    const sortDirection = ctx.sortCriteria.direction;
    return {
        sortDirection: ctx.sortCriteria.direction,
        onClick: ()=>{
            if (sortDirection === undefined) setSortCriteria({
                key: key,
                direction: "asc"
            });
            if (sortDirection === "asc") setSortCriteria({
                key: key,
                direction: "desc"
            });
            if (sortDirection === "desc") setSortCriteria(undefined);
        }
    };
};
const $ffa62b15e7d75df3$export$e00e2ace74badd4e = (filterKey)=>{
    const { filterOptionsByKey: filterOptionsByKey } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return filterOptionsByKey[filterKey].sort((a, b)=>a.label > b.label ? 1 : -1);
};
const $ffa62b15e7d75df3$export$7ae092e5866bd7d3 = ()=>{
    const setFilter = $ffa62b15e7d75df3$export$a522d27da4074c2();
    const setSortCriteria = $ffa62b15e7d75df3$export$5b8a3c885421eb7c();
    return function reset() {
        setSortCriteria(undefined);
        setFilter("search", []);
        setFilter("status", []);
        setFilter("category", []);
        setFilter("selectedProduct", []);
    };
};

});
parcelRegister("7iwdN", function(module, exports) {
$parcel$export(module.exports, "CLOUD_BASE_PATH", function () { return $3ab8d70c989cf75c$export$6d5070f150ecd91; });
$parcel$export(module.exports, "useRoadmapFeaturesContext", function () { return $3ab8d70c989cf75c$export$8bb3881bbfbce6f5; });
$parcel$export(module.exports, "RoadmapFeaturesContextProvider", function () { return $3ab8d70c989cf75c$export$cc9094b62665bcf1; });
$parcel$export(module.exports, "emptyFilters", function () { return $3ab8d70c989cf75c$export$68abacd3bc566b56; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");
const $3ab8d70c989cf75c$export$6d5070f150ecd91 = "/roadmap/cloud";
const $3ab8d70c989cf75c$export$c66cccefb563e9a1 = "/roadmap/data-center";
const $3ab8d70c989cf75c$var$RoadmapFeaturesContext = /*#__PURE__*/ (0, $gljCV.createContext)(undefined);
const $3ab8d70c989cf75c$export$8bb3881bbfbce6f5 = ()=>{
    const ctx = (0, $gljCV.useContext)($3ab8d70c989cf75c$var$RoadmapFeaturesContext);
    if (!ctx) throw new Error("missing context provider for RoadmapFeaturesContext");
    return ctx;
};
const $3ab8d70c989cf75c$export$cc9094b62665bcf1 = (props)=>{
    const { pageBasePath: pageBasePath, filterOptionsByKey: filterOptionsByKey } = props;
    var _props_filters;
    // filters
    const initialFilters = $3ab8d70c989cf75c$var$getInitialFilters((_props_filters = props.filters) !== null && _props_filters !== void 0 ? _props_filters : {});
    const [filters, setFilters] = (0, $gljCV.useState)(initialFilters);
    // sort
    const [sortCriteria, setSortCriteria] = (0, $gljCV.useState)(props.sortCriteria);
    // selected feature
    const [selectedFeature, setSelectedFeature] = (0, $gljCV.useState)(props.selectedFeature);
    // results
    const [features, setFeatures] = (0, $gljCV.useState)(props.features);
    (0, $gljCV.useEffect)(()=>{
        setFeatures(props.features);
    }, [
        props.features
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)($3ab8d70c989cf75c$var$RoadmapFeaturesContext.Provider, {
        value: {
            pageBasePath: pageBasePath,
            features: features,
            setFeatures: setFeatures,
            filters: filters,
            setFilters: setFilters,
            filterOptionsByKey: filterOptionsByKey,
            sortCriteria: sortCriteria,
            setSortCriteria: setSortCriteria,
            selectedFeature: selectedFeature,
            setSelectedFeature: setSelectedFeature
        },
        children: props.children
    });
};
const $3ab8d70c989cf75c$export$68abacd3bc566b56 = {
    category: [],
    status: [],
    search: [],
    selectedProduct: []
};
function $3ab8d70c989cf75c$var$getInitialFilters(filters) {
    return (0, $6ogO3._)({}, $3ab8d70c989cf75c$export$68abacd3bc566b56, filters);
}

});

parcelRegister("2OD6N", function(module, exports) {
$parcel$export(module.exports, "getFilteredAndSortedRoadmapFeatures", function () { return $c1e231f117ad5b91$export$e45024fbc7d2fc41; });
function $c1e231f117ad5b91$export$e45024fbc7d2fc41(args) {
    const { features: features, filters: filters, sortCriteria: sortCriteria } = args;
    let filtered = features.filter((feature)=>{
        return $c1e231f117ad5b91$var$matchesCategory(feature, filters.category) && $c1e231f117ad5b91$var$matchesSelectedProduct(feature, filters.selectedProduct) && $c1e231f117ad5b91$var$matchesSearch(feature, filters.search) && $c1e231f117ad5b91$var$matchesStatus(feature, filters.status);
    });
    if (sortCriteria) filtered = [
        ...filtered
    ].sort((a, b)=>$c1e231f117ad5b91$var$compareFeatures(a, b, sortCriteria));
    return filtered;
}
function $c1e231f117ad5b91$var$extractTextFromJson(json) {
    if (typeof json === "string") return json;
    if (typeof json === "number" || typeof json === "boolean") return String(json);
    if (json === null || json === undefined) return "";
    if (Array.isArray(json)) return json.map((item)=>$c1e231f117ad5b91$var$extractTextFromJson(item)).join(" ");
    if (typeof json === "object") return Object.values(json).map((value)=>$c1e231f117ad5b91$var$extractTextFromJson(value)).join(" ");
    return "";
}
function $c1e231f117ad5b91$var$matchesSearch(feature, searchTerms) {
    if (searchTerms.length === 0) return true;
    const titleText = feature.title.toLowerCase();
    const descriptionText = $c1e231f117ad5b91$var$extractTextFromJson(feature.description.json).toLowerCase();
    const aggregateText = `${titleText} ${descriptionText}`;
    return searchTerms.every((term)=>aggregateText.includes(term.toLowerCase()));
}
function $c1e231f117ad5b91$var$matchesCategory(feature, categories) {
    if (categories.length === 0) return true;
    return categories.includes(feature.category.queryParameter);
}
function $c1e231f117ad5b91$var$matchesSelectedProduct(feature, selectedProducts) {
    if (selectedProducts.length === 0) return true;
    return feature.appsCollection.items.some((app)=>selectedProducts.includes(app.filterQueryParam));
}
function $c1e231f117ad5b91$var$matchesStatus(feature, statuses) {
    if (statuses.length === 0) return true;
    return statuses.includes(feature.status.roadmapStatusNameExternal);
}
function $c1e231f117ad5b91$var$compareFeatures(a, b, sortCriteria) {
    const { key: key, direction: direction } = sortCriteria;
    const multiplier = direction === "asc" ? 1 : -1;
    let aValue;
    let bValue;
    switch(key){
        case "title":
            aValue = a.title;
            bValue = b.title;
            break;
        case "category":
            aValue = a.category.roadmapCategoryNameExternal;
            bValue = b.category.roadmapCategoryNameExternal;
            break;
        case "status":
            aValue = a.status.roadmapStatusNameExternal;
            bValue = b.status.roadmapStatusNameExternal;
            break;
        case "timeFrame":
            aValue = a.timeFrame;
            bValue = b.timeFrame;
            break;
        default:
            return 0;
    }
    if (aValue < bValue) return -1 * multiplier;
    if (aValue > bValue) return 1 * multiplier;
    return 0;
}

});

parcelRegister("7pPqA", function(module, exports) {
$parcel$export(module.exports, "getQueryParamFromWindow", function () { return $310042fbac99da87$export$c88f6acd6921f5e8; });
$parcel$export(module.exports, "setQueryParam", function () { return $310042fbac99da87$export$8abc040b5116ed65; });
$parcel$export(module.exports, "setQueryParams", function () { return $310042fbac99da87$export$7755017099c85a0d; });
$parcel$export(module.exports, "setSlug", function () { return $310042fbac99da87$export$8863edec1beb539e; });
$parcel$export(module.exports, "getSlugFromWindow", function () { return $310042fbac99da87$export$e5c851c2cbeb3bc9; });
$parcel$export(module.exports, "clearSlug", function () { return $310042fbac99da87$export$497d95d751f2c8ad; });
function $310042fbac99da87$export$95fd5664a53dd0c5(param, search) {
    const urlParams = new URLSearchParams(search);
    const value = urlParams.get(param);
    return value ? value.split(";") : [];
}
function $310042fbac99da87$export$c88f6acd6921f5e8(param) {
    return $310042fbac99da87$export$95fd5664a53dd0c5(param, window.location.search);
}
function $310042fbac99da87$export$8abc040b5116ed65(key, values) {
    if (typeof window === "undefined") return;
    const urlParams = new URLSearchParams(window.location.search);
    const value = values.join(";");
    if (value) urlParams.set(key, value);
    else urlParams.delete(key);
    // Build query string manually to avoid URL-encoding semicolons
    const queryString = Array.from(urlParams.entries()).map(([k, v])=>{
        const encodedKey = encodeURIComponent(k);
        // Keep semicolons unencoded in values
        const encodedValue = v.split(";").map((part)=>encodeURIComponent(part)).join(";");
        return `${encodedKey}=${encodedValue}`;
    }).join("&");
    const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ""}${window.location.hash}`;
    window.history.pushState({}, "", newUrl);
}
function $310042fbac99da87$export$7755017099c85a0d(params) {
    Object.entries(params).forEach(([key, values])=>{
        $310042fbac99da87$export$8abc040b5116ed65(key, values);
    });
}
function $310042fbac99da87$export$8863edec1beb539e(value, opts = {}) {
    if (typeof window === "undefined") return;
    const { basePath: basePath } = opts;
    let newPath;
    if (basePath) {
        // Treat basePath as non-changeable
        const basePathParts = basePath.split("/").filter(Boolean);
        // If a part exists after the base path, remove it (it will be replaced by the new slug)
        // If no part exists after the base path, remove nothing (just append the new slug)
        // Result is always: basePath + new slug
        newPath = `/${basePathParts.join("/")}/${value}`;
    } else {
        // Original behavior when basePath is not specified
        const pathParts = window.location.pathname.split("/").filter(Boolean);
        newPath = pathParts.length > 0 ? `/${pathParts.join("/")}/${value}` : `/${value}`;
    }
    const newUrl = `${newPath}${window.location.search}${window.location.hash}`;
    window.history.pushState({}, "", newUrl);
}
function $310042fbac99da87$export$29f5936f887dc758(pathname, opts = {}) {
    const { basePath: basePath } = opts;
    const currentPathParts = pathname.split("/").filter(Boolean);
    if (basePath) {
        const basePathParts = basePath.split("/").filter(Boolean);
        // Check if current path starts with base path
        const startsWithBase = basePathParts.every((part, index)=>currentPathParts[index] === part);
        if (startsWithBase && currentPathParts.length > basePathParts.length) // Return the part after the basePath
        return currentPathParts[basePathParts.length];
        // No part exists after the basePath, return undefined
        return undefined;
    } else // No basePath specified, return the last path part
    return currentPathParts.length > 0 ? currentPathParts[currentPathParts.length - 1] : undefined;
}
function $310042fbac99da87$export$e5c851c2cbeb3bc9(opts = {}) {
    return $310042fbac99da87$export$29f5936f887dc758(window.location.pathname, opts);
}
function $310042fbac99da87$export$497d95d751f2c8ad(opts = {}) {
    if (typeof window === "undefined") return;
    const { basePath: basePath } = opts;
    const currentPathParts = window.location.pathname.split("/").filter(Boolean);
    if (basePath) {
        const basePathParts = basePath.split("/").filter(Boolean);
        // Check if current path starts with base path
        const startsWithBase = basePathParts.every((part, index)=>currentPathParts[index] === part);
        // Only clear if there's a part after the base path
        if (startsWithBase && currentPathParts.length > basePathParts.length) {
            // Remove the part after the basePath
            const newPath = `/${basePathParts.join("/")}`;
            const newUrl = `${newPath}${window.location.search}${window.location.hash}`;
            window.history.pushState({}, "", newUrl);
        }
    // If no part exists after the base path, don't change the URL
    } else {
        // No basePath specified, use original behavior
        const pathParts = [
            ...currentPathParts
        ];
        if (pathParts.length > 0) pathParts.pop();
        const newPath = pathParts.length > 0 ? `/${pathParts.join("/")}` : "/";
        const newUrl = `${newPath}${window.location.search}${window.location.hash}`;
        window.history.pushState({}, "", newUrl);
    }
}

});


parcelRegister("20kWR", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $66d70741ba057020$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $jE3Ci = parcelRequire("jE3Ci");

var $kbpa7 = parcelRequire("kbpa7");
const $66d70741ba057020$export$60332b2344f7fe41 = (props)=>{
    var _data_description_json_content__content_, _data_description_json_content_;
    const { data: data } = props;
    const statusColor = $66d70741ba057020$var$getStatusColor(data.status.roadmapStatusNameExternal.toLowerCase());
    const intl = (0, $8e22h.default)();
    const learnMoreLabel = intl.formatMessage({
        id: "roadmapFeatures.learnMore",
        defaultMessage: "Learn more"
    });
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c11p5 _yv0e1i37 _2z051wug _zulp1e2i _4cvrv2br _1bahv2br _1yt41ejb _19ityzqy _bfhkcd5j _2rkovwyg _80omtlke _vchhusvi _v564slvs _o7ks1kw8 _1dbz1cd0 _1mjb1txw _na0i1bp4 _2osnutpp"
        ]),
        style: {
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("h3", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyba982 _vwz41f4h"
                        ]),
                        children: data.title
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                        children: (_data_description_json_content_ = data.description.json.content[0]) === null || _data_description_json_content_ === void 0 ? void 0 : (_data_description_json_content__content_ = _data_description_json_content_.content[0]) === null || _data_description_json_content__content_ === void 0 ? void 0 : _data_description_json_content__content_.value
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iPPTB.Link), {
                            text: learnMoreLabel,
                            "aria-label": learnMoreLabel,
                            href: data.slug
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq"
                ]),
                children: data.category.roadmapCategoryNameExternal
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq",
                    "_1pfhyh40"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jE3Ci.Lozenge), {
                    text: data.status.roadmapStatusNameExternal,
                    appearance: statusColor
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq"
                ]),
                children: data.timeFrame
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq",
                    "_1pfhyh40",
                    "_1e0c1txw _1n261g80 _zulp1b66"
                ]),
                children: data.appsCollection.items.map((app)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $jE3Ci.Lozenge), {
                        text: app.roadmapAppNameExternal,
                        appearance: "neutral"
                    }, app.filterQueryParam))
            })
        ]
    });
};
const $66d70741ba057020$var$getStatusColor = (status)=>{
    let statusColor = "neutral";
    if (status === "future") statusColor = "purple";
    if (status === "coming soon") statusColor = "yellow";
    if (status === "released") statusColor = "lime";
    if (status === "completed") statusColor = "neutral";
    return statusColor;
};
const $66d70741ba057020$var$cardRowCss = null;
const $66d70741ba057020$var$cellCss = null;
const $66d70741ba057020$var$lozengeCellCss = null;
const $66d70741ba057020$var$featureNameCss = null;
const $66d70741ba057020$var$appsCell = null;

});


parcelRegister("cwkIh", function(module, exports) {
$parcel$export(module.exports, "ColumnHeaders", function () { return $b36c734c8491a922$export$945861bc4c775e51; });
/* column-headers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $2LBZM = parcelRequire("2LBZM");

var $1OYBO = parcelRequire("1OYBO");
const $b36c734c8491a922$export$945861bc4c775e51 = ()=>{
    const intl = (0, $8e22h.default)();
    const titleSortProps = (0, $2LBZM.useSort)("title");
    const categorySortProps = (0, $2LBZM.useSort)("category");
    const statusSortProps = (0, $2LBZM.useSort)("status");
    const timeFrameSortProps = (0, $2LBZM.useSort)("timeFrame");
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c11p5 _yv0e1i37 _2z051wug _zulp1e2i _4cvr1h6o _1bahv2br _1yt4vu7j _179ryzqy _syaz1dyx _1wyb1crf _y3gn1e5h _vchhusvi _1mjbglyw"
        ]),
        style: {
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $1OYBO.ColumnHeader), (0, $dPABA._)((0, $6ogO3._)({}, titleSortProps), {
                sortable: true,
                label: intl.formatMessage({
                    id: "roadmapFeatures.update",
                    defaultMessage: "Update"
                })
            })),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $1OYBO.ColumnHeader), (0, $dPABA._)((0, $6ogO3._)({}, categorySortProps), {
                sortable: true,
                label: intl.formatMessage({
                    id: "roadmapFeatures.category",
                    defaultMessage: "Category"
                })
            })),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $1OYBO.ColumnHeader), (0, $dPABA._)((0, $6ogO3._)({}, statusSortProps), {
                sortable: true,
                label: intl.formatMessage({
                    id: "roadmapFeatures.status",
                    defaultMessage: "Status"
                })
            })),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $1OYBO.ColumnHeader), (0, $dPABA._)((0, $6ogO3._)({}, timeFrameSortProps), {
                sortable: true,
                label: intl.formatMessage({
                    id: "roadmapFeatures.time",
                    defaultMessage: "Time"
                })
            })),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $1OYBO.ColumnHeader), {
                sortable: false,
                label: intl.formatMessage({
                    id: "roadmapFeatures.apps",
                    defaultMessage: "Apps"
                })
            })
        ]
    });
};
const $b36c734c8491a922$var$headerRowCss = null;

});
parcelRegister("1OYBO", function(module, exports) {
$parcel$export(module.exports, "ColumnHeader", function () { return $80d006960efe257e$export$5667c09b71ee0f05; });
/* column-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
const $80d006960efe257e$export$5667c09b71ee0f05 = (props)=>{
    const { label: label, sortable: sortable, sortDirection: sortDirection, onClick: onClick } = props;
    const sortSymbol = sortDirection === "asc" ? "\u2191" : sortDirection === "desc" ? "\u2193" : "";
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_k48pni7l _o5721q9c _y3gn1e5h _1e0c116y _4cvr1h6o _zulp1y44"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("button", {
            onClick: onClick,
            className: (0, $2jatx.default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _11q7glyw _1e0c116y _4cvr1h6o _zulp1y44 _11c81kw7 _syaz1kw7 _80omtlke _d0altlke"
            ]),
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_vwz4cjiy _1wyb7vkz"
                    ]),
                    children: label
                }),
                sortable && /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_1e0c116y _4cvr1h6o _1bah1h6o _1bsb1crf _4t3i1crf _1wyb7vkz"
                    ]),
                    children: sortSymbol !== null && sortSymbol !== void 0 ? sortSymbol : /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1e0c1o8l _1bsbftgi _4t3iftgi"
                        ])
                    })
                })
            ]
        })
    });
};
const $80d006960efe257e$var$headerCellCss = null;
const $80d006960efe257e$var$labelTextCss = null;
const $80d006960efe257e$var$headerButtonCss = null;
const $80d006960efe257e$var$sortIconWrapperCss = null;
const $80d006960efe257e$var$sortIconPlaceholderCss = null;

});


parcelRegister("l5Cys", function(module, exports) {
$parcel$export(module.exports, "Layout", function () { return $ba7cbf8f19b1a13e$export$c84671f46d6a1ca; });
/* layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
const $ba7cbf8f19b1a13e$export$c84671f46d6a1ca = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _p12f1yae _1e0c11p5 _2z051wug _1p571ejb"
        ]),
        children: [
            props.searchWithFilters,
            props.columnHeaders,
            props.cards
        ]
    });
};
const $ba7cbf8f19b1a13e$var$layoutCss = null;

});

parcelRegister("deC8f", function(module, exports) {
$parcel$export(module.exports, "SearchWithFilters", function () { return (parcelRequire("3Nxop")).SearchWithFilters; });
parcelRequire("3Nxop");

});
parcelRegister("3Nxop", function(module, exports) {
$parcel$export(module.exports, "SearchWithFilters", function () { return $5701f908310c3ff2$export$164878005b1b038c; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");
parcelRequire("87rFO");
var $ihYMb = parcelRequire("ihYMb");

var $2LBZM = parcelRequire("2LBZM");
const $5701f908310c3ff2$export$164878005b1b038c = ()=>{
    const [searchStringValue, setSearchStringValue] = (0, $gljCV.useState)("");
    const [searchInputFieldFocused, setSearchInputFieldFocused] = (0, $gljCV.useState)(false);
    const setFilter = (0, $2LBZM.useSetFilter)();
    const setSearch = (0, $2LBZM.useSetSearch)();
    const appValue = (0, $2LBZM.useFilter)("selectedProduct");
    const statusValue = (0, $2LBZM.useFilter)("status");
    const categoryValue = (0, $2LBZM.useFilter)("category");
    const appOptions = (0, $2LBZM.useFilterOptions)("selectedProduct");
    const statusOptions = (0, $2LBZM.useFilterOptions)("status");
    const categoryOptions = (0, $2LBZM.useFilterOptions)("category");
    const [filterObject, setFilterObject] = (0, $gljCV.useState)({
        app: appOptions.reduce((acc, opt)=>{
            const isSelected = appValue.includes(opt.label);
            return (0, $dPABA._)((0, $6ogO3._)({}, acc), {
                [opt.label]: {
                    committedActive: isSelected,
                    stagedActive: isSelected
                }
            });
        }, {}),
        category: categoryOptions.reduce((acc, opt)=>{
            const isSelected = categoryValue.includes(opt.label);
            return (0, $dPABA._)((0, $6ogO3._)({}, acc), {
                [opt.label]: {
                    committedActive: isSelected,
                    stagedActive: isSelected
                }
            });
        }, {}),
        status: statusOptions.reduce((acc, opt)=>{
            const isSelected = statusValue.includes(opt.label);
            return (0, $dPABA._)((0, $6ogO3._)({}, acc), {
                [opt.label]: {
                    committedActive: isSelected,
                    stagedActive: isSelected
                }
            });
        }, {})
    });
    const clearSearchField = (0, $gljCV.useCallback)(()=>{
        setSearchStringValue("");
        setSearchInputFieldFocused(false);
    }, []);
    const runSearchWithFilters = (0, $gljCV.useCallback)((filterObj, searchTerm)=>{
        setFilterObject(filterObj);
        // search
        setSearch(searchTerm);
        // app (selectedProduct) filter
        const appFilterValue = [];
        Object.entries(filterObj.app).map(([label, { committedActive: committedActive }])=>{
            if (committedActive) {
                const option = appOptions.find((opt)=>opt.label === label);
                if (option) appFilterValue.push(option.value);
            }
        });
        setFilter("selectedProduct", appFilterValue);
        // category filter
        const categoryFilterValue = [];
        Object.entries(filterObj.category).map(([label, { committedActive: committedActive }])=>{
            if (committedActive) {
                const option = categoryOptions.find((opt)=>opt.label === label);
                if (option) categoryFilterValue.push(option.value);
            }
        });
        setFilter("category", categoryFilterValue);
        // status filter
        const statusFilterValue = [];
        Object.entries(filterObj.status).map(([label, { committedActive: committedActive }])=>{
            if (committedActive) {
                const option = statusOptions.find((opt)=>opt.label === label);
                if (option) statusFilterValue.push(option.value);
            }
        });
        setFilter("status", statusFilterValue);
    }, []);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $ihYMb.default), {
        filterObject: filterObject,
        searchStringValue: searchStringValue,
        searchInputFieldFocused: searchInputFieldFocused,
        setSearchInputFieldFocused: setSearchInputFieldFocused,
        setFilterObjectValue: setFilterObject,
        setSearchString: setSearchStringValue,
        clearSearchField: clearSearchField,
        runSearchWithFilters: runSearchWithFilters
    });
};

});
parcelRegister("87rFO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("ihYMb")).default; });

var $ihYMb = parcelRequire("ihYMb");

});
parcelRegister("ihYMb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $920593310c76585f$export$2e2bcd8739ae039; });
/* uniform-search-with-filters.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $5qUgh = parcelRequire("5qUgh");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $lgRQS = parcelRequire("lgRQS");

var $hjTlF = parcelRequire("hjTlF");
parcelRequire("fd8I2");
var $8OrKI = parcelRequire("8OrKI");
const $920593310c76585f$var$UniformSearchWithFilters = ({ filterObject: filterObject, searchStringValue: searchStringValue, searchInputFieldFocused: searchInputFieldFocused, setFilterObjectValue: setFilterObjectValue, setSearchInputFieldFocused: setSearchInputFieldFocused, setSearchString: setSearchString, clearSearchField: clearSearchField, runSearchWithFilters: runSearchWithFilters })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const localizedMap = {
        app: "App",
        category: "Category",
        status: "Status"
    };
    const clearAllFilters = ()=>{
        setFilterObjectValue((prevState)=>{
            const cleared = {};
            Object.keys(prevState).forEach((category)=>{
                const categoryKey = category;
                cleared[categoryKey] = {};
                Object.keys(prevState[categoryKey]).forEach((optionName)=>{
                    cleared[categoryKey][optionName] = {
                        committedActive: false,
                        stagedActive: false
                    };
                });
            });
            runSearchWithFilters(cleared, "");
            return cleared;
        });
    };
    const whichFilterModalIsOpenObjectDefaultState = {
        app: false,
        category: false,
        status: false
    };
    Object.freeze(whichFilterModalIsOpenObjectDefaultState);
    const [whichFilterModalIsOpenObject, updateWhichFilterModalIsOpenObject] = (0, $gljCV.useState)(whichFilterModalIsOpenObjectDefaultState);
    // Updates the state of which filter modal is open
    // If a modal is closing, we commit all the stagedActive values
    const updateWhichFilterModalIsShown = (subFilter)=>{
        const isModalClosing = Object.keys(whichFilterModalIsOpenObject).filter((key)=>whichFilterModalIsOpenObject[key]);
        updateWhichFilterModalIsOpenObject(()=>(0, $dPABA._)((0, $6ogO3._)({}, whichFilterModalIsOpenObjectDefaultState), {
                [subFilter]: !whichFilterModalIsOpenObject[subFilter]
            }));
        if (isModalClosing.length > 0) setFilterObjectValue((prevState)=>{
            filterObject = (0, $6ogO3._)({}, prevState, (0, $8OrKI.commitAllStagedActiveValues)(prevState));
            runSearchWithFilters(filterObject, searchStringValue);
            return filterObject;
        });
    };
    // Updates the stagedActive value of the filter
    const updateSubFilterStagedValue = (subFilterName, filterOptionName)=>{
        setFilterObjectValue((prevState)=>{
            return (0, $dPABA._)((0, $6ogO3._)({}, prevState), {
                [subFilterName]: (0, $dPABA._)((0, $6ogO3._)({}, prevState[subFilterName]), {
                    [filterOptionName]: (0, $dPABA._)((0, $6ogO3._)({}, prevState[subFilterName][filterOptionName]), {
                        stagedActive: !prevState[subFilterName][filterOptionName].stagedActive
                    })
                })
            });
        });
    };
    // Handles logic for determining which filter modal to show
    const getFilterModal = (showFilter, filterKey)=>{
        if (!showFilter || !whichFilterModalIsOpenObject[filterKey]) return null;
        return /*#__PURE__*/ (0, $dypTs.jsx)((0, $hjTlF.UniformFilterModal), {
            subFilter: filterKey,
            subFilterObject: filterObject[filterKey],
            updateFilterObject: (filterOptionName)=>updateSubFilterStagedValue(filterKey, filterOptionName)
        });
    };
    const filterButtonClickWrapper = (ev, filterCategory)=>{
        ev.preventDefault();
        createAnalyticsEvent({
            origin: "web",
            platform: "web",
            product: "marketing",
            source: "none",
            userIdType: "atlassianAccount",
            eventComponent: "uniformFilterButton",
            event: "clicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "component",
            attributes: {
                labelEnglish: filterCategory,
                url: location.href,
                page_path: location.pathname,
                eventComponent: "uniformFilterButton"
            }
        }).fire();
        updateWhichFilterModalIsShown(filterCategory);
    };
    const buttonPropsList = [
        {
            variant: "primary",
            color: "light_grey",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, "app")
        },
        {
            variant: "primary",
            color: "light_grey",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, "category")
        },
        {
            variant: "primary",
            color: "light_grey",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onClick: (ev)=>filterButtonClickWrapper(ev, "status")
        }
    ];
    // If any filter modal is open, show the modal
    const showModal = Object.values(whichFilterModalIsOpenObject).filter((isActiveValue)=>isActiveValue).length > 0;
    const handleDocumentClick = (0, $gljCV.useCallback)((event)=>{
        if (showModal) {
            let parentNode = event.target;
            while(parentNode && parentNode.nodeName !== "BODY"){
                if (parentNode.id === "uniform-filter-modal-component-parent") return;
                parentNode = parentNode.parentNode;
            }
        }
        // If we are here, it means the click was outside the modal
        const isModalClosing = Object.keys(whichFilterModalIsOpenObject).filter((key)=>whichFilterModalIsOpenObject[key]);
        if (isModalClosing.length > 0) {
            updateWhichFilterModalIsOpenObject(()=>(0, $6ogO3._)({}, whichFilterModalIsOpenObjectDefaultState));
            setFilterObjectValue((prevState)=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                filterObject = (0, $6ogO3._)({}, prevState, (0, $8OrKI.commitAllStagedActiveValues)(prevState));
                runSearchWithFilters(filterObject, searchStringValue);
                return filterObject;
            });
        }
    }, [
        showModal
    ]);
    // Attach and detach the event listener for the document click
    // This is used to determine if there is a click outside of the filter modals
    (0, $gljCV.useEffect)(()=>{
        // Attach the listeners on component mount.
        document.addEventListener("click", handleDocumentClick, false);
        // Detach the listeners on component unmount.
        return ()=>{
            document.removeEventListener("click", handleDocumentClick, false);
        };
    }, [
        handleDocumentClick
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $bQjAr.default), {
        name: "uniform-filters",
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.TypographyStyles), {
            children: /*#__PURE__*/ (0, $dypTs.jsx)("section", {
                className: (0, $2jatx.default)([
                    "_19pkys9h _2hwxidpf _otyrzwfg _18u0idpf _12eoidpf _1mg17vkz"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1n261q9c _1bah1yb4"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1n261q9c _p12f1jax _i0dlmko7 _1bahesu3 _8fz61w8u _1a8l1w8u _o5kcesu3"
                                ]),
                                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $lgRQS.SearchBar), {
                                    searchStringValue: searchStringValue,
                                    setSearchString: setSearchString,
                                    runSearch: ()=>runSearchWithFilters(filterObject, searchStringValue),
                                    searchInputFieldFocused: searchInputFieldFocused,
                                    setSearchInputFieldFocused: setSearchInputFieldFocused,
                                    clearSearchField: clearSearchField
                                })
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _1e0c1txw _1n261q9c _i0dl1ns9 _v5646lqh _1a8lka7h"
                                ]),
                                children: [
                                    buttonPropsList.map((buttonProp, index)=>{
                                        const filterKey = Object.keys(filterObject)[index];
                                        // Inefficient, we should look into memoizing this
                                        const numFiltersActive = (0, $8OrKI.getActiveFiltersByFilterType)(filterKey, filterObject);
                                        const buttonClassNameBuilder = `uniform-filter-button-adg4 ${numFiltersActive ? "filter-active" : ""} ${whichFilterModalIsOpenObject[filterKey] ? "selected" : ""}`;
                                        const filterModal = getFilterModal(showModal, filterKey);
                                        return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                                            className: "uniform-filter-button",
                                            children: [
                                                /*#__PURE__*/ (0, $dypTs.jsxs)((0, $5qUgh.Adg4Button), (0, $dPABA._)((0, $6ogO3._)({}, buttonProp), {
                                                    className: (0, $2jatx.default)([
                                                        "_2nip1dk0 _1eay7vkz _15tu7vkz _1d2ztlke _g52k1j6v _1iwx1ipv _1a9g1nn1 _1mjbglyw _1fqbf1gs _1p3kftgi _128g18ms _1n7j150w _19lc150w _1w3o1dli _1og01dli _mtmv1dli _1il01o8l _1qqaglyw",
                                                        buttonClassNameBuilder
                                                    ]),
                                                    id: "uniform-filter-modal-component-parent",
                                                    style: {
                                                        "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                                                        "--_1ugh14a": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.purple100"))
                                                    },
                                                    children: [
                                                        localizedMap[filterKey],
                                                        " ",
                                                        $920593310c76585f$var$filterDropDownArrowSVG,
                                                        /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_1e0cglyw _ae4v1h6o _11q71p6p _2rko1ssb _ahbqftgi _syaz1hlo _1bsbgktf _4t3igktf _k48pni7l"
                                                            ]),
                                                            style: {
                                                                "--_liss8u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.purple300")),
                                                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                                            },
                                                            children: numFiltersActive
                                                        })
                                                    ]
                                                })),
                                                filterModal
                                            ]
                                        }, index);
                                    }),
                                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $5qUgh.Adg4Button), {
                                        variant: "primary",
                                        color: "light_grey",
                                        onClick: clearAllFilters,
                                        className: (0, $2jatx.default)([
                                            "_2nip1dk0 _1eay7vkz _15tu7vkz _1d2ztlke _g52k1j6v _1iwx1ipv _1a9g1nn1 _1mjbglyw _1fqbf1gs _1p3kftgi _128g18ms _1n7j150w _19lc150w _1w3o1dli _1og01dli _mtmv1dli _1il01o8l _1qqaglyw",
                                            "_11q7xeuo",
                                            "uniform-filter-button-adg4 clear-filters-button"
                                        ]),
                                        style: {
                                            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                                            "--_1ugh14a": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.purple100")),
                                            "--_1vwzriw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.yellow"))
                                        },
                                        children: "Clear filters"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $920593310c76585f$var$filterDropDownArrowSVG = /*#__PURE__*/ (0, $dypTs.jsx)("svg", {
    width: "10",
    height: "6",
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "uniform-filter-dropdown-arrow",
    children: /*#__PURE__*/ (0, $dypTs.jsx)("path", {
        d: "M9 1.18164L5 4.818L1 1.18164",
        stroke: (0, $kbpa7.wacToken)("color.primary.black"),
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
const $920593310c76585f$var$uniformFiltersSectionContainerStyle = null;
const $920593310c76585f$var$uniformFiltersContainerStyle = null;
const $920593310c76585f$var$filterButtonContainerStyle = null;
const $920593310c76585f$var$filterButtonStyles = null;
const $920593310c76585f$var$filterButtonCountStyles = null;
const $920593310c76585f$var$clearFiltersButtonStyle = null;
const $920593310c76585f$var$searchButtonContainerStyle = null;
var $920593310c76585f$export$2e2bcd8739ae039 = $920593310c76585f$var$UniformSearchWithFilters;

});
parcelRegister("lgRQS", function(module, exports) {
$parcel$export(module.exports, "SearchBar", function () { return $638264a52bcdb51e$export$79d13b60110f33be; });
/* search-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $3n8tj = parcelRequire("3n8tj");

var $03P38 = parcelRequire("03P38");
const $638264a52bcdb51e$export$79d13b60110f33be = ({ searchStringValue: searchStringValue, searchInputFieldFocused: searchInputFieldFocused, setSearchString: setSearchString, setSearchInputFieldFocused: setSearchInputFieldFocused, clearSearchField: clearSearchField, runSearch: runSearch })=>{
    const intl = (0, $8e22h.default)();
    let createAnalyticsEvent = null;
    try {
        const analyticsHook = (0, $eY3N6.useAnalyticsEvents)();
        createAnalyticsEvent = analyticsHook.createAnalyticsEvent;
    } catch (e) {
    // Analytics provider not available
    }
    const searchRef = (0, $gljCV.useRef)(null);
    const onSearchInputChange = (event)=>{
        setSearchString(event.target.value);
    };
    const handleSearchBarFocus = ()=>{
        setSearchInputFieldFocused(true);
        if (createAnalyticsEvent) createAnalyticsEvent({
            origin: "web",
            platform: "web",
            product: "marketing",
            source: "none",
            userIdType: "atlassianAccount",
            eventComponent: "searchInput",
            event: "clicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "component",
            attributes: {
                url: location.href,
                page_path: location.pathname,
                eventComponent: "searchInput"
            }
        }).fire();
    };
    const handleOnBlur = ()=>{
        if (searchStringValue === "") setSearchInputFieldFocused(false);
        else setSearchInputFieldFocused(true);
    };
    const handleSearchButtonClick = (0, $gljCV.useCallback)(()=>{
        if (searchRef.current) searchRef.current.focus();
        runSearch();
    }, [
        runSearch
    ]);
    const handleClearSearchButtonClick = ()=>{
        clearSearchField();
        if (searchRef.current) searchRef.current.focus();
    };
    const searchClassName = searchInputFieldFocused ? "search-active" : "";
    return /*#__PURE__*/ (0, $dypTs.jsxs)("form", {
        onSubmit: (evt)=>{
            evt.preventDefault();
            handleSearchButtonClick();
        },
        className: (0, $2jatx.default)([
            "_4t3ior1b _1bsb1osq _11q7150w _2rko1ylp _1e0c1txw _1n261q9c _1bah1yb4 _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _scffglyw _1rwq1j28 _xmji1r31 _gxxuglyw _34ir1o36 _5hv91osq _17ea1vuk _125xdlk8 _psgk1hlo _yizh1fw0 _ggg71nn1 _1owa1w8u _4u6k1j28 _10709by0 _1f021txw _1vh3esu3 _dier1q9c _1b10idpf _cpccftgi _1s5lidpf _18asftgi _1sku1h6o _12nmbz2e _1d2m1f4h _11vy1wcj _p2rgx19p"
        ]),
        style: {
            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("input", {
                className: searchClassName,
                type: "text",
                placeholder: (intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                    id: "SearchBar.searchPlaceholder",
                    defaultMessage: "Search"
                })) || "Search",
                onFocus: handleSearchBarFocus,
                onBlur: handleOnBlur,
                onChange: onSearchInputChange,
                value: searchStringValue,
                ref: searchRef
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: `search-buttons-container ${searchClassName}`,
                children: [
                    searchInputFieldFocused && /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)((0, $03P38.UniformSearchCloseButton), {
                                onClick: handleClearSearchButtonClick
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                className: "search-buttons-divider"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $3n8tj.UniformSearchButton), {})
                ]
            })
        ]
    });
};
const $638264a52bcdb51e$var$searchBarContainerStyle = null;

});
parcelRegister("3n8tj", function(module, exports) {
$parcel$export(module.exports, "UniformSearchButton", function () { return $d01e7f55404b7a17$export$fcc9da1be4557ae1; });
/* uniform-search-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $bZmYH = parcelRequire("bZmYH");

var $kbpa7 = parcelRequire("kbpa7");
const $d01e7f55404b7a17$var$searchIconStyle = null;
const $d01e7f55404b7a17$var$searchIconSvgStyle = null;
const $d01e7f55404b7a17$export$fcc9da1be4557ae1 = ()=>{
    let searchLabel = "Search";
    try {
        const intl = (0, $8e22h.default)();
        searchLabel = intl.formatMessage({
            id: "SearchButton.label",
            defaultMessage: "Search"
        });
    } catch (e) {
    // IntlProvider not available, use default
    }
    return /*#__PURE__*/ (0, $dypTs.jsx)("button", {
        type: "submit",
        id: "search-icon",
        "aria-label": searchLabel,
        "data-event": "clicked",
        "data-event-component": "button",
        "data-event-container": "searchButton",
        className: (0, $2jatx.default)([
            "_ahbqftgi _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz1nc2"
        ]),
        style: {
            "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100"))
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
            className: (0, $2jatx.default)([
                "_syaz1hlo _2rko1ssb _4t3i1wug _ca0q14y2 _u5f314y2 _n3td14y2 _19bv14y2 _1bsbzwfg _1ul9zwfg _irr31rga"
            ]),
            style: {
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
            },
            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))), {
                label: searchLabel
            })
        })
    });
};

});

parcelRegister("03P38", function(module, exports) {
$parcel$export(module.exports, "UniformSearchCloseButton", function () { return $cf60fc5b8402956c$export$5170f7b0a027f68a; });
/* uniform-search-close-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $dE0sS = parcelRequire("dE0sS");
const $cf60fc5b8402956c$var$searchButtonStyle = null;
const $cf60fc5b8402956c$var$searchIconStyle = null;
const $cf60fc5b8402956c$export$5170f7b0a027f68a = (props)=>{
    let searchCloseLabel = "Clear search";
    try {
        const intl = (0, $8e22h.default)();
        searchCloseLabel = intl.formatMessage({
            id: "SearchCloseButton.label",
            defaultMessage: "Clear search"
        });
    } catch (e) {
    // IntlProvider not available, use default
    }
    return /*#__PURE__*/ (0, $dypTs.jsx)("button", {
        type: "button",
        onClick: props.onClick,
        id: "search-close-icon",
        "aria-label": searchCloseLabel,
        "data-event": "clicked",
        "data-event-component": "button",
        "data-event-container": "searchCloseButton",
        className: (0, $2jatx.default)([
            "_1pfh1y44 _12l2ftgi _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz1nc2 _30l31nc2"
        ]),
        style: {
            "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100"))
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $dE0sS.Cross), {
            size: "24",
            className: (0, $2jatx.default)([
                "_syaz1hlo _2rko1ssb _4t3i1wug _ca0q14y2 _u5f314y2 _n3td14y2 _19bv14y2 _1bsb1ul9"
            ]),
            style: {
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
            }
        })
    });
};

});


parcelRegister("hjTlF", function(module, exports) {
$parcel$export(module.exports, "UniformFilterModal", function () { return $f44020fab7cdce9e$export$a3fbc260ab4db874; });
/* uniform-filter-modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $f44020fab7cdce9e$export$a3fbc260ab4db874 = ({ subFilter: subFilter, subFilterObject: subFilterObject, updateFilterObject: updateFilterObject })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _bfhku67f _2rkogktf _1pbycs5v _152t4bvh _ca0q7vkz _u5f31tcg _n3td1tcg _19bv1tcg _2lx21bp4 _16qs20pt",
            subFilter
        ]),
        id: "uniform-filter-modal-component-parent",
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4"
            ]),
            children: Object.keys(subFilterObject).map((filterOptionName, index)=>{
                const filterObject = subFilterObject[filterOptionName];
                const active = filterObject.stagedActive;
                const optionId = `option-${subFilter.replace(/\s/g, "")}-${index}`;
                return /*#__PURE__*/ (0, $dypTs.jsxs)("label", {
                    htmlFor: optionId,
                    className: (0, $2jatx.default)([
                        "_19pkftgi _2hwxidpf _otyridpf _18u0idpf _80omtlke _1e0c1txw _1n261q9c _4cvr1h6o _1bah1y6m"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)("input", {
                            id: optionId,
                            type: "checkbox",
                            onClick: ()=>updateFilterObject(filterOptionName),
                            className: (0, $2jatx.default)([
                                "_kqswstnw _tzy4idpf _lcxvglyw"
                            ])
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_1bsbgktf _4t3igktf _2rko1l7b _19it1n5q _i0dlgktf _12l2ftgi _11q7cd5j _1e0c1txw _1bah1h6o _4cvr1h6o _bfw78djs _1c3917la _uq4u8djs",
                                active ? "checked" : ""
                            ]),
                            style: {
                                "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100")),
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                            },
                            children: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_tzy4idpf",
                                    active && "_tzy4kb7n"
                                ]),
                                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.Icon), {
                                    name: "featurecheckmark",
                                    size: "xs",
                                    color: (0, $kbpa7.wacToken)("color.neutral.light0")
                                })
                            })
                        }),
                        filterOptionName
                    ]
                }, filterOptionName);
            })
        })
    });
};
const $f44020fab7cdce9e$var$uniformFilterModalStyle = null;
const $f44020fab7cdce9e$var$filterRadioButtonContainerStyle = null;
const $f44020fab7cdce9e$var$checkboxSpanStyle = null;
const $f44020fab7cdce9e$var$iconSpanBaseStyle = null;
const $f44020fab7cdce9e$var$iconSpanVisibleStyle = null;
const $f44020fab7cdce9e$var$hiddenInputStyle = null;
const $f44020fab7cdce9e$var$filterListContainerStyle = null;

});

parcelRegister("fd8I2", function(module, exports) {
$parcel$export(module.exports, "commitAllStagedActiveValues", function () { return (parcelRequire("8OrKI")).commitAllStagedActiveValues; });
$parcel$export(module.exports, "getActiveFiltersByFilterType", function () { return (parcelRequire("8OrKI")).getActiveFiltersByFilterType; });

var $8OrKI = parcelRequire("8OrKI");
parcelRequire("fM5ld");

});
parcelRegister("8OrKI", function(module, exports) {
$parcel$export(module.exports, "commitAllStagedActiveValues", function () { return $91b56c3aa2113c4b$export$995b34954b6e3c5d; });
$parcel$export(module.exports, "getActiveFiltersByFilterType", function () { return $91b56c3aa2113c4b$export$5c95673afb2371b8; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");
const $91b56c3aa2113c4b$export$995b34954b6e3c5d = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = (0, $6ogO3._)({}, prevState[filterCategory], Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
            acc[filterOptionName] = (0, $dPABA._)((0, $6ogO3._)({}, filterOptionValue), {
                committedActive: filterOptionValue.stagedActive
            });
            return acc;
        }, {}));
        return acc;
    }, {});
};
const $91b56c3aa2113c4b$export$32ef36095a2643ff = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = (0, $6ogO3._)({}, prevState[filterCategory], Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
            acc[filterOptionName] = (0, $dPABA._)((0, $6ogO3._)({}, filterOptionValue), {
                stagedActive: false
            });
            return acc;
        }, {}));
        return acc;
    }, {});
};
const $91b56c3aa2113c4b$export$6e8eccaa2da87c2a = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = (0, $6ogO3._)({}, prevState[filterCategory], Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
            acc[filterOptionName] = (0, $dPABA._)((0, $6ogO3._)({}, filterOptionValue), {
                stagedActive: filterOptionValue.committedActive
            });
            return acc;
        }, {}));
        return acc;
    }, {});
};
const $91b56c3aa2113c4b$export$5c95673afb2371b8 = (filter, filterObject)=>{
    if (filter === "all") return Object.values(filterObject).reduce((acc, filterCategory)=>acc + Object.values(filterCategory).reduce((subacc, filterOption)=>filterOption.committedActive ? subacc + 1 : subacc, 0), 0);
    else return Object.values(filterObject[filter]).reduce((acc, subFilter)=>subFilter.committedActive ? acc + 1 : acc, 0);
};

});

parcelRegister("fM5ld", function(module, exports) {

});








parcelRegister("esueT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("6smfw")).default; });

var $6smfw = parcelRequire("6smfw");

});
parcelRegister("6smfw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ead486866758e335$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $9mOHh = parcelRequire("9mOHh");
const $ead486866758e335$var$UniformRovoChatBox = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $9mOHh.RovoChatBoxContainer), {});
};
var $ead486866758e335$export$2e2bcd8739ae039 = $ead486866758e335$var$UniformRovoChatBox;

});
parcelRegister("9mOHh", function(module, exports) {
$parcel$export(module.exports, "ChatHeader", function () { return $d988f9da35c79665$export$1263ff8fe28ec69f; });
$parcel$export(module.exports, "RovoChatBoxContainer", function () { return $d988f9da35c79665$export$acbe8b1c07595f91; });
/* chat.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $gljCV = parcelRequire("gljCV");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $2u2Jd = parcelRequire("2u2Jd");

var $eY3N6 = parcelRequire("eY3N6");

var $h4ACf = parcelRequire("h4ACf");

var $hLJF4 = parcelRequire("hLJF4");

var $k9ZIM = parcelRequire("k9ZIM");

var $7VwhR = parcelRequire("7VwhR");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $32ng3 = parcelRequire("32ng3");

var $3riD8 = parcelRequire("3riD8");

var $9jvKE = parcelRequire("9jvKE");

var $ewaN9 = parcelRequire("ewaN9");

var $l9P27 = parcelRequire("l9P27");

var $kcKpS = parcelRequire("kcKpS");
const $d988f9da35c79665$var$sectionStyles = null;
const $d988f9da35c79665$var$chatHeaderContainerStyles = null;
const $d988f9da35c79665$var$rovoLoaderStyles = null;
const $d988f9da35c79665$var$h1Styles = null;
const $d988f9da35c79665$var$textfieldContainerStyles = null;
const $d988f9da35c79665$var$ctaButtonStyles = null;
const $d988f9da35c79665$var$disabledInteractionCss = null;
const $d988f9da35c79665$var$RovoPillButton = ({ isDisabled: isDisabled, onClick: onClick })=>{
    const intl = (0, $8e22h.default)();
    const askRovoLabel = intl.formatMessage({
        id: "RovoChat.askRovo",
        defaultMessage: "Ask Rovo"
    });
    const tooltipContent = intl.formatMessage({
        id: "RovoChat.writePromptTooltip",
        defaultMessage: "Write a prompt"
    });
    const button = /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Button), {
        variant: "primary",
        size: "small",
        onClick: isDisabled ? undefined : onClick,
        className: (0, $2jatx.default)([
            "_1tke1ylp",
            isDisabled && "_lcxvglyw _80om73ad"
        ]),
        children: askRovoLabel
    });
    // Only show tooltip when button is disabled (no text entered)
    if (isDisabled) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $hLJF4.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
            style: {
                display: "inline-block"
            },
            children: button
        })
    });
    // No tooltip when button is enabled (user has typed something)
    return button;
};
const $d988f9da35c79665$var$inputStyles = null;
const $d988f9da35c79665$var$chatBoxContainerStyles = null;
const $d988f9da35c79665$var$getNamedHeader = (firstName)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
        id: "RovoChat.greeting",
        defaultMessage: "Hey {name},{br}let's get to work",
        values: {
            name: (0, $7VwhR.getFirstName)(firstName),
            br: /*#__PURE__*/ (0, $dypTs.jsx)("br", {})
        }
    });
};
const $d988f9da35c79665$export$1263ff8fe28ec69f = ()=>{
    const { isUserLoggedIn: isUserLoggedIn, name: name } = (0, $3riD8.useLoggedInUser)();
    const firstName = (0, $7VwhR.getFirstName)(name !== null && name !== void 0 ? name : "");
    // If 'gwp-9000-new-rovo-video-hero' is enabled, <h1> shows the video; else, Rovo Chat Header uses <h1>.
    // Check feature flag at render time to allow tests to mock it properly
    const isNewRovoVideoHeroEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9000NewRovoVideoHero);
    const getMessage = ()=>{
        if (isUserLoggedIn && firstName) return $d988f9da35c79665$var$getNamedHeader(firstName);
        return /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
            id: "RovoChat.greeting",
            defaultMessage: "Hey there,{br}ready to get to work?",
            values: {
                br: /*#__PURE__*/ (0, $dypTs.jsx)("br", {})
            }
        });
    };
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_p12fbxu3 _1bsb1osq _y3gn1h6o _1e0c1txw _2lx21bp4 _4cvr1h6o _zulpa982 _1p57a982 _gy1pa982 _6rth1tcg"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1j2z _4t3i1j2z _1ul914no _1tke14no _p12f14no _c71l14no _19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3 _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _1e0c1ule _1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2u2Jd))), {
                    options: {
                        loop: true,
                        autoplay: true,
                        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($l9P27))),
                        rendererSettings: {
                            preserveAspectRatio: "xMidYMid slice"
                        }
                    },
                    height: 36,
                    width: 36
                })
            }),
            isNewRovoVideoHeroEnabled ? /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz48vuz _1wybckbl _k48p9y44"
                ]),
                children: getMessage()
            }) : /*#__PURE__*/ (0, $dypTs.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz48vuz _1wybckbl _k48p9y44"
                ]),
                children: getMessage()
            })
        ]
    });
};
const $d988f9da35c79665$export$e7a1e4b67bd87c97 = ({ textareaRef: externalRef, value: externalValue, onValueChange: onValueChange, previewValue: previewValue })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $k9ZIM.useAnalyticsClient)();
    const hasTrackedTyping = (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).useRef(false);
    const defaultPlaceholder = intl.formatMessage({
        id: "RovoChat.placeholder",
        defaultMessage: "Find something, plan something, or make something"
    });
    const placeholder = previewValue || defaultPlaceholder;
    const internalRef = (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).useRef(null);
    const textareaRef = externalRef || internalRef;
    const MAX_HEIGHT = 140; // keep in sync with inputStyles.maxHeight
    const resizeToContent = (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).useCallback(()=>{
        const el = textareaRef.current;
        if (!el) return;
        el.style.height = "auto";
        const next = Math.min(el.scrollHeight, MAX_HEIGHT);
        el.style.height = `${next}px`;
    }, [
        textareaRef,
        MAX_HEIGHT
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).useEffect(()=>{
        resizeToContent();
    }, [
        resizeToContent
    ]);
    const handleChange = ()=>{
        resizeToContent();
    };
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).useState("");
    const displayValue = externalValue !== null && externalValue !== void 0 ? externalValue : value;
    const fireTypingAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).useCallback(()=>{
        if (!hasTrackedTyping.current && analyticsClient) {
            hasTrackedTyping.current = true;
            createAnalyticsEvent({
                product: "marketing",
                platform: "web",
                eventType: "ui",
                action: "typed",
                actionSubject: "textInput",
                actionSubjectId: "rovoChatBox",
                attributes: {
                    url: location.href
                }
            }).fire();
        }
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const handleClick = ()=>{
        const prompt = displayValue.trim();
        if (!prompt) return;
        // Fire analytics event for submission
        if (analyticsClient) createAnalyticsEvent({
            product: "marketing",
            platform: "web",
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "rovoChatBox",
            attributes: {
                url: location.href,
                promptLength: prompt.length
            }
        }).fire();
        const chatUrl = new URL("https://home.atlassian.com/chat");
        chatUrl.searchParams.set("rovoChatPathway", "chat");
        chatUrl.searchParams.set("rovoChatPrompt", prompt);
        const loginUrl = `https://id.atlassian.com/login?continue=${encodeURIComponent(chatUrl.toString())}`;
        console.log("generated URL: ", loginUrl);
        window.location.assign(loginUrl);
    };
    // Determine which button to show based on feature gate
    const usePillButton = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8979RovoOnWacButton);
    const isButtonDisabled = !displayValue.trim();
    const writePromptTooltip = intl.formatMessage({
        id: "RovoChat.writePromptTooltip",
        defaultMessage: "Write a prompt"
    });
    const submitTooltip = intl.formatMessage({
        id: "RovoChat.submitTooltip",
        defaultMessage: "Submit"
    });
    const tooltipContent = isButtonDisabled ? writePromptTooltip : submitTooltip;
    const handleKeyDown = (e)=>{
        // Submit on Enter (but allow Shift+Enter for new lines)
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleClick();
        }
    };
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bsb1xup _2lx21bp4 _4cvr1fhb _zulputpp _vchhusvi _2rko1crf _19it1k0a _11q71j9a _16qs1cd0 _1yt41s3g _1jj0utpp _14b5cv93 _1reo15vq _18m915vq"
        ]),
        style: {
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("textarea", {
                ref: textareaRef,
                tabIndex: 0,
                placeholder: placeholder,
                maxLength: 1000,
                value: displayValue,
                onChange: (e)=>{
                    const newValue = e.target.value;
                    setValue(newValue);
                    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(newValue);
                    handleChange(e);
                    // Fire analytics event on first character typed
                    if (newValue.length > 0) fireTypingAnalytics();
                },
                onKeyDown: handleKeyDown,
                className: (0, $2jatx.default)([
                    "_1bsb1osq _1tkegktf _c71l11ux _18m91wug _19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb7vkz _ect41kw7 _vwz4bs82 _slp31hna _1i4q1hna _o5721jtm _14zgglyw _nt751r31 _49pcglyw _1hvw1o36"
                ])
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _1bahesu3 _1bsb1osq _zulpu2gc"
                ]),
                children: usePillButton ? /*#__PURE__*/ (0, $dypTs.jsx)($d988f9da35c79665$var$RovoPillButton, {
                    isDisabled: isButtonDisabled,
                    onClick: handleClick
                }) : /*#__PURE__*/ (0, $dypTs.jsx)((0, $kcKpS.RovoIconButton), {
                    isDisabled: isButtonDisabled,
                    onClick: handleClick,
                    icon: /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h4ACf))), {
                        label: ""
                    }),
                    ariaLabel: "Send message",
                    tooltip: tooltipContent
                })
            })
        ]
    });
};
const $d988f9da35c79665$export$acbe8b1c07595f91 = ()=>{
    const [chatValue, setChatValue] = (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).useState("");
    const [previewValue, setPreviewValue] = (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).useState("");
    const textareaRef = (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).useRef(null);
    const handleColdStartButtonClick = (prompt)=>{
        setChatValue(prompt);
        setPreviewValue(""); // Clear preview when button is clicked
    };
    const handleColdStartButtonHover = (prompt)=>{
        // Only show preview if there's no current value
        if (!chatValue) setPreviewValue(prompt);
    };
    const handleColdStartButtonHoverEnd = ()=>{
        setPreviewValue("");
    };
    // Auto-focus textarea on mount
    (0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).useEffect(()=>{
        var _textareaRef_current;
        (_textareaRef_current = textareaRef.current) === null || _textareaRef_current === void 0 ? void 0 : _textareaRef_current.focus({
            preventScroll: true
        });
    }, []);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _p12fcv93 _1bsb1osq _zulpftgi"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)($d988f9da35c79665$export$e7a1e4b67bd87c97, {
                textareaRef: textareaRef,
                value: chatValue,
                onValueChange: setChatValue,
                previewValue: previewValue
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $ewaN9.ColdStartButtonsRow), {
                onButtonClick: handleColdStartButtonClick,
                onButtonHover: handleColdStartButtonHover,
                onButtonHoverEnd: handleColdStartButtonHoverEnd
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $9jvKE.AIFooter), {})
        ]
    });
};
const $d988f9da35c79665$export$9b4d0c63c2bc86a3 = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)($d988f9da35c79665$export$1263ff8fe28ec69f, {}),
            /*#__PURE__*/ (0, $dypTs.jsx)($d988f9da35c79665$export$acbe8b1c07595f91, {})
        ]
    });
};

});
parcelRegister("9jvKE", function(module, exports) {
$parcel$export(module.exports, "AIFooter", function () { return $dd34a5a7e0bde922$export$b209bc813a85fb1d; });
/* ai-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
parcelRequire("gljCV");

var $iVyKn = parcelRequire("iVyKn");

var $LlYs2 = parcelRequire("LlYs2");
const $dd34a5a7e0bde922$var$footerStyles = null;
const $dd34a5a7e0bde922$var$contentStyles = null;
const $dd34a5a7e0bde922$var$linkStyles = null;
const $dd34a5a7e0bde922$var$iconStyles = null;
const $dd34a5a7e0bde922$var$textStyles = null;
const $dd34a5a7e0bde922$export$b209bc813a85fb1d = ({ href: href = "https://www.atlassian.com/trust/atlassian-intelligence" })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1osq _vchhusvi"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _zulp1y44 _ca0qftgi _u5f3idpf _n3tdftgi _19bvidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1bah1h6o _4cvr1h6o _syaz1oju"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($LlYs2))), {
                        label: "Information",
                        size: "small"
                    })
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)("a", {
                    href: href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: (0, $2jatx.default)([
                        "_4bfu1r31 _1hmsglyw _ajmmnqa1 _80omtlke"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_ect41gqc _k48pi7a9 _1wyb1crf _vwz47vkz _syaz131l _1iqs1rm4 _zg8l4jg8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                            id: "RovoChat.usesAI",
                            defaultMessage: "Uses AI. Verify results."
                        })
                    })
                })
            ]
        })
    });
};

});

parcelRegister("ewaN9", function(module, exports) {
$parcel$export(module.exports, "ColdStartButtonsRow", function () { return $f3203383727f3391$export$f8e46ea9cdd11698; });
/* cold-starts-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("gljCV");

var $8e22h = parcelRequire("8e22h");

var $FI4AH = parcelRequire("FI4AH");

var $6zF1U = parcelRequire("6zF1U");

var $bZmYH = parcelRequire("bZmYH");

var $kbpa7 = parcelRequire("kbpa7");
const $f3203383727f3391$var$buttonStyles = null;
const $f3203383727f3391$var$iconStyles = null;
const $f3203383727f3391$var$textStyles = null;
const $f3203383727f3391$var$buttonsContainerStyles = null;
const $f3203383727f3391$var$COLD_START_BUTTONS = [
    {
        icon: /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($FI4AH))), {
            label: "Chart trend up"
        }),
        labelMessageId: "RovoChat.coldStart.stayUpToDate",
        labelDefaultMessage: "Stay up to date",
        promptMessageId: "RovoChat.coldStart.stayUpToDatePrompt",
        promptDefaultMessage: "What's new this week that I should know about?"
    },
    {
        icon: /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))), {
            label: "Search"
        }),
        labelMessageId: "RovoChat.coldStart.findInformation",
        labelDefaultMessage: "Find information",
        promptMessageId: "RovoChat.coldStart.findInformationPrompt",
        promptDefaultMessage: "Help me find information about [topic or process]"
    },
    {
        icon: /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zF1U))), {
            label: "Lightbulb"
        }),
        labelMessageId: "RovoChat.coldStart.brainstormIdeas",
        labelDefaultMessage: "Brainstorm ideas",
        promptMessageId: "RovoChat.coldStart.brainstormIdeasPrompt",
        promptDefaultMessage: "Let's brainstorm ideas for [project, campaign, or topic]."
    }
];
const $f3203383727f3391$export$b99f19cc0647223e = ({ icon: icon, buttonText: buttonText, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $dypTs.jsxs)("button", {
        onClick: onClick,
        type: "button",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _zulpi2wt _1yt4h8dc _2rko1y44 _19it1k0a _11q71rga _80omtlke _v5641gvb _1tkezwfg _19lc150w _4cvxnqye _1snt1rga _pojju4vp _1ygb8djs _1ah3yh40 _j6xtu4vp _q4ztnqye"
        ]),
        style: {
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300")),
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
            "--_1a8xanm": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light600")),
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: icon
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect4zeyy _k48p1nn1 _1wybdlk8 _vwz41yan _y3gn1h6o _syaz1yg0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _o5721q9c"
                ]),
                style: {
                    "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                },
                children: buttonText
            })
        ]
    });
};
const $f3203383727f3391$export$f8e46ea9cdd11698 = ({ onButtonClick: onButtonClick, onButtonHover: onButtonHover, onButtonHoverEnd: onButtonHoverEnd })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _zulpftgi _ca0q7vkz _u5f31crf _n3td7vkz _19bv1crf _1bsb1osq _1bah1h6o _1n261g80"
        ]),
        children: $f3203383727f3391$var$COLD_START_BUTTONS.map((button)=>{
            const label = intl.formatMessage({
                id: button.labelMessageId,
                defaultMessage: button.labelDefaultMessage
            });
            const prompt = intl.formatMessage({
                id: button.promptMessageId,
                defaultMessage: button.promptDefaultMessage
            });
            return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                onMouseEnter: ()=>onButtonHover === null || onButtonHover === void 0 ? void 0 : onButtonHover(prompt),
                onMouseLeave: ()=>onButtonHoverEnd === null || onButtonHoverEnd === void 0 ? void 0 : onButtonHoverEnd(),
                onFocus: ()=>onButtonHover === null || onButtonHover === void 0 ? void 0 : onButtonHover(prompt),
                onBlur: ()=>onButtonHoverEnd === null || onButtonHoverEnd === void 0 ? void 0 : onButtonHoverEnd(),
                children: /*#__PURE__*/ (0, $dypTs.jsx)($f3203383727f3391$export$b99f19cc0647223e, {
                    icon: button.icon,
                    buttonText: label,
                    onClick: ()=>onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick(prompt)
                })
            }, button.labelMessageId);
        })
    });
};

});

parcelRegister("l9P27", function(module, exports) {
module.exports = JSON.parse("{\"assets\":[{\"id\":\"58\",\"layers\":[{\"ind\":57,\"ty\":4,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"rc\",\"p\":{\"a\":0,\"k\":[18.5,30]},\"r\":{\"a\":0,\"k\":0},\"s\":{\"a\":0,\"k\":[37,60]}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,0]},\"o\":{\"a\":0,\"k\":0}}]},{\"ind\":0,\"ty\":4,\"ks\":{\"s\":{\"a\":0,\"k\":[133.33,133.33]}},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[1.67,-0.92],[0.04,-0.02],[0.41,-1.27],[0,-0.57],[0,0],[0,0],[0,0],[0,-2.55],[0,0],[0.23,-0.7],[0.03,-0.07],[0,0],[0,1.95],[0,0],[1.68,0.97],[0,0]],\"o\":[[-1.65,-0.95],[-0.03,0.02],[-1.18,0.69],[-0.16,0.52],[0,0],[0,0],[0,0],[2.21,1.27],[0,0],[0,0.75],[-0.02,0.07],[0,0],[1.69,-0.97],[0,0],[0,-1.94],[0,0],[0,0]],\"v\":[[8.5,0.73],[3.15,0.68],[3.05,0.74],[0.59,3.79],[0.34,5.44],[0.34,12.63],[7.12,16.54],[9.35,17.82],[12.92,24],[12.92,42.55],[12.57,44.73],[12.5,44.96],[24.59,37.98],[27.31,33.27],[27.31,14.71],[24.59,10.01],[21.5,8.23]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.31,0.32,0.35,1]},\"r\":2,\"o\":{\"a\":0,\"k\":100}},{\"ty\":\"tr\",\"o\":{\"a\":0,\"k\":100}}]},{\"ty\":\"tr\",\"o\":{\"a\":0,\"k\":100}}]}]}]},{\"id\":\"61\",\"layers\":[{\"ind\":60,\"ty\":0,\"parent\":56,\"ks\":{},\"w\":37,\"h\":60,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"58\"},{\"ind\":56,\"ty\":3,\"ks\":{\"a\":{\"a\":0,\"k\":[18.5,30]},\"p\":{\"a\":0,\"k\":[18.5,93]}},\"ip\":0,\"op\":385,\"st\":0}]},{\"id\":\"53\",\"layers\":[{\"ind\":6,\"ty\":4,\"parent\":5,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":5,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1140]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":8,\"ty\":4,\"parent\":7,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":7,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,912]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":10,\"ty\":4,\"parent\":9,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":9,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,684]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":12,\"ty\":4,\"parent\":11,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":11,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,456]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":14,\"ty\":4,\"parent\":13,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":13,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,228]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":16,\"ty\":4,\"parent\":15,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":15,\"ty\":3,\"parent\":4,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":18,\"ty\":4,\"parent\":17,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":17,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1311]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":20,\"ty\":4,\"parent\":19,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":19,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1083]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":22,\"ty\":4,\"parent\":21,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":21,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,855]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":24,\"ty\":4,\"parent\":23,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":23,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,627]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":26,\"ty\":4,\"parent\":25,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":25,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,399]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":28,\"ty\":4,\"parent\":27,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":27,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,171]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":30,\"ty\":4,\"parent\":29,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":29,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1254]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":32,\"ty\":4,\"parent\":31,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":31,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1026]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":34,\"ty\":4,\"parent\":33,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":33,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,798]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":36,\"ty\":4,\"parent\":35,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":35,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,570]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":38,\"ty\":4,\"parent\":37,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":37,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,342]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":40,\"ty\":4,\"parent\":39,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":39,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,114]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":42,\"ty\":4,\"parent\":41,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":41,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1197]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":44,\"ty\":4,\"parent\":43,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":43,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,969]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":46,\"ty\":4,\"parent\":45,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":45,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,741]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":48,\"ty\":4,\"parent\":47,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":47,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,513]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":50,\"ty\":4,\"parent\":49,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":49,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,285]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":52,\"ty\":4,\"parent\":51,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":51,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,57]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":4,\"ty\":3,\"parent\":3,\"ks\":{\"a\":{\"a\":0,\"k\":[28.5,700.5]},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[28.5,-439.5],\"i\":{\"x\":[1,0.5],\"y\":[1,1]},\"o\":{\"x\":[0,0.5],\"y\":[0,0]}},{\"t\":192,\"s\":[28.5,-325.5],\"i\":{\"x\":[1,0.5],\"y\":[1,1]},\"o\":{\"x\":[0,0.5],\"y\":[0,0]}},{\"t\":384,\"s\":[28.5,-211.5],\"h\":1}]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":3,\"ty\":3,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1140]}},\"ip\":0,\"op\":385,\"st\":0}]},{\"id\":\"120\",\"layers\":[{\"ind\":119,\"ty\":4,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"rc\",\"p\":{\"a\":0,\"k\":[18,30]},\"r\":{\"a\":0,\"k\":0},\"s\":{\"a\":0,\"k\":[36,60]}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,0]},\"o\":{\"a\":0,\"k\":0}}]},{\"ind\":0,\"ty\":4,\"ks\":{\"s\":{\"a\":0,\"k\":[133.33,133.33]}},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,-1.95],[0,0],[-1.68,-0.97],[0,0],[0,0],[-1.67,0.92],[-0.04,0.02],[-0.41,1.27],[0,0.57],[0,0],[0,0],[0,0],[0,2.55],[0,0],[-0.22,0.7],[-0.03,0.07]],\"o\":[[0,0],[-1.69,0.97],[0,0],[0,1.94],[0,0],[0,0],[1.66,0.95],[0.03,-0.02],[1.19,-0.68],[0.17,-0.52],[0,0],[0,0],[0,0],[-2.21,-1.27],[0,0],[0,-0.75],[0.03,-0.07],[0,0]],\"v\":[[14.81,0],[2.72,6.97],[0,11.68],[0,30.24],[2.73,34.95],[5.59,36.61],[18.8,44.23],[24.16,44.28],[24.26,44.21],[26.72,41.16],[26.98,39.52],[26.98,32.33],[19.98,28.3],[17.96,27.13],[14.39,20.96],[14.39,2.41],[14.73,0.23],[14.81,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.31,0.32,0.35,1]},\"r\":2,\"o\":{\"a\":0,\"k\":100}},{\"ty\":\"tr\",\"o\":{\"a\":0,\"k\":100}}]},{\"ty\":\"tr\",\"o\":{\"a\":0,\"k\":100}}]}]}]},{\"id\":\"123\",\"layers\":[{\"ind\":122,\"ty\":0,\"parent\":118,\"ks\":{},\"w\":36,\"h\":60,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"120\"},{\"ind\":118,\"ty\":3,\"ks\":{\"a\":{\"a\":0,\"k\":[18,30]},\"p\":{\"a\":0,\"k\":[39,168.63]}},\"ip\":0,\"op\":385,\"st\":0}]},{\"id\":\"115\",\"layers\":[{\"ind\":68,\"ty\":4,\"parent\":67,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":67,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,57]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":70,\"ty\":4,\"parent\":69,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":69,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,285]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":72,\"ty\":4,\"parent\":71,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":71,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1197]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":74,\"ty\":4,\"parent\":73,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":73,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,969]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":76,\"ty\":4,\"parent\":75,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":75,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,741]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":78,\"ty\":4,\"parent\":77,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":77,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,513]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":80,\"ty\":4,\"parent\":79,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":79,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,114]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":82,\"ty\":4,\"parent\":81,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":81,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,342]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":84,\"ty\":4,\"parent\":83,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":83,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1254]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":86,\"ty\":4,\"parent\":85,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":85,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1026]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":88,\"ty\":4,\"parent\":87,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":87,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,798]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":90,\"ty\":4,\"parent\":89,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":89,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,570]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":92,\"ty\":4,\"parent\":91,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":91,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,171]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":94,\"ty\":4,\"parent\":93,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":93,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,399]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":96,\"ty\":4,\"parent\":95,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":95,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1311]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":98,\"ty\":4,\"parent\":97,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":97,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1083]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":100,\"ty\":4,\"parent\":99,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":99,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,855]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":102,\"ty\":4,\"parent\":101,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":101,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,627]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":104,\"ty\":4,\"parent\":103,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":103,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,0]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":106,\"ty\":4,\"parent\":105,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":105,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,228]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":108,\"ty\":4,\"parent\":107,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":107,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1140]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":110,\"ty\":4,\"parent\":109,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":109,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,912]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":112,\"ty\":4,\"parent\":111,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":111,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,684]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":114,\"ty\":4,\"parent\":113,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":113,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,456]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":66,\"ty\":3,\"parent\":65,\"ks\":{\"a\":{\"a\":0,\"k\":[28.5,700.5]},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[28.5,700.5],\"i\":{\"x\":[1,0.5],\"y\":[1,1]},\"o\":{\"x\":[0,0.5],\"y\":[0,0]}},{\"t\":192,\"s\":[28.5,586.5],\"i\":{\"x\":[1,0.5],\"y\":[1,1]},\"o\":{\"x\":[0,0.5],\"y\":[0,0]}},{\"t\":384,\"s\":[28.5,472.5],\"h\":1}]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":65,\"ty\":3,\"ks\":{\"p\":{\"a\":0,\"k\":[1,229]}},\"ip\":0,\"op\":385,\"st\":0}]}],\"fr\":60,\"h\":64,\"ip\":0,\"layers\":[{\"ind\":63,\"ty\":0,\"td\":1,\"parent\":2,\"ks\":{},\"w\":37,\"h\":123,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"61\"},{\"ind\":55,\"ty\":0,\"tt\":1,\"parent\":2,\"ks\":{\"a\":{\"a\":0,\"k\":[0,1140]}},\"w\":57,\"h\":2541,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"53\"},{\"ind\":2,\"ty\":3,\"parent\":1,\"ks\":{\"p\":{\"a\":0,\"k\":[25,-63]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":125,\"ty\":0,\"td\":1,\"parent\":64,\"ks\":{},\"w\":57,\"h\":199,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"123\"},{\"ind\":117,\"ty\":0,\"tt\":1,\"parent\":64,\"ks\":{\"a\":{\"a\":0,\"k\":[1,229]}},\"w\":58,\"h\":1630,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"115\"},{\"ind\":64,\"ty\":3,\"parent\":1,\"ks\":{\"p\":{\"a\":0,\"k\":[-17,-134.63]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":1,\"ty\":3,\"parent\":0,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":0,\"ty\":3,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0}],\"meta\":{\"g\":\"https://jitter.video\"},\"op\":384,\"v\":\"5.7.4\",\"w\":64}");

});

parcelRegister("kcKpS", function(module, exports) {
$parcel$export(module.exports, "RovoIconButton", function () { return $f8af6a64db54ac3f$export$654fb6c640da31b4; });
/* rovo-icon-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("gljCV");

var $hLJF4 = parcelRequire("hLJF4");

var $kbpa7 = parcelRequire("kbpa7");
// Icon styles for the button
const $f8af6a64db54ac3f$var$iconStyles = null;
// Disabled state styles
const $f8af6a64db54ac3f$var$disabledStyles = null;
// Enabled state styles
const $f8af6a64db54ac3f$var$enabledStyles = null;
const $f8af6a64db54ac3f$export$654fb6c640da31b4 = ({ isDisabled: isDisabled = true, onClick: onClick, icon: icon, ariaLabel: ariaLabel = "Submit", tooltip: tooltip })=>{
    const button = /*#__PURE__*/ (0, $dypTs.jsx)("button", {
        onClick: isDisabled ? undefined : onClick,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _2rko1ssb _19itglyw _80omtlke _v5642hjt _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1o9zidpf _1ygb8djs _1ah31y44",
            isDisabled ? "_bfhkm7j4 _syaz11tk _80om73ad _irr3m7j4 _30l311tk" : "_bfhk17la _syaz15cr _irr31tj6 _1di61ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: icon
    });
    if (tooltip) {
        // Wrap disabled buttons in a span so tooltip works
        if (isDisabled) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $hLJF4.default), {
            content: tooltip,
            children: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                style: {
                    display: "inline-block"
                },
                children: button
            })
        });
        return /*#__PURE__*/ (0, $dypTs.jsx)((0, $hLJF4.default), {
            content: tooltip,
            children: button
        });
    }
    return button;
};

});




parcelRegister("kiHKn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("2Oxuw")).default; });

var $2Oxuw = parcelRequire("2Oxuw");

});
parcelRegister("2Oxuw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $312f7aad558dbf1f$export$2e2bcd8739ae039; });
/* rovo-chat-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $312f7aad558dbf1f$var$uniformSlotContainerCss = null;
const $312f7aad558dbf1f$var$UniformRovoChatContainer = ()=>{
    const contentContainerRef = (0, $gljCV.useRef)(null);
    const [interacting, setInteracting] = (0, $gljCV.useState)(false);
    const interactingRef = (0, $gljCV.useRef)(interacting);
    (0, $gljCV.useEffect)(()=>{
        interactingRef.current = interacting;
    }, [
        interacting
    ]);
    // On-load
    (0, $gljCV.useEffect)(()=>{
        let hasRun = false;
        let observer = null;
        let cleanup;
        let wheelTimeout = null;
        let keyTimeout = null;
        const container = contentContainerRef.current;
        function runEffectLogic() {
            if (hasRun) return;
            hasRun = true;
            const handleFirstInteraction = ()=>{
                if (!interactingRef.current) setInteracting(true);
            };
            const handleFirstClick = ()=>{
                handleFirstInteraction();
                enableScrollEvents();
            };
            // Scroll blocking
            function preventDefault(e) {
                e.preventDefault();
                handleFirstInteraction();
            }
            function onWheel(e) {
                preventDefault(e);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                wheelTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onKeyDown(e) {
                preventDefault(e);
                if (keyTimeout) clearTimeout(keyTimeout);
                keyTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onTouchMove(e) {
                preventDefault(e);
            }
            function onTouchEnd() {
                enableScrollEvents();
            }
            function blockScrollEvents() {
                window.addEventListener("wheel", onWheel, {
                    passive: false
                });
                window.addEventListener("touchmove", onTouchMove, {
                    passive: false
                });
                window.addEventListener("touchend", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("touchcancel", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("keydown", onKeyDown, {
                    passive: false
                });
            }
            function enableScrollEvents() {
                window.removeEventListener("wheel", onWheel);
                window.removeEventListener("touchmove", onTouchMove);
                window.removeEventListener("touchend", onTouchEnd);
                window.removeEventListener("touchcancel", onTouchEnd);
                window.removeEventListener("keydown", onKeyDown);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                if (keyTimeout) clearTimeout(keyTimeout);
            }
            blockScrollEvents();
            // Content container click interactions
            if (container) container.addEventListener("click", handleFirstClick, {
                once: true
            });
            // Also listen for global clicks as fallback
            const handleGlobalClick = ()=>{
                handleFirstInteraction();
                window.removeEventListener("click", handleGlobalClick);
            };
            window.addEventListener("click", handleGlobalClick);
            // Store cleanup function
            cleanup = ()=>{
                enableScrollEvents();
                if (container) container.removeEventListener("click", handleFirstClick);
                window.removeEventListener("click", handleGlobalClick);
            };
        }
        // Intersection Observer setup
        observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
                runEffectLogic();
                observer === null || observer === void 0 ? void 0 : observer.disconnect();
            }
        }, {
            threshold: 0.1
        });
        if (container) observer.observe(container);
        // Cleanup - ensure scroll events are always re-enabled
        return ()=>{
            if (observer && container) observer.unobserve(container);
            if (cleanup) cleanup();
        };
    }, []);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _kqswh2mm _bfhk1rga"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _1e023bav _1bsb2faw _4t3i1wug _1reo15vq _18m915vq _3zmjv4q2",
                    "_t9eccvni"
                ]),
                style: {
                    "--_182sf68": (0, $6ZVlx.default)(interacting ? "translateX(-120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ih4h04rnm06355wnp2arca3f4gkg0258.webp",
                    alt: "",
                    style: $312f7aad558dbf1f$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _rjxp3bav _1bsb2faw _4t3i1wug _1reo15vq _18m915vq _1fbdv4q2",
                    "_t9eccfs3"
                ]),
                style: {
                    "--_1tebple": (0, $6ZVlx.default)(interacting ? "translateX(120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3qji3u3j76e5i63yjsj7pnko2npm30n4.webp",
                    alt: "",
                    style: $312f7aad558dbf1f$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                ref: contentContainerRef,
                className: (0, $2jatx.default)([
                    "_4t3i1o9t _1xloz8o0 _165tcv93"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
                    name: "chatContent"
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_181nglyw"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ts3bd426400kq6ds07w1208q7a038r0.webp",
                    alt: "",
                    style: $312f7aad558dbf1f$var$imageStyles,
                    className: (0, $2jatx.default)([
                        "_181nglyw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_dm25glyw _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6325jfp76jcjym74os216mopusw7m420.webp",
                    alt: "",
                    style: $312f7aad558dbf1f$var$imageStyles
                })
            })
        ]
    });
};
var $312f7aad558dbf1f$export$2e2bcd8739ae039 = $312f7aad558dbf1f$var$UniformRovoChatContainer;
const $312f7aad558dbf1f$var$desktopAssetStyle = {
    width: "787px"
};
const $312f7aad558dbf1f$var$desktopLeftAssetCss = null;
const $312f7aad558dbf1f$var$desktopRightAssetCss = null;
const $312f7aad558dbf1f$var$desktopCss = null;
const $312f7aad558dbf1f$var$tabletCss = null;
const $312f7aad558dbf1f$var$mobileCss = null;
const $312f7aad558dbf1f$var$imageStyles = {
    width: "100%",
    display: "block"
};
const $312f7aad558dbf1f$var$sectionCss = null;

});


parcelRegister("eCz5y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("4Aw5W")).default; });

var $4Aw5W = parcelRequire("4Aw5W");

});
parcelRegister("4Aw5W", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $61a1b380208f9747$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $9mOHh = parcelRequire("9mOHh");
const $61a1b380208f9747$var$UniformRovoChatHeader = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $9mOHh.ChatHeader), {});
};
var $61a1b380208f9747$export$2e2bcd8739ae039 = $61a1b380208f9747$var$UniformRovoChatHeader;

});


parcelRegister("6xyfr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("4LrCk")).default; });

var $4LrCk = parcelRequire("4LrCk");

});
parcelRegister("4LrCk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $14b3a29ed349294b$export$2e2bcd8739ae039; });
/* rovo-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $8e22h = parcelRequire("8e22h");

var $cc8iN = parcelRequire("cc8iN");

var $ahmPu = parcelRequire("ahmPu");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("iBGmF");
var $82Z9J = parcelRequire("82Z9J");
// Helper function for scroll event management (extracted to reduce complexity)
const $14b3a29ed349294b$var$createScrollEventHandlers = (handleFirstInteraction, enableScrollEvents, wheelTimeout, keyTimeout)=>{
    const preventDefault = (e)=>{
        e.preventDefault();
        handleFirstInteraction();
    };
    const onWheel = (e)=>{
        preventDefault(e);
        if (wheelTimeout.current) clearTimeout(wheelTimeout.current);
        wheelTimeout.current = setTimeout(enableScrollEvents, 20);
    };
    const onKeyDown = (e)=>{
        preventDefault(e);
        if (keyTimeout.current) clearTimeout(keyTimeout.current);
        keyTimeout.current = setTimeout(enableScrollEvents, 20);
    };
    const onTouchMove = (e)=>{
        preventDefault(e);
    };
    const onTouchEnd = ()=>{
        enableScrollEvents();
    };
    return {
        onWheel: onWheel,
        onKeyDown: onKeyDown,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
    };
};
/* eslint-disable complexity -- Complex interactive video carousel component */ const $14b3a29ed349294b$var$UniformRovoHero = ({ defaultHeading: defaultHeading, defaultSubheading: defaultSubheading, videoCarousel: videoCarousel, primaryCtaLabel: primaryCtaLabel, primaryCtaHref: primaryCtaHref, headingTag: headingTag = "h1", flattenData: flattenData = true })=>{
    const videoCarouselData = flattenData ? (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    videoCarousel) : videoCarousel;
    const videoRefs = (0, $gljCV.useRef)([]);
    const videoContainerRef = (0, $gljCV.useRef)(null);
    const [current, setCurrent] = (0, $gljCV.useState)(-1);
    const currentRef = (0, $gljCV.useRef)(current);
    const [playing, setPlaying] = (0, $gljCV.useState)(true);
    const [durations, setDurations] = (0, $gljCV.useState)(Array(videoCarouselData.length).fill(0));
    const [fillBarResetKey, setFillBarResetKey] = (0, $gljCV.useState)(0);
    // @ts-ignore
    const prevViewportWidth = (0, $gljCV.useRef)(typeof window !== "undefined" ? window.innerWidth : 0);
    const [viewportWidth, setViewportWidth] = (0, $gljCV.useState)(typeof window !== "undefined" ? window.innerWidth : 0);
    (0, $gljCV.useEffect)(()=>{
        currentRef.current = current;
    }, [
        current
    ]);
    // Helper function for setting up video durations (using useCallback to make it stable)
    const setupVideoDurations = (0, $gljCV.useCallback)(()=>{
        videoCarouselData.forEach((_, idx)=>{
            const video = videoRefs.current[idx];
            if (!video) return;
            if (video.readyState >= 1) setDurations((durs)=>{
                const copy = [
                    ...durs
                ];
                copy[idx] = video.duration;
                return copy;
            });
            else video.onloadedmetadata = ()=>{
                setDurations((durs)=>{
                    const copy = [
                        ...durs
                    ];
                    copy[idx] = video.duration;
                    return copy;
                });
            };
        });
    }, [
        videoCarouselData
    ]);
    // Helper to set up scroll blocking and event listeners (using useCallback to reduce complexity)
    const setupScrollBlockingAndEvents = (0, $gljCV.useCallback)((handleFirstInteraction, wheelTimeout, keyTimeout)=>{
        const enableScrollEvents = (handlers)=>{
            window.removeEventListener("wheel", handlers.onWheel);
            window.removeEventListener("touchmove", handlers.onTouchMove);
            window.removeEventListener("touchend", handlers.onTouchEnd);
            window.removeEventListener("touchcancel", handlers.onTouchEnd);
            window.removeEventListener("keydown", handlers.onKeyDown);
            if (wheelTimeout.current) clearTimeout(wheelTimeout.current);
            if (keyTimeout.current) clearTimeout(keyTimeout.current);
        };
        const handlers = $14b3a29ed349294b$var$createScrollEventHandlers(handleFirstInteraction, ()=>enableScrollEvents(handlers), wheelTimeout, keyTimeout);
        const handleFirstClick = ()=>{
            handleFirstInteraction();
            enableScrollEvents(handlers);
        };
        // Block scroll events
        window.addEventListener("wheel", handlers.onWheel, {
            passive: false
        });
        window.addEventListener("touchmove", handlers.onTouchMove, {
            passive: false
        });
        window.addEventListener("touchend", handlers.onTouchEnd, {
            passive: false
        });
        window.addEventListener("touchcancel", handlers.onTouchEnd, {
            passive: false
        });
        window.addEventListener("keydown", handlers.onKeyDown, {
            passive: false
        });
        return {
            handleFirstClick: handleFirstClick,
            enableScrollEvents: ()=>enableScrollEvents(handlers)
        };
    }, []);
    // On-load
    (0, $gljCV.useEffect)(()=>{
        let hasRun = false;
        let observer = null;
        let cleanup;
        const wheelTimeout = {
            current: null
        };
        const keyTimeout = {
            current: null
        };
        function runEffectLogic() {
            if (hasRun) return;
            hasRun = true;
            const handleFirstInteraction = ()=>{
                if (currentRef.current === -1) setCurrent(0);
            };
            const { handleFirstClick: handleFirstClick, enableScrollEvents: enableScrollEvents } = setupScrollBlockingAndEvents(handleFirstInteraction, wheelTimeout, keyTimeout);
            // Video container click interactions
            const container = videoContainerRef.current;
            if (container) container.addEventListener("pointerdown", handleFirstClick, {
                once: true
            });
            // Video durations
            setupVideoDurations();
            // Store cleanup function
            cleanup = ()=>{
                enableScrollEvents();
                if (container) {
                    container.removeEventListener("pointerdown", handleFirstInteraction);
                    container.removeEventListener("keydown", handleFirstInteraction);
                }
            };
        }
        // Intersection Observer setup
        const videoContainer = videoContainerRef.current;
        observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
                runEffectLogic();
                observer === null || observer === void 0 ? void 0 : observer.disconnect();
            }
        }, {
            threshold: 0.1
        });
        if (videoContainer) observer.observe(videoContainer);
        // Cleanup - ensure scroll events are always re-enabled
        return ()=>{
            if (observer && videoContainer) observer.unobserve(videoContainer);
            if (cleanup) cleanup();
        };
    }, [
        setupVideoDurations,
        setupScrollBlockingAndEvents
    ]);
    // Video handlers - using useCallback to reduce complexity
    const handleEnded = (0, $gljCV.useCallback)(()=>{
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent((prev)=>(prev + 1) % videoCarouselData.length);
    }, [
        current,
        videoCarouselData.length
    ]);
    const togglePlay = (0, $gljCV.useCallback)(()=>{
        setPlaying((p)=>!p);
    }, []);
    const handleTeamClick = (0, $gljCV.useCallback)((idx)=>{
        if (idx === current) return;
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent(idx);
        setPlaying(true);
    }, [
        current
    ]);
    // Pause/play current video
    (0, $gljCV.useEffect)(()=>{
        if (current === -1) return;
        const video = videoRefs.current[current];
        if (video) {
            if (playing) {
                if (video.ended) video.currentTime = 0;
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                video.play().catch(()=>{});
            } else video.pause();
        }
    }, [
        playing,
        current
    ]);
    const currentDuration = durations[current] || 10;
    // Responsive asset type - extracted to reduce complexity
    (0, $gljCV.useEffect)(()=>{
        const breakpoints = [
            768,
            1024
        ];
        const prevWidth = {
            current: window.innerWidth
        };
        let resizeTimeout;
        const crossedBreakpoint = (prev, curr)=>breakpoints.some((bp)=>prev < bp && curr >= bp || prev >= bp && curr < bp);
        const handleResizeEnd = ()=>{
            const currWidth = window.innerWidth;
            if (crossedBreakpoint(prevWidth.current, currWidth)) setFillBarResetKey((k)=>k + 1);
            prevWidth.current = currWidth;
        };
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(handleResizeEnd, 300);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
        };
    }, []);
    const assetType = viewportWidth >= 1024 ? "desktop" : viewportWidth >= 768 ? "tablet" : "mobile";
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _kqswh2mm _bfhk1rga"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _1e023bav _3zmjv4q2",
                    "_t9ec1qbm"
                ]),
                style: {
                    "--_12q5zt9": (0, $6ZVlx.default)(current !== -1 ? "translateX(-120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ih4h04rnm06355wnp2arca3f4gkg0258.webp",
                    alt: "",
                    style: $14b3a29ed349294b$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _rjxp3bav _1fbdv4q2",
                    "_t9ecc5kj"
                ]),
                style: {
                    "--_1ylu95p": (0, $6ZVlx.default)(current !== -1 ? "translateX(120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3qji3u3j76e5i63yjsj7pnko2npm30n4.webp",
                    alt: "",
                    style: $14b3a29ed349294b$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1reo15vq _1rjcxncg _133i1ejb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $82Z9J.UniformColumnLayout), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o"
                            ]),
                            children: [
                                defaultSubheading && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_16mf1pz4 _12n91k8s _179m1k92 _1k84oxwj",
                                        "body-lg subheading"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                    },
                                    children: defaultSubheading
                                }),
                                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_4cvr1h6o _1pfhpxbi"
                                    ]),
                                    children: headingTag === "h1" ? /*#__PURE__*/ (0, $dypTs.jsx)("h1", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _a13e10xh"
                                        ]),
                                        children: defaultHeading
                                    }) : /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _a13e10xh"
                                        ]),
                                        children: defaultHeading
                                    })
                                }),
                                primaryCtaLabel && primaryCtaHref && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1n261g80 _zulputpp _1bah1h6o _1mou1ejb _urukpxbi"
                                    ]),
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Button), {
                                        href: primaryCtaHref,
                                        className: (0, $2jatx.default)([
                                            "_3fcw1q9c _1cqs1j6v _1bys1k92 _1jw8bfng"
                                        ]),
                                        children: primaryCtaLabel
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        ref: videoContainerRef,
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1e021ssb _t9eczr6s",
                            "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje"
                        ]),
                        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _4t3i1osq _1e0c1ule _y3gn1h6o _kqswh2mm _1reo15vq _18m915vq"
                            ]),
                            children: videoCarouselData.map(({ team: team, mobileVideoSrc: mobileVideoSrc, tabletVideoSrc: tabletVideoSrc, desktopVideoSrc: desktopVideoSrc, mobilePoster: mobilePoster, tabletPoster: tabletPoster, desktopPoster: desktopPoster, ariaLabel: ariaLabel }, idx)=>{
                                var _ref;
                                return /*#__PURE__*/ (0, $dypTs.jsx)("video", {
                                    ref: (el)=>videoRefs.current[idx] = el,
                                    src: assetType === "desktop" ? desktopVideoSrc : assetType === "tablet" ? tabletVideoSrc : mobileVideoSrc,
                                    muted: true,
                                    playsInline: true,
                                    onEnded: handleEnded,
                                    autoPlay: idx === current && playing,
                                    controls: false,
                                    "aria-label": ariaLabel,
                                    preload: "auto",
                                    poster: (_ref = assetType === "desktop" ? desktopPoster : assetType === "tablet" ? tabletPoster : mobilePoster) !== null && _ref !== void 0 ? _ref : undefined,
                                    className: (0, $2jatx.default)([
                                        "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje",
                                        "_3um01ppy _4t3io5ou"
                                    ]),
                                    style: {
                                        "--_1wpk543": (0, $6ZVlx.default)(idx === current || idx === 0 && current === -1 ? "visible" : "hidden"),
                                        "--_1b1vnti": (0, $6ZVlx.default)(idx === current || idx === 0 && current === -1 ? "100%" : 0)
                                    }
                                }, team);
                            })
                        })
                    }),
                    current !== -1 && /*#__PURE__*/ (0, $dypTs.jsx)((0, $82Z9J.UniformColumnLayout), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1pfhoahv _195g1wug _1bsb1osq _p12fbxu3 _zulputpp _y44v1dy3 _1e0c11p5 _yv0e1qft _476dutpp _19d71wug _zzszh9n0"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                                    onClick: togglePlay,
                                    className: (0, $2jatx.default)([
                                        "_4t3i1ady _1bsb1ady _19pkyjp0 _2hwxyjp0 _otyryjp0 _18u0yjp0 _bfhk1j28 _19itglyw _2rko1osq _1ii7kb7n _yyhycs5v _d0altlke _1tzgkb7n _1acakb7n"
                                    ]),
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_4t3izwfg _1bsbzwfg _bfhk1aeo _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31s03 _1tjq1s1x"
                                        ]),
                                        style: {
                                            "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000")),
                                            "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800")),
                                            "--_1jncskl": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark300"))
                                        },
                                        children: playing ? /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc8iN))), {
                                            label: intl.formatMessage({
                                                id: "rovo-hero.pause",
                                                defaultMessage: "Pause"
                                            })
                                        }) : /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                                            label: intl.formatMessage({
                                                id: "rovo-hero.play",
                                                defaultMessage: "Play"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1y6m _zulputpp _1bsb1osq"
                                    ]),
                                    children: videoCarouselData.map(({ team: team }, idx)=>/*#__PURE__*/ (0, $dypTs.jsxs)("button", {
                                            onClick: ()=>handleTeamClick(idx),
                                            className: (0, $2jatx.default)([
                                                "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _ect41pz4 _1wyb1j6v _k48p1fw0 _vwz41k8s",
                                                "_syazxvv5 _d0al18ta"
                                            ]),
                                            style: {
                                                "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                                                "--_145xjfw": (0, $6ZVlx.default)(idx === current ? (0, $kbpa7.wacToken)("color.primary.blue") : (0, $kbpa7.wacToken)("color.neutral.light800")),
                                                "--_1sd2kd4": (0, $6ZVlx.default)(idx === current ? "auto" : "pointer")
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_4t3iftgi _1bsb1osq _kqswh2mm _1reo15vq _18m915vq _bfhku4vp _1mou1ilp",
                                                        idx === 0 && "_2rkonggr",
                                                        idx === videoCarouselData.length - 1 && "_2rkof82g"
                                                    ]),
                                                    style: {
                                                        "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                                                    },
                                                    children: idx === current && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_4t3i1osq _1bsb1osq _bfhk17la _kqswstnw _1e02idpf _152tidpf",
                                                            "_y44v1gj6 _1y0c1j4f",
                                                            "fillBar"
                                                        ]),
                                                        style: {
                                                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                                                            "--_1fmqpqp": (0, $6ZVlx.default)(currentDuration, "s"),
                                                            "--_snrfvu": (0, $6ZVlx.default)(playing ? "running" : "paused")
                                                        }
                                                    }, fillBarResetKey)
                                                }),
                                                team
                                            ]
                                        }, team))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_181nglyw"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ts3bd426400kq6ds07w1208q7a038r0.webp",
                    alt: "",
                    style: $14b3a29ed349294b$var$imageStyles,
                    className: (0, $2jatx.default)([
                        "_181nglyw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_dm25glyw _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6325jfp76jcjym74os216mopusw7m420.webp",
                    alt: "",
                    style: $14b3a29ed349294b$var$imageStyles
                })
            })
        ]
    });
};
var /* eslint-enable complexity */ $14b3a29ed349294b$export$2e2bcd8739ae039 = $14b3a29ed349294b$var$UniformRovoHero;
const $14b3a29ed349294b$var$desktopAssetStyle = {
    width: "787px"
};
const $14b3a29ed349294b$var$desktopLeftAssetCss = null;
const $14b3a29ed349294b$var$desktopRightAssetCss = null;
const $14b3a29ed349294b$var$desktopCss = null;
const $14b3a29ed349294b$var$tabletCss = null;
const $14b3a29ed349294b$var$mobileCss = null;
const $14b3a29ed349294b$var$imageStyles = {
    width: "100%",
    display: "block"
};
const $14b3a29ed349294b$var$sectionCss = null;
const $14b3a29ed349294b$var$containerCss = null;
const $14b3a29ed349294b$var$subheadingCss = null;
const $14b3a29ed349294b$var$headingContainerCss = null;
const $14b3a29ed349294b$var$headingCss = null;
const $14b3a29ed349294b$var$mainHeadingCss = null;
const $14b3a29ed349294b$var$ctaContainerCss = null;
const $14b3a29ed349294b$var$ctaCss = null;
const $14b3a29ed349294b$var$videoContainerCss = null;
const $14b3a29ed349294b$var$videoDimensionsCss = null;
const $14b3a29ed349294b$var$videoCss = null;
const $14b3a29ed349294b$var$fadeIn = null;
const $14b3a29ed349294b$var$controlContainerCss = null;
const $14b3a29ed349294b$var$barContainerCss = null;
const $14b3a29ed349294b$var$buttonCss = null;
const $14b3a29ed349294b$var$buttonCirlceCss = null;
const $14b3a29ed349294b$var$firstBarCss = null;
const $14b3a29ed349294b$var$lastBarCss = null;
const $14b3a29ed349294b$var$barbuttonCss = null;
const $14b3a29ed349294b$var$barCss = null;
const $14b3a29ed349294b$var$fillBarCss = null;
const $14b3a29ed349294b$var$fill = null;

});


parcelRegister("g7Irr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("v15B3")).default; });

var $v15B3 = parcelRequire("v15B3");

});
parcelRegister("v15B3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4094c0fa404a407$export$2e2bcd8739ae039; });
/* scrollable-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2VIbp = parcelRequire("2VIbp");

var $2fk4i = parcelRequire("2fk4i");

var $jE3Ci = parcelRequire("jE3Ci");

var $kbpa7 = parcelRequire("kbpa7");
const $d4094c0fa404a407$var$UniformScrollableHeroCards = (props)=>{
    const { flattenData: flattenData = true } = props;
    let { scrollableCard: scrollableCard } = props;
    if (flattenData) {
        const flattened = (0, $2VIbp.flattenScrollableCardProps)(props);
        scrollableCard = flattened.scrollableCard;
    }
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_11q71ybm _1rjcpxbi _18zr1jfw _1bhl1ejb"
        ]),
        style: {
            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1s9t _p12f1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _9nneu2gc _1yt4u2gc _zulp1ejb _85i51ejb _1reo1wug _rjfvx6dd _1fjgurpi _a5o91kbs _15peu2gc _1v6m1rga _gce7u2gc _aayn1q9v _155au2gc _1w1e15zi _2osnpxbi"
            ]),
            style: {
                "--_o8nmkh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue500")),
                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
            },
            children: scrollableCard === null || scrollableCard === void 0 ? void 0 : scrollableCard.map((card, index)=>{
                var _card_scrollableCardUrl;
                const cardContent = /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $jE3Ci.Lozenge), {
                            appearance: card.scrollableCardLozengeColor || "neutral",
                            text: card.scrollableCardLozengeText
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_18s86fpf _1yt414kv _th3simiu _lrmn10nf",
                                "scrollable-card-title"
                            ]),
                            children: card.scrollableCardTitle
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Image), {
                            src: card.scrollableCardImage,
                            alt: card.scrollableCardTitle
                        })
                    ]
                });
                return ((_card_scrollableCardUrl = card.scrollableCardUrl) === null || _card_scrollableCardUrl === void 0 ? void 0 : _card_scrollableCardUrl.path) ? /*#__PURE__*/ (0, $dypTs.jsx)("a", {
                    href: card.scrollableCardUrl.path,
                    "aria-label": card.scrollableCardUrl.alt || card.scrollableCardTitle,
                    className: (0, $2jatx.default)([
                        "_1hu1v2br _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4cvr1y6m _1bsbeq5r _1ul9eq5r _zulp1b66 _11q7cd5j _2rkovwyg _16qszucj _1yt418tt _mezj1osq _bna7sb0t _1jpx1dfr _1j3s1nty _1cr61wug _1hlxidpf _1874idpf _10ewidpf",
                        "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazn7od _80omtlke _v564iooc _1llwjtcz _1dbz1cd0 _y2mv1mie"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                        "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                        "--_o8nmkh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue500"))
                    },
                    children: cardContent
                }, index) : /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1hu1v2br _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4cvr1y6m _1bsbeq5r _1ul9eq5r _zulp1b66 _11q7cd5j _2rkovwyg _16qszucj _1yt418tt _mezj1osq _bna7sb0t _1jpx1dfr _1j3s1nty _1cr61wug _1hlxidpf _1874idpf _10ewidpf"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                        "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
                    },
                    children: cardContent
                }, index);
            })
        })
    });
};
const $d4094c0fa404a407$var$containerStyles = null;
const $d4094c0fa404a407$var$scrollableContainer = null;
const $d4094c0fa404a407$var$titleStyles = null;
const $d4094c0fa404a407$var$cardWrapper = null;
const $d4094c0fa404a407$var$clickableCardStyles = null;
var $d4094c0fa404a407$export$2e2bcd8739ae039 = $d4094c0fa404a407$var$UniformScrollableHeroCards;

});
parcelRegister("2VIbp", function(module, exports) {
$parcel$export(module.exports, "flattenScrollableCardProps", function () { return $2f8a6ad73f8e2a83$export$f91448e13674e82b; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $f2QWG = parcelRequire("f2QWG");
const $2f8a6ad73f8e2a83$export$f91448e13674e82b = (props)=>{
    return (0, $dPABA._)((0, $6ogO3._)({}, props), {
        scrollableCard: (0, $f2QWG.flattenValues)(props.scrollableCard)
    });
};

});



parcelRegister("71GXn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0984c2e73b0694a4$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");
parcelRequire("l1i8p");
var $5f18E = parcelRequire("5f18E");

var $j5L4q = parcelRequire("j5L4q");
const $0984c2e73b0694a4$var$UniformSideNav = ({ component: component })=>{
    var _component_slots, _component_parameters_title, _component_parameters;
    var _component_slots_sideNavItems;
    const slotItems = (_component_slots_sideNavItems = (_component_slots = component.slots) === null || _component_slots === void 0 ? void 0 : _component_slots["sideNavItems"]) !== null && _component_slots_sideNavItems !== void 0 ? _component_slots_sideNavItems : null;
    if (!slotItems) return;
    const sideNavItems = (0, $j5L4q.transformNavItemData)(slotItems);
    const props = {
        title: (_component_parameters = component.parameters) === null || _component_parameters === void 0 ? void 0 : (_component_parameters_title = _component_parameters["title"]) === null || _component_parameters_title === void 0 ? void 0 : _component_parameters_title.value,
        sideNavItems: sideNavItems
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $5f18E.SideNav), (0, $6ogO3._)({}, props));
};
var $0984c2e73b0694a4$export$2e2bcd8739ae039 = $0984c2e73b0694a4$var$UniformSideNav;

});
parcelRegister("j5L4q", function(module, exports) {
$parcel$export(module.exports, "transformNavItemData", function () { return $ec6d0de2a0c3a497$export$bbcc1b49937dee22; });
const $ec6d0de2a0c3a497$export$bbcc1b49937dee22 = (slots)=>{
    return slots.map((childComponent)=>{
        var _childProps_collectionName, _childComponent_slots;
        var _childComponent_parameters;
        const childProps = (_childComponent_parameters = childComponent.parameters) !== null && _childComponent_parameters !== void 0 ? _childComponent_parameters : {};
        if (childComponent.type === "sideNavLink") {
            var _childProps_anchors, _childProps_text, _childProps_href;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const anchors = (_childProps_anchors = childProps["anchors"]) === null || _childProps_anchors === void 0 ? void 0 : _childProps_anchors.value;
            return {
                type: "link",
                text: (_childProps_text = childProps["text"]) === null || _childProps_text === void 0 ? void 0 : _childProps_text.value,
                href: (_childProps_href = childProps["href"]) === null || _childProps_href === void 0 ? void 0 : _childProps_href.value,
                anchors: anchors ? anchors.map((anchor)=>anchor.fields.text.value) : null,
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event-component": "linkButton",
                    "data-event-container": "sideNav",
                    "data-event": "clicked"
                }
            };
        }
        if (childComponent.type === "sideNavCollection") return {
            type: "collection",
            collectionName: (_childProps_collectionName = childProps["collectionName"]) === null || _childProps_collectionName === void 0 ? void 0 : _childProps_collectionName.value,
            sideNavItems: $ec6d0de2a0c3a497$export$bbcc1b49937dee22((_childComponent_slots = childComponent.slots) === null || _childComponent_slots === void 0 ? void 0 : _childComponent_slots["sideNavItems"])
        };
        return;
    });
};

});


parcelRegister("iSYyH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("3DCiB")).default; });

var $3DCiB = parcelRequire("3DCiB");

});
parcelRegister("3DCiB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6e00143a5b9453fa$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $2fk4i = parcelRequire("2fk4i");

var $j5L4q = parcelRequire("j5L4q");
const $6e00143a5b9453fa$var$UniformSideNavCollection = ({ component: component })=>{
    var _component_slots, _component_parameters_collectionName, _component_parameters;
    var _component_slots_sideNavItems;
    const slotItems = (_component_slots_sideNavItems = (_component_slots = component.slots) === null || _component_slots === void 0 ? void 0 : _component_slots["sideNavItems"]) !== null && _component_slots_sideNavItems !== void 0 ? _component_slots_sideNavItems : null;
    if (!slotItems) return;
    const sideNavItems = (0, $j5L4q.transformNavItemData)(slotItems);
    const props = {
        type: "collection",
        collectionName: (_component_parameters = component.parameters) === null || _component_parameters === void 0 ? void 0 : (_component_parameters_collectionName = _component_parameters["collectionName"]) === null || _component_parameters_collectionName === void 0 ? void 0 : _component_parameters_collectionName.value,
        sideNavItems: sideNavItems
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.SideNavCollection), (0, $6ogO3._)({}, props));
};
var $6e00143a5b9453fa$export$2e2bcd8739ae039 = $6e00143a5b9453fa$var$UniformSideNavCollection;

});


parcelRegister("gdpMV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("acEyk")).default; });

var $acEyk = parcelRequire("acEyk");

});
parcelRegister("acEyk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d6c9de186a63542c$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $2fk4i = parcelRequire("2fk4i");
const $d6c9de186a63542c$var$UniformSideNavLink = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.SideNavLink), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "sideNav",
            "data-event": "clicked"
        }
    }));
};
var $d6c9de186a63542c$export$2e2bcd8739ae039 = $d6c9de186a63542c$var$UniformSideNavLink;

});


parcelRegister("6Oj1c", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("ies6q")).default; });

var $ies6q = parcelRequire("ies6q");

});
parcelRegister("ies6q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b8d6774ae7c2be16$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $jVa6Y = parcelRequire("jVa6Y");
const $b8d6774ae7c2be16$export$143e70f94b3fb702 = (providerList)=>{
    return providerList.reduce((previous, key)=>(0, $dPABA._)((0, $6ogO3._)({}, previous), {
            [key.toLowerCase()]: key
        }), {});
};
const $b8d6774ae7c2be16$var$UniformSignUpForm = ({ socialProviders: socialProviders })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $jVa6Y.default), {
        Login: null,
        Social: (socialProviders === null || socialProviders === void 0 ? void 0 : socialProviders.length) ? /*#__PURE__*/ (0, $dypTs.jsx)((0, $jVa6Y.Social), {
            providers: $b8d6774ae7c2be16$export$143e70f94b3fb702(socialProviders)
        }) : undefined
    });
};
var $b8d6774ae7c2be16$export$2e2bcd8739ae039 = $b8d6774ae7c2be16$var$UniformSignUpForm;

});


parcelRegister("f4xf5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("dXwUh")).default; });

var $dXwUh = parcelRequire("dXwUh");

});
parcelRegister("dXwUh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $66223983e87b0882$export$2e2bcd8739ae039; });
/* single-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");
// eslint-disable-next-line complexity
const $66223983e87b0882$var$UniformSingleTab = (props)=>{
    const { orientation: orientation = {
        mobile: "vertical"
    }, gap: gap = {
        mobile: "0"
    } } = props;
    var _gap_mobile, _gap_tablet, _ref, _gap_desktop, _ref1, _ref2;
    const gapObject = {
        mobile: (_gap_mobile = gap.mobile) !== null && _gap_mobile !== void 0 ? _gap_mobile : "0",
        // @ts-ignore
        tablet: (_ref = (_gap_tablet = gap === null || gap === void 0 ? void 0 : gap.tablet) !== null && _gap_tablet !== void 0 ? _gap_tablet : gap.mobile) !== null && _ref !== void 0 ? _ref : "0",
        // @ts-ignore
        desktop: (_ref2 = (_ref1 = (_gap_desktop = gap === null || gap === void 0 ? void 0 : gap.desktop) !== null && _gap_desktop !== void 0 ? _gap_desktop : gap === null || gap === void 0 ? void 0 : gap.tablet) !== null && _ref1 !== void 0 ? _ref1 : gap.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
    const styles = null;
    const orientationObject = {
        mobile: orientation.mobile || "vertical",
        // @ts-ignore
        tablet: orientation.tablet || orientation.mobile || "vertical",
        desktop: // @ts-ignore
        orientation.desktop || // @ts-ignore
        orientation.tablet || orientation.mobile || "vertical"
    };
    const orientationStyle = null;
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _4t3i1wug _1e0c1txw _zulp1a6y _19wggsi3 _pdlmxbqd",
            "_1e0c1txw _2lx22h65 _1lp71tnc _1inip4d6"
        ]),
        style: {
            "--_rkv8x9": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.mobile + ")"),
            "--_9wptik": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.tablet + ")"),
            "--_3wdyhk": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.desktop + ")"),
            "--_pv2ypa": (0, $6ZVlx.default)(orientationObject.mobile === "horizontal" ? "row" : "column"),
            "--_dek1s0": (0, $6ZVlx.default)(orientationObject.tablet === "horizontal" ? "row" : "column"),
            "--_1ng513r": (0, $6ZVlx.default)(orientationObject.desktop === "horizontal" ? "row" : "column")
        },
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
            name: "tabContents"
        })
    });
};
var $66223983e87b0882$export$2e2bcd8739ae039 = $66223983e87b0882$var$UniformSingleTab;

});


parcelRegister("5sAm0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("kfc2o")).default; });

var $kfc2o = parcelRequire("kfc2o");

});
parcelRegister("kfc2o", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $27eb9bd54e7ff40d$export$2e2bcd8739ae039; });
/* split-color-background-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("gljCV");

var $01zo5 = parcelRequire("01zo5");
const $27eb9bd54e7ff40d$var$UniformSplitColorBackgroundContainer = ({ topColor: topColor, bottomColor: bottomColor, sectionDivider: sectionDivider, extendBackgroundColor: extendBackgroundColor })=>{
    const baseStyle = null;
    const horizontalStyle = null;
    const highLeft = null;
    const highRight = null;
    const coverStyles = null;
    const sectionDividerComponent = /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _4t3iq9zu _1bsb1osq _11q7jj3k _152t1ssb _t9ec1i34 _1kt9b3bt _cfu11ule _kfgt1osq _1mp41osq _1cs8stnw _iajmidpf _1rus1utj",
            bottomColor === "transparent" && sectionDivider === "high-left" && "_mkrz7yzi",
            bottomColor === "transparent" && sectionDivider === "high-right" && "_mkrz1swj",
            sectionDivider === "high-left" && "_tgsmte2m",
            sectionDivider === "high-right" && "_tgsmrjfx"
        ]),
        style: {
            "--_nlw01g": (0, $6ZVlx.default)(topColor),
            "--_130a3qa": (0, $6ZVlx.default)(bottomColor)
        }
    });
    const extendedBackgroundColorComponent = /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1bsbauwl _4t3i1osq _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s",
            sectionDivider && "_1kt9b3bt _cfu11ule _1mp41osq _1cs8stnw _iajmidpf _1rusjj3k _kfgt2ts6 _aetrb3bt _1ywu1ule _z0ai1osq _18postnw _1bqq1mrw _1gufidpf _1hfk1utj _1qdg2ts6",
            !sectionDivider && "_11q7eqnl"
        ]),
        style: {
            "--_nlw01g": (0, $6ZVlx.default)(topColor),
            "--_130a3qa": (0, $6ZVlx.default)(bottomColor)
        },
        children: sectionDivider && sectionDividerComponent
    });
    const slotWrapper = ({ items: items })=>{
        return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm"
            ]),
            children: items
        });
    };
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _9luy1wqb _ce5au29b _wfa7llbu",
            !extendBackgroundColor && sectionDivider && "_1kt9b3bt _cfu11ule _1mp41osq _1cs8stnw _iajmidpf _1rusjj3k _kfgt2ts6 _aetrb3bt _1ywu1ule _z0ai1osq _18postnw _1bqq1mrw _1gufidpf _1hfk1utj _1qdg2ts6",
            !extendBackgroundColor && !sectionDivider && "_11q7eqnl"
        ]),
        style: {
            "--_nlw01g": (0, $6ZVlx.default)(topColor),
            "--_130a3qa": (0, $6ZVlx.default)(bottomColor)
        },
        children: [
            sectionDivider && !extendBackgroundColor && sectionDividerComponent,
            extendBackgroundColor && extendedBackgroundColorComponent,
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
                name: "component",
                wrapperComponent: sectionDivider ? slotWrapper : undefined
            })
        ]
    });
};
var $27eb9bd54e7ff40d$export$2e2bcd8739ae039 = $27eb9bd54e7ff40d$var$UniformSplitColorBackgroundContainer;

});


parcelRegister("JXKd7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a7edf981de66d57a$export$2e2bcd8739ae039; });

var $3rWcE = parcelRequire("3rWcE");
var $a7edf981de66d57a$export$2e2bcd8739ae039 = (0, $3rWcE.UniformStatsSection);

});
parcelRegister("3rWcE", function(module, exports) {
$parcel$export(module.exports, "UniformStatsSection", function () { return $b524ec055947d1b4$export$a5aec67e611930b9; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $kbpa7 = parcelRequire("kbpa7");

var $4Fnxt = parcelRequire("4Fnxt");
const $b524ec055947d1b4$export$a5aec67e611930b9 = (props)=>{
    const statsProps = {
        headerText: props.title,
        bigStat: {
            stat: props.primaryStatNumber,
            statText: props.primaryStatDescription,
            statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
            statSymbol: {
                symbolCharacter: props.primaryStatSymbolCharacter,
                symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: props.secondaryStatNumber,
                statText: props.secondaryStatDescription,
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: props.secondaryStatSymbolCharacter,
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            },
            {
                stat: props.tertiaryStatNumber,
                statText: props.tertiaryStatDescription,
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: props.tertiaryStatSymbolCharacter,
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $4Fnxt.Stats), (0, $6ogO3._)({}, statsProps));
};

});


parcelRegister("akfBj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("j4sH0")).default; });

var $j4sH0 = parcelRequire("j4sH0");

});
parcelRegister("j4sH0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b09338c9a9b6a724$export$2e2bcd8739ae039; });
/* sub-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");
const $b09338c9a9b6a724$var$lightTextStyles = null;
const $b09338c9a9b6a724$var$isDarkBackgroundColor = (color)=>{
    return color ? [
        "#1868DB",
        "#101214"
    ].includes(color) : false;
};
const $b09338c9a9b6a724$var$UniformsubProduct = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul91l27 _1yt41giy"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkrdoj _2hwxrdoj _otyrrdoj _18u0rdoj _4t3i7urh _1bsb7urh"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $imIsw.Picture), {
                        image: {
                            src: props.imageUrl,
                            alt: props.imageAlt
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect4bzd7 _1wyb1l3r _zg8l4jg8 _k48p1nn1 _vwz4dlk8",
                    $b09338c9a9b6a724$var$isDarkBackgroundColor(props.backgroundColor) && "_syazcd5j"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: props.title
            })
        ]
    });
};
var $b09338c9a9b6a724$export$2e2bcd8739ae039 = $b09338c9a9b6a724$var$UniformsubProduct;

});


parcelRegister("ej1nL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("evFps")).default; });

var $evFps = parcelRequire("evFps");

});
parcelRegister("evFps", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $97121cc693296ff7$export$2e2bcd8739ae039; });
/* tabs-12-col.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");

var $gljCV = parcelRequire("gljCV");

var $01zo5 = parcelRequire("01zo5");

var $2axoc = parcelRequire("2axoc");
parcelRequire("5uGt2");
var $7kpd6 = parcelRequire("7kpd6");

var $1rGpC = parcelRequire("1rGpC");
const $97121cc693296ff7$var$uniformTabsContainerStyles = null;
const $97121cc693296ff7$var$UniformTabs12Col = ({ headerText: headerText, subHeaderText: subHeaderText, bgColor: bgColor = "bgWhite", enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false })=>{
    const renderTabs = (0, $gljCV.useCallback)(({ items: items })=>{
        const tabsData = items.map((item, index)=>{
            var // @ts-ignore
            _item_props_children_props_data, _item_props_children_props, _item_props_children, _item_props, _params_title, _params_iconUrl;
            const params = (_item_props = item.props) === null || _item_props === void 0 ? void 0 : (_item_props_children = _item_props.children) === null || _item_props_children === void 0 ? void 0 : (_item_props_children_props = _item_props_children.props) === null || _item_props_children_props === void 0 ? void 0 : (_item_props_children_props_data = _item_props_children_props.data) === null || _item_props_children_props_data === void 0 ? void 0 : _item_props_children_props_data.parameters;
            return {
                id: `tab-${index}`,
                title: params === null || params === void 0 ? void 0 : (_params_title = params.title) === null || _params_title === void 0 ? void 0 : _params_title.value,
                iconUrl: params === null || params === void 0 ? void 0 : (_params_iconUrl = params.iconUrl) === null || _params_iconUrl === void 0 ? void 0 : _params_iconUrl.value,
                tabComponent: item
            };
        });
        return /*#__PURE__*/ (0, $dypTs.jsx)((0, $7kpd6.TabsSection), {
            alignment: "center",
            tabsData: tabsData,
            tabSize: "large",
            bgColor: bgColor,
            enableRovoBorder: enableRovoBorder,
            enableResponsiveTabSize: enableResponsiveTabSize
        });
    }, [
        bgColor,
        enableRovoBorder,
        enableResponsiveTabSize
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1jfw _1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: [
            (headerText || subHeaderText) && /*#__PURE__*/ (0, $dypTs.jsx)((0, $1rGpC.Row), {
                layout: "8",
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2axoc.ContentBlock), {
                    title: headerText,
                    text: subHeaderText,
                    titleAs: "h2",
                    alignment: "center"
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
                name: "tabs",
                wrapperComponent: renderTabs
            })
        ]
    });
};
var $97121cc693296ff7$export$2e2bcd8739ae039 = $97121cc693296ff7$var$UniformTabs12Col;

});


parcelRegister("loBJh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("eWY7v")).default; });

var $eWY7v = parcelRequire("eWY7v");

});
parcelRegister("eWY7v", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bd4a0508f0e82f76$export$2e2bcd8739ae039; });
/* tabs-8-col.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
parcelRequire("gljCV");

var $01zo5 = parcelRequire("01zo5");

var $2axoc = parcelRequire("2axoc");
parcelRequire("5uGt2");
var $7kpd6 = parcelRequire("7kpd6");
const $bd4a0508f0e82f76$var$uniformTabsContainerStyles = null;
const $bd4a0508f0e82f76$var$UniformTabs8Col = ({ headerText: headerText, subHeaderText: subHeaderText, bgColor: bgColor = "bgWhite" })=>{
    const renderTabs = ({ items: items })=>{
        const tabsData = items.map((item, index)=>{
            var _item_props_children_props_data_parameters_title, _item_props_children_props_data_parameters, _item_props_children_props_data, _item_props_children_props, _item_props_children, _item_props;
            return {
                id: `tab-${index}`,
                // @ts-ignore
                title: (_item_props = item.props) === null || _item_props === void 0 ? void 0 : (_item_props_children = _item_props.children) === null || _item_props_children === void 0 ? void 0 : (_item_props_children_props = _item_props_children.props) === null || _item_props_children_props === void 0 ? void 0 : (_item_props_children_props_data = _item_props_children_props.data) === null || _item_props_children_props_data === void 0 ? void 0 : (_item_props_children_props_data_parameters = _item_props_children_props_data.parameters) === null || _item_props_children_props_data_parameters === void 0 ? void 0 : (_item_props_children_props_data_parameters_title = _item_props_children_props_data_parameters.title) === null || _item_props_children_props_data_parameters_title === void 0 ? void 0 : _item_props_children_props_data_parameters_title.value,
                tabComponent: item
            };
        });
        return /*#__PURE__*/ (0, $dypTs.jsx)((0, $7kpd6.TabsSection), {
            alignment: "start",
            tabsData: tabsData,
            tabSize: "small",
            bgColor: bgColor
        });
    };
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1jfw _1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: [
            (headerText || subHeaderText) && /*#__PURE__*/ (0, $dypTs.jsx)((0, $2axoc.ContentBlock), {
                title: headerText,
                titleAs: "h2",
                alignment: "start",
                text: subHeaderText
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
                name: "tabs",
                wrapperComponent: renderTabs
            })
        ]
    });
};
var $bd4a0508f0e82f76$export$2e2bcd8739ae039 = $bd4a0508f0e82f76$var$UniformTabs8Col;

});


parcelRegister("dj2gn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("kb0v3")).default; });

var $kb0v3 = parcelRequire("kb0v3");

});
parcelRegister("kb0v3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $941c8958d6f8744b$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $gb1W2 = parcelRequire("gb1W2");
const $941c8958d6f8744b$var$UniformTemplateCta = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $gb1W2.TemplateCta), (0, $6ogO3._)({}, props));
};
var $941c8958d6f8744b$export$2e2bcd8739ae039 = $941c8958d6f8744b$var$UniformTemplateCta;

});


parcelRegister("dC1vp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gP8Hr")).default; });

var $gP8Hr = parcelRequire("gP8Hr");

});
parcelRegister("gP8Hr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bccaaeb31231192a$export$2e2bcd8739ae039; });
// @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $1pIeE = parcelRequire("1pIeE");

var $lFwc0 = parcelRequire("lFwc0");

var $dziIc = parcelRequire("dziIc");

var $2WL8B = parcelRequire("2WL8B");

var $lqyi6 = parcelRequire("lqyi6");

var $kooLp = parcelRequire("kooLp");
const $bccaaeb31231192a$var$UniformTemplateModalButton = (props)=>{
    const { text: text, productKey: productKey, templateName: templateName, pluginModuleKey: pluginModuleKey, href: href } = props;
    const { openModalForTemplate: openModalForTemplate } = (0, $lFwc0.useSiteSelectorContext)();
    const { setTemplate: setTemplate } = (0, $1pIeE.useProductTemplateContext)();
    // AIS = Atlassian Identity Service - provides user's existing Atlassian sites
    const aisSites = (0, $2WL8B.useSitesWithCurrentProduct)();
    const locale = (0, $kooLp.useLocale)();
    const localizedSignupHref = (0, $kooLp.useLocalizedHref)("/try/cloud/signup");
    const [buttonProps, setButtonProps] = (0, $gljCV.useState)({
        href: $bccaaeb31231192a$var$getDefaultHref({
            productKey: productKey,
            locale: locale
        })
    });
    const fullStargateProductKey = productKey === "jira-service-management" ? "jira-servicedesk.ondemand" : `${productKey}.ondemand`;
    (0, $gljCV.useEffect)(()=>{
        if (pluginModuleKey && productKey) {
            const templateData = {
                templateId: pluginModuleKey,
                templateName: templateName,
                productKey: fullStargateProductKey
            };
            setTemplate(templateData);
            var _aisSites_map;
            // Get site URLs for the current product
            const siteUrls = (_aisSites_map = aisSites === null || aisSites === void 0 ? void 0 : aisSites.map((site)=>site.url)) !== null && _aisSites_map !== void 0 ? _aisSites_map : [];
            // Determine action based on user's sites
            const action = (0, $dziIc.getTemplateAction)({
                templateData: templateData,
                siteUrls: siteUrls,
                localizedSignupHref: localizedSignupHref
            });
            if (action.type === "modal") setButtonProps({
                onClick: (event)=>{
                    event.stopPropagation();
                    event.preventDefault();
                    openModalForTemplate(templateData);
                }
            });
            else setButtonProps({
                href: action.href
            });
        } else if (href) setButtonProps({
            href: (0, $kooLp.getLocalizedHref)({
                href: href,
                locale: locale
            })
        });
        return ()=>{
            setTemplate(null);
        };
    }, [
        openModalForTemplate,
        templateName,
        pluginModuleKey,
        fullStargateProductKey,
        href,
        productKey,
        locale,
        aisSites,
        localizedSignupHref,
        setTemplate
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $lqyi6.Button), (0, $dPABA._)((0, $6ogO3._)({}, buttonProps), {
        children: text
    }));
};
function $bccaaeb31231192a$var$getDefaultHref(args) {
    const { locale: locale, productKey: productKey } = args;
    if (productKey === "jira-software") return (0, $kooLp.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=jira&edition=free",
        locale: locale
    });
    if (productKey === "confluence") return (0, $kooLp.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=confluence&edition=free",
        locale: locale
    });
    if (productKey === "jira-service-management") return (0, $kooLp.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=jira-service-management&edition=free",
        locale: locale
    });
    return "";
}
var $bccaaeb31231192a$export$2e2bcd8739ae039 = $bccaaeb31231192a$var$UniformTemplateModalButton;

});
parcelRegister("dziIc", function(module, exports) {
$parcel$export(module.exports, "getTemplateAction", function () { return $bbf78a31d6ae35df$export$4935503ffd4d8306; });

var $20OkY = parcelRequire("20OkY");

var $lact3 = parcelRequire("lact3");
const $bbf78a31d6ae35df$export$4935503ffd4d8306 = (params)=>{
    const { templateData: templateData, siteUrls: siteUrls, redirectToIdentity: redirectToIdentity, internalLinkAfterIdentity: internalLinkAfterIdentity, localizedSignupHref: localizedSignupHref } = params;
    // If user has existing sites, show modal
    if (siteUrls.length > 0) return {
        type: "modal",
        templateData: templateData
    };
    // Otherwise, redirect directly
    const href = $bbf78a31d6ae35df$var$getRedirectHref({
        templateData: templateData,
        redirectToIdentity: redirectToIdentity,
        internalLinkAfterIdentity: internalLinkAfterIdentity,
        localizedSignupHref: localizedSignupHref
    });
    return {
        type: "redirect",
        href: href
    };
};
const $bbf78a31d6ae35df$var$getRedirectHref = (params)=>{
    const { templateData: templateData, redirectToIdentity: redirectToIdentity, internalLinkAfterIdentity: internalLinkAfterIdentity, localizedSignupHref: localizedSignupHref } = params;
    const { templateId: templateId, templateName: templateName } = templateData;
    if (redirectToIdentity && internalLinkAfterIdentity) return $bbf78a31d6ae35df$var$getIdentityUrl(templateId, templateName, internalLinkAfterIdentity);
    return $bbf78a31d6ae35df$var$getCloudSignupUrl(templateData, localizedSignupHref, internalLinkAfterIdentity);
};
const $bbf78a31d6ae35df$var$isJiraProduct = (productKey)=>{
    return [
        (0, $20OkY.ProductKeys).JIRA_CORE,
        (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK,
        (0, $20OkY.ProductKeys).JIRA_SOFTWARE,
        (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY
    ].includes(productKey);
};
const $bbf78a31d6ae35df$var$getCloudSignupUrl = (templateData, localizedSignupHref, internalLinkAfterIdentity)=>{
    const { templateId: templateId, templateName: templateName, productKey: productKey } = templateData;
    let url = `${localizedSignupHref}?product=${productKey}&templateId=${templateId}&edition=free`;
    if ($bbf78a31d6ae35df$var$isJiraProduct(productKey)) {
        const urlParams = new URLSearchParams(location.search);
        if (!urlParams.has("p")) urlParams.append("templateModal", templateId);
        url += `&continue=${encodeURIComponent(`${location.href}?${urlParams.toString()}`)}`;
    } else if (productKey === (0, $20OkY.ProductKeys).CONFLUENCE) {
        const continueUrl = `${(0, $lact3.getWacIntegrationUrl)()}${internalLinkAfterIdentity !== null && internalLinkAfterIdentity !== void 0 ? internalLinkAfterIdentity : ""}?templateId=${templateId + encodeURIComponent("&templateName=" + encodeURIComponent(templateName))}`;
        url = `${url}&continue=${encodeURIComponent(continueUrl)}`;
    }
    return url;
};
const $bbf78a31d6ae35df$var$getIdentityUrl = (templateId, templateName, internalLinkAfterIdentity)=>{
    const loginUrl = `${(0, $lact3.getIdentityBaseUrl)()}/login?`;
    const continueUrl = `${(0, $lact3.getWacIntegrationUrl)()}${internalLinkAfterIdentity}?templateName=${encodeURIComponent(templateName)}&templateId=${templateId}`;
    return `${loginUrl}&continue=${encodeURIComponent(continueUrl)}`;
};

});



parcelRegister("1il1O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("cwpkM")).default; });

var $cwpkM = parcelRequire("cwpkM");

});
parcelRegister("cwpkM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0641dc4fa0c9006d$export$2e2bcd8739ae039; });
/* template-preview.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $1wldG = parcelRequire("1wldG");

var $e3eMt = parcelRequire("e3eMt");
const $0641dc4fa0c9006d$var$UniformTemplatePreview = ({ templatePreview: templatePreview, templateType: templateType })=>{
    if (!templatePreview) return null;
    var _templatePreview_file_url, _templatePreview_description;
    return /*#__PURE__*/ (0, $dypTs.jsx)("section", {
        className: (0, $2jatx.default)([
            "_y3gn1h6o _kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $e3eMt.UniformTemplatePreviewWindow), {
            url: (_templatePreview_file_url = templatePreview.file.url) !== null && _templatePreview_file_url !== void 0 ? _templatePreview_file_url : "",
            alt: (_templatePreview_description = templatePreview.description) !== null && _templatePreview_description !== void 0 ? _templatePreview_description : "",
            templateType: templateType || (0, $1wldG.TemplateType).Page
        })
    });
};
const $0641dc4fa0c9006d$var$templatePreviewSection = null;
var $0641dc4fa0c9006d$export$2e2bcd8739ae039 = $0641dc4fa0c9006d$var$UniformTemplatePreview;

});
parcelRegister("e3eMt", function(module, exports) {
$parcel$export(module.exports, "UniformTemplatePreviewWindow", function () { return $d2c1227d2c24707c$export$7796399069f4fd6e; });
/* template-preview-window.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kz1DD = parcelRequire("kz1DD");

var $1wldG = parcelRequire("1wldG");

var $kbpa7 = parcelRequire("kbpa7");

var $gRDcE = parcelRequire("gRDcE");

var $yKFYG = parcelRequire("yKFYG");
const $d2c1227d2c24707c$var$previewTopBar = null;
const $d2c1227d2c24707c$var$previewBarDot = null;
const $d2c1227d2c24707c$var$previewImage = null;
const $d2c1227d2c24707c$export$7796399069f4fd6e = ({ url: url, alt: alt, templateType: templateType })=>{
    const templatePreview = null;
    const previewScreenshot = null;
    const whiteboardPreviewWrapper = null;
    const zoomControls = null;
    const zoomControl = null;
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_p12f1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug"
        ]),
        children: templateType === (0, $1wldG.TemplateType).Whiteboard ? /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
            children: [
                /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1yt41ano _4t3ipxbi _vchhusvi _1s1g1b66 _5fbc1b66 _bfhkvejh"
                    ]),
                    style: {
                        "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1gwv _18m91wug _bfhkcd5j _1yxn1b66 _1ein1b66 _19it1k0a _11qbbn52 _12fm15vq",
                        "_80om1qgj _ou2u1osq"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                        "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                    },
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $kz1DD.TransformWrapper), {
                        children: ({ zoomIn: zoomIn, zoomOut: zoomOut })=>/*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $kz1DD.TransformComponent), {
                                        children: /*#__PURE__*/ (0, $dypTs.jsx)("img", {
                                            src: url,
                                            alt: alt,
                                            className: (0, $2jatx.default)([
                                                "_1bsb1osq _p12f1osq"
                                            ])
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _zulpu2gc _kqswstnw _u7copxbi _rjxppxbi"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                                                onClick: ()=>zoomIn(),
                                                "aria-label": "Zoom In",
                                                className: (0, $2jatx.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $gRDcE.ZoomIn), {
                                                    size: "16"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                                                onClick: ()=>zoomOut(),
                                                "aria-label": "Zoom Out",
                                                className: (0, $2jatx.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $yKFYG.ZoomOut), {
                                                    size: "16"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
            children: [
                /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1yt41ano _4t3ipxbi _vchhusvi _1s1g1b66 _5fbc1b66 _bfhkvejh"
                    ]),
                    style: {
                        "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1gwv _18m91wug _bfhkcd5j _1yxn1b66 _1ein1b66 _19it1k0a _11qbbn52 _12fm15vq"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                        "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                    },
                    children: /*#__PURE__*/ (0, $dypTs.jsx)("img", {
                        src: url,
                        alt: alt,
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _p12f1osq"
                        ])
                    })
                })
            ]
        })
    });
};

});



parcelRegister("gh93G", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("11uBo")).default; });

var $11uBo = parcelRequire("11uBo");

});
parcelRegister("11uBo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fd0ee32942954c5a$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jMhSx = parcelRequire("jMhSx");

var $faxYF = parcelRequire("faxYF");
const $fd0ee32942954c5a$var$UniformText = ({ text: text, style: style = "body-lg", alignment: alignment = "left", headingLevel: headingLevel })=>{
    const [textRef, textColor] = (0, $faxYF.useStylePropertyVariableValueFromParent)("--dxp-container-text-color");
    const alignmentStyle = null;
    const boldStyling = null;
    const resetMargin = null;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.TypographyStyles), {
        children: /*#__PURE__*/ (0, $dypTs.jsx)("p", {
            ref: textRef,
            className: (0, $2jatx.default)([
                style.includes("bold") && "_3dt51fw0",
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                "_y3gnoues",
                style
            ]),
            role: headingLevel ? `heading` : undefined,
            "aria-level": headingLevel,
            style: (0, $dPABA._)((0, $6ogO3._)({}, textColor ? {
                color: textColor
            } : undefined), {
                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
            }),
            children: text
        })
    });
};
var $fd0ee32942954c5a$export$2e2bcd8739ae039 = $fd0ee32942954c5a$var$UniformText;

});


parcelRegister("84zj4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("hnLdc")).default; });

var $hnLdc = parcelRequire("hnLdc");

});
parcelRegister("hnLdc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $961aae6f61765b8c$export$2e2bcd8739ae039; });
/* text-with-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("gh93G");
var $11uBo = parcelRequire("11uBo");

var $2ggtO = parcelRequire("2ggtO");
const $961aae6f61765b8c$export$69f8fbc89c62ee2a = "body-md";
const $961aae6f61765b8c$export$8cea64591eaafc6 = (props)=>{
    const { text: text, style: style = $961aae6f61765b8c$export$69f8fbc89c62ee2a, icon: icon } = props;
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $jMhSx.TypographyStyles), {
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("span", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _zulpftgi"
            ]),
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                    "data-testid": "TextWithIcon-icon",
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2ggtO.Icon), {
                        name: icon,
                        size: style === "body-sm" ? "small" : "medium"
                    })
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                    className: (0, $2jatx.default)([
                        style === "body-sm" && "_1pfht94y",
                        style === "body-md" && "_1pfh1l7b"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $11uBo.default), {
                        text: text,
                        style: style
                    })
                })
            ]
        })
    });
};
const $961aae6f61765b8c$var$wrapperCss = null;
const $961aae6f61765b8c$var$smTextCss = null;
const $961aae6f61765b8c$var$mdTextCss = null;
var $961aae6f61765b8c$export$2e2bcd8739ae039 = $961aae6f61765b8c$export$8cea64591eaafc6;

});
parcelRegister("2ggtO", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $74139676dd5cc642$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");
parcelRequire("gljCV");

var $f3oWf = parcelRequire("f3oWf");
const $74139676dd5cc642$export$f04a61298a47a40f = (props)=>{
    const { name: name, size: size } = props;
    if (!name) return /*#__PURE__*/ (0, $dypTs.jsx)($74139676dd5cc642$var$GlyphIcon, {
        size: size,
        name: "TaskInProgressIcon"
    });
    // @ts-ignore
    const { version: version } = (0, $f3oWf.iconMapping)[name];
    if (version === "glyph") return /*#__PURE__*/ (0, $dypTs.jsx)($74139676dd5cc642$var$GlyphIcon, (0, $6ogO3._)({}, props));
    return /*#__PURE__*/ (0, $dypTs.jsx)($74139676dd5cc642$var$CoreIcon, (0, $6ogO3._)({}, props));
};
const $74139676dd5cc642$var$iconWrapperSmallCss = null;
const $74139676dd5cc642$var$iconWrapperMediumCss = null;
const $74139676dd5cc642$var$CoreIcon = (props)=>{
    const { name: name, size: size } = props;
    // @ts-ignore
    const BaseIcon = (0, $f3oWf.iconMapping)[name].component;
    return /*#__PURE__*/ (0, $dypTs.jsx)("span", {
        // @ts-ignore
        className: (0, $2jatx.default)([
            size === "small" && "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === "medium" && "_1bsbzwfg _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)(BaseIcon, {
            icon: name
        })
    });
};
const $74139676dd5cc642$var$GlyphIcon = (props)=>{
    const { name: name, size: size } = props;
    // @ts-ignore
    const BaseGlyphIcon = (0, $f3oWf.iconMapping)[name].component;
    return /*#__PURE__*/ (0, $dypTs.jsx)("span", {
        // @ts-ignore
        className: (0, $2jatx.default)([
            size === "small" && "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === "small" && "_17521o4j",
            size === "medium" && "_1bsbzwfg _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === "medium" && "_1q511lya _17521txs"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)(BaseGlyphIcon, {
            icon: name,
            size: size
        })
    });
};
const $74139676dd5cc642$var$glyphIconWrapperSmallCss = null;
const $74139676dd5cc642$var$glyphIconWrapperMediumCss = null;

});
parcelRegister("f3oWf", function(module, exports) {
$parcel$export(module.exports, "iconMapping", function () { return $e4f57aa48d72479d$export$82f701de2810d5a7; });

var $hXSMk = parcelRequire("hXSMk");

var $j1ciw = parcelRequire("j1ciw");

var $glYau = parcelRequire("glYau");

var $9Cyyz = parcelRequire("9Cyyz");

var $4szpS = parcelRequire("4szpS");

var $26k9M = parcelRequire("26k9M");

var $9lp51 = parcelRequire("9lp51");

var $4ZYjw = parcelRequire("4ZYjw");

var $87kcI = parcelRequire("87kcI");

var $bOuCy = parcelRequire("bOuCy");

var $lfTOg = parcelRequire("lfTOg");

var $efg6m = parcelRequire("efg6m");

var $eOOWL = parcelRequire("eOOWL");

var $35vmV = parcelRequire("35vmV");

var $7NfvL = parcelRequire("7NfvL");

var $gNuc8 = parcelRequire("gNuc8");

var $a9Umc = parcelRequire("a9Umc");

var $aSr2F = parcelRequire("aSr2F");

var $9tc44 = parcelRequire("9tc44");

var $9dCmO = parcelRequire("9dCmO");

var $dmI5f = parcelRequire("dmI5f");

var $ppCkT = parcelRequire("ppCkT");

var $b2tob = parcelRequire("b2tob");

var $2lAyB = parcelRequire("2lAyB");

var $5alrx = parcelRequire("5alrx");

var $eMDDH = parcelRequire("eMDDH");

var $cB1fn = parcelRequire("cB1fn");

var $b0jeq = parcelRequire("b0jeq");

var $kbgnS = parcelRequire("kbgnS");

var $7JEHy = parcelRequire("7JEHy");

var $7Xpzl = parcelRequire("7Xpzl");

var $6ED9p = parcelRequire("6ED9p");

var $3GRvb = parcelRequire("3GRvb");

var $kzcfD = parcelRequire("kzcfD");

var $gsdeR = parcelRequire("gsdeR");

var $WKTmf = parcelRequire("WKTmf");

var $aZNQ9 = parcelRequire("aZNQ9");

var $kVLN7 = parcelRequire("kVLN7");

var $3nGGx = parcelRequire("3nGGx");

var $gXz9s = parcelRequire("gXz9s");

var $PQhz5 = parcelRequire("PQhz5");

var $bf5rK = parcelRequire("bf5rK");

var $gvZeq = parcelRequire("gvZeq");

var $ggVkr = parcelRequire("ggVkr");

var $iMdbU = parcelRequire("iMdbU");

var $7pQ29 = parcelRequire("7pQ29");

var $6QMjb = parcelRequire("6QMjb");

var $8TzqB = parcelRequire("8TzqB");

var $7v2eo = parcelRequire("7v2eo");

var $dTWad = parcelRequire("dTWad");

var $ePHAx = parcelRequire("ePHAx");

var $bZmYH = parcelRequire("bZmYH");

var $5ABRP = parcelRequire("5ABRP");

var $cBEbW = parcelRequire("cBEbW");

var $l6HGO = parcelRequire("l6HGO");

var $8pvt1 = parcelRequire("8pvt1");

var $3dYrz = parcelRequire("3dYrz");

var $gjva1 = parcelRequire("gjva1");

var $fLF1J = parcelRequire("fLF1J");

var $hKesO = parcelRequire("hKesO");

var $kHMU7 = parcelRequire("kHMU7");

var $k2zyM = parcelRequire("k2zyM");

var $2GO8b = parcelRequire("2GO8b");

var $8BlKa = parcelRequire("8BlKa");

var $6xXDI = parcelRequire("6xXDI");
const $e4f57aa48d72479d$export$82f701de2810d5a7 = {
    TimelineIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fLF1J))),
        version: "core"
    },
    CalendarIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($lfTOg))),
        version: "core"
    },
    WarningIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kHMU7))),
        version: "core"
    },
    TeamsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gjva1))),
        version: "core"
    },
    ChangesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($efg6m))),
        version: "core"
    },
    ChartBarIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($eOOWL))),
        version: "core"
    },
    BriefcaseIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($87kcI))),
        version: "core"
    },
    AutomationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9Cyyz))),
        version: "core"
    },
    BugIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bOuCy))),
        version: "core"
    },
    DepartmentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ppCkT))),
        version: "core"
    },
    EyeOpenIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5alrx))),
        version: "core"
    },
    BranchIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4ZYjw))),
        version: "core"
    },
    PhoneIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7pQ29))),
        version: "core"
    },
    CommentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9dCmO))),
        version: "core"
    },
    Page: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($PQhz5))),
        version: "core"
    },
    PersonAddIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ggVkr))),
        version: "core"
    },
    PersonAddedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iMdbU))),
        version: "core"
    },
    LobbyBellIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kzcfD))),
        version: "core"
    },
    InformationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7Xpzl))),
        version: "core"
    },
    PriorityMajorIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8TzqB))),
        version: "core"
    },
    OfficeBuildingIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3nGGx))),
        version: "core"
    },
    ChartTrendIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gNuc8))),
        version: "core"
    },
    CheckboxCheckedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9tc44))),
        version: "core"
    },
    GoalIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7JEHy))),
        version: "core"
    },
    ScreenIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ePHAx))),
        version: "core"
    },
    BookWithBookmarkIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9lp51))),
        version: "core"
    },
    PagesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bf5rK))),
        version: "core"
    },
    ChartMatrixIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7NfvL))),
        version: "core"
    },
    RoadmapIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dTWad))),
        version: "core"
    },
    ShowMoreVerticalIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5ABRP))),
        version: "core"
    },
    TagIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8pvt1))),
        version: "core"
    },
    MarketplaceIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($WKTmf))),
        version: "core"
    },
    AngleBracketsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($j1ciw))),
        version: "core"
    },
    ProjectIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7v2eo))),
        version: "core"
    },
    BoardIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($26k9M))),
        version: "core"
    },
    MegaphoneIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($aZNQ9))),
        version: "core"
    },
    TransitionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hKesO))),
        version: "core"
    },
    StarStarredIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($l6HGO))),
        version: "core"
    },
    EmojiIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2lAyB))),
        version: "core"
    },
    TaskInProgressIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3dYrz))),
        version: "core"
    },
    FormsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kbgnS))),
        version: "core"
    },
    FilesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($b0jeq))),
        version: "core"
    },
    FileIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cB1fn))),
        version: "core"
    },
    ListBulletedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6ED9p))),
        version: "core"
    },
    SmartLinkListIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cBEbW))),
        version: "core"
    },
    MagicWandIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gsdeR))),
        version: "core"
    },
    OperationsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gXz9s))),
        version: "core"
    },
    DecisionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dmI5f))),
        version: "core"
    },
    FeedbackIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($eMDDH))),
        version: "core"
    },
    ObjectiveIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kVLN7))),
        version: "core"
    },
    PresenterModeIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6QMjb))),
        version: "core"
    },
    BacklogIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4szpS))),
        version: "core"
    },
    SearchIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))),
        version: "core"
    },
    EditIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($b2tob))),
        version: "core"
    },
    CheckMarkIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($aSr2F))),
        version: "core"
    },
    CheckCircleIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($a9Umc))),
        version: "core"
    },
    ListChecklistIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3GRvb))),
        version: "core"
    },
    ArchiveBoxIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($glYau))),
        version: "core"
    },
    AlertIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hXSMk))),
        version: "core"
    },
    RoadmapsPlanIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8BlKa))),
        version: "core"
    },
    PeopleGroupIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gvZeq))),
        version: "core"
    },
    BrowserExtensionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($k2zyM))),
        version: "core"
    },
    SyncIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6xXDI))),
        version: "core"
    },
    NotepadIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2GO8b))),
        version: "core"
    },
    ChartBubbleIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($35vmV))),
        version: "core"
    }
};

});
parcelRegister("j1ciw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd87a66aae0d7ce4$var$_react = $dd87a66aae0d7ce4$var$_interopRequireDefault((parcelRequire("gljCV")));

var $dd87a66aae0d7ce4$var$_baseNew = $dd87a66aae0d7ce4$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $dd87a66aae0d7ce4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd87a66aae0d7ce4$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $dd87a66aae0d7ce4$var$_react.default.createElement($dd87a66aae0d7ce4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$dd87a66aae0d7ce4$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $dd87a66aae0d7ce4$var$_default = module.exports.default = $dd87a66aae0d7ce4$var$AngleBracketsIcon;

});

parcelRegister("glYau", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be7d47ad00f4bda6$var$_react = $be7d47ad00f4bda6$var$_interopRequireDefault((parcelRequire("gljCV")));

var $be7d47ad00f4bda6$var$_baseNew = $be7d47ad00f4bda6$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $be7d47ad00f4bda6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be7d47ad00f4bda6$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $be7d47ad00f4bda6$var$_react.default.createElement($be7d47ad00f4bda6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$be7d47ad00f4bda6$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $be7d47ad00f4bda6$var$_default = module.exports.default = $be7d47ad00f4bda6$var$ArchiveBoxIcon;

});

parcelRegister("4ZYjw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a3ba4fc78c82d2f$var$_react = $3a3ba4fc78c82d2f$var$_interopRequireDefault((parcelRequire("gljCV")));

var $3a3ba4fc78c82d2f$var$_baseNew = $3a3ba4fc78c82d2f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $3a3ba4fc78c82d2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a3ba4fc78c82d2f$var$BranchIcon = (props)=>/*#__PURE__*/ $3a3ba4fc78c82d2f$var$_react.default.createElement($3a3ba4fc78c82d2f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$3a3ba4fc78c82d2f$var$BranchIcon.displayName = 'BranchIcon';
var $3a3ba4fc78c82d2f$var$_default = module.exports.default = $3a3ba4fc78c82d2f$var$BranchIcon;

});

parcelRegister("87kcI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2b10cb2fb36d0ad7bfa02e0b0408651>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e8ea64a8ad4d13f$var$_react = $5e8ea64a8ad4d13f$var$_interopRequireDefault((parcelRequire("gljCV")));

var $5e8ea64a8ad4d13f$var$_baseNew = $5e8ea64a8ad4d13f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5e8ea64a8ad4d13f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e8ea64a8ad4d13f$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $5e8ea64a8ad4d13f$var$_react.default.createElement($5e8ea64a8ad4d13f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 2.5a.5.5 0 0 0-.5.5v1h5V3a.5.5 0 0 0-.5-.5zM12 4V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v1H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 5.5a.5.5 0 0 0-.5.5v2h11V6a.5.5 0 0 0-.5-.5zm10.5 4H8.75V11h-1.5V9.5H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$5e8ea64a8ad4d13f$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
var $5e8ea64a8ad4d13f$var$_default = module.exports.default = $5e8ea64a8ad4d13f$var$BriefcaseIcon;

});

parcelRegister("7NfvL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d0119e14b14178352097aaf532e33e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ac9243d88762656$var$_react = $5ac9243d88762656$var$_interopRequireDefault((parcelRequire("gljCV")));

var $5ac9243d88762656$var$_baseNew = $5ac9243d88762656$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5ac9243d88762656$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartMatrix".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Matrix view in in JPD, and other matrix charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ac9243d88762656$var$ChartMatrixIcon = (props)=>/*#__PURE__*/ $5ac9243d88762656$var$_react.default.createElement($5ac9243d88762656$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8 4.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13.25 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5.5 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2m5.5-9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m8 3.5a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M10.5 8A1.75 1.75 0 1 1 14 8a1.75 1.75 0 0 1-3.5 0m-5 2.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$5ac9243d88762656$var$ChartMatrixIcon.displayName = 'ChartMatrixIcon';
var $5ac9243d88762656$var$_default = module.exports.default = $5ac9243d88762656$var$ChartMatrixIcon;

});

parcelRegister("kbgnS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6cd595d4ec67af9dd83acc02e35c9f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb118b4320ed1979$var$_react = $eb118b4320ed1979$var$_interopRequireDefault((parcelRequire("gljCV")));

var $eb118b4320ed1979$var$_baseNew = $eb118b4320ed1979$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $eb118b4320ed1979$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Form".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents forms across Atlassian products, including Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb118b4320ed1979$var$FormIcon = (props)=>/*#__PURE__*/ $eb118b4320ed1979$var$_react.default.createElement($eb118b4320ed1979$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.5H1V0h6zM1 3.875c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75C15 6.385 14.384 7 13.625 7H2.375C1.615 7 1 6.384 1 5.625zM2.5 4v1.5h11V4zM7 10.5H1V9h6zm-6 2.375c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75c0 .76-.616 1.375-1.375 1.375H2.375C1.615 16 1 15.384 1 14.625zM2.5 13v1.5h11V13z" clip-rule="evenodd"/>`
    }, props));
$eb118b4320ed1979$var$FormIcon.displayName = 'FormIcon';
var $eb118b4320ed1979$var$_default = module.exports.default = $eb118b4320ed1979$var$FormIcon;

});

parcelRegister("7Xpzl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43a7428702b82788297fb999fe29f0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cb1e08dc9ec04f5$var$_react = $5cb1e08dc9ec04f5$var$_interopRequireDefault((parcelRequire("gljCV")));

var $5cb1e08dc9ec04f5$var$_baseNew = $5cb1e08dc9ec04f5$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5cb1e08dc9ec04f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cb1e08dc9ec04f5$var$InformationIcon = (props)=>/*#__PURE__*/ $5cb1e08dc9ec04f5$var$_react.default.createElement($5cb1e08dc9ec04f5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$5cb1e08dc9ec04f5$var$InformationIcon.displayName = 'InformationIcon';
var $5cb1e08dc9ec04f5$var$_default = module.exports.default = $5cb1e08dc9ec04f5$var$InformationIcon;

});

parcelRegister("3GRvb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::481d1ea8ad85e9d7b0bddff8ba9b16d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2afecbb2c786369d$var$_react = $2afecbb2c786369d$var$_interopRequireDefault((parcelRequire("gljCV")));

var $2afecbb2c786369d$var$_baseNew = $2afecbb2c786369d$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $2afecbb2c786369d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListChecklist".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: Checklist, 'Requirement' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2afecbb2c786369d$var$ListChecklistIcon = (props)=>/*#__PURE__*/ $2afecbb2c786369d$var$_react.default.createElement($2afecbb2c786369d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.59 9.97-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07-1.37-2.12 1.26-.81.81 1.25 2.33-2.95zm0-7.5-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07L.01 4.04l1.26-.81.81 1.25 2.33-2.95zM16 11v1.5H7V11zm0-7.5V5H7V3.5z"/>`
    }, props));
$2afecbb2c786369d$var$ListChecklistIcon.displayName = 'ListChecklistIcon';
var $2afecbb2c786369d$var$_default = module.exports.default = $2afecbb2c786369d$var$ListChecklistIcon;

});

parcelRegister("gsdeR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b57d69a7e6f53846886bde82f36883e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfa987cbb111f216$var$_react = $bfa987cbb111f216$var$_interopRequireDefault((parcelRequire("gljCV")));

var $bfa987cbb111f216$var$_baseNew = $bfa987cbb111f216$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $bfa987cbb111f216$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MagicWand".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bfa987cbb111f216$var$MagicWandIcon = (props)=>/*#__PURE__*/ $bfa987cbb111f216$var$_react.default.createElement($bfa987cbb111f216$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.027 3.911a1.376 1.376 0 0 1 1.841-.094l.105.094 1.116 1.116a1.376 1.376 0 0 1 0 1.946l-8.616 8.616a1.376 1.376 0 0 1-1.946 0L.411 14.473a1.376 1.376 0 0 1 0-1.946zM1.561 13.5l.939.94L7.938 9 7 8.061zm13.431-4.067-1.06 1.06-1.415-1.414 1.061-1.06zM8.061 7l.938.938L10.939 6l-.94-.94zM16 5v1.5h-2V5zM7.982 2.422l-1.06 1.06-1.414-1.414 1.06-1.06zm7.01-.354-1.414 1.414-1.06-1.06 1.414-1.414zM11 0v2H9.5V0z"/>`
    }, props));
$bfa987cbb111f216$var$MagicWandIcon.displayName = 'MagicWandIcon';
var $bfa987cbb111f216$var$_default = module.exports.default = $bfa987cbb111f216$var$MagicWandIcon;

});

parcelRegister("WKTmf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ed07350d21c7e2ad94ff4198361d506>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b09caa48a867fe5$var$_react = $0b09caa48a867fe5$var$_interopRequireDefault((parcelRequire("gljCV")));

var $0b09caa48a867fe5$var$_baseNew = $0b09caa48a867fe5$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $0b09caa48a867fe5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Marketplace".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Marketplace.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b09caa48a867fe5$var$MarketplaceIcon = (props)=>/*#__PURE__*/ $0b09caa48a867fe5$var$_react.default.createElement($0b09caa48a867fe5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.789 1.513A.75.75 0 0 1 2.5 1h11a.75.75 0 0 1 .711.513l1.502 4.5a.8.8 0 0 1 .038.237A3.08 3.08 0 0 1 14 9.032V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.031A3.08 3.08 0 0 1 .25 6.25q0-.12.038-.237zM3.5 9.329V13a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9.33a3.08 3.08 0 0 1-2.166-1.064A3.08 3.08 0 0 1 8 9.334a3.08 3.08 0 0 1-2.334-1.068A3.08 3.08 0 0 1 3.5 9.329M4.916 6.25v.03a1.584 1.584 0 0 1-3.163.08l.037-.11zm1.5.038.005-.038h3.158l.004.038a1.584 1.584 0 0 1-3.166 0M9.413 4.75H6.588l.25-2.25h2.324zm1.672 1.5a1.584 1.584 0 0 0 3.164.11l-.037-.11zm2.626-1.5h-2.788l-.25-2.25h2.288zM5.33 2.5l-.25 2.25H2.29l.75-2.25z" clip-rule="evenodd"/>`
    }, props));
$0b09caa48a867fe5$var$MarketplaceIcon.displayName = 'MarketplaceIcon';
var $0b09caa48a867fe5$var$_default = module.exports.default = $0b09caa48a867fe5$var$MarketplaceIcon;

});

parcelRegister("kVLN7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6209776ef69c56f26af2970fd840a919>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3ce33e03a650826$var$_react = $f3ce33e03a650826$var$_interopRequireDefault((parcelRequire("gljCV")));

var $f3ce33e03a650826$var$_baseNew = $f3ce33e03a650826$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f3ce33e03a650826$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Objective".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for objectives.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f3ce33e03a650826$var$ObjectiveIcon = (props)=>/*#__PURE__*/ $f3ce33e03a650826$var$_react.default.createElement($f3ce33e03a650826$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.422.02a.75.75 0 0 1 .54.493l.38 1.144 1.145.381a.75.75 0 0 1 .293 1.242l-2 2a.75.75 0 0 1-.53.22h-1.69L8.03 9.03 6.97 7.97l3.53-3.53V2.75a.75.75 0 0 1 .22-.53l2-2a.75.75 0 0 1 .702-.2M12 4h.94l.922-.922-.35-.116a.75.75 0 0 1-.473-.475l-.117-.349-.922.923zM8 1.5A6.5 6.5 0 1 0 14.5 8H16a8 8 0 1 1-8-8zM8 5a3 3 0 1 0 3 3h1.5A4.5 4.5 0 1 1 8 3.5z" clip-rule="evenodd"/>`
    }, props));
$f3ce33e03a650826$var$ObjectiveIcon.displayName = 'ObjectiveIcon';
var $f3ce33e03a650826$var$_default = module.exports.default = $f3ce33e03a650826$var$ObjectiveIcon;

});

parcelRegister("gXz9s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30e149500cf1a05a183dbc43511b361c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c58d6c629e1736c9$var$_react = $c58d6c629e1736c9$var$_interopRequireDefault((parcelRequire("gljCV")));

var $c58d6c629e1736c9$var$_baseNew = $c58d6c629e1736c9$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c58d6c629e1736c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Operations".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for IT Operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c58d6c629e1736c9$var$OperationsIcon = (props)=>/*#__PURE__*/ $c58d6c629e1736c9$var$_react.default.createElement($c58d6c629e1736c9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.036 2.904A6.501 6.501 0 1 0 8 14.5V16a8 8 0 1 1 5.657-13.657l.53.53L8.28 8.78 7.22 7.72l2.304-2.305A3.001 3.001 0 1 0 8 11v1.5a4.5 4.5 0 1 1 2.608-8.168z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14.58 4.862a.75.75 0 0 1 .959.454l.008.025a.75.75 0 1 1-1.414.499l-.007-.02a.75.75 0 0 1 .454-.958m-2.798 2.573a.75.75 0 0 1 .713.786l-.001.015-.001.014a.75.75 0 1 1-1.498-.083v-.01l.001-.01a.75.75 0 0 1 .786-.712m3.497.184a.75.75 0 0 1 .71.787v.026a.75.75 0 1 1-1.498-.081V8.33a.75.75 0 0 1 .788-.711m-4.205 2.656a.75.75 0 0 1-.052 1.06l-.022.019a.75.75 0 1 1-1-1.118l.015-.013a.75.75 0 0 1 1.059.052m3.799.16a.75.75 0 0 1 .355.999l-.011.023a.75.75 0 0 1-1.353-.649l.01-.019a.75.75 0 0 1 .999-.355m-1.457 2.442a.75.75 0 0 1-.053 1.06l-.02.017a.75.75 0 0 1-1.001-1.117l.015-.014a.75.75 0 0 1 1.06.054m-2.278 1.703a.75.75 0 0 1-.454.959l-.025.008a.75.75 0 0 1-.499-1.414l.02-.007a.75.75 0 0 1 .958.454" clip-rule="evenodd"/>`
    }, props));
$c58d6c629e1736c9$var$OperationsIcon.displayName = 'OperationsIcon';
var $c58d6c629e1736c9$var$_default = module.exports.default = $c58d6c629e1736c9$var$OperationsIcon;

});

parcelRegister("6QMjb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::975f3556f302c98e53e9a5c512ff1020>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4fcd12739890eab7$var$_react = $4fcd12739890eab7$var$_interopRequireDefault((parcelRequire("gljCV")));

var $4fcd12739890eab7$var$_baseNew = $4fcd12739890eab7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $4fcd12739890eab7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PresenterMode".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for presenter mode in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4fcd12739890eab7$var$PresenterModeIcon = (props)=>/*#__PURE__*/ $4fcd12739890eab7$var$_react.default.createElement($4fcd12739890eab7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.909 2.5a2.409 2.409 0 0 0-1.054 4.576l-.657 1.348a3.909 3.909 0 1 1 5.226-5.226l-1.348.657A2.41 2.41 0 0 0 4.909 2.5m-.19 2.22a.75.75 0 0 1 .786-.175l9 3.25a.75.75 0 0 1 .02 1.403l-3.822 1.505-1.505 3.822a.75.75 0 0 1-1.403-.02l-3.25-9a.75.75 0 0 1 .175-.785M6.5 6.498l2.032 5.628.896-2.276a.75.75 0 0 1 .423-.423l2.276-.896z" clip-rule="evenodd"/>`
    }, props));
$4fcd12739890eab7$var$PresenterModeIcon.displayName = 'PresenterModeIcon';
var $4fcd12739890eab7$var$_default = module.exports.default = $4fcd12739890eab7$var$PresenterModeIcon;

});

parcelRegister("8TzqB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff5f3689a11c3468e5139786a8e64251>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $679ef10acd2bbfb1$var$_react = $679ef10acd2bbfb1$var$_interopRequireDefault((parcelRequire("gljCV")));

var $679ef10acd2bbfb1$var$_baseNew = $679ef10acd2bbfb1$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $679ef10acd2bbfb1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityMajor".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for major work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $679ef10acd2bbfb1$var$PriorityMajorIcon = (props)=>/*#__PURE__*/ $679ef10acd2bbfb1$var$_react.default.createElement($679ef10acd2bbfb1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 4.75-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625L2.913 6 8 2.65 13.087 6zm0 4.5-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 7.149l5.087 3.353zm0 4.5-5.5-3.626a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 11.65l5.087 3.353z"/>`
    }, props));
$679ef10acd2bbfb1$var$PriorityMajorIcon.displayName = 'PriorityMajorIcon';
var $679ef10acd2bbfb1$var$_default = module.exports.default = $679ef10acd2bbfb1$var$PriorityMajorIcon;

});

parcelRegister("ePHAx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1698552166bfef93121ec02f2fff1081>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc7a3db189edd40$var$_react = $acc7a3db189edd40$var$_interopRequireDefault((parcelRequire("gljCV")));

var $acc7a3db189edd40$var$_baseNew = $acc7a3db189edd40$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $acc7a3db189edd40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc7a3db189edd40$var$ScreenIcon = (props)=>/*#__PURE__*/ $acc7a3db189edd40$var$_react.default.createElement($acc7a3db189edd40$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$acc7a3db189edd40$var$ScreenIcon.displayName = 'ScreenIcon';
var $acc7a3db189edd40$var$_default = module.exports.default = $acc7a3db189edd40$var$ScreenIcon;

});

parcelRegister("5ABRP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02df73cd5dddff20d82e48f58fe7ce92>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $411db02b8e362021$var$_react = $411db02b8e362021$var$_interopRequireDefault((parcelRequire("gljCV")));

var $411db02b8e362021$var$_baseNew = $411db02b8e362021$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $411db02b8e362021$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $411db02b8e362021$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $411db02b8e362021$var$_react.default.createElement($411db02b8e362021$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$411db02b8e362021$var$ShowMoreVerticalIcon.displayName = 'ShowMoreVerticalIcon';
var $411db02b8e362021$var$_default = module.exports.default = $411db02b8e362021$var$ShowMoreVerticalIcon;

});

parcelRegister("cBEbW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0cf5658da3b79d5f876ad9c272a691a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92d81dfa59bd0691$var$_react = $92d81dfa59bd0691$var$_interopRequireDefault((parcelRequire("gljCV")));

var $92d81dfa59bd0691$var$_baseNew = $92d81dfa59bd0691$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $92d81dfa59bd0691$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkList".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link embedded link lists.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92d81dfa59bd0691$var$SmartLinkListIcon = (props)=>/*#__PURE__*/ $92d81dfa59bd0691$var$_react.default.createElement($92d81dfa59bd0691$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm2.5 3H4V4h1.5zm6.5 0H7V4h5zM5.5 8.75H4v-1.5h1.5zm6.5 0H7v-1.5h5zM5.5 12H4v-1.5h1.5zm6.5 0H7v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$92d81dfa59bd0691$var$SmartLinkListIcon.displayName = 'SmartLinkListIcon';
var $92d81dfa59bd0691$var$_default = module.exports.default = $92d81dfa59bd0691$var$SmartLinkListIcon;

});

parcelRegister("8pvt1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::338651941b03ec38a528c6808ae2ffcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61f91141962a089c$var$_react = $61f91141962a089c$var$_interopRequireDefault((parcelRequire("gljCV")));

var $61f91141962a089c$var$_baseNew = $61f91141962a089c$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $61f91141962a089c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61f91141962a089c$var$TagIcon = (props)=>/*#__PURE__*/ $61f91141962a089c$var$_react.default.createElement($61f91141962a089c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$61f91141962a089c$var$TagIcon.displayName = 'TagIcon';
var $61f91141962a089c$var$_default = module.exports.default = $61f91141962a089c$var$TagIcon;

});

parcelRegister("3dYrz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::350d68f25c9b4e9b7a6f8128f373fbcc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $259178d3a19d4fdf$var$_react = $259178d3a19d4fdf$var$_interopRequireDefault((parcelRequire("gljCV")));

var $259178d3a19d4fdf$var$_baseNew = $259178d3a19d4fdf$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $259178d3a19d4fdf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskInProgress".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for in progress task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $259178d3a19d4fdf$var$TaskInProgressIcon = (props)=>/*#__PURE__*/ $259178d3a19d4fdf$var$_react.default.createElement($259178d3a19d4fdf$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h7.646L6.97 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1.542a6.501 6.501 0 1 0 0-1.5M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$259178d3a19d4fdf$var$TaskInProgressIcon.displayName = 'TaskInProgressIcon';
var $259178d3a19d4fdf$var$_default = module.exports.default = $259178d3a19d4fdf$var$TaskInProgressIcon;

});

parcelRegister("hKesO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b20915105f9f06f3ef89ee9497af0ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ceb1f3baa60c34d4$var$_react = $ceb1f3baa60c34d4$var$_interopRequireDefault((parcelRequire("gljCV")));

var $ceb1f3baa60c34d4$var$_baseNew = $ceb1f3baa60c34d4$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ceb1f3baa60c34d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Transition".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for transitions in Analytics.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ceb1f3baa60c34d4$var$TransitionIcon = (props)=>/*#__PURE__*/ $ceb1f3baa60c34d4$var$_react.default.createElement($ceb1f3baa60c34d4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5h-.816c-.586 0-1.062.476-1.062 1.063v5.875A2.563 2.563 0 0 1 6.188 13.5h-.816a2.25 2.25 0 1 1 0-1.5h.816c.586 0 1.062-.476 1.062-1.062V5.062A2.56 2.56 0 0 1 9.813 2.5zM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$ceb1f3baa60c34d4$var$TransitionIcon.displayName = 'TransitionIcon';
var $ceb1f3baa60c34d4$var$_default = module.exports.default = $ceb1f3baa60c34d4$var$TransitionIcon;

});





parcelRegister("4iHqa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f6839accbaa6a771$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $gA8LO = parcelRequire("gA8LO");

var $r5nBh = parcelRequire("r5nBh");
const $f6839accbaa6a771$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        title: null,
        details: null,
        asset: null,
        embedLink: null
    };
    const { topicintroduction: topicintroduction } = body;
    function getRichText(richText) {
        if (typeof richText === "string") return richText;
        return (0, $gA8LO.documentToHtmlString)(richText);
    }
    var _topicintroduction_topicIntroductionTitleExternal, _getRichText, _topicintroduction_embedLink;
    const formattedBody = {
        title: (_topicintroduction_topicIntroductionTitleExternal = topicintroduction === null || topicintroduction === void 0 ? void 0 : topicintroduction.topicIntroductionTitleExternal) !== null && _topicintroduction_topicIntroductionTitleExternal !== void 0 ? _topicintroduction_topicIntroductionTitleExternal : null,
        details: (_getRichText = getRichText(topicintroduction === null || topicintroduction === void 0 ? void 0 : topicintroduction.topicIntroductionDetails)) !== null && _getRichText !== void 0 ? _getRichText : null,
        asset: (()=>{
            var _topicintroduction_topicIntroductionAsset;
            const formattedAsset = $f6839accbaa6a771$var$formatAsset(topicintroduction === null || topicintroduction === void 0 ? void 0 : (_topicintroduction_topicIntroductionAsset = topicintroduction.topicIntroductionAsset) === null || _topicintroduction_topicIntroductionAsset === void 0 ? void 0 : _topicintroduction_topicIntroductionAsset[0]);
            return formattedAsset ? [
                formattedAsset
            ] : null;
        })(),
        embedLink: (_topicintroduction_embedLink = topicintroduction === null || topicintroduction === void 0 ? void 0 : topicintroduction.embedLink) !== null && _topicintroduction_embedLink !== void 0 ? _topicintroduction_embedLink : null
    };
    return formattedBody;
};
// eslint-disable-next-line complexity
const $f6839accbaa6a771$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $f6839accbaa6a771$var$UniformTopicIntroductionContent = (props)=>{
    const topicIntroduction = (0, $gljCV.useMemo)(()=>$f6839accbaa6a771$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $r5nBh.TopicIntroductionContent), {
        topicIntroduction: topicIntroduction
    });
};
var $f6839accbaa6a771$export$2e2bcd8739ae039 = $f6839accbaa6a771$var$UniformTopicIntroductionContent;

});
parcelRegister("r5nBh", function(module, exports) {
$parcel$export(module.exports, "TopicIntroductionContent", function () { return $9269f056c92268cb$export$c79bf2a9fdb4b5c2; });
/* topic-introduction-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $gA8LO = parcelRequire("gA8LO");

var $gtz2R = parcelRequire("gtz2R");

var $B5GRx = parcelRequire("B5GRx");
function $9269f056c92268cb$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $gA8LO.documentToHtmlString)(richText);
}
const $9269f056c92268cb$export$c79bf2a9fdb4b5c2 = ({ topicIntroduction: topicIntroduction })=>{
    var _topicIntroduction_asset;
    var _topicIntroduction_title, _topicIntroduction_details, _topicIntroduction_embedLink, _topicIntroduction_title1, _topicIntroduction_asset_;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        "data-testid": "agile-hub-introduction-content",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            (topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.title) && /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_6rthze3t"
                ]),
                children: topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.title
            }),
            (topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.details) && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthv47k"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                    name: (_topicIntroduction_title = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.title) !== null && _topicIntroduction_title !== void 0 ? _topicIntroduction_title : "",
                    text: $9269f056c92268cb$var$getRichText((_topicIntroduction_details = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.details) !== null && _topicIntroduction_details !== void 0 ? _topicIntroduction_details : "")
                })
            }),
            (topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.embedLink) && /*#__PURE__*/ (0, $dypTs.jsx)((0, $gtz2R.AgileVideo), {
                embedLink: (_topicIntroduction_embedLink = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.embedLink) !== null && _topicIntroduction_embedLink !== void 0 ? _topicIntroduction_embedLink : "",
                title: (_topicIntroduction_title1 = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.title) !== null && _topicIntroduction_title1 !== void 0 ? _topicIntroduction_title1 : "",
                thumbnail: (_topicIntroduction_asset_ = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : (_topicIntroduction_asset = topicIntroduction.asset) === null || _topicIntroduction_asset === void 0 ? void 0 : _topicIntroduction_asset[0]) !== null && _topicIntroduction_asset_ !== void 0 ? _topicIntroduction_asset_ : null
            })
        ]
    });
};

});


parcelRegister("74AbP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7cb3c3459595c819$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $gA8LO = parcelRequire("gA8LO");

var $aiX8y = parcelRequire("aiX8y");
const $7cb3c3459595c819$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        tutorialIntroductionName: null,
        tutorialIntroductionDetails: null,
        tutorialIntroductionAsset: null,
        embedLink: null
    };
    const { tutorialintroduction: tutorialintroduction } = body;
    function getRichText(richText) {
        if (typeof richText === "string") return richText;
        return (0, $gA8LO.documentToHtmlString)(richText);
    }
    var _tutorialintroduction_tutorialIntroductionTitleExternal, _getRichText, _formatAsset, _tutorialintroduction_embedLink;
    const formattedBody = {
        tutorialIntroductionName: (_tutorialintroduction_tutorialIntroductionTitleExternal = tutorialintroduction === null || tutorialintroduction === void 0 ? void 0 : tutorialintroduction.tutorialIntroductionTitleExternal) !== null && _tutorialintroduction_tutorialIntroductionTitleExternal !== void 0 ? _tutorialintroduction_tutorialIntroductionTitleExternal : null,
        tutorialIntroductionDetails: (_getRichText = getRichText(tutorialintroduction === null || tutorialintroduction === void 0 ? void 0 : tutorialintroduction.tutorialIntroductionDetails)) !== null && _getRichText !== void 0 ? _getRichText : null,
        tutorialIntroductionAsset: (_formatAsset = $7cb3c3459595c819$var$formatAsset(tutorialintroduction === null || tutorialintroduction === void 0 ? void 0 : tutorialintroduction.tutorialIntroductionAsset)) !== null && _formatAsset !== void 0 ? _formatAsset : null,
        embedLink: (_tutorialintroduction_embedLink = tutorialintroduction === null || tutorialintroduction === void 0 ? void 0 : tutorialintroduction.embedLink) !== null && _tutorialintroduction_embedLink !== void 0 ? _tutorialintroduction_embedLink : null
    };
    return formattedBody;
};
// eslint-disable-next-line complexity
const $7cb3c3459595c819$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $7cb3c3459595c819$var$UniformTutorialIntroductionContent = (props)=>{
    const tutorialIntroduction = (0, $gljCV.useMemo)(()=>$7cb3c3459595c819$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $aiX8y.TutorialIntroductionContent), {
        tutorialIntroduction: tutorialIntroduction
    });
};
var $7cb3c3459595c819$export$2e2bcd8739ae039 = $7cb3c3459595c819$var$UniformTutorialIntroductionContent;

});
parcelRegister("aiX8y", function(module, exports) {
$parcel$export(module.exports, "TutorialIntroductionContent", function () { return $99ea134c1e677511$export$8d53a13d50897e0d; });
/* tutorial-introduction-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $gA8LO = parcelRequire("gA8LO");

var $gtz2R = parcelRequire("gtz2R");

var $B5GRx = parcelRequire("B5GRx");
function $99ea134c1e677511$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $gA8LO.documentToHtmlString)(richText);
}
const $99ea134c1e677511$export$8d53a13d50897e0d = ({ tutorialIntroduction: tutorialIntroduction })=>{
    var _tutorialIntroduction_tutorialIntroductionName, _tutorialIntroduction_tutorialIntroductionDetails, _tutorialIntroduction_embedLink, _tutorialIntroduction_tutorialIntroductionName1;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        "data-testid": "agile-hub-introduction-content",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            (tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionName) && /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_6rthze3t"
                ]),
                children: tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionName
            }),
            (tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionDetails) && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthv47k"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), {
                    name: (_tutorialIntroduction_tutorialIntroductionName = tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionName) !== null && _tutorialIntroduction_tutorialIntroductionName !== void 0 ? _tutorialIntroduction_tutorialIntroductionName : "",
                    text: $99ea134c1e677511$var$getRichText((_tutorialIntroduction_tutorialIntroductionDetails = tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionDetails) !== null && _tutorialIntroduction_tutorialIntroductionDetails !== void 0 ? _tutorialIntroduction_tutorialIntroductionDetails : "")
                })
            }),
            (tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.embedLink) && /*#__PURE__*/ (0, $dypTs.jsx)((0, $gtz2R.AgileVideo), {
                embedLink: (_tutorialIntroduction_embedLink = tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.embedLink) !== null && _tutorialIntroduction_embedLink !== void 0 ? _tutorialIntroduction_embedLink : "",
                title: (_tutorialIntroduction_tutorialIntroductionName1 = tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionName) !== null && _tutorialIntroduction_tutorialIntroductionName1 !== void 0 ? _tutorialIntroduction_tutorialIntroductionName1 : "",
                thumbnail: tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionAsset
            })
        ]
    });
};

});


parcelRegister("3NZjV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("3QKwy")).default; });

var $3QKwy = parcelRequire("3QKwy");
 // export type { UniformVariantProps } from "./src/variant";

});
parcelRegister("3QKwy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3060f0168074f205$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $01zo5 = parcelRequire("01zo5");
const $3060f0168074f205$var$UniformVariant = ()=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
        name: "content"
    });
};
var $3060f0168074f205$export$2e2bcd8739ae039 = $3060f0168074f205$var$UniformVariant;

});


parcelRegister("aRY8n", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("lEcJc")).default; });

var $lEcJc = parcelRequire("lEcJc");

});
parcelRegister("lEcJc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bb51508c51ba651c$export$2e2bcd8739ae039; });

var $dypTs = parcelRequire("dypTs");

var $01zo5 = parcelRequire("01zo5");
const $bb51508c51ba651c$var$UniformVariantContainer = ()=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $01zo5.UniformSlot), {
        name: "content"
    });
var $bb51508c51ba651c$export$2e2bcd8739ae039 = $bb51508c51ba651c$var$UniformVariantContainer;

});


parcelRegister("jghFx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("1GX5U")).default; });

var $1GX5U = parcelRequire("1GX5U");

});
parcelRegister("1GX5U", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3b0a9b5927ee6753$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $lE15B = parcelRequire("lE15B");
const $3b0a9b5927ee6753$var$UniformVideo = (props)=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $lE15B.Video), (0, $6ogO3._)({}, props));
};
var $3b0a9b5927ee6753$export$2e2bcd8739ae039 = $3b0a9b5927ee6753$var$UniformVideo;

});


parcelRegister("eHC4Z", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("fzMpf")).default; });

var $fzMpf = parcelRequire("fzMpf");

});
parcelRegister("fzMpf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ccbd79059002b008$export$2e2bcd8739ae039; });
/* video-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $8e22h = parcelRequire("8e22h");

var $cc8iN = parcelRequire("cc8iN");

var $ahmPu = parcelRequire("ahmPu");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("iBGmF");
var $82Z9J = parcelRequire("82Z9J");
const $ccbd79059002b008$var$UniformVideoCarousel = ({ videoCarousel: videoCarousel, flattenData: flattenData = true })=>{
    const videoCarouselData = flattenData ? (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    videoCarousel) : videoCarousel;
    const videoRefs = (0, $gljCV.useRef)([]);
    const videoContainerRef = (0, $gljCV.useRef)(null);
    const [current, setCurrent] = (0, $gljCV.useState)(0);
    const currentRef = (0, $gljCV.useRef)(current);
    const [playing, setPlaying] = (0, $gljCV.useState)(true);
    const [durations, setDurations] = (0, $gljCV.useState)(Array(videoCarouselData.length).fill(0));
    const [fillBarResetKey, setFillBarResetKey] = (0, $gljCV.useState)(0);
    // @ts-ignore
    const prevViewportWidth = (0, $gljCV.useRef)(typeof window !== "undefined" ? window.innerWidth : 0);
    const [viewportWidth, setViewportWidth] = (0, $gljCV.useState)(typeof window !== "undefined" ? window.innerWidth : 0);
    (0, $gljCV.useEffect)(()=>{
        currentRef.current = current;
    }, [
        current
    ]);
    // On-load - set up video durations
    (0, $gljCV.useEffect)(()=>{
        // Video durations
        videoCarouselData.forEach((_, idx)=>{
            const video = videoRefs.current[idx];
            if (!video) return;
            if (video.readyState >= 1) setDurations((durs)=>{
                const copy = [
                    ...durs
                ];
                copy[idx] = video.duration;
                return copy;
            });
            else video.onloadedmetadata = ()=>{
                setDurations((durs)=>{
                    const copy = [
                        ...durs
                    ];
                    copy[idx] = video.duration;
                    return copy;
                });
            };
        });
    }, [
        videoCarouselData
    ]);
    // Play next video on end, looping
    const handleEnded = ()=>{
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent((prev)=>(prev + 1) % videoCarouselData.length);
    };
    // Pause/play current video
    (0, $gljCV.useEffect)(()=>{
        const video = videoRefs.current[current];
        if (video) {
            if (playing) {
                if (video.ended) video.currentTime = 0;
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                video.play().catch(()=>{});
            } else video.pause();
        }
    }, [
        playing,
        current
    ]);
    // Pause/play toggle
    const togglePlay = ()=>{
        setPlaying((p)=>!p);
    };
    // Jump to a specific video and start from beginning
    const handleTeamClick = (idx)=>{
        if (idx === current) return;
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent(idx);
        setPlaying(true);
    };
    const currentDuration = durations[current] || 10;
    // Responsive asset type
    (0, $gljCV.useEffect)(()=>{
        let resizeTimeout;
        const breakpoints = [
            768,
            1024
        ];
        // Store previous width outside the handler so it persists
        const prevViewportWidth = {
            current: window.innerWidth
        };
        function crossedBreakpoint(prev, curr) {
            return breakpoints.some((bp)=>prev < bp && curr >= bp || prev >= bp && curr < bp);
        }
        const handleResizeEnd = ()=>{
            const currWidth = window.innerWidth;
            if (crossedBreakpoint(prevViewportWidth.current, currWidth)) setFillBarResetKey((k)=>k + 1);
            prevViewportWidth.current = currWidth;
        };
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(handleResizeEnd, 300);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
        };
    }, []);
    const assetType = viewportWidth >= 1024 ? "desktop" : viewportWidth >= 768 ? "tablet" : "mobile";
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                ref: videoContainerRef,
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e021ssb _t9eczr6s",
                    "_1bsb1osq _4t3ieo28 _1vkh124j _tnru1jje"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _4t3i1osq _1e0c1ule _y3gn1h6o _kqswh2mm _1reo15vq _18m915vq"
                    ]),
                    children: videoCarouselData.map(({ team: team, mobileVideoSrc: mobileVideoSrc, tabletVideoSrc: tabletVideoSrc, desktopVideoSrc: desktopVideoSrc, mobilePoster: mobilePoster, tabletPoster: tabletPoster, desktopPoster: desktopPoster, ariaLabel: ariaLabel }, idx)=>{
                        var _ref;
                        return /*#__PURE__*/ (0, $dypTs.jsx)("video", {
                            ref: (el)=>videoRefs.current[idx] = el,
                            src: assetType === "desktop" ? desktopVideoSrc : assetType === "tablet" ? tabletVideoSrc : mobileVideoSrc,
                            muted: true,
                            playsInline: true,
                            onEnded: handleEnded,
                            autoPlay: idx === current && playing,
                            controls: false,
                            "aria-label": ariaLabel,
                            preload: "auto",
                            poster: (_ref = assetType === "desktop" ? desktopPoster : assetType === "tablet" ? tabletPoster : mobilePoster) !== null && _ref !== void 0 ? _ref : undefined,
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _4t3ieo28 _1vkh124j _tnru1jje",
                                "_1e0c1ule _3um0ceft _4t3iq0p9 _5ral1dfr"
                            ]),
                            style: {
                                "--_1ktsfil": (0, $6ZVlx.default)(idx === current ? "visible" : "hidden"),
                                "--_18c8iaj": (0, $6ZVlx.default)(idx === current ? "100%" : 0)
                            }
                        }, team);
                    })
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $82Z9J.UniformColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhoahv _195g1wug _1bsb1osq _p12fbxu3 _zulputpp _1e0c11p5 _yv0e15eh _1ul9idpf _476dutpp _19d71wug _zzszh9n0"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)("button", {
                            onClick: togglePlay,
                            className: (0, $2jatx.default)([
                                "_4t3i1ady _1bsb1ady _19pkyjp0 _2hwxyjp0 _otyryjp0 _18u0yjp0 _bfhk1j28 _19itglyw _2rko1osq _1ii7kb7n _yyhycs5v _d0altlke _1tzgkb7n _1acakb7n"
                            ]),
                            children: /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_4t3izwfg _1bsbzwfg _bfhk1aeo _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31s03 _1tjq1s1x"
                                ]),
                                style: {
                                    "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000")),
                                    "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800")),
                                    "--_1jncskl": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark300"))
                                },
                                children: playing ? /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc8iN))), {
                                    label: intl.formatMessage({
                                        id: "rovo-hero.pause",
                                        defaultMessage: "Pause"
                                    })
                                }) : /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                                    label: intl.formatMessage({
                                        id: "rovo-hero.play",
                                        defaultMessage: "Play"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1y6m _zulputpp _1bsb1osq _1ul9idpf _1reo15vq _18m915vq"
                            ]),
                            children: videoCarouselData.map(({ team: team }, idx)=>/*#__PURE__*/ (0, $dypTs.jsxs)("button", {
                                    onClick: ()=>handleTeamClick(idx),
                                    className: (0, $2jatx.default)([
                                        "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _1ul9idpf _1o9zkb7n _ect41pz4 _1wyb1j6v _k48p1fw0 _vwz41k8s _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
                                        "_syazxvv5 _d0al18ta"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                                        "--_145xjfw": (0, $6ZVlx.default)(idx === current ? (0, $kbpa7.wacToken)("color.primary.blue") : (0, $kbpa7.wacToken)("color.neutral.light800")),
                                        "--_1sd2kd4": (0, $6ZVlx.default)(idx === current ? "auto" : "pointer")
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_4t3iftgi _1bsb1osq _kqswh2mm _1reo15vq _18m915vq _bfhku4vp _1mou1ilp",
                                                idx === 0 && "_2rkonggr",
                                                idx === videoCarouselData.length - 1 && "_2rkof82g"
                                            ]),
                                            style: {
                                                "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                                            },
                                            children: idx === current && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3i1osq _1bsb1osq _bfhk17la _kqswstnw _1e02idpf _152tidpf",
                                                    "_y44v1gj6 _1y0c1j4f",
                                                    "fillBar"
                                                ]),
                                                style: {
                                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                                                    "--_1fmqpqp": (0, $6ZVlx.default)(currentDuration, "s"),
                                                    "--_snrfvu": (0, $6ZVlx.default)(playing ? "running" : "paused")
                                                }
                                            }, fillBarResetKey)
                                        }),
                                        team
                                    ]
                                }, team))
                        })
                    ]
                })
            })
        ]
    });
};
var $ccbd79059002b008$export$2e2bcd8739ae039 = $ccbd79059002b008$var$UniformVideoCarousel;
const $ccbd79059002b008$var$containerCss = null;
const $ccbd79059002b008$var$videoContainerCss = null;
const $ccbd79059002b008$var$videoDimensionsCss = null;
const $ccbd79059002b008$var$videoCss = null;
const $ccbd79059002b008$var$controlContainerCss = null;
const $ccbd79059002b008$var$barContainerCss = null;
const $ccbd79059002b008$var$buttonCss = null;
const $ccbd79059002b008$var$buttonCirlceCss = null;
const $ccbd79059002b008$var$firstBarCss = null;
const $ccbd79059002b008$var$lastBarCss = null;
const $ccbd79059002b008$var$barbuttonCss = null;
const $ccbd79059002b008$var$barCss = null;
const $ccbd79059002b008$var$fillBarCss = null;
const $ccbd79059002b008$var$fill = null;

});



parcelRegister("g70ym", function(module, exports) {
$parcel$export(module.exports, "UniformMissingComponent", function () { return $ff4b1737eead1b52$export$ec79654869ecfe2e; });
/* uniform-missing-component.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
const $ff4b1737eead1b52$export$ec79654869ecfe2e = ({ componentName: componentName })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("span", {
        id: `UNIFORM-MISSING-COMPONENT-${componentName}`,
        "data-nosnippet": true,
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            "_1e0cglyw"
        ])
    });
};

});



//# sourceMappingURL=index.676b7358.js.map
